(function () {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7d57"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7d57"] = parcelRequire;
}
parcelRequire.register("k7705", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\x00") return "�";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRequire.register("eye48", function(module, exports) {

/*!
 * jQuery Validation Plugin v1.19.5
 *
 * https://jqueryvalidation.org/
 *
 * Copyright (c) 2022 Jörn Zaefferer
 * Released under the MIT license
 */ (function(factory) {
    if (typeof define === "function" && define.amd) define([
        "jquery"
    ], factory);
    else if (0, module.exports) module.exports = factory((parcelRequire("k7705")));
    else factory(jQuery);
})(function($) {
    $.extend($.fn, {
        // https://jqueryvalidation.org/validate/
        validate: function(options) {
            // If nothing is selected, return nothing; can't chain anyway
            if (!this.length) {
                if (options && options.debug && window.console) console.warn("Nothing selected, can't validate, returning nothing.");
                return;
            }
            // Check if a validator for this form was already created
            var validator = $.data(this[0], "validator");
            if (validator) return validator;
            // Add novalidate tag if HTML5.
            this.attr("novalidate", "novalidate");
            validator = new $.validator(options, this[0]);
            $.data(this[0], "validator", validator);
            if (validator.settings.onsubmit) {
                this.on("click.validate", ":submit", function(event) {
                    // Track the used submit button to properly handle scripted
                    // submits later.
                    validator.submitButton = event.currentTarget;
                    // Allow suppressing validation by adding a cancel class to the submit button
                    if ($(this).hasClass("cancel")) validator.cancelSubmit = true;
                    // Allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
                    if ($(this).attr("formnovalidate") !== undefined) validator.cancelSubmit = true;
                });
                // Validate the form on submit
                this.on("submit.validate", function(event) {
                    if (validator.settings.debug) // Prevent form submit to be able to see console output
                    event.preventDefault();
                    function handle() {
                        var hidden, result;
                        // Insert a hidden input as a replacement for the missing submit button
                        // The hidden input is inserted in two cases:
                        //   - A user defined a `submitHandler`
                        //   - There was a pending request due to `remote` method and `stopRequest()`
                        //     was called to submit the form in case it's valid
                        if (validator.submitButton && (validator.settings.submitHandler || validator.formSubmitted)) hidden = $("<input type='hidden'/>").attr("name", validator.submitButton.name).val($(validator.submitButton).val()).appendTo(validator.currentForm);
                        if (validator.settings.submitHandler && !validator.settings.debug) {
                            result = validator.settings.submitHandler.call(validator, validator.currentForm, event);
                            if (hidden) // And clean up afterwards; thanks to no-block-scope, hidden can be referenced
                            hidden.remove();
                            if (result !== undefined) return result;
                            return false;
                        }
                        return true;
                    }
                    // Prevent submit for invalid forms or custom submit handlers
                    if (validator.cancelSubmit) {
                        validator.cancelSubmit = false;
                        return handle();
                    }
                    if (validator.form()) {
                        if (validator.pendingRequest) {
                            validator.formSubmitted = true;
                            return false;
                        }
                        return handle();
                    } else {
                        validator.focusInvalid();
                        return false;
                    }
                });
            }
            return validator;
        },
        // https://jqueryvalidation.org/valid/
        valid: function() {
            var valid, validator, errorList;
            if ($(this[0]).is("form")) valid = this.validate().form();
            else {
                errorList = [];
                valid = true;
                validator = $(this[0].form).validate();
                this.each(function() {
                    valid = validator.element(this) && valid;
                    if (!valid) errorList = errorList.concat(validator.errorList);
                });
                validator.errorList = errorList;
            }
            return valid;
        },
        // https://jqueryvalidation.org/rules/
        rules: function(command, argument) {
            var element = this[0], isContentEditable = typeof this.attr("contenteditable") !== "undefined" && this.attr("contenteditable") !== "false", settings, staticRules, existingRules, data, param, filtered;
            // If nothing is selected, return empty object; can't chain anyway
            if (element == null) return;
            if (!element.form && isContentEditable) {
                element.form = this.closest("form")[0];
                element.name = this.attr("name");
            }
            if (element.form == null) return;
            if (command) {
                settings = $.data(element.form, "validator").settings;
                staticRules = settings.rules;
                existingRules = $.validator.staticRules(element);
                switch(command){
                    case "add":
                        $.extend(existingRules, $.validator.normalizeRule(argument));
                        // Remove messages from rules, but allow them to be set separately
                        delete existingRules.messages;
                        staticRules[element.name] = existingRules;
                        if (argument.messages) settings.messages[element.name] = $.extend(settings.messages[element.name], argument.messages);
                        break;
                    case "remove":
                        if (!argument) {
                            delete staticRules[element.name];
                            return existingRules;
                        }
                        filtered = {};
                        $.each(argument.split(/\s/), function(index, method) {
                            filtered[method] = existingRules[method];
                            delete existingRules[method];
                        });
                        return filtered;
                }
            }
            data = $.validator.normalizeRules($.extend({}, $.validator.classRules(element), $.validator.attributeRules(element), $.validator.dataRules(element), $.validator.staticRules(element)), element);
            // Make sure required is at front
            if (data.required) {
                param = data.required;
                delete data.required;
                data = $.extend({
                    required: param
                }, data);
            }
            // Make sure remote is at back
            if (data.remote) {
                param = data.remote;
                delete data.remote;
                data = $.extend(data, {
                    remote: param
                });
            }
            return data;
        }
    });
    // JQuery trim is deprecated, provide a trim method based on String.prototype.trim
    var trim = function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    };
    // Custom selectors
    $.extend($.expr.pseudos || $.expr[":"], {
        // https://jqueryvalidation.org/blank-selector/
        blank: function(a) {
            return !trim("" + $(a).val());
        },
        // https://jqueryvalidation.org/filled-selector/
        filled: function(a) {
            var val = $(a).val();
            return val !== null && !!trim("" + val);
        },
        // https://jqueryvalidation.org/unchecked-selector/
        unchecked: function(a) {
            return !$(a).prop("checked");
        }
    });
    // Constructor for validator
    $.validator = function(options, form) {
        this.settings = $.extend(true, {}, $.validator.defaults, options);
        this.currentForm = form;
        this.init();
    };
    // https://jqueryvalidation.org/jQuery.validator.format/
    $.validator.format = function(source, params) {
        if (arguments.length === 1) return function() {
            var args = $.makeArray(arguments);
            args.unshift(source);
            return $.validator.format.apply(this, args);
        };
        if (params === undefined) return source;
        if (arguments.length > 2 && params.constructor !== Array) params = $.makeArray(arguments).slice(1);
        if (params.constructor !== Array) params = [
            params
        ];
        $.each(params, function(i, n) {
            source = source.replace(new RegExp("\\{" + i + "\\}", "g"), function() {
                return n;
            });
        });
        return source;
    };
    $.extend($.validator, {
        defaults: {
            messages: {},
            groups: {},
            rules: {},
            errorClass: "error",
            pendingClass: "pending",
            validClass: "valid",
            errorElement: "label",
            focusCleanup: false,
            focusInvalid: true,
            errorContainer: $([]),
            errorLabelContainer: $([]),
            onsubmit: true,
            ignore: ":hidden",
            ignoreTitle: false,
            onfocusin: function(element) {
                this.lastActive = element;
                // Hide error label and remove error class on focus if enabled
                if (this.settings.focusCleanup) {
                    if (this.settings.unhighlight) this.settings.unhighlight.call(this, element, this.settings.errorClass, this.settings.validClass);
                    this.hideThese(this.errorsFor(element));
                }
            },
            onfocusout: function(element) {
                if (!this.checkable(element) && (element.name in this.submitted || !this.optional(element))) this.element(element);
            },
            onkeyup: function(element, event) {
                // Avoid revalidate the field when pressing one of the following keys
                // Shift       => 16
                // Ctrl        => 17
                // Alt         => 18
                // Caps lock   => 20
                // End         => 35
                // Home        => 36
                // Left arrow  => 37
                // Up arrow    => 38
                // Right arrow => 39
                // Down arrow  => 40
                // Insert      => 45
                // Num lock    => 144
                // AltGr key   => 225
                var excludedKeys = [
                    16,
                    17,
                    18,
                    20,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    45,
                    144,
                    225
                ];
                if (event.which === 9 && this.elementValue(element) === "" || $.inArray(event.keyCode, excludedKeys) !== -1) return;
                else if (element.name in this.submitted || element.name in this.invalid) this.element(element);
            },
            onclick: function(element) {
                // Click on selects, radiobuttons and checkboxes
                if (element.name in this.submitted) this.element(element);
                else if (element.parentNode.name in this.submitted) this.element(element.parentNode);
            },
            highlight: function(element, errorClass, validClass) {
                if (element.type === "radio") this.findByName(element.name).addClass(errorClass).removeClass(validClass);
                else $(element).addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
                if (element.type === "radio") this.findByName(element.name).removeClass(errorClass).addClass(validClass);
                else $(element).removeClass(errorClass).addClass(validClass);
            }
        },
        // https://jqueryvalidation.org/jQuery.validator.setDefaults/
        setDefaults: function(settings) {
            $.extend($.validator.defaults, settings);
        },
        messages: {
            required: "This field is required.",
            remote: "Please fix this field.",
            email: "Please enter a valid email address.",
            url: "Please enter a valid URL.",
            date: "Please enter a valid date.",
            dateISO: "Please enter a valid date (ISO).",
            number: "Please enter a valid number.",
            digits: "Please enter only digits.",
            equalTo: "Please enter the same value again.",
            maxlength: $.validator.format("Please enter no more than {0} characters."),
            minlength: $.validator.format("Please enter at least {0} characters."),
            rangelength: $.validator.format("Please enter a value between {0} and {1} characters long."),
            range: $.validator.format("Please enter a value between {0} and {1}."),
            max: $.validator.format("Please enter a value less than or equal to {0}."),
            min: $.validator.format("Please enter a value greater than or equal to {0}."),
            step: $.validator.format("Please enter a multiple of {0}.")
        },
        autoCreateRanges: false,
        prototype: {
            init: function() {
                this.labelContainer = $(this.settings.errorLabelContainer);
                this.errorContext = this.labelContainer.length && this.labelContainer || $(this.currentForm);
                this.containers = $(this.settings.errorContainer).add(this.settings.errorLabelContainer);
                this.submitted = {};
                this.valueCache = {};
                this.pendingRequest = 0;
                this.pending = {};
                this.invalid = {};
                this.reset();
                var currentForm = this.currentForm, groups = this.groups = {}, rules;
                $.each(this.settings.groups, function(key, value) {
                    if (typeof value === "string") value = value.split(/\s/);
                    $.each(value, function(index, name) {
                        groups[name] = key;
                    });
                });
                rules = this.settings.rules;
                $.each(rules, function(key, value) {
                    rules[key] = $.validator.normalizeRule(value);
                });
                function delegate(event) {
                    var isContentEditable = typeof $(this).attr("contenteditable") !== "undefined" && $(this).attr("contenteditable") !== "false";
                    // Set form expando on contenteditable
                    if (!this.form && isContentEditable) {
                        this.form = $(this).closest("form")[0];
                        this.name = $(this).attr("name");
                    }
                    // Ignore the element if it belongs to another form. This will happen mainly
                    // when setting the `form` attribute of an input to the id of another form.
                    if (currentForm !== this.form) return;
                    var validator = $.data(this.form, "validator"), eventType = "on" + event.type.replace(/^validate/, ""), settings = validator.settings;
                    if (settings[eventType] && !$(this).is(settings.ignore)) settings[eventType].call(validator, this, event);
                }
                $(this.currentForm).on("focusin.validate focusout.validate keyup.validate", ":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], [type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], [type='radio'], [type='checkbox'], [contenteditable], [type='button']", delegate)// Support: Chrome, oldIE
                // "select" is provided as event.target when clicking a option
                .on("click.validate", "select, option, [type='radio'], [type='checkbox']", delegate);
                if (this.settings.invalidHandler) $(this.currentForm).on("invalid-form.validate", this.settings.invalidHandler);
            },
            // https://jqueryvalidation.org/Validator.form/
            form: function() {
                this.checkForm();
                $.extend(this.submitted, this.errorMap);
                this.invalid = $.extend({}, this.errorMap);
                if (!this.valid()) $(this.currentForm).triggerHandler("invalid-form", [
                    this
                ]);
                this.showErrors();
                return this.valid();
            },
            checkForm: function() {
                this.prepareForm();
                for(var i = 0, elements = this.currentElements = this.elements(); elements[i]; i++)this.check(elements[i]);
                return this.valid();
            },
            // https://jqueryvalidation.org/Validator.element/
            element: function(element) {
                var cleanElement = this.clean(element), checkElement = this.validationTargetFor(cleanElement), v = this, result = true, rs, group;
                if (checkElement === undefined) delete this.invalid[cleanElement.name];
                else {
                    this.prepareElement(checkElement);
                    this.currentElements = $(checkElement);
                    // If this element is grouped, then validate all group elements already
                    // containing a value
                    group = this.groups[checkElement.name];
                    if (group) $.each(this.groups, function(name, testgroup) {
                        if (testgroup === group && name !== checkElement.name) {
                            cleanElement = v.validationTargetFor(v.clean(v.findByName(name)));
                            if (cleanElement && cleanElement.name in v.invalid) {
                                v.currentElements.push(cleanElement);
                                result = v.check(cleanElement) && result;
                            }
                        }
                    });
                    rs = this.check(checkElement) !== false;
                    result = result && rs;
                    if (rs) this.invalid[checkElement.name] = false;
                    else this.invalid[checkElement.name] = true;
                    if (!this.numberOfInvalids()) // Hide error containers on last error
                    this.toHide = this.toHide.add(this.containers);
                    this.showErrors();
                    // Add aria-invalid status for screen readers
                    $(element).attr("aria-invalid", !rs);
                }
                return result;
            },
            // https://jqueryvalidation.org/Validator.showErrors/
            showErrors: function(errors) {
                if (errors) {
                    var validator = this;
                    // Add items to error list and map
                    $.extend(this.errorMap, errors);
                    this.errorList = $.map(this.errorMap, function(message, name) {
                        return {
                            message: message,
                            element: validator.findByName(name)[0]
                        };
                    });
                    // Remove items from success list
                    this.successList = $.grep(this.successList, function(element) {
                        return !(element.name in errors);
                    });
                }
                if (this.settings.showErrors) this.settings.showErrors.call(this, this.errorMap, this.errorList);
                else this.defaultShowErrors();
            },
            // https://jqueryvalidation.org/Validator.resetForm/
            resetForm: function() {
                if ($.fn.resetForm) $(this.currentForm).resetForm();
                this.invalid = {};
                this.submitted = {};
                this.prepareForm();
                this.hideErrors();
                var elements = this.elements().removeData("previousValue").removeAttr("aria-invalid");
                this.resetElements(elements);
            },
            resetElements: function(elements) {
                var i;
                if (this.settings.unhighlight) for(i = 0; elements[i]; i++){
                    this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, "");
                    this.findByName(elements[i].name).removeClass(this.settings.validClass);
                }
                else elements.removeClass(this.settings.errorClass).removeClass(this.settings.validClass);
            },
            numberOfInvalids: function() {
                return this.objectLength(this.invalid);
            },
            objectLength: function(obj) {
                /* jshint unused: false */ var count = 0, i;
                for(i in obj)// This check allows counting elements with empty error
                // message as invalid elements
                if (obj[i] !== undefined && obj[i] !== null && obj[i] !== false) count++;
                return count;
            },
            hideErrors: function() {
                this.hideThese(this.toHide);
            },
            hideThese: function(errors) {
                errors.not(this.containers).text("");
                this.addWrapper(errors).hide();
            },
            valid: function() {
                return this.size() === 0;
            },
            size: function() {
                return this.errorList.length;
            },
            focusInvalid: function() {
                if (this.settings.focusInvalid) try {
                    $(this.findLastActive() || this.errorList.length && this.errorList[0].element || []).filter(":visible").trigger("focus")// Manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
                    .trigger("focusin");
                } catch (e) {
                // Ignore IE throwing errors when focusing hidden elements
                }
            },
            findLastActive: function() {
                var lastActive = this.lastActive;
                return lastActive && $.grep(this.errorList, function(n) {
                    return n.element.name === lastActive.name;
                }).length === 1 && lastActive;
            },
            elements: function() {
                var validator = this, rulesCache = {};
                // Select all valid inputs inside the form (no submit or reset buttons)
                return $(this.currentForm).find("input, select, textarea, [contenteditable]").not(":submit, :reset, :image, :disabled").not(this.settings.ignore).filter(function() {
                    var name = this.name || $(this).attr("name"); // For contenteditable
                    var isContentEditable = typeof $(this).attr("contenteditable") !== "undefined" && $(this).attr("contenteditable") !== "false";
                    if (!name && validator.settings.debug && window.console) console.error("%o has no name assigned", this);
                    // Set form expando on contenteditable
                    if (isContentEditable) {
                        this.form = $(this).closest("form")[0];
                        this.name = name;
                    }
                    // Ignore elements that belong to other/nested forms
                    if (this.form !== validator.currentForm) return false;
                    // Select only the first element for each name, and only those with rules specified
                    if (name in rulesCache || !validator.objectLength($(this).rules())) return false;
                    rulesCache[name] = true;
                    return true;
                });
            },
            clean: function(selector) {
                return $(selector)[0];
            },
            errors: function() {
                var errorClass = this.settings.errorClass.split(" ").join(".");
                return $(this.settings.errorElement + "." + errorClass, this.errorContext);
            },
            resetInternals: function() {
                this.successList = [];
                this.errorList = [];
                this.errorMap = {};
                this.toShow = $([]);
                this.toHide = $([]);
            },
            reset: function() {
                this.resetInternals();
                this.currentElements = $([]);
            },
            prepareForm: function() {
                this.reset();
                this.toHide = this.errors().add(this.containers);
            },
            prepareElement: function(element) {
                this.reset();
                this.toHide = this.errorsFor(element);
            },
            elementValue: function(element) {
                var $element = $(element), type = element.type, isContentEditable = typeof $element.attr("contenteditable") !== "undefined" && $element.attr("contenteditable") !== "false", val, idx;
                if (type === "radio" || type === "checkbox") return this.findByName(element.name).filter(":checked").val();
                else if (type === "number" && typeof element.validity !== "undefined") return element.validity.badInput ? "NaN" : $element.val();
                if (isContentEditable) val = $element.text();
                else val = $element.val();
                if (type === "file") {
                    // Modern browser (chrome & safari)
                    if (val.substr(0, 12) === "C:\\fakepath\\") return val.substr(12);
                    // Legacy browsers
                    // Unix-based path
                    idx = val.lastIndexOf("/");
                    if (idx >= 0) return val.substr(idx + 1);
                    // Windows-based path
                    idx = val.lastIndexOf("\\");
                    if (idx >= 0) return val.substr(idx + 1);
                    // Just the file name
                    return val;
                }
                if (typeof val === "string") return val.replace(/\r/g, "");
                return val;
            },
            check: function(element) {
                element = this.validationTargetFor(this.clean(element));
                var rules = $(element).rules(), rulesCount = $.map(rules, function(n, i) {
                    return i;
                }).length, dependencyMismatch = false, val = this.elementValue(element), result, method, rule, normalizer;
                // Prioritize the local normalizer defined for this element over the global one
                // if the former exists, otherwise user the global one in case it exists.
                if (typeof rules.normalizer === "function") normalizer = rules.normalizer;
                else if (typeof this.settings.normalizer === "function") normalizer = this.settings.normalizer;
                // If normalizer is defined, then call it to retreive the changed value instead
                // of using the real one.
                // Note that `this` in the normalizer is `element`.
                if (normalizer) {
                    val = normalizer.call(element, val);
                    // Delete the normalizer from rules to avoid treating it as a pre-defined method.
                    delete rules.normalizer;
                }
                for(method in rules){
                    rule = {
                        method: method,
                        parameters: rules[method]
                    };
                    try {
                        result = $.validator.methods[method].call(this, val, element, rule.parameters);
                        // If a method indicates that the field is optional and therefore valid,
                        // don't mark it as valid when there are no other rules
                        if (result === "dependency-mismatch" && rulesCount === 1) {
                            dependencyMismatch = true;
                            continue;
                        }
                        dependencyMismatch = false;
                        if (result === "pending") {
                            this.toHide = this.toHide.not(this.errorsFor(element));
                            return;
                        }
                        if (!result) {
                            this.formatAndAdd(element, rule);
                            return false;
                        }
                    } catch (e) {
                        if (this.settings.debug && window.console) console.log("Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e);
                        if (e instanceof TypeError) e.message += ".  Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.";
                        throw e;
                    }
                }
                if (dependencyMismatch) return;
                if (this.objectLength(rules)) this.successList.push(element);
                return true;
            },
            // Return the custom message for the given element and validation method
            // specified in the element's HTML5 data attribute
            // return the generic message if present and no method specific message is present
            customDataMessage: function(element, method) {
                return $(element).data("msg" + method.charAt(0).toUpperCase() + method.substring(1).toLowerCase()) || $(element).data("msg");
            },
            // Return the custom message for the given element name and validation method
            customMessage: function(name, method) {
                var m = this.settings.messages[name];
                return m && (m.constructor === String ? m : m[method]);
            },
            // Return the first defined argument, allowing empty strings
            findDefined: function() {
                for(var i = 0; i < arguments.length; i++){
                    if (arguments[i] !== undefined) return arguments[i];
                }
                return undefined;
            },
            // The second parameter 'rule' used to be a string, and extended to an object literal
            // of the following form:
            // rule = {
            //     method: "method name",
            //     parameters: "the given method parameters"
            // }
            //
            // The old behavior still supported, kept to maintain backward compatibility with
            // old code, and will be removed in the next major release.
            defaultMessage: function(element, rule) {
                if (typeof rule === "string") rule = {
                    method: rule
                };
                var message = this.findDefined(this.customMessage(element.name, rule.method), this.customDataMessage(element, rule.method), // 'title' is never undefined, so handle empty string as undefined
                !this.settings.ignoreTitle && element.title || undefined, $.validator.messages[rule.method], "<strong>Warning: No message defined for " + element.name + "</strong>"), theregex = /\$?\{(\d+)\}/g;
                if (typeof message === "function") message = message.call(this, rule.parameters, element);
                else if (theregex.test(message)) message = $.validator.format(message.replace(theregex, "{$1}"), rule.parameters);
                return message;
            },
            formatAndAdd: function(element, rule) {
                var message = this.defaultMessage(element, rule);
                this.errorList.push({
                    message: message,
                    element: element,
                    method: rule.method
                });
                this.errorMap[element.name] = message;
                this.submitted[element.name] = message;
            },
            addWrapper: function(toToggle) {
                if (this.settings.wrapper) toToggle = toToggle.add(toToggle.parent(this.settings.wrapper));
                return toToggle;
            },
            defaultShowErrors: function() {
                var i, elements, error;
                for(i = 0; this.errorList[i]; i++){
                    error = this.errorList[i];
                    if (this.settings.highlight) this.settings.highlight.call(this, error.element, this.settings.errorClass, this.settings.validClass);
                    this.showLabel(error.element, error.message);
                }
                if (this.errorList.length) this.toShow = this.toShow.add(this.containers);
                if (this.settings.success) for(i = 0; this.successList[i]; i++)this.showLabel(this.successList[i]);
                if (this.settings.unhighlight) for(i = 0, elements = this.validElements(); elements[i]; i++)this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, this.settings.validClass);
                this.toHide = this.toHide.not(this.toShow);
                this.hideErrors();
                this.addWrapper(this.toShow).show();
            },
            validElements: function() {
                return this.currentElements.not(this.invalidElements());
            },
            invalidElements: function() {
                return $(this.errorList).map(function() {
                    return this.element;
                });
            },
            showLabel: function(element, message) {
                var place, group, errorID, v, error = this.errorsFor(element), elementID = this.idOrName(element), describedBy = $(element).attr("aria-describedby");
                if (error.length) {
                    // Refresh error/success class
                    error.removeClass(this.settings.validClass).addClass(this.settings.errorClass);
                    // Replace message on existing label
                    error.html(message);
                } else {
                    // Create error element
                    error = $("<" + this.settings.errorElement + ">").attr("id", elementID + "-error").addClass(this.settings.errorClass).html(message || "");
                    // Maintain reference to the element to be placed into the DOM
                    place = error;
                    if (this.settings.wrapper) // Make sure the element is visible, even in IE
                    // actually showing the wrapped element is handled elsewhere
                    place = error.hide().show().wrap("<" + this.settings.wrapper + "/>").parent();
                    if (this.labelContainer.length) this.labelContainer.append(place);
                    else if (this.settings.errorPlacement) this.settings.errorPlacement.call(this, place, $(element));
                    else place.insertAfter(element);
                    // Link error back to the element
                    if (error.is("label")) // If the error is a label, then associate using 'for'
                    error.attr("for", elementID);
                    else if (error.parents("label[for='" + this.escapeCssMeta(elementID) + "']").length === 0) {
                        errorID = error.attr("id");
                        // Respect existing non-error aria-describedby
                        if (!describedBy) describedBy = errorID;
                        else if (!describedBy.match(new RegExp("\\b" + this.escapeCssMeta(errorID) + "\\b"))) // Add to end of list if not already present
                        describedBy += " " + errorID;
                        $(element).attr("aria-describedby", describedBy);
                        // If this element is grouped, then assign to all elements in the same group
                        group = this.groups[element.name];
                        if (group) {
                            v = this;
                            $.each(v.groups, function(name, testgroup) {
                                if (testgroup === group) $("[name='" + v.escapeCssMeta(name) + "']", v.currentForm).attr("aria-describedby", error.attr("id"));
                            });
                        }
                    }
                }
                if (!message && this.settings.success) {
                    error.text("");
                    if (typeof this.settings.success === "string") error.addClass(this.settings.success);
                    else this.settings.success(error, element);
                }
                this.toShow = this.toShow.add(error);
            },
            errorsFor: function(element) {
                var name = this.escapeCssMeta(this.idOrName(element)), describer = $(element).attr("aria-describedby"), selector = "label[for='" + name + "'], label[for='" + name + "'] *";
                // 'aria-describedby' should directly reference the error element
                if (describer) selector = selector + ", #" + this.escapeCssMeta(describer).replace(/\s+/g, ", #");
                return this.errors().filter(selector);
            },
            // See https://api.jquery.com/category/selectors/, for CSS
            // meta-characters that should be escaped in order to be used with JQuery
            // as a literal part of a name/id or any selector.
            escapeCssMeta: function(string) {
                if (string === undefined) return "";
                return string.replace(/([\\!"#$%&'()*+,./:;<=>?@\[\]^`{|}~])/g, "\\$1");
            },
            idOrName: function(element) {
                return this.groups[element.name] || (this.checkable(element) ? element.name : element.id || element.name);
            },
            validationTargetFor: function(element) {
                // If radio/checkbox, validate first element in group instead
                if (this.checkable(element)) element = this.findByName(element.name);
                // Always apply ignore filter
                return $(element).not(this.settings.ignore)[0];
            },
            checkable: function(element) {
                return /radio|checkbox/i.test(element.type);
            },
            findByName: function(name) {
                return $(this.currentForm).find("[name='" + this.escapeCssMeta(name) + "']");
            },
            getLength: function(value, element) {
                switch(element.nodeName.toLowerCase()){
                    case "select":
                        return $("option:selected", element).length;
                    case "input":
                        if (this.checkable(element)) return this.findByName(element.name).filter(":checked").length;
                }
                return value.length;
            },
            depend: function(param, element) {
                return this.dependTypes[typeof param] ? this.dependTypes[typeof param](param, element) : true;
            },
            dependTypes: {
                "boolean": function(param) {
                    return param;
                },
                "string": function(param, element) {
                    return !!$(param, element.form).length;
                },
                "function": function(param, element) {
                    return param(element);
                }
            },
            optional: function(element) {
                var val = this.elementValue(element);
                return !$.validator.methods.required.call(this, val, element) && "dependency-mismatch";
            },
            startRequest: function(element) {
                if (!this.pending[element.name]) {
                    this.pendingRequest++;
                    $(element).addClass(this.settings.pendingClass);
                    this.pending[element.name] = true;
                }
            },
            stopRequest: function(element, valid) {
                this.pendingRequest--;
                // Sometimes synchronization fails, make sure pendingRequest is never < 0
                if (this.pendingRequest < 0) this.pendingRequest = 0;
                delete this.pending[element.name];
                $(element).removeClass(this.settings.pendingClass);
                if (valid && this.pendingRequest === 0 && this.formSubmitted && this.form() && this.pendingRequest === 0) {
                    $(this.currentForm).trigger("submit");
                    // Remove the hidden input that was used as a replacement for the
                    // missing submit button. The hidden input is added by `handle()`
                    // to ensure that the value of the used submit button is passed on
                    // for scripted submits triggered by this method
                    if (this.submitButton) $("input:hidden[name='" + this.submitButton.name + "']", this.currentForm).remove();
                    this.formSubmitted = false;
                } else if (!valid && this.pendingRequest === 0 && this.formSubmitted) {
                    $(this.currentForm).triggerHandler("invalid-form", [
                        this
                    ]);
                    this.formSubmitted = false;
                }
            },
            previousValue: function(element, method) {
                method = typeof method === "string" && method || "remote";
                return $.data(element, "previousValue") || $.data(element, "previousValue", {
                    old: null,
                    valid: true,
                    message: this.defaultMessage(element, {
                        method: method
                    })
                });
            },
            // Cleans up all forms and elements, removes validator-specific events
            destroy: function() {
                this.resetForm();
                $(this.currentForm).off(".validate").removeData("validator").find(".validate-equalTo-blur").off(".validate-equalTo").removeClass("validate-equalTo-blur").find(".validate-lessThan-blur").off(".validate-lessThan").removeClass("validate-lessThan-blur").find(".validate-lessThanEqual-blur").off(".validate-lessThanEqual").removeClass("validate-lessThanEqual-blur").find(".validate-greaterThanEqual-blur").off(".validate-greaterThanEqual").removeClass("validate-greaterThanEqual-blur").find(".validate-greaterThan-blur").off(".validate-greaterThan").removeClass("validate-greaterThan-blur");
            }
        },
        classRuleSettings: {
            required: {
                required: true
            },
            email: {
                email: true
            },
            url: {
                url: true
            },
            date: {
                date: true
            },
            dateISO: {
                dateISO: true
            },
            number: {
                number: true
            },
            digits: {
                digits: true
            },
            creditcard: {
                creditcard: true
            }
        },
        addClassRules: function(className, rules) {
            if (className.constructor === String) this.classRuleSettings[className] = rules;
            else $.extend(this.classRuleSettings, className);
        },
        classRules: function(element) {
            var rules = {}, classes = $(element).attr("class");
            if (classes) $.each(classes.split(" "), function() {
                if (this in $.validator.classRuleSettings) $.extend(rules, $.validator.classRuleSettings[this]);
            });
            return rules;
        },
        normalizeAttributeRule: function(rules, type, method, value) {
            // Convert the value to a number for number inputs, and for text for backwards compability
            // allows type="date" and others to be compared as strings
            if (/min|max|step/.test(method) && (type === null || /number|range|text/.test(type))) {
                value = Number(value);
                // Support Opera Mini, which returns NaN for undefined minlength
                if (isNaN(value)) value = undefined;
            }
            if (value || value === 0) rules[method] = value;
            else if (type === method && type !== "range") // Exception: the jquery validate 'range' method
            // does not test for the html5 'range' type
            rules[type === "date" ? "dateISO" : method] = true;
        },
        attributeRules: function(element) {
            var rules = {}, $element = $(element), type = element.getAttribute("type"), method, value;
            for(method in $.validator.methods){
                // Support for <input required> in both html5 and older browsers
                if (method === "required") {
                    value = element.getAttribute(method);
                    // Some browsers return an empty string for the required attribute
                    // and non-HTML5 browsers might have required="" markup
                    if (value === "") value = true;
                    // Force non-HTML5 browsers to return bool
                    value = !!value;
                } else value = $element.attr(method);
                this.normalizeAttributeRule(rules, type, method, value);
            }
            // 'maxlength' may be returned as -1, 2147483647 ( IE ) and 524288 ( safari ) for text inputs
            if (rules.maxlength && /-1|2147483647|524288/.test(rules.maxlength)) delete rules.maxlength;
            return rules;
        },
        dataRules: function(element) {
            var rules = {}, $element = $(element), type = element.getAttribute("type"), method, value;
            for(method in $.validator.methods){
                value = $element.data("rule" + method.charAt(0).toUpperCase() + method.substring(1).toLowerCase());
                // Cast empty attributes like `data-rule-required` to `true`
                if (value === "") value = true;
                this.normalizeAttributeRule(rules, type, method, value);
            }
            return rules;
        },
        staticRules: function(element) {
            var rules = {}, validator = $.data(element.form, "validator");
            if (validator.settings.rules) rules = $.validator.normalizeRule(validator.settings.rules[element.name]) || {};
            return rules;
        },
        normalizeRules: function(rules, element) {
            // Handle dependency check
            $.each(rules, function(prop, val) {
                // Ignore rule when param is explicitly false, eg. required:false
                if (val === false) {
                    delete rules[prop];
                    return;
                }
                if (val.param || val.depends) {
                    var keepRule = true;
                    switch(typeof val.depends){
                        case "string":
                            keepRule = !!$(val.depends, element.form).length;
                            break;
                        case "function":
                            keepRule = val.depends.call(element, element);
                            break;
                    }
                    if (keepRule) rules[prop] = val.param !== undefined ? val.param : true;
                    else {
                        $.data(element.form, "validator").resetElements($(element));
                        delete rules[prop];
                    }
                }
            });
            // Evaluate parameters
            $.each(rules, function(rule, parameter) {
                rules[rule] = typeof parameter === "function" && rule !== "normalizer" ? parameter(element) : parameter;
            });
            // Clean number parameters
            $.each([
                "minlength",
                "maxlength"
            ], function() {
                if (rules[this]) rules[this] = Number(rules[this]);
            });
            $.each([
                "rangelength",
                "range"
            ], function() {
                var parts;
                if (rules[this]) {
                    if (Array.isArray(rules[this])) rules[this] = [
                        Number(rules[this][0]),
                        Number(rules[this][1])
                    ];
                    else if (typeof rules[this] === "string") {
                        parts = rules[this].replace(/[\[\]]/g, "").split(/[\s,]+/);
                        rules[this] = [
                            Number(parts[0]),
                            Number(parts[1])
                        ];
                    }
                }
            });
            if ($.validator.autoCreateRanges) {
                // Auto-create ranges
                if (rules.min != null && rules.max != null) {
                    rules.range = [
                        rules.min,
                        rules.max
                    ];
                    delete rules.min;
                    delete rules.max;
                }
                if (rules.minlength != null && rules.maxlength != null) {
                    rules.rangelength = [
                        rules.minlength,
                        rules.maxlength
                    ];
                    delete rules.minlength;
                    delete rules.maxlength;
                }
            }
            return rules;
        },
        // Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
        normalizeRule: function(data) {
            if (typeof data === "string") {
                var transformed = {};
                $.each(data.split(/\s/), function() {
                    transformed[this] = true;
                });
                data = transformed;
            }
            return data;
        },
        // https://jqueryvalidation.org/jQuery.validator.addMethod/
        addMethod: function(name, method, message) {
            $.validator.methods[name] = method;
            $.validator.messages[name] = message !== undefined ? message : $.validator.messages[name];
            if (method.length < 3) $.validator.addClassRules(name, $.validator.normalizeRule(name));
        },
        // https://jqueryvalidation.org/jQuery.validator.methods/
        methods: {
            // https://jqueryvalidation.org/required-method/
            required: function(value, element, param) {
                // Check if dependency is met
                if (!this.depend(param, element)) return "dependency-mismatch";
                if (element.nodeName.toLowerCase() === "select") {
                    // Could be an array for select-multiple or a string, both are fine this way
                    var val = $(element).val();
                    return val && val.length > 0;
                }
                if (this.checkable(element)) return this.getLength(value, element) > 0;
                return value !== undefined && value !== null && value.length > 0;
            },
            // https://jqueryvalidation.org/email-method/
            email: function(value, element) {
                // From https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address
                // Retrieved 2014-01-14
                // If you have a problem with this implementation, report a bug against the above spec
                // Or use custom methods to implement your own email validation
                return this.optional(element) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value);
            },
            // https://jqueryvalidation.org/url-method/
            url: function(value, element) {
                // Copyright (c) 2010-2013 Diego Perini, MIT licensed
                // https://gist.github.com/dperini/729294
                // see also https://mathiasbynens.be/demo/url-regex
                // modified to allow protocol-relative URLs
                return this.optional(element) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})+(?::(?:[^\]\[?\/<~#`!@$^&*()+=}|:";',>{ ]|%[0-9A-Fa-f]{2})*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
            },
            // https://jqueryvalidation.org/date-method/
            date: function() {
                var called = false;
                return function(value, element) {
                    if (!called) {
                        called = true;
                        if (this.settings.debug && window.console) console.warn("The `date` method is deprecated and will be removed in version '2.0.0'.\nPlease don't use it, since it relies on the Date constructor, which\nbehaves very differently across browsers and locales. Use `dateISO`\ninstead or one of the locale specific methods in `localizations/`\nand `additional-methods.js`.");
                    }
                    return this.optional(element) || !/Invalid|NaN/.test(new Date(value).toString());
                };
            }(),
            // https://jqueryvalidation.org/dateISO-method/
            dateISO: function(value, element) {
                return this.optional(element) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(value);
            },
            // https://jqueryvalidation.org/number-method/
            number: function(value, element) {
                return this.optional(element) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value);
            },
            // https://jqueryvalidation.org/digits-method/
            digits: function(value, element) {
                return this.optional(element) || /^\d+$/.test(value);
            },
            // https://jqueryvalidation.org/minlength-method/
            minlength: function(value, element, param) {
                var length = Array.isArray(value) ? value.length : this.getLength(value, element);
                return this.optional(element) || length >= param;
            },
            // https://jqueryvalidation.org/maxlength-method/
            maxlength: function(value, element, param) {
                var length = Array.isArray(value) ? value.length : this.getLength(value, element);
                return this.optional(element) || length <= param;
            },
            // https://jqueryvalidation.org/rangelength-method/
            rangelength: function(value, element, param) {
                var length = Array.isArray(value) ? value.length : this.getLength(value, element);
                return this.optional(element) || length >= param[0] && length <= param[1];
            },
            // https://jqueryvalidation.org/min-method/
            min: function(value, element, param) {
                return this.optional(element) || value >= param;
            },
            // https://jqueryvalidation.org/max-method/
            max: function(value, element, param) {
                return this.optional(element) || value <= param;
            },
            // https://jqueryvalidation.org/range-method/
            range: function(value, element, param) {
                return this.optional(element) || value >= param[0] && value <= param[1];
            },
            // https://jqueryvalidation.org/step-method/
            step: function(value, element, param) {
                var type = $(element).attr("type"), errorMessage = "Step attribute on input type " + type + " is not supported.", supportedTypes = [
                    "text",
                    "number",
                    "range"
                ], re = new RegExp("\\b" + type + "\\b"), notSupported = type && !re.test(supportedTypes.join()), decimalPlaces = function(num) {
                    var match = ("" + num).match(/(?:\.(\d+))?$/);
                    if (!match) return 0;
                    // Number of digits right of decimal point.
                    return match[1] ? match[1].length : 0;
                }, toInt = function(num) {
                    return Math.round(num * Math.pow(10, decimals));
                }, valid = true, decimals;
                // Works only for text, number and range input types
                // TODO find a way to support input types date, datetime, datetime-local, month, time and week
                if (notSupported) throw new Error(errorMessage);
                decimals = decimalPlaces(param);
                // Value can't have too many decimals
                if (decimalPlaces(value) > decimals || toInt(value) % toInt(param) !== 0) valid = false;
                return this.optional(element) || valid;
            },
            // https://jqueryvalidation.org/equalTo-method/
            equalTo: function(value, element, param) {
                // Bind to the blur event of the target in order to revalidate whenever the target field is updated
                var target = $(param);
                if (this.settings.onfocusout && target.not(".validate-equalTo-blur").length) target.addClass("validate-equalTo-blur").on("blur.validate-equalTo", function() {
                    $(element).valid();
                });
                return value === target.val();
            },
            // https://jqueryvalidation.org/remote-method/
            remote: function(value, element, param, method) {
                if (this.optional(element)) return "dependency-mismatch";
                method = typeof method === "string" && method || "remote";
                var previous = this.previousValue(element, method), validator, data, optionDataString;
                if (!this.settings.messages[element.name]) this.settings.messages[element.name] = {};
                previous.originalMessage = previous.originalMessage || this.settings.messages[element.name][method];
                this.settings.messages[element.name][method] = previous.message;
                param = typeof param === "string" && {
                    url: param
                } || param;
                optionDataString = $.param($.extend({
                    data: value
                }, param.data));
                if (previous.old === optionDataString) return previous.valid;
                previous.old = optionDataString;
                validator = this;
                this.startRequest(element);
                data = {};
                data[element.name] = value;
                $.ajax($.extend(true, {
                    mode: "abort",
                    port: "validate" + element.name,
                    dataType: "json",
                    data: data,
                    context: validator.currentForm,
                    success: function(response) {
                        var valid = response === true || response === "true", errors, message, submitted;
                        validator.settings.messages[element.name][method] = previous.originalMessage;
                        if (valid) {
                            submitted = validator.formSubmitted;
                            validator.resetInternals();
                            validator.toHide = validator.errorsFor(element);
                            validator.formSubmitted = submitted;
                            validator.successList.push(element);
                            validator.invalid[element.name] = false;
                            validator.showErrors();
                        } else {
                            errors = {};
                            message = response || validator.defaultMessage(element, {
                                method: method,
                                parameters: value
                            });
                            errors[element.name] = previous.message = message;
                            validator.invalid[element.name] = true;
                            validator.showErrors(errors);
                        }
                        previous.valid = valid;
                        validator.stopRequest(element, valid);
                    }
                }, param));
                return "pending";
            }
        }
    });
    // Ajax mode: abort
    // usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
    // if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()
    var pendingRequests = {}, ajax;
    // Use a prefilter if available (1.5+)
    if ($.ajaxPrefilter) $.ajaxPrefilter(function(settings, _, xhr) {
        var port = settings.port;
        if (settings.mode === "abort") {
            if (pendingRequests[port]) pendingRequests[port].abort();
            pendingRequests[port] = xhr;
        }
    });
    else {
        // Proxy ajax
        ajax = $.ajax;
        $.ajax = function(settings) {
            var mode = ("mode" in settings ? settings : $.ajaxSettings).mode, port = ("port" in settings ? settings : $.ajaxSettings).port;
            if (mode === "abort") {
                if (pendingRequests[port]) pendingRequests[port].abort();
                pendingRequests[port] = ajax.apply(this, arguments);
                return pendingRequests[port];
            }
            return ajax.apply(this, arguments);
        };
    }
    return $;
});

});

//Jquery

var $k7705 = parcelRequire("k7705");
//Support for safari 12.1 and below
if (typeof $175aa37981e22611$var$globalThis === "undefined") var $175aa37981e22611$var$globalThis = Function("return this")();
$175aa37981e22611$var$globalThis.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($k7705)));



var $k7705 = parcelRequire("k7705");
parcelRequire("eye48");
var $a1e924ddae77fec1$exports = {};

// Unobtrusive validation support library for jQuery and jQuery Validate
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// @version v3.2.12
/*jslint white: true, browser: true, onevar: true, undef: true, nomen: true, eqeqeq: true, plusplus: true, bitwise: true, regexp: true, newcap: true, immed: true, strict: false */ /*global document: false, jQuery: false */ (function(factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define("jquery.validate.unobtrusive", [
        "jquery-validation"
    ], factory);
    else if (0, $a1e924ddae77fec1$exports) // CommonJS-like environments that support module.exports     
    $a1e924ddae77fec1$exports = factory((parcelRequire("eye48")));
    else // Browser global
    jQuery.validator.unobtrusive = factory(jQuery);
})(function($) {
    var $jQval = $.validator, adapters, data_validation = "unobtrusiveValidation";
    function setValidationValues(options, ruleName, value) {
        options.rules[ruleName] = value;
        if (options.message) options.messages[ruleName] = options.message;
    }
    function splitAndTrim(value) {
        return value.replace(/^\s+|\s+$/g, "").split(/\s*,\s*/g);
    }
    function escapeAttributeValue(value) {
        // As mentioned on http://api.jquery.com/category/selectors/
        return value.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, "\\$1");
    }
    function getModelPrefix(fieldName) {
        return fieldName.substr(0, fieldName.lastIndexOf(".") + 1);
    }
    function appendModelPrefix(value, prefix) {
        if (value.indexOf("*.") === 0) value = value.replace("*.", prefix);
        return value;
    }
    function onError(error, inputElement) {
        var container = $(this).find("[data-valmsg-for='" + escapeAttributeValue(inputElement[0].name) + "']"), replaceAttrValue = container.attr("data-valmsg-replace"), replace = replaceAttrValue ? $.parseJSON(replaceAttrValue) !== false : null;
        container.removeClass("field-validation-valid").addClass("field-validation-error");
        error.data("unobtrusiveContainer", container);
        if (replace) {
            container.empty();
            error.removeClass("input-validation-error").appendTo(container);
        } else error.hide();
    }
    function onErrors(event, validator) {
        var container = $(this).find("[data-valmsg-summary=true]"), list = container.find("ul");
        if (list && list.length && validator.errorList.length) {
            list.empty();
            container.addClass("validation-summary-errors").removeClass("validation-summary-valid");
            $.each(validator.errorList, function() {
                $("<li />").html(this.message).appendTo(list);
            });
        }
    }
    function onSuccess(error) {
        var container = error.data("unobtrusiveContainer");
        if (container) {
            var replaceAttrValue = container.attr("data-valmsg-replace"), replace = replaceAttrValue ? $.parseJSON(replaceAttrValue) : null;
            container.addClass("field-validation-valid").removeClass("field-validation-error");
            error.removeData("unobtrusiveContainer");
            if (replace) container.empty();
        }
    }
    function onReset(event) {
        var $form = $(this), key = "__jquery_unobtrusive_validation_form_reset";
        if ($form.data(key)) return;
        // Set a flag that indicates we're currently resetting the form.
        $form.data(key, true);
        try {
            $form.data("validator").resetForm();
        } finally{
            $form.removeData(key);
        }
        $form.find(".validation-summary-errors").addClass("validation-summary-valid").removeClass("validation-summary-errors");
        $form.find(".field-validation-error").addClass("field-validation-valid").removeClass("field-validation-error").removeData("unobtrusiveContainer").find(">*") // If we were using valmsg-replace, get the underlying error
        .removeData("unobtrusiveContainer");
    }
    function validationInfo(form) {
        var $form = $(form), result = $form.data(data_validation), onResetProxy = $.proxy(onReset, form), defaultOptions = $jQval.unobtrusive.options || {}, execInContext = function(name, args) {
            var func = defaultOptions[name];
            func && $.isFunction(func) && func.apply(form, args);
        };
        if (!result) {
            result = {
                options: {
                    errorClass: defaultOptions.errorClass || "input-validation-error",
                    errorElement: defaultOptions.errorElement || "span",
                    errorPlacement: function() {
                        onError.apply(form, arguments);
                        execInContext("errorPlacement", arguments);
                    },
                    invalidHandler: function() {
                        onErrors.apply(form, arguments);
                        execInContext("invalidHandler", arguments);
                    },
                    messages: {},
                    rules: {},
                    success: function() {
                        onSuccess.apply(form, arguments);
                        execInContext("success", arguments);
                    }
                },
                attachValidation: function() {
                    $form.off("reset." + data_validation, onResetProxy).on("reset." + data_validation, onResetProxy).validate(this.options);
                },
                validate: function() {
                    $form.validate();
                    return $form.valid();
                }
            };
            $form.data(data_validation, result);
        }
        return result;
    }
    $jQval.unobtrusive = {
        adapters: [],
        parseElement: function(element, skipAttach) {
            /// <summary>
            /// Parses a single HTML element for unobtrusive validation attributes.
            /// </summary>
            /// <param name="element" domElement="true">The HTML element to be parsed.</param>
            /// <param name="skipAttach" type="Boolean">[Optional] true to skip attaching the
            /// validation to the form. If parsing just this single element, you should specify true.
            /// If parsing several elements, you should specify false, and manually attach the validation
            /// to the form when you are finished. The default is false.</param>
            var $element = $(element), form = $element.parents("form")[0], valInfo, rules, messages;
            if (!form) return;
            valInfo = validationInfo(form);
            valInfo.options.rules[element.name] = rules = {};
            valInfo.options.messages[element.name] = messages = {};
            $.each(this.adapters, function() {
                var prefix = "data-val-" + this.name, message = $element.attr(prefix), paramValues = {};
                if (message !== undefined) {
                    prefix += "-";
                    $.each(this.params, function() {
                        paramValues[this] = $element.attr(prefix + this);
                    });
                    this.adapt({
                        element: element,
                        form: form,
                        message: message,
                        params: paramValues,
                        rules: rules,
                        messages: messages
                    });
                }
            });
            $.extend(rules, {
                "__dummy__": true
            });
            if (!skipAttach) valInfo.attachValidation();
        },
        parse: function(selector) {
            /// <summary>
            /// Parses all the HTML elements in the specified selector. It looks for input elements decorated
            /// with the [data-val=true] attribute value and enables validation according to the data-val-*
            /// attribute values.
            /// </summary>
            /// <param name="selector" type="String">Any valid jQuery selector.</param>
            // $forms includes all forms in selector's DOM hierarchy (parent, children and self) that have at least one
            // element with data-val=true
            var $selector = $(selector), $forms = $selector.parents().addBack().filter("form").add($selector.find("form")).has("[data-val=true]");
            $selector.find("[data-val=true]").each(function() {
                $jQval.unobtrusive.parseElement(this, true);
            });
            $forms.each(function() {
                var info = validationInfo(this);
                if (info) info.attachValidation();
            });
        }
    };
    adapters = $jQval.unobtrusive.adapters;
    adapters.add = function(adapterName, params, fn) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
        /// <param name="params" type="Array" optional="true">[Optional] An array of parameter names (strings) that will
        /// be extracted from the data-val-nnnn-mmmm HTML attributes (where nnnn is the adapter name, and
        /// mmmm is the parameter name).</param>
        /// <param name="fn" type="Function">The function to call, which adapts the values from the HTML
        /// attributes into jQuery Validate rules and/or messages.</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        if (!fn) {
            fn = params;
            params = [];
        }
        this.push({
            name: adapterName,
            params: params,
            adapt: fn
        });
        return this;
    };
    adapters.addBool = function(adapterName, ruleName) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
        /// the jQuery Validate validation rule has no parameter values.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
        /// <param name="ruleName" type="String" optional="true">[Optional] The name of the jQuery Validate rule. If not provided, the value
        /// of adapterName will be used instead.</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        return this.add(adapterName, function(options) {
            setValidationValues(options, ruleName || adapterName, true);
        });
    };
    adapters.addMinMax = function(adapterName, minRuleName, maxRuleName, minMaxRuleName, minAttribute, maxAttribute) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
        /// the jQuery Validate validation has three potential rules (one for min-only, one for max-only, and
        /// one for min-and-max). The HTML parameters are expected to be named -min and -max.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
        /// <param name="minRuleName" type="String">The name of the jQuery Validate rule to be used when you only
        /// have a minimum value.</param>
        /// <param name="maxRuleName" type="String">The name of the jQuery Validate rule to be used when you only
        /// have a maximum value.</param>
        /// <param name="minMaxRuleName" type="String">The name of the jQuery Validate rule to be used when you
        /// have both a minimum and maximum value.</param>
        /// <param name="minAttribute" type="String" optional="true">[Optional] The name of the HTML attribute that
        /// contains the minimum value. The default is "min".</param>
        /// <param name="maxAttribute" type="String" optional="true">[Optional] The name of the HTML attribute that
        /// contains the maximum value. The default is "max".</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        return this.add(adapterName, [
            minAttribute || "min",
            maxAttribute || "max"
        ], function(options) {
            var min = options.params.min, max = options.params.max;
            if (min && max) setValidationValues(options, minMaxRuleName, [
                min,
                max
            ]);
            else if (min) setValidationValues(options, minRuleName, min);
            else if (max) setValidationValues(options, maxRuleName, max);
        });
    };
    adapters.addSingleVal = function(adapterName, attribute, ruleName) {
        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
        /// the jQuery Validate validation rule has a single value.</summary>
        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
        /// in the data-val-nnnn HTML attribute(where nnnn is the adapter name).</param>
        /// <param name="attribute" type="String">[Optional] The name of the HTML attribute that contains the value.
        /// The default is "val".</param>
        /// <param name="ruleName" type="String" optional="true">[Optional] The name of the jQuery Validate rule. If not provided, the value
        /// of adapterName will be used instead.</param>
        /// <returns type="jQuery.validator.unobtrusive.adapters" />
        return this.add(adapterName, [
            attribute || "val"
        ], function(options) {
            setValidationValues(options, ruleName || adapterName, options.params[attribute]);
        });
    };
    $jQval.addMethod("__dummy__", function(value, element, params) {
        return true;
    });
    $jQval.addMethod("regex", function(value, element, params) {
        var match;
        if (this.optional(element)) return true;
        match = new RegExp(params).exec(value);
        return match && match.index === 0 && match[0].length === value.length;
    });
    $jQval.addMethod("nonalphamin", function(value, element, nonalphamin) {
        var match;
        if (nonalphamin) {
            match = value.match(/\W/g);
            match = match && match.length >= nonalphamin;
        }
        return match;
    });
    if ($jQval.methods.extension) {
        adapters.addSingleVal("accept", "mimtype");
        adapters.addSingleVal("extension", "extension");
    } else // for backward compatibility, when the 'extension' validation method does not exist, such as with versions
    // of JQuery Validation plugin prior to 1.10, we should use the 'accept' method for
    // validating the extension, and ignore mime-type validations as they are not supported.
    adapters.addSingleVal("extension", "extension", "accept");
    adapters.addSingleVal("regex", "pattern");
    adapters.addBool("creditcard").addBool("date").addBool("digits").addBool("email").addBool("number").addBool("url");
    adapters.addMinMax("length", "minlength", "maxlength", "rangelength").addMinMax("range", "min", "max", "range");
    adapters.addMinMax("minlength", "minlength").addMinMax("maxlength", "minlength", "maxlength");
    adapters.add("equalto", [
        "other"
    ], function(options) {
        var prefix = getModelPrefix(options.element.name), other = options.params.other, fullOtherName = appendModelPrefix(other, prefix), element = $(options.form).find(":input").filter("[name='" + escapeAttributeValue(fullOtherName) + "']")[0];
        setValidationValues(options, "equalTo", element);
    });
    adapters.add("required", function(options) {
        // jQuery Validate equates "required" with "mandatory" for checkbox elements
        if (options.element.tagName.toUpperCase() !== "INPUT" || options.element.type.toUpperCase() !== "CHECKBOX") setValidationValues(options, "required", true);
    });
    adapters.add("remote", [
        "url",
        "type",
        "additionalfields"
    ], function(options) {
        var value = {
            url: options.params.url,
            type: options.params.type || "GET",
            data: {}
        }, prefix = getModelPrefix(options.element.name);
        $.each(splitAndTrim(options.params.additionalfields || options.element.name), function(i, fieldName) {
            var paramName = appendModelPrefix(fieldName, prefix);
            value.data[paramName] = function() {
                var field = $(options.form).find(":input").filter("[name='" + escapeAttributeValue(paramName) + "']");
                // For checkboxes and radio buttons, only pick up values from checked fields.
                if (field.is(":checkbox")) return field.filter(":checked").val() || field.filter(":hidden").val() || "";
                else if (field.is(":radio")) return field.filter(":checked").val() || "";
                return field.val();
            };
        });
        setValidationValues(options, "remote", value);
    });
    adapters.add("password", [
        "min",
        "nonalphamin",
        "regex"
    ], function(options) {
        if (options.params.min) setValidationValues(options, "minlength", options.params.min);
        if (options.params.nonalphamin) setValidationValues(options, "nonalphamin", options.params.nonalphamin);
        if (options.params.regex) setValidationValues(options, "regex", options.params.regex);
    });
    adapters.add("fileextensions", [
        "extensions"
    ], function(options) {
        setValidationValues(options, "extension", options.params.extensions);
    });
    $(function() {
        $jQval.unobtrusive.parse(document);
    });
    return $jQval.unobtrusive;
});


/*!
  * Bootstrap v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $5ebaad8d9c96015f$exports = {};

$parcel$export($5ebaad8d9c96015f$exports, "popperGenerator", function () { return $53a7d16ce2fc7e90$export$ed5e13716264f202; });
$parcel$export($5ebaad8d9c96015f$exports, "detectOverflow", function () { return $9c7320c55d77eeae$export$2e2bcd8739ae039; });
$parcel$export($5ebaad8d9c96015f$exports, "createPopperBase", function () { return $53a7d16ce2fc7e90$export$8f7491d57c8f97a9; });
$parcel$export($5ebaad8d9c96015f$exports, "createPopper", function () { return $cde9fc91dfb666d1$export$8f7491d57c8f97a9; });
$parcel$export($5ebaad8d9c96015f$exports, "createPopperLite", function () { return $762a64d8111e71fa$export$8f7491d57c8f97a9; });
var $b0fa20bf610d91e8$exports = {};

$parcel$export($b0fa20bf610d91e8$exports, "top", function () { return $b0fa20bf610d91e8$export$1e95b668f3b82d; });
$parcel$export($b0fa20bf610d91e8$exports, "bottom", function () { return $b0fa20bf610d91e8$export$40e543e69a8b3fbb; });
$parcel$export($b0fa20bf610d91e8$exports, "right", function () { return $b0fa20bf610d91e8$export$79ffe56a765070d2; });
$parcel$export($b0fa20bf610d91e8$exports, "left", function () { return $b0fa20bf610d91e8$export$eabcd2c8791e7bf4; });
$parcel$export($b0fa20bf610d91e8$exports, "auto", function () { return $b0fa20bf610d91e8$export$dfb5619354ba860; });
$parcel$export($b0fa20bf610d91e8$exports, "basePlacements", function () { return $b0fa20bf610d91e8$export$aec2ce47c367b8c3; });
$parcel$export($b0fa20bf610d91e8$exports, "start", function () { return $b0fa20bf610d91e8$export$b3571188c770cc5a; });
$parcel$export($b0fa20bf610d91e8$exports, "end", function () { return $b0fa20bf610d91e8$export$bd5df0f255a350f8; });
$parcel$export($b0fa20bf610d91e8$exports, "clippingParents", function () { return $b0fa20bf610d91e8$export$390fd549c5303b4d; });
$parcel$export($b0fa20bf610d91e8$exports, "viewport", function () { return $b0fa20bf610d91e8$export$d7b7311ec04a3e8f; });
$parcel$export($b0fa20bf610d91e8$exports, "popper", function () { return $b0fa20bf610d91e8$export$ae5ab1c730825774; });
$parcel$export($b0fa20bf610d91e8$exports, "reference", function () { return $b0fa20bf610d91e8$export$ca50aac9f3ba507f; });
$parcel$export($b0fa20bf610d91e8$exports, "variationPlacements", function () { return $b0fa20bf610d91e8$export$368f9a87e87fa4e1; });
$parcel$export($b0fa20bf610d91e8$exports, "placements", function () { return $b0fa20bf610d91e8$export$803cd8101b6c182b; });
$parcel$export($b0fa20bf610d91e8$exports, "beforeRead", function () { return $b0fa20bf610d91e8$export$421679a7c3d56e; });
$parcel$export($b0fa20bf610d91e8$exports, "read", function () { return $b0fa20bf610d91e8$export$aafa59e2e03f2942; });
$parcel$export($b0fa20bf610d91e8$exports, "afterRead", function () { return $b0fa20bf610d91e8$export$6964f6c886723980; });
$parcel$export($b0fa20bf610d91e8$exports, "beforeMain", function () { return $b0fa20bf610d91e8$export$c65e99957a05207c; });
$parcel$export($b0fa20bf610d91e8$exports, "main", function () { return $b0fa20bf610d91e8$export$f22da7240b7add18; });
$parcel$export($b0fa20bf610d91e8$exports, "afterMain", function () { return $b0fa20bf610d91e8$export$bab79516f2d662fe; });
$parcel$export($b0fa20bf610d91e8$exports, "beforeWrite", function () { return $b0fa20bf610d91e8$export$8d4d2d70e7d46032; });
$parcel$export($b0fa20bf610d91e8$exports, "write", function () { return $b0fa20bf610d91e8$export$68d8715fc104d294; });
$parcel$export($b0fa20bf610d91e8$exports, "afterWrite", function () { return $b0fa20bf610d91e8$export$70a6e5159acce2e6; });
$parcel$export($b0fa20bf610d91e8$exports, "modifierPhases", function () { return $b0fa20bf610d91e8$export$d087d3878fdf71d5; });
var $b0fa20bf610d91e8$export$1e95b668f3b82d = "top";
var $b0fa20bf610d91e8$export$40e543e69a8b3fbb = "bottom";
var $b0fa20bf610d91e8$export$79ffe56a765070d2 = "right";
var $b0fa20bf610d91e8$export$eabcd2c8791e7bf4 = "left";
var $b0fa20bf610d91e8$export$dfb5619354ba860 = "auto";
var $b0fa20bf610d91e8$export$aec2ce47c367b8c3 = [
    $b0fa20bf610d91e8$export$1e95b668f3b82d,
    $b0fa20bf610d91e8$export$40e543e69a8b3fbb,
    $b0fa20bf610d91e8$export$79ffe56a765070d2,
    $b0fa20bf610d91e8$export$eabcd2c8791e7bf4
];
var $b0fa20bf610d91e8$export$b3571188c770cc5a = "start";
var $b0fa20bf610d91e8$export$bd5df0f255a350f8 = "end";
var $b0fa20bf610d91e8$export$390fd549c5303b4d = "clippingParents";
var $b0fa20bf610d91e8$export$d7b7311ec04a3e8f = "viewport";
var $b0fa20bf610d91e8$export$ae5ab1c730825774 = "popper";
var $b0fa20bf610d91e8$export$ca50aac9f3ba507f = "reference";
var $b0fa20bf610d91e8$export$368f9a87e87fa4e1 = /*#__PURE__*/ $b0fa20bf610d91e8$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $b0fa20bf610d91e8$export$b3571188c770cc5a,
        placement + "-" + $b0fa20bf610d91e8$export$bd5df0f255a350f8
    ]);
}, []);
var $b0fa20bf610d91e8$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($b0fa20bf610d91e8$export$aec2ce47c367b8c3, [
    $b0fa20bf610d91e8$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $b0fa20bf610d91e8$export$b3571188c770cc5a,
        placement + "-" + $b0fa20bf610d91e8$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $b0fa20bf610d91e8$export$421679a7c3d56e = "beforeRead";
var $b0fa20bf610d91e8$export$aafa59e2e03f2942 = "read";
var $b0fa20bf610d91e8$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $b0fa20bf610d91e8$export$c65e99957a05207c = "beforeMain";
var $b0fa20bf610d91e8$export$f22da7240b7add18 = "main";
var $b0fa20bf610d91e8$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $b0fa20bf610d91e8$export$8d4d2d70e7d46032 = "beforeWrite";
var $b0fa20bf610d91e8$export$68d8715fc104d294 = "write";
var $b0fa20bf610d91e8$export$70a6e5159acce2e6 = "afterWrite";
var $b0fa20bf610d91e8$export$d087d3878fdf71d5 = [
    $b0fa20bf610d91e8$export$421679a7c3d56e,
    $b0fa20bf610d91e8$export$aafa59e2e03f2942,
    $b0fa20bf610d91e8$export$6964f6c886723980,
    $b0fa20bf610d91e8$export$c65e99957a05207c,
    $b0fa20bf610d91e8$export$f22da7240b7add18,
    $b0fa20bf610d91e8$export$bab79516f2d662fe,
    $b0fa20bf610d91e8$export$8d4d2d70e7d46032,
    $b0fa20bf610d91e8$export$68d8715fc104d294,
    $b0fa20bf610d91e8$export$70a6e5159acce2e6
];


var $694f9bf7602fdae0$exports = {};

$parcel$export($694f9bf7602fdae0$exports, "applyStyles", function () { return $19593d99407d3b67$export$2e2bcd8739ae039; });
$parcel$export($694f9bf7602fdae0$exports, "arrow", function () { return $0f2d8a445a7a0ecc$export$2e2bcd8739ae039; });
$parcel$export($694f9bf7602fdae0$exports, "computeStyles", function () { return $cbf32c3cf3e381c9$export$2e2bcd8739ae039; });
$parcel$export($694f9bf7602fdae0$exports, "eventListeners", function () { return $788edde0355a7239$export$2e2bcd8739ae039; });
$parcel$export($694f9bf7602fdae0$exports, "flip", function () { return $4d82aec99d71dadd$export$2e2bcd8739ae039; });
$parcel$export($694f9bf7602fdae0$exports, "hide", function () { return $3323efb926459725$export$2e2bcd8739ae039; });
$parcel$export($694f9bf7602fdae0$exports, "offset", function () { return $b3969bedbc0192a7$export$2e2bcd8739ae039; });
$parcel$export($694f9bf7602fdae0$exports, "popperOffsets", function () { return $3412dca0cf00c7bb$export$2e2bcd8739ae039; });
$parcel$export($694f9bf7602fdae0$exports, "preventOverflow", function () { return $1b0d084f76133902$export$2e2bcd8739ae039; });
function $6e797f1c3acad9dc$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $2c4362badba08e36$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $6b5f72663863aefe$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2c4362badba08e36$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $6b5f72663863aefe$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2c4362badba08e36$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $6b5f72663863aefe$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $2c4362badba08e36$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $19593d99407d3b67$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $6b5f72663863aefe$export$1b3bfaa9684536aa)(element) || !(0, $6e797f1c3acad9dc$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $19593d99407d3b67$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $6b5f72663863aefe$export$1b3bfaa9684536aa)(element) || !(0, $6e797f1c3acad9dc$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $19593d99407d3b67$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $19593d99407d3b67$var$applyStyles,
    effect: $19593d99407d3b67$var$effect,
    requires: [
        "computeStyles"
    ]
};



function $b41f9e4a4a968585$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}



var $ab783ef444b383f2$export$8960430cfd85939f = Math.max;
var $ab783ef444b383f2$export$96ec731ed4dcb222 = Math.min;
var $ab783ef444b383f2$export$2077e0241d6afd3c = Math.round;



function $3cf86841ae12e62f$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $24ef01af797e1cd1$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $3cf86841ae12e62f$export$2e2bcd8739ae039)());
}


function $5fcc9413926a0bed$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $6b5f72663863aefe$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $ab783ef444b383f2$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $ab783ef444b383f2$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $6b5f72663863aefe$export$45a5e7f76e0caa8d)(element) ? (0, $2c4362badba08e36$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $24ef01af797e1cd1$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $7bbaa7b1a4d287e7$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $5fcc9413926a0bed$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $3a34d8f04021f3b0$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $6b5f72663863aefe$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $deb5991fdf672691$export$2e2bcd8739ae039(element) {
    return (0, $2c4362badba08e36$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $1b49ca8ea463ed28$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $6e797f1c3acad9dc$export$2e2bcd8739ae039)(element)) >= 0;
}




function $a65394726d21110e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $6b5f72663863aefe$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $a3c7da9e67b78ba8$export$2e2bcd8739ae039(element) {
    if ((0, $6e797f1c3acad9dc$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $6b5f72663863aefe$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $a65394726d21110e$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $5c6b59fee47decbb$var$getTrueOffsetParent(element) {
    if (!(0, $6b5f72663863aefe$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $deb5991fdf672691$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $5c6b59fee47decbb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $3cf86841ae12e62f$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $3cf86841ae12e62f$export$2e2bcd8739ae039)());
    if (isIE && (0, $6b5f72663863aefe$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $deb5991fdf672691$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $a3c7da9e67b78ba8$export$2e2bcd8739ae039)(element);
    if ((0, $6b5f72663863aefe$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $6b5f72663863aefe$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $6e797f1c3acad9dc$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $deb5991fdf672691$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $5c6b59fee47decbb$export$2e2bcd8739ae039(element) {
    var window = (0, $2c4362badba08e36$export$2e2bcd8739ae039)(element);
    var offsetParent = $5c6b59fee47decbb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $1b49ca8ea463ed28$export$2e2bcd8739ae039)(offsetParent) && (0, $deb5991fdf672691$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $5c6b59fee47decbb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $6e797f1c3acad9dc$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $6e797f1c3acad9dc$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $deb5991fdf672691$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $5c6b59fee47decbb$var$getContainingBlock(element) || window;
}


function $174cc8719889960e$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $8ac87cae0444a429$export$f28d906d67a997f3(min, value, max) {
    return (0, $ab783ef444b383f2$export$8960430cfd85939f)(min, (0, $ab783ef444b383f2$export$96ec731ed4dcb222)(value, max));
}
function $8ac87cae0444a429$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $8ac87cae0444a429$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $9f20b2ce00b91c0c$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $289dbbad22d010a3$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $9f20b2ce00b91c0c$export$2e2bcd8739ae039)(), paddingObject);
}


function $69c41ead971cfc5d$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $0f2d8a445a7a0ecc$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $289dbbad22d010a3$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $69c41ead971cfc5d$export$2e2bcd8739ae039)(padding, (0, $b0fa20bf610d91e8$export$aec2ce47c367b8c3)));
};
function $0f2d8a445a7a0ecc$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $b41f9e4a4a968585$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $174cc8719889960e$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $b0fa20bf610d91e8$export$eabcd2c8791e7bf4),
        (0, $b0fa20bf610d91e8$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0f2d8a445a7a0ecc$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $7bbaa7b1a4d287e7$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $b0fa20bf610d91e8$export$1e95b668f3b82d) : (0, $b0fa20bf610d91e8$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $b0fa20bf610d91e8$export$40e543e69a8b3fbb) : (0, $b0fa20bf610d91e8$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5c6b59fee47decbb$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $8ac87cae0444a429$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0f2d8a445a7a0ecc$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $3a34d8f04021f3b0$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0f2d8a445a7a0ecc$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $0f2d8a445a7a0ecc$var$arrow,
    effect: $0f2d8a445a7a0ecc$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $32f6b154a39fb70a$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $cbf32c3cf3e381c9$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $cbf32c3cf3e381c9$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $ab783ef444b383f2$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $ab783ef444b383f2$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $cbf32c3cf3e381c9$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $b0fa20bf610d91e8$export$eabcd2c8791e7bf4);
    var sideY = (0, $b0fa20bf610d91e8$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5c6b59fee47decbb$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $2c4362badba08e36$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $a65394726d21110e$export$2e2bcd8739ae039)(popper);
            if ((0, $deb5991fdf672691$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $b0fa20bf610d91e8$export$1e95b668f3b82d) || (placement === (0, $b0fa20bf610d91e8$export$eabcd2c8791e7bf4) || placement === (0, $b0fa20bf610d91e8$export$79ffe56a765070d2)) && variation === (0, $b0fa20bf610d91e8$export$bd5df0f255a350f8)) {
            sideY = (0, $b0fa20bf610d91e8$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $b0fa20bf610d91e8$export$eabcd2c8791e7bf4) || (placement === (0, $b0fa20bf610d91e8$export$1e95b668f3b82d) || placement === (0, $b0fa20bf610d91e8$export$40e543e69a8b3fbb)) && variation === (0, $b0fa20bf610d91e8$export$bd5df0f255a350f8)) {
            sideX = (0, $b0fa20bf610d91e8$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $cbf32c3cf3e381c9$var$unsetSides);
    var _ref4 = roundOffsets === true ? $cbf32c3cf3e381c9$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2c4362badba08e36$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $cbf32c3cf3e381c9$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $b41f9e4a4a968585$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $32f6b154a39fb70a$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $cbf32c3cf3e381c9$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $cbf32c3cf3e381c9$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $cbf32c3cf3e381c9$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $cbf32c3cf3e381c9$var$computeStyles,
    data: {}
};



var $788edde0355a7239$var$passive = {
    passive: true
};
function $788edde0355a7239$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2c4362badba08e36$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $788edde0355a7239$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $788edde0355a7239$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $788edde0355a7239$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $788edde0355a7239$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $788edde0355a7239$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $788edde0355a7239$var$effect,
    data: {}
};


var $42197a31bce61e2a$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $42197a31bce61e2a$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $42197a31bce61e2a$var$hash[matched];
    });
}



var $d6b7f7451377d482$var$hash = {
    start: "end",
    end: "start"
};
function $d6b7f7451377d482$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $d6b7f7451377d482$var$hash[matched];
    });
}








function $c33081f4f4848b00$export$2e2bcd8739ae039(node) {
    var win = (0, $2c4362badba08e36$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $e93a8292968f6e40$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $5fcc9413926a0bed$export$2e2bcd8739ae039)((0, $a65394726d21110e$export$2e2bcd8739ae039)(element)).left + (0, $c33081f4f4848b00$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $3365690c6fec9b41$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2c4362badba08e36$export$2e2bcd8739ae039)(element);
    var html = (0, $a65394726d21110e$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $24ef01af797e1cd1$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e93a8292968f6e40$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $7c8e33dfcc7f4504$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $a65394726d21110e$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $c33081f4f4848b00$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $ab783ef444b383f2$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $ab783ef444b383f2$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e93a8292968f6e40$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $deb5991fdf672691$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $ab783ef444b383f2$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $667e0df33a541a1b$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $deb5991fdf672691$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $befefaa8ae1f5fb6$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $6e797f1c3acad9dc$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $6b5f72663863aefe$export$1b3bfaa9684536aa)(node) && (0, $667e0df33a541a1b$export$2e2bcd8739ae039)(node)) return node;
    return $befefaa8ae1f5fb6$export$2e2bcd8739ae039((0, $a3c7da9e67b78ba8$export$2e2bcd8739ae039)(node));
}





function $ebbf647fbc65c6bd$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $befefaa8ae1f5fb6$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2c4362badba08e36$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $667e0df33a541a1b$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($ebbf647fbc65c6bd$export$2e2bcd8739ae039((0, $a3c7da9e67b78ba8$export$2e2bcd8739ae039)(target)));
}










function $c2115c996b3bae14$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $baaa8e48e91800a4$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $5fcc9413926a0bed$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $baaa8e48e91800a4$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $b0fa20bf610d91e8$export$d7b7311ec04a3e8f) ? (0, $c2115c996b3bae14$export$2e2bcd8739ae039)((0, $3365690c6fec9b41$export$2e2bcd8739ae039)(element, strategy)) : (0, $6b5f72663863aefe$export$45a5e7f76e0caa8d)(clippingParent) ? $baaa8e48e91800a4$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $c2115c996b3bae14$export$2e2bcd8739ae039)((0, $7c8e33dfcc7f4504$export$2e2bcd8739ae039)((0, $a65394726d21110e$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $baaa8e48e91800a4$var$getClippingParents(element) {
    var clippingParents = (0, $ebbf647fbc65c6bd$export$2e2bcd8739ae039)((0, $a3c7da9e67b78ba8$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $deb5991fdf672691$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $6b5f72663863aefe$export$1b3bfaa9684536aa)(element) ? (0, $5c6b59fee47decbb$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $6b5f72663863aefe$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $6b5f72663863aefe$export$45a5e7f76e0caa8d)(clippingParent) && (0, $3a34d8f04021f3b0$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $6e797f1c3acad9dc$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $baaa8e48e91800a4$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $baaa8e48e91800a4$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $baaa8e48e91800a4$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $ab783ef444b383f2$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $ab783ef444b383f2$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $ab783ef444b383f2$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $ab783ef444b383f2$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $baaa8e48e91800a4$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $013f06915154a3e3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $b41f9e4a4a968585$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $32f6b154a39fb70a$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $b0fa20bf610d91e8$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $b0fa20bf610d91e8$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $b0fa20bf610d91e8$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $b0fa20bf610d91e8$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $174cc8719889960e$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $b0fa20bf610d91e8$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $b0fa20bf610d91e8$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $9c7320c55d77eeae$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $b0fa20bf610d91e8$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $b0fa20bf610d91e8$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $b0fa20bf610d91e8$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $289dbbad22d010a3$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $69c41ead971cfc5d$export$2e2bcd8739ae039)(padding, (0, $b0fa20bf610d91e8$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $b0fa20bf610d91e8$export$ae5ab1c730825774) ? (0, $b0fa20bf610d91e8$export$ca50aac9f3ba507f) : (0, $b0fa20bf610d91e8$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $baaa8e48e91800a4$export$2e2bcd8739ae039)((0, $6b5f72663863aefe$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $a65394726d21110e$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $5fcc9413926a0bed$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $013f06915154a3e3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $c2115c996b3bae14$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $b0fa20bf610d91e8$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $b0fa20bf610d91e8$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $b0fa20bf610d91e8$export$79ffe56a765070d2),
                (0, $b0fa20bf610d91e8$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $b0fa20bf610d91e8$export$1e95b668f3b82d),
                (0, $b0fa20bf610d91e8$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $8fc318668e3868c8$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $b0fa20bf610d91e8$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $32f6b154a39fb70a$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $b0fa20bf610d91e8$export$368f9a87e87fa4e1) : (0, $b0fa20bf610d91e8$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $32f6b154a39fb70a$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $b0fa20bf610d91e8$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9c7320c55d77eeae$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $b41f9e4a4a968585$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $4d82aec99d71dadd$var$getExpandedFallbackPlacements(placement) {
    if ((0, $b41f9e4a4a968585$export$2e2bcd8739ae039)(placement) === (0, $b0fa20bf610d91e8$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $42197a31bce61e2a$export$2e2bcd8739ae039)(placement);
    return [
        (0, $d6b7f7451377d482$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $d6b7f7451377d482$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $4d82aec99d71dadd$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $b41f9e4a4a968585$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $42197a31bce61e2a$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $4d82aec99d71dadd$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $b41f9e4a4a968585$export$2e2bcd8739ae039)(placement) === (0, $b0fa20bf610d91e8$export$dfb5619354ba860) ? (0, $8fc318668e3868c8$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $b41f9e4a4a968585$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $32f6b154a39fb70a$export$2e2bcd8739ae039)(placement) === (0, $b0fa20bf610d91e8$export$b3571188c770cc5a);
        var isVertical = [
            (0, $b0fa20bf610d91e8$export$1e95b668f3b82d),
            (0, $b0fa20bf610d91e8$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $9c7320c55d77eeae$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $b0fa20bf610d91e8$export$79ffe56a765070d2) : (0, $b0fa20bf610d91e8$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $b0fa20bf610d91e8$export$40e543e69a8b3fbb) : (0, $b0fa20bf610d91e8$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $42197a31bce61e2a$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $42197a31bce61e2a$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4d82aec99d71dadd$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $4d82aec99d71dadd$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $3323efb926459725$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $3323efb926459725$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $b0fa20bf610d91e8$export$1e95b668f3b82d),
        (0, $b0fa20bf610d91e8$export$79ffe56a765070d2),
        (0, $b0fa20bf610d91e8$export$40e543e69a8b3fbb),
        (0, $b0fa20bf610d91e8$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $3323efb926459725$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9c7320c55d77eeae$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $9c7320c55d77eeae$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $3323efb926459725$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $3323efb926459725$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $3323efb926459725$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $3323efb926459725$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $3323efb926459725$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $3323efb926459725$var$hide
};




function $b3969bedbc0192a7$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $b41f9e4a4a968585$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $b0fa20bf610d91e8$export$eabcd2c8791e7bf4),
        (0, $b0fa20bf610d91e8$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $b0fa20bf610d91e8$export$eabcd2c8791e7bf4),
        (0, $b0fa20bf610d91e8$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $b3969bedbc0192a7$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $b0fa20bf610d91e8$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $b3969bedbc0192a7$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b3969bedbc0192a7$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $b3969bedbc0192a7$var$offset
};



function $3412dca0cf00c7bb$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $013f06915154a3e3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3412dca0cf00c7bb$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $3412dca0cf00c7bb$var$popperOffsets,
    data: {}
};





function $b8c2eadbabdacb42$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $1b0d084f76133902$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9c7320c55d77eeae$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $b41f9e4a4a968585$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $32f6b154a39fb70a$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $174cc8719889960e$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $b8c2eadbabdacb42$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $b0fa20bf610d91e8$export$1e95b668f3b82d) : (0, $b0fa20bf610d91e8$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $b0fa20bf610d91e8$export$40e543e69a8b3fbb) : (0, $b0fa20bf610d91e8$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $b0fa20bf610d91e8$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $b0fa20bf610d91e8$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $7bbaa7b1a4d287e7$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $9f20b2ce00b91c0c$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $8ac87cae0444a429$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5c6b59fee47decbb$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $8ac87cae0444a429$export$f28d906d67a997f3)(tether ? (0, $ab783ef444b383f2$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $ab783ef444b383f2$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $b0fa20bf610d91e8$export$1e95b668f3b82d) : (0, $b0fa20bf610d91e8$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $b0fa20bf610d91e8$export$40e543e69a8b3fbb) : (0, $b0fa20bf610d91e8$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $b0fa20bf610d91e8$export$1e95b668f3b82d),
            (0, $b0fa20bf610d91e8$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $8ac87cae0444a429$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $8ac87cae0444a429$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $1b0d084f76133902$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $1b0d084f76133902$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};








function $b9bc4723b8c76165$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $3c0f0d7b457cdf8a$export$2e2bcd8739ae039(node) {
    if (node === (0, $2c4362badba08e36$export$2e2bcd8739ae039)(node) || !(0, $6b5f72663863aefe$export$1b3bfaa9684536aa)(node)) return (0, $c33081f4f4848b00$export$2e2bcd8739ae039)(node);
    else return (0, $b9bc4723b8c76165$export$2e2bcd8739ae039)(node);
}








function $3ae8c59781650d66$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $ab783ef444b383f2$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $ab783ef444b383f2$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $3ae8c59781650d66$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $6b5f72663863aefe$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $6b5f72663863aefe$export$1b3bfaa9684536aa)(offsetParent) && $3ae8c59781650d66$var$isElementScaled(offsetParent);
    var documentElement = (0, $a65394726d21110e$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $5fcc9413926a0bed$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $6e797f1c3acad9dc$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $667e0df33a541a1b$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $3c0f0d7b457cdf8a$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $6b5f72663863aefe$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $5fcc9413926a0bed$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e93a8292968f6e40$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $14ea379ca0cdf888$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $14ea379ca0cdf888$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $14ea379ca0cdf888$var$order(modifiers); // order based on phase
    return (0, $b0fa20bf610d91e8$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $2fd42a78b1d63b84$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $8744ca974d4da82d$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $53a7d16ce2fc7e90$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $53a7d16ce2fc7e90$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $53a7d16ce2fc7e90$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $53a7d16ce2fc7e90$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $53a7d16ce2fc7e90$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $6b5f72663863aefe$export$45a5e7f76e0caa8d)(reference) ? (0, $ebbf647fbc65c6bd$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $ebbf647fbc65c6bd$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $ebbf647fbc65c6bd$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $14ea379ca0cdf888$export$2e2bcd8739ae039)((0, $8744ca974d4da82d$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$53a7d16ce2fc7e90$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $3ae8c59781650d66$export$2e2bcd8739ae039)(reference, (0, $5c6b59fee47decbb$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $7bbaa7b1a4d287e7$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $2fd42a78b1d63b84$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$53a7d16ce2fc7e90$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $53a7d16ce2fc7e90$export$8f7491d57c8f97a9 = /*#__PURE__*/ $53a7d16ce2fc7e90$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $cde9fc91dfb666d1$export$d34966752335dd47 = [
    (0, $788edde0355a7239$export$2e2bcd8739ae039),
    (0, $3412dca0cf00c7bb$export$2e2bcd8739ae039),
    (0, $cbf32c3cf3e381c9$export$2e2bcd8739ae039),
    (0, $19593d99407d3b67$export$2e2bcd8739ae039),
    (0, $b3969bedbc0192a7$export$2e2bcd8739ae039),
    (0, $4d82aec99d71dadd$export$2e2bcd8739ae039),
    (0, $1b0d084f76133902$export$2e2bcd8739ae039),
    (0, $0f2d8a445a7a0ecc$export$2e2bcd8739ae039),
    (0, $3323efb926459725$export$2e2bcd8739ae039)
];
var $cde9fc91dfb666d1$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $53a7d16ce2fc7e90$export$ed5e13716264f202)({
    defaultModifiers: $cde9fc91dfb666d1$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $762a64d8111e71fa$export$d34966752335dd47 = [
    (0, $788edde0355a7239$export$2e2bcd8739ae039),
    (0, $3412dca0cf00c7bb$export$2e2bcd8739ae039),
    (0, $cbf32c3cf3e381c9$export$2e2bcd8739ae039),
    (0, $19593d99407d3b67$export$2e2bcd8739ae039)
];
var $762a64d8111e71fa$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $53a7d16ce2fc7e90$export$ed5e13716264f202)({
    defaultModifiers: $762a64d8111e71fa$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($5ebaad8d9c96015f$exports, $b0fa20bf610d91e8$exports);
$parcel$exportWildcard($5ebaad8d9c96015f$exports, $694f9bf7602fdae0$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$elementMap = new Map();
const $8593c12df4688393$var$Data = {
    set (element, key, instance) {
        if (!$8593c12df4688393$var$elementMap.has(element)) $8593c12df4688393$var$elementMap.set(element, new Map());
        const instanceMap = $8593c12df4688393$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($8593c12df4688393$var$elementMap.has(element)) return $8593c12df4688393$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$8593c12df4688393$var$elementMap.has(element)) return;
        const instanceMap = $8593c12df4688393$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $8593c12df4688393$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $8593c12df4688393$var$MAX_UID = 1000000;
const $8593c12df4688393$var$MILLISECONDS_MULTIPLIER = 1000;
const $8593c12df4688393$var$TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $8593c12df4688393$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $8593c12df4688393$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $8593c12df4688393$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $8593c12df4688393$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $8593c12df4688393$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $8593c12df4688393$var$MILLISECONDS_MULTIPLIER;
};
const $8593c12df4688393$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($8593c12df4688393$var$TRANSITION_END));
};
const $8593c12df4688393$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $8593c12df4688393$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($8593c12df4688393$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($8593c12df4688393$var$parseSelector(object));
    return null;
};
const $8593c12df4688393$var$isVisible = (element)=>{
    if (!$8593c12df4688393$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $8593c12df4688393$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $8593c12df4688393$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $8593c12df4688393$var$findShadowRoot(element.parentNode);
};
const $8593c12df4688393$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $8593c12df4688393$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $8593c12df4688393$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $8593c12df4688393$var$DOMContentLoadedCallbacks = [];
const $8593c12df4688393$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$8593c12df4688393$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $8593c12df4688393$var$DOMContentLoadedCallbacks)callback();
        });
        $8593c12df4688393$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $8593c12df4688393$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $8593c12df4688393$var$defineJQueryPlugin = (plugin)=>{
    $8593c12df4688393$var$onDOMContentLoaded(()=>{
        const $ = $8593c12df4688393$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $8593c12df4688393$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const $8593c12df4688393$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $8593c12df4688393$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $8593c12df4688393$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($8593c12df4688393$var$TRANSITION_END, handler);
        $8593c12df4688393$var$execute(callback);
    };
    transitionElement.addEventListener($8593c12df4688393$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $8593c12df4688393$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $8593c12df4688393$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $8593c12df4688393$var$stripNameRegex = /\..*/;
const $8593c12df4688393$var$stripUidRegex = /::\d+$/;
const $8593c12df4688393$var$eventRegistry = {}; // Events storage
let $8593c12df4688393$var$uidEvent = 1;
const $8593c12df4688393$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $8593c12df4688393$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $8593c12df4688393$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$8593c12df4688393$var$uidEvent++}` || element.uidEvent || $8593c12df4688393$var$uidEvent++;
}
function $8593c12df4688393$var$getElementEvents(element) {
    const uid = $8593c12df4688393$var$makeEventUid(element);
    element.uidEvent = uid;
    $8593c12df4688393$var$eventRegistry[uid] = $8593c12df4688393$var$eventRegistry[uid] || {};
    return $8593c12df4688393$var$eventRegistry[uid];
}
function $8593c12df4688393$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $8593c12df4688393$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $8593c12df4688393$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $8593c12df4688393$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $8593c12df4688393$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $8593c12df4688393$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $8593c12df4688393$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $8593c12df4688393$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $8593c12df4688393$var$getTypeEvent(originalTypeEvent);
    if (!$8593c12df4688393$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $8593c12df4688393$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $8593c12df4688393$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $8593c12df4688393$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $8593c12df4688393$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $8593c12df4688393$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $8593c12df4688393$var$makeEventUid(callable, originalTypeEvent.replace($8593c12df4688393$var$namespaceRegex, ""));
    const fn = isDelegated ? $8593c12df4688393$var$bootstrapDelegationHandler(element, handler, callable) : $8593c12df4688393$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $8593c12df4688393$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $8593c12df4688393$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $8593c12df4688393$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $8593c12df4688393$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $8593c12df4688393$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($8593c12df4688393$var$stripNameRegex, "");
    return $8593c12df4688393$var$customEvents[event] || event;
}
const $8593c12df4688393$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $8593c12df4688393$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $8593c12df4688393$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $8593c12df4688393$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $8593c12df4688393$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $8593c12df4688393$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$8593c12df4688393$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($8593c12df4688393$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $8593c12df4688393$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $8593c12df4688393$var$getjQuery();
        const typeEvent = $8593c12df4688393$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $8593c12df4688393$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $8593c12df4688393$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $8593c12df4688393$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $8593c12df4688393$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $8593c12df4688393$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$8593c12df4688393$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$8593c12df4688393$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $8593c12df4688393$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $8593c12df4688393$var$normalizeData(element.getAttribute(`data-bs-${$8593c12df4688393$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $8593c12df4688393$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $8593c12df4688393$var$isElement(element) ? $8593c12df4688393$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$8593c12df4688393$var$isElement(element) ? $8593c12df4688393$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $8593c12df4688393$var$isElement(value) ? "element" : $8593c12df4688393$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$VERSION = "5.3.2";
/**
 * Class definition
 */ class $8593c12df4688393$var$BaseComponent extends $8593c12df4688393$var$Config {
    constructor(element, config){
        super();
        element = $8593c12df4688393$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $8593c12df4688393$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $8593c12df4688393$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $8593c12df4688393$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $8593c12df4688393$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $8593c12df4688393$var$Data.get($8593c12df4688393$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $8593c12df4688393$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $8593c12df4688393$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? $8593c12df4688393$var$parseSelector(hrefAttribute.trim()) : null;
    }
    return selector;
};
const $8593c12df4688393$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$8593c12df4688393$var$isDisabled(el) && $8593c12df4688393$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $8593c12df4688393$var$getSelector(element);
        if (selector) return $8593c12df4688393$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $8593c12df4688393$var$getSelector(element);
        return selector ? $8593c12df4688393$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $8593c12df4688393$var$getSelector(element);
        return selector ? $8593c12df4688393$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $8593c12df4688393$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $8593c12df4688393$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($8593c12df4688393$var$isDisabled(this)) return;
        const target = $8593c12df4688393$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$f = "alert";
const $8593c12df4688393$var$DATA_KEY$a = "bs.alert";
const $8593c12df4688393$var$EVENT_KEY$b = `.${$8593c12df4688393$var$DATA_KEY$a}`;
const $8593c12df4688393$var$EVENT_CLOSE = `close${$8593c12df4688393$var$EVENT_KEY$b}`;
const $8593c12df4688393$var$EVENT_CLOSED = `closed${$8593c12df4688393$var$EVENT_KEY$b}`;
const $8593c12df4688393$var$CLASS_NAME_FADE$5 = "fade";
const $8593c12df4688393$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $8593c12df4688393$export$caec2af78bcc877f extends $8593c12df4688393$var$BaseComponent {
    // Getters
    static get NAME() {
        return $8593c12df4688393$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($8593c12df4688393$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8593c12df4688393$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $8593c12df4688393$var$enableDismissTrigger($8593c12df4688393$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $8593c12df4688393$var$defineJQueryPlugin($8593c12df4688393$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$e = "button";
const $8593c12df4688393$var$DATA_KEY$9 = "bs.button";
const $8593c12df4688393$var$EVENT_KEY$a = `.${$8593c12df4688393$var$DATA_KEY$9}`;
const $8593c12df4688393$var$DATA_API_KEY$6 = ".data-api";
const $8593c12df4688393$var$CLASS_NAME_ACTIVE$3 = "active";
const $8593c12df4688393$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $8593c12df4688393$var$EVENT_CLICK_DATA_API$6 = `click${$8593c12df4688393$var$EVENT_KEY$a}${$8593c12df4688393$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $8593c12df4688393$export$353f5b6fc5456de1 extends $8593c12df4688393$var$BaseComponent {
    // Getters
    static get NAME() {
        return $8593c12df4688393$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($8593c12df4688393$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8593c12df4688393$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $8593c12df4688393$var$EventHandler.on(document, $8593c12df4688393$var$EVENT_CLICK_DATA_API$6, $8593c12df4688393$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($8593c12df4688393$var$SELECTOR_DATA_TOGGLE$5);
    const data = $8593c12df4688393$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $8593c12df4688393$var$defineJQueryPlugin($8593c12df4688393$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$d = "swipe";
const $8593c12df4688393$var$EVENT_KEY$9 = ".bs.swipe";
const $8593c12df4688393$var$EVENT_TOUCHSTART = `touchstart${$8593c12df4688393$var$EVENT_KEY$9}`;
const $8593c12df4688393$var$EVENT_TOUCHMOVE = `touchmove${$8593c12df4688393$var$EVENT_KEY$9}`;
const $8593c12df4688393$var$EVENT_TOUCHEND = `touchend${$8593c12df4688393$var$EVENT_KEY$9}`;
const $8593c12df4688393$var$EVENT_POINTERDOWN = `pointerdown${$8593c12df4688393$var$EVENT_KEY$9}`;
const $8593c12df4688393$var$EVENT_POINTERUP = `pointerup${$8593c12df4688393$var$EVENT_KEY$9}`;
const $8593c12df4688393$var$POINTER_TYPE_TOUCH = "touch";
const $8593c12df4688393$var$POINTER_TYPE_PEN = "pen";
const $8593c12df4688393$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $8593c12df4688393$var$SWIPE_THRESHOLD = 40;
const $8593c12df4688393$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $8593c12df4688393$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $8593c12df4688393$var$Swipe extends $8593c12df4688393$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$8593c12df4688393$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $8593c12df4688393$var$Default$c;
    }
    static get DefaultType() {
        return $8593c12df4688393$var$DefaultType$c;
    }
    static get NAME() {
        return $8593c12df4688393$var$NAME$d;
    }
    // Public
    dispose() {
        $8593c12df4688393$var$EventHandler.off(this._element, $8593c12df4688393$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $8593c12df4688393$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $8593c12df4688393$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $8593c12df4688393$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($8593c12df4688393$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $8593c12df4688393$var$POINTER_TYPE_PEN || event.pointerType === $8593c12df4688393$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$c = "carousel";
const $8593c12df4688393$var$DATA_KEY$8 = "bs.carousel";
const $8593c12df4688393$var$EVENT_KEY$8 = `.${$8593c12df4688393$var$DATA_KEY$8}`;
const $8593c12df4688393$var$DATA_API_KEY$5 = ".data-api";
const $8593c12df4688393$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $8593c12df4688393$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $8593c12df4688393$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $8593c12df4688393$var$ORDER_NEXT = "next";
const $8593c12df4688393$var$ORDER_PREV = "prev";
const $8593c12df4688393$var$DIRECTION_LEFT = "left";
const $8593c12df4688393$var$DIRECTION_RIGHT = "right";
const $8593c12df4688393$var$EVENT_SLIDE = `slide${$8593c12df4688393$var$EVENT_KEY$8}`;
const $8593c12df4688393$var$EVENT_SLID = `slid${$8593c12df4688393$var$EVENT_KEY$8}`;
const $8593c12df4688393$var$EVENT_KEYDOWN$1 = `keydown${$8593c12df4688393$var$EVENT_KEY$8}`;
const $8593c12df4688393$var$EVENT_MOUSEENTER$1 = `mouseenter${$8593c12df4688393$var$EVENT_KEY$8}`;
const $8593c12df4688393$var$EVENT_MOUSELEAVE$1 = `mouseleave${$8593c12df4688393$var$EVENT_KEY$8}`;
const $8593c12df4688393$var$EVENT_DRAG_START = `dragstart${$8593c12df4688393$var$EVENT_KEY$8}`;
const $8593c12df4688393$var$EVENT_LOAD_DATA_API$3 = `load${$8593c12df4688393$var$EVENT_KEY$8}${$8593c12df4688393$var$DATA_API_KEY$5}`;
const $8593c12df4688393$var$EVENT_CLICK_DATA_API$5 = `click${$8593c12df4688393$var$EVENT_KEY$8}${$8593c12df4688393$var$DATA_API_KEY$5}`;
const $8593c12df4688393$var$CLASS_NAME_CAROUSEL = "carousel";
const $8593c12df4688393$var$CLASS_NAME_ACTIVE$2 = "active";
const $8593c12df4688393$var$CLASS_NAME_SLIDE = "slide";
const $8593c12df4688393$var$CLASS_NAME_END = "carousel-item-end";
const $8593c12df4688393$var$CLASS_NAME_START = "carousel-item-start";
const $8593c12df4688393$var$CLASS_NAME_NEXT = "carousel-item-next";
const $8593c12df4688393$var$CLASS_NAME_PREV = "carousel-item-prev";
const $8593c12df4688393$var$SELECTOR_ACTIVE = ".active";
const $8593c12df4688393$var$SELECTOR_ITEM = ".carousel-item";
const $8593c12df4688393$var$SELECTOR_ACTIVE_ITEM = $8593c12df4688393$var$SELECTOR_ACTIVE + $8593c12df4688393$var$SELECTOR_ITEM;
const $8593c12df4688393$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $8593c12df4688393$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $8593c12df4688393$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $8593c12df4688393$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $8593c12df4688393$var$KEY_TO_DIRECTION = {
    [$8593c12df4688393$var$ARROW_LEFT_KEY$1]: $8593c12df4688393$var$DIRECTION_RIGHT,
    [$8593c12df4688393$var$ARROW_RIGHT_KEY$1]: $8593c12df4688393$var$DIRECTION_LEFT
};
const $8593c12df4688393$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $8593c12df4688393$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $8593c12df4688393$export$144901db2ea8e967 extends $8593c12df4688393$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $8593c12df4688393$var$SelectorEngine.findOne($8593c12df4688393$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $8593c12df4688393$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $8593c12df4688393$var$Default$b;
    }
    static get DefaultType() {
        return $8593c12df4688393$var$DefaultType$b;
    }
    static get NAME() {
        return $8593c12df4688393$var$NAME$c;
    }
    // Public
    next() {
        this._slide($8593c12df4688393$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $8593c12df4688393$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($8593c12df4688393$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $8593c12df4688393$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $8593c12df4688393$var$EventHandler.one(this._element, $8593c12df4688393$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $8593c12df4688393$var$EventHandler.one(this._element, $8593c12df4688393$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $8593c12df4688393$var$ORDER_NEXT : $8593c12df4688393$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $8593c12df4688393$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $8593c12df4688393$var$SelectorEngine.find($8593c12df4688393$var$SELECTOR_ITEM_IMG, this._element))$8593c12df4688393$var$EventHandler.on(img, $8593c12df4688393$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $8593c12df4688393$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($8593c12df4688393$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($8593c12df4688393$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $8593c12df4688393$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $8593c12df4688393$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $8593c12df4688393$var$SelectorEngine.findOne($8593c12df4688393$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($8593c12df4688393$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $8593c12df4688393$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($8593c12df4688393$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $8593c12df4688393$var$ORDER_NEXT;
        const nextElement = element || $8593c12df4688393$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $8593c12df4688393$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($8593c12df4688393$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $8593c12df4688393$var$CLASS_NAME_START : $8593c12df4688393$var$CLASS_NAME_END;
        const orderClassName = isNext ? $8593c12df4688393$var$CLASS_NAME_NEXT : $8593c12df4688393$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $8593c12df4688393$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($8593c12df4688393$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($8593c12df4688393$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($8593c12df4688393$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($8593c12df4688393$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $8593c12df4688393$var$SelectorEngine.findOne($8593c12df4688393$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $8593c12df4688393$var$SelectorEngine.find($8593c12df4688393$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($8593c12df4688393$var$isRTL()) return direction === $8593c12df4688393$var$DIRECTION_LEFT ? $8593c12df4688393$var$ORDER_PREV : $8593c12df4688393$var$ORDER_NEXT;
        return direction === $8593c12df4688393$var$DIRECTION_LEFT ? $8593c12df4688393$var$ORDER_NEXT : $8593c12df4688393$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($8593c12df4688393$var$isRTL()) return order === $8593c12df4688393$var$ORDER_PREV ? $8593c12df4688393$var$DIRECTION_LEFT : $8593c12df4688393$var$DIRECTION_RIGHT;
        return order === $8593c12df4688393$var$ORDER_PREV ? $8593c12df4688393$var$DIRECTION_RIGHT : $8593c12df4688393$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8593c12df4688393$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $8593c12df4688393$var$EventHandler.on(document, $8593c12df4688393$var$EVENT_CLICK_DATA_API$5, $8593c12df4688393$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $8593c12df4688393$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($8593c12df4688393$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $8593c12df4688393$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($8593c12df4688393$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$8593c12df4688393$var$EventHandler.on(window, $8593c12df4688393$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $8593c12df4688393$var$SelectorEngine.find($8593c12df4688393$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$8593c12df4688393$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $8593c12df4688393$var$defineJQueryPlugin($8593c12df4688393$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$b = "collapse";
const $8593c12df4688393$var$DATA_KEY$7 = "bs.collapse";
const $8593c12df4688393$var$EVENT_KEY$7 = `.${$8593c12df4688393$var$DATA_KEY$7}`;
const $8593c12df4688393$var$DATA_API_KEY$4 = ".data-api";
const $8593c12df4688393$var$EVENT_SHOW$6 = `show${$8593c12df4688393$var$EVENT_KEY$7}`;
const $8593c12df4688393$var$EVENT_SHOWN$6 = `shown${$8593c12df4688393$var$EVENT_KEY$7}`;
const $8593c12df4688393$var$EVENT_HIDE$6 = `hide${$8593c12df4688393$var$EVENT_KEY$7}`;
const $8593c12df4688393$var$EVENT_HIDDEN$6 = `hidden${$8593c12df4688393$var$EVENT_KEY$7}`;
const $8593c12df4688393$var$EVENT_CLICK_DATA_API$4 = `click${$8593c12df4688393$var$EVENT_KEY$7}${$8593c12df4688393$var$DATA_API_KEY$4}`;
const $8593c12df4688393$var$CLASS_NAME_SHOW$7 = "show";
const $8593c12df4688393$var$CLASS_NAME_COLLAPSE = "collapse";
const $8593c12df4688393$var$CLASS_NAME_COLLAPSING = "collapsing";
const $8593c12df4688393$var$CLASS_NAME_COLLAPSED = "collapsed";
const $8593c12df4688393$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$8593c12df4688393$var$CLASS_NAME_COLLAPSE} .${$8593c12df4688393$var$CLASS_NAME_COLLAPSE}`;
const $8593c12df4688393$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $8593c12df4688393$var$WIDTH = "width";
const $8593c12df4688393$var$HEIGHT = "height";
const $8593c12df4688393$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $8593c12df4688393$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $8593c12df4688393$var$Default$a = {
    parent: null,
    toggle: true
};
const $8593c12df4688393$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $8593c12df4688393$export$78768a9af065a7b extends $8593c12df4688393$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $8593c12df4688393$var$SelectorEngine.find($8593c12df4688393$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $8593c12df4688393$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $8593c12df4688393$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $8593c12df4688393$var$Default$a;
    }
    static get DefaultType() {
        return $8593c12df4688393$var$DefaultType$a;
    }
    static get NAME() {
        return $8593c12df4688393$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($8593c12df4688393$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$8593c12df4688393$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($8593c12df4688393$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($8593c12df4688393$var$CLASS_NAME_COLLAPSE, $8593c12df4688393$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $8593c12df4688393$var$reflow(this._element);
        this._element.classList.add($8593c12df4688393$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_COLLAPSE, $8593c12df4688393$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $8593c12df4688393$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($8593c12df4688393$var$CLASS_NAME_COLLAPSE);
            $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($8593c12df4688393$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $8593c12df4688393$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($8593c12df4688393$var$CLASS_NAME_HORIZONTAL) ? $8593c12df4688393$var$WIDTH : $8593c12df4688393$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($8593c12df4688393$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $8593c12df4688393$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $8593c12df4688393$var$SelectorEngine.find($8593c12df4688393$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $8593c12df4688393$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($8593c12df4688393$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $8593c12df4688393$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $8593c12df4688393$var$EventHandler.on(document, $8593c12df4688393$var$EVENT_CLICK_DATA_API$4, $8593c12df4688393$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of $8593c12df4688393$var$SelectorEngine.getMultipleElementsFromSelector(this))$8593c12df4688393$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $8593c12df4688393$var$defineJQueryPlugin($8593c12df4688393$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$a = "dropdown";
const $8593c12df4688393$var$DATA_KEY$6 = "bs.dropdown";
const $8593c12df4688393$var$EVENT_KEY$6 = `.${$8593c12df4688393$var$DATA_KEY$6}`;
const $8593c12df4688393$var$DATA_API_KEY$3 = ".data-api";
const $8593c12df4688393$var$ESCAPE_KEY$2 = "Escape";
const $8593c12df4688393$var$TAB_KEY$1 = "Tab";
const $8593c12df4688393$var$ARROW_UP_KEY$1 = "ArrowUp";
const $8593c12df4688393$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $8593c12df4688393$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $8593c12df4688393$var$EVENT_HIDE$5 = `hide${$8593c12df4688393$var$EVENT_KEY$6}`;
const $8593c12df4688393$var$EVENT_HIDDEN$5 = `hidden${$8593c12df4688393$var$EVENT_KEY$6}`;
const $8593c12df4688393$var$EVENT_SHOW$5 = `show${$8593c12df4688393$var$EVENT_KEY$6}`;
const $8593c12df4688393$var$EVENT_SHOWN$5 = `shown${$8593c12df4688393$var$EVENT_KEY$6}`;
const $8593c12df4688393$var$EVENT_CLICK_DATA_API$3 = `click${$8593c12df4688393$var$EVENT_KEY$6}${$8593c12df4688393$var$DATA_API_KEY$3}`;
const $8593c12df4688393$var$EVENT_KEYDOWN_DATA_API = `keydown${$8593c12df4688393$var$EVENT_KEY$6}${$8593c12df4688393$var$DATA_API_KEY$3}`;
const $8593c12df4688393$var$EVENT_KEYUP_DATA_API = `keyup${$8593c12df4688393$var$EVENT_KEY$6}${$8593c12df4688393$var$DATA_API_KEY$3}`;
const $8593c12df4688393$var$CLASS_NAME_SHOW$6 = "show";
const $8593c12df4688393$var$CLASS_NAME_DROPUP = "dropup";
const $8593c12df4688393$var$CLASS_NAME_DROPEND = "dropend";
const $8593c12df4688393$var$CLASS_NAME_DROPSTART = "dropstart";
const $8593c12df4688393$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $8593c12df4688393$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $8593c12df4688393$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $8593c12df4688393$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$8593c12df4688393$var$SELECTOR_DATA_TOGGLE$3}.${$8593c12df4688393$var$CLASS_NAME_SHOW$6}`;
const $8593c12df4688393$var$SELECTOR_MENU = ".dropdown-menu";
const $8593c12df4688393$var$SELECTOR_NAVBAR = ".navbar";
const $8593c12df4688393$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $8593c12df4688393$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $8593c12df4688393$var$PLACEMENT_TOP = $8593c12df4688393$var$isRTL() ? "top-end" : "top-start";
const $8593c12df4688393$var$PLACEMENT_TOPEND = $8593c12df4688393$var$isRTL() ? "top-start" : "top-end";
const $8593c12df4688393$var$PLACEMENT_BOTTOM = $8593c12df4688393$var$isRTL() ? "bottom-end" : "bottom-start";
const $8593c12df4688393$var$PLACEMENT_BOTTOMEND = $8593c12df4688393$var$isRTL() ? "bottom-start" : "bottom-end";
const $8593c12df4688393$var$PLACEMENT_RIGHT = $8593c12df4688393$var$isRTL() ? "left-start" : "right-start";
const $8593c12df4688393$var$PLACEMENT_LEFT = $8593c12df4688393$var$isRTL() ? "right-start" : "left-start";
const $8593c12df4688393$var$PLACEMENT_TOPCENTER = "top";
const $8593c12df4688393$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $8593c12df4688393$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $8593c12df4688393$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $8593c12df4688393$export$931cbfb6bfb85fc extends $8593c12df4688393$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $8593c12df4688393$var$SelectorEngine.next(this._element, $8593c12df4688393$var$SELECTOR_MENU)[0] || $8593c12df4688393$var$SelectorEngine.prev(this._element, $8593c12df4688393$var$SELECTOR_MENU)[0] || $8593c12df4688393$var$SelectorEngine.findOne($8593c12df4688393$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $8593c12df4688393$var$Default$9;
    }
    static get DefaultType() {
        return $8593c12df4688393$var$DefaultType$9;
    }
    static get NAME() {
        return $8593c12df4688393$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($8593c12df4688393$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($8593c12df4688393$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$8593c12df4688393$var$EventHandler.on(element, "mouseover", $8593c12df4688393$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($8593c12df4688393$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($8593c12df4688393$var$CLASS_NAME_SHOW$6);
        $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($8593c12df4688393$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$8593c12df4688393$var$EventHandler.off(element, "mouseover", $8593c12df4688393$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($8593c12df4688393$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $8593c12df4688393$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$8593c12df4688393$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$8593c12df4688393$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $5ebaad8d9c96015f$exports === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($8593c12df4688393$var$isElement(this._config.reference)) referenceElement = $8593c12df4688393$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $5ebaad8d9c96015f$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($8593c12df4688393$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($8593c12df4688393$var$CLASS_NAME_DROPEND)) return $8593c12df4688393$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($8593c12df4688393$var$CLASS_NAME_DROPSTART)) return $8593c12df4688393$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($8593c12df4688393$var$CLASS_NAME_DROPUP_CENTER)) return $8593c12df4688393$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($8593c12df4688393$var$CLASS_NAME_DROPDOWN_CENTER)) return $8593c12df4688393$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($8593c12df4688393$var$CLASS_NAME_DROPUP)) return isEnd ? $8593c12df4688393$var$PLACEMENT_TOPEND : $8593c12df4688393$var$PLACEMENT_TOP;
        return isEnd ? $8593c12df4688393$var$PLACEMENT_BOTTOMEND : $8593c12df4688393$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($8593c12df4688393$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $8593c12df4688393$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$8593c12df4688393$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $8593c12df4688393$var$SelectorEngine.find($8593c12df4688393$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$8593c12df4688393$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $8593c12df4688393$var$getNextActiveElement(items, target, key === $8593c12df4688393$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8593c12df4688393$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $8593c12df4688393$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $8593c12df4688393$var$TAB_KEY$1) return;
        const openToggles = $8593c12df4688393$var$SelectorEngine.find($8593c12df4688393$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $8593c12df4688393$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $8593c12df4688393$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $8593c12df4688393$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $8593c12df4688393$var$ARROW_UP_KEY$1,
            $8593c12df4688393$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($8593c12df4688393$var$SELECTOR_DATA_TOGGLE$3) ? this : $8593c12df4688393$var$SelectorEngine.prev(this, $8593c12df4688393$var$SELECTOR_DATA_TOGGLE$3)[0] || $8593c12df4688393$var$SelectorEngine.next(this, $8593c12df4688393$var$SELECTOR_DATA_TOGGLE$3)[0] || $8593c12df4688393$var$SelectorEngine.findOne($8593c12df4688393$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $8593c12df4688393$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $8593c12df4688393$var$EventHandler.on(document, $8593c12df4688393$var$EVENT_KEYDOWN_DATA_API, $8593c12df4688393$var$SELECTOR_DATA_TOGGLE$3, $8593c12df4688393$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$8593c12df4688393$var$EventHandler.on(document, $8593c12df4688393$var$EVENT_KEYDOWN_DATA_API, $8593c12df4688393$var$SELECTOR_MENU, $8593c12df4688393$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$8593c12df4688393$var$EventHandler.on(document, $8593c12df4688393$var$EVENT_CLICK_DATA_API$3, $8593c12df4688393$export$931cbfb6bfb85fc.clearMenus);
$8593c12df4688393$var$EventHandler.on(document, $8593c12df4688393$var$EVENT_KEYUP_DATA_API, $8593c12df4688393$export$931cbfb6bfb85fc.clearMenus);
$8593c12df4688393$var$EventHandler.on(document, $8593c12df4688393$var$EVENT_CLICK_DATA_API$3, $8593c12df4688393$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $8593c12df4688393$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $8593c12df4688393$var$defineJQueryPlugin($8593c12df4688393$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$9 = "backdrop";
const $8593c12df4688393$var$CLASS_NAME_FADE$4 = "fade";
const $8593c12df4688393$var$CLASS_NAME_SHOW$5 = "show";
const $8593c12df4688393$var$EVENT_MOUSEDOWN = `mousedown.bs.${$8593c12df4688393$var$NAME$9}`;
const $8593c12df4688393$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $8593c12df4688393$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $8593c12df4688393$var$Backdrop extends $8593c12df4688393$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $8593c12df4688393$var$Default$8;
    }
    static get DefaultType() {
        return $8593c12df4688393$var$DefaultType$8;
    }
    static get NAME() {
        return $8593c12df4688393$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $8593c12df4688393$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $8593c12df4688393$var$reflow(element);
        element.classList.add($8593c12df4688393$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $8593c12df4688393$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $8593c12df4688393$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($8593c12df4688393$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $8593c12df4688393$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $8593c12df4688393$var$EventHandler.off(this._element, $8593c12df4688393$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($8593c12df4688393$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $8593c12df4688393$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $8593c12df4688393$var$EventHandler.on(element, $8593c12df4688393$var$EVENT_MOUSEDOWN, ()=>{
            $8593c12df4688393$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $8593c12df4688393$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$8 = "focustrap";
const $8593c12df4688393$var$DATA_KEY$5 = "bs.focustrap";
const $8593c12df4688393$var$EVENT_KEY$5 = `.${$8593c12df4688393$var$DATA_KEY$5}`;
const $8593c12df4688393$var$EVENT_FOCUSIN$2 = `focusin${$8593c12df4688393$var$EVENT_KEY$5}`;
const $8593c12df4688393$var$EVENT_KEYDOWN_TAB = `keydown.tab${$8593c12df4688393$var$EVENT_KEY$5}`;
const $8593c12df4688393$var$TAB_KEY = "Tab";
const $8593c12df4688393$var$TAB_NAV_FORWARD = "forward";
const $8593c12df4688393$var$TAB_NAV_BACKWARD = "backward";
const $8593c12df4688393$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $8593c12df4688393$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $8593c12df4688393$var$FocusTrap extends $8593c12df4688393$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $8593c12df4688393$var$Default$7;
    }
    static get DefaultType() {
        return $8593c12df4688393$var$DefaultType$7;
    }
    static get NAME() {
        return $8593c12df4688393$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $8593c12df4688393$var$EventHandler.off(document, $8593c12df4688393$var$EVENT_KEY$5); // guard against infinite focus loop
        $8593c12df4688393$var$EventHandler.on(document, $8593c12df4688393$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $8593c12df4688393$var$EventHandler.on(document, $8593c12df4688393$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $8593c12df4688393$var$EventHandler.off(document, $8593c12df4688393$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $8593c12df4688393$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $8593c12df4688393$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $8593c12df4688393$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $8593c12df4688393$var$TAB_NAV_BACKWARD : $8593c12df4688393$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $8593c12df4688393$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $8593c12df4688393$var$PROPERTY_PADDING = "padding-right";
const $8593c12df4688393$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $8593c12df4688393$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $8593c12df4688393$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($8593c12df4688393$var$SELECTOR_FIXED_CONTENT, $8593c12df4688393$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($8593c12df4688393$var$SELECTOR_STICKY_CONTENT, $8593c12df4688393$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $8593c12df4688393$var$PROPERTY_PADDING);
        this._resetElementAttributes($8593c12df4688393$var$SELECTOR_FIXED_CONTENT, $8593c12df4688393$var$PROPERTY_PADDING);
        this._resetElementAttributes($8593c12df4688393$var$SELECTOR_STICKY_CONTENT, $8593c12df4688393$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $8593c12df4688393$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $8593c12df4688393$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $8593c12df4688393$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($8593c12df4688393$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $8593c12df4688393$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$7 = "modal";
const $8593c12df4688393$var$DATA_KEY$4 = "bs.modal";
const $8593c12df4688393$var$EVENT_KEY$4 = `.${$8593c12df4688393$var$DATA_KEY$4}`;
const $8593c12df4688393$var$DATA_API_KEY$2 = ".data-api";
const $8593c12df4688393$var$ESCAPE_KEY$1 = "Escape";
const $8593c12df4688393$var$EVENT_HIDE$4 = `hide${$8593c12df4688393$var$EVENT_KEY$4}`;
const $8593c12df4688393$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$8593c12df4688393$var$EVENT_KEY$4}`;
const $8593c12df4688393$var$EVENT_HIDDEN$4 = `hidden${$8593c12df4688393$var$EVENT_KEY$4}`;
const $8593c12df4688393$var$EVENT_SHOW$4 = `show${$8593c12df4688393$var$EVENT_KEY$4}`;
const $8593c12df4688393$var$EVENT_SHOWN$4 = `shown${$8593c12df4688393$var$EVENT_KEY$4}`;
const $8593c12df4688393$var$EVENT_RESIZE$1 = `resize${$8593c12df4688393$var$EVENT_KEY$4}`;
const $8593c12df4688393$var$EVENT_CLICK_DISMISS = `click.dismiss${$8593c12df4688393$var$EVENT_KEY$4}`;
const $8593c12df4688393$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$8593c12df4688393$var$EVENT_KEY$4}`;
const $8593c12df4688393$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$8593c12df4688393$var$EVENT_KEY$4}`;
const $8593c12df4688393$var$EVENT_CLICK_DATA_API$2 = `click${$8593c12df4688393$var$EVENT_KEY$4}${$8593c12df4688393$var$DATA_API_KEY$2}`;
const $8593c12df4688393$var$CLASS_NAME_OPEN = "modal-open";
const $8593c12df4688393$var$CLASS_NAME_FADE$3 = "fade";
const $8593c12df4688393$var$CLASS_NAME_SHOW$4 = "show";
const $8593c12df4688393$var$CLASS_NAME_STATIC = "modal-static";
const $8593c12df4688393$var$OPEN_SELECTOR$1 = ".modal.show";
const $8593c12df4688393$var$SELECTOR_DIALOG = ".modal-dialog";
const $8593c12df4688393$var$SELECTOR_MODAL_BODY = ".modal-body";
const $8593c12df4688393$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $8593c12df4688393$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $8593c12df4688393$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $8593c12df4688393$export$2b77a92f1a5ad772 extends $8593c12df4688393$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $8593c12df4688393$var$SelectorEngine.findOne($8593c12df4688393$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $8593c12df4688393$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $8593c12df4688393$var$Default$6;
    }
    static get DefaultType() {
        return $8593c12df4688393$var$DefaultType$6;
    }
    static get NAME() {
        return $8593c12df4688393$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($8593c12df4688393$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $8593c12df4688393$var$EventHandler.off(window, $8593c12df4688393$var$EVENT_KEY$4);
        $8593c12df4688393$var$EventHandler.off(this._dialog, $8593c12df4688393$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $8593c12df4688393$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $8593c12df4688393$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $8593c12df4688393$var$SelectorEngine.findOne($8593c12df4688393$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $8593c12df4688393$var$reflow(this._element);
        this._element.classList.add($8593c12df4688393$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $8593c12df4688393$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $8593c12df4688393$var$EventHandler.on(window, $8593c12df4688393$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $8593c12df4688393$var$EventHandler.one(this._element, $8593c12df4688393$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($8593c12df4688393$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($8593c12df4688393$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($8593c12df4688393$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($8593c12df4688393$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $8593c12df4688393$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $8593c12df4688393$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $8593c12df4688393$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $8593c12df4688393$var$EventHandler.on(document, $8593c12df4688393$var$EVENT_CLICK_DATA_API$2, $8593c12df4688393$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $8593c12df4688393$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $8593c12df4688393$var$EventHandler.one(target, $8593c12df4688393$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $8593c12df4688393$var$EventHandler.one(target, $8593c12df4688393$var$EVENT_HIDDEN$4, ()=>{
            if ($8593c12df4688393$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $8593c12df4688393$var$SelectorEngine.findOne($8593c12df4688393$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $8593c12df4688393$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $8593c12df4688393$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$8593c12df4688393$var$enableDismissTrigger($8593c12df4688393$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $8593c12df4688393$var$defineJQueryPlugin($8593c12df4688393$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$6 = "offcanvas";
const $8593c12df4688393$var$DATA_KEY$3 = "bs.offcanvas";
const $8593c12df4688393$var$EVENT_KEY$3 = `.${$8593c12df4688393$var$DATA_KEY$3}`;
const $8593c12df4688393$var$DATA_API_KEY$1 = ".data-api";
const $8593c12df4688393$var$EVENT_LOAD_DATA_API$2 = `load${$8593c12df4688393$var$EVENT_KEY$3}${$8593c12df4688393$var$DATA_API_KEY$1}`;
const $8593c12df4688393$var$ESCAPE_KEY = "Escape";
const $8593c12df4688393$var$CLASS_NAME_SHOW$3 = "show";
const $8593c12df4688393$var$CLASS_NAME_SHOWING$1 = "showing";
const $8593c12df4688393$var$CLASS_NAME_HIDING = "hiding";
const $8593c12df4688393$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $8593c12df4688393$var$OPEN_SELECTOR = ".offcanvas.show";
const $8593c12df4688393$var$EVENT_SHOW$3 = `show${$8593c12df4688393$var$EVENT_KEY$3}`;
const $8593c12df4688393$var$EVENT_SHOWN$3 = `shown${$8593c12df4688393$var$EVENT_KEY$3}`;
const $8593c12df4688393$var$EVENT_HIDE$3 = `hide${$8593c12df4688393$var$EVENT_KEY$3}`;
const $8593c12df4688393$var$EVENT_HIDE_PREVENTED = `hidePrevented${$8593c12df4688393$var$EVENT_KEY$3}`;
const $8593c12df4688393$var$EVENT_HIDDEN$3 = `hidden${$8593c12df4688393$var$EVENT_KEY$3}`;
const $8593c12df4688393$var$EVENT_RESIZE = `resize${$8593c12df4688393$var$EVENT_KEY$3}`;
const $8593c12df4688393$var$EVENT_CLICK_DATA_API$1 = `click${$8593c12df4688393$var$EVENT_KEY$3}${$8593c12df4688393$var$DATA_API_KEY$1}`;
const $8593c12df4688393$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$8593c12df4688393$var$EVENT_KEY$3}`;
const $8593c12df4688393$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $8593c12df4688393$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $8593c12df4688393$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $8593c12df4688393$export$591ca0244c9dfcd4 extends $8593c12df4688393$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $8593c12df4688393$var$Default$5;
    }
    static get DefaultType() {
        return $8593c12df4688393$var$DefaultType$5;
    }
    static get NAME() {
        return $8593c12df4688393$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $8593c12df4688393$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($8593c12df4688393$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($8593c12df4688393$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_SHOWING$1);
            $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($8593c12df4688393$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_SHOW$3, $8593c12df4688393$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $8593c12df4688393$var$ScrollBarHelper().reset();
            $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $8593c12df4688393$var$Backdrop({
            className: $8593c12df4688393$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $8593c12df4688393$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $8593c12df4688393$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8593c12df4688393$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $8593c12df4688393$var$EventHandler.on(document, $8593c12df4688393$var$EVENT_CLICK_DATA_API$1, $8593c12df4688393$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $8593c12df4688393$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($8593c12df4688393$var$isDisabled(this)) return;
    $8593c12df4688393$var$EventHandler.one(target, $8593c12df4688393$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($8593c12df4688393$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $8593c12df4688393$var$SelectorEngine.findOne($8593c12df4688393$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $8593c12df4688393$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $8593c12df4688393$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$8593c12df4688393$var$EventHandler.on(window, $8593c12df4688393$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $8593c12df4688393$var$SelectorEngine.find($8593c12df4688393$var$OPEN_SELECTOR))$8593c12df4688393$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$8593c12df4688393$var$EventHandler.on(window, $8593c12df4688393$var$EVENT_RESIZE, ()=>{
    for (const element of $8593c12df4688393$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $8593c12df4688393$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$8593c12df4688393$var$enableDismissTrigger($8593c12df4688393$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $8593c12df4688393$var$defineJQueryPlugin($8593c12df4688393$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $8593c12df4688393$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $8593c12df4688393$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $8593c12df4688393$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $8593c12df4688393$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $8593c12df4688393$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $8593c12df4688393$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($8593c12df4688393$var$uriAttributes.has(attributeName)) return Boolean($8593c12df4688393$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $8593c12df4688393$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$8593c12df4688393$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$5 = "TemplateFactory";
const $8593c12df4688393$var$Default$4 = {
    allowList: $8593c12df4688393$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $8593c12df4688393$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $8593c12df4688393$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $8593c12df4688393$var$TemplateFactory extends $8593c12df4688393$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $8593c12df4688393$var$Default$4;
    }
    static get DefaultType() {
        return $8593c12df4688393$var$DefaultType$4;
    }
    static get NAME() {
        return $8593c12df4688393$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $8593c12df4688393$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $8593c12df4688393$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($8593c12df4688393$var$isElement(content)) {
            this._putElementInTemplate($8593c12df4688393$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $8593c12df4688393$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $8593c12df4688393$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$4 = "tooltip";
const $8593c12df4688393$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $8593c12df4688393$var$CLASS_NAME_FADE$2 = "fade";
const $8593c12df4688393$var$CLASS_NAME_MODAL = "modal";
const $8593c12df4688393$var$CLASS_NAME_SHOW$2 = "show";
const $8593c12df4688393$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $8593c12df4688393$var$SELECTOR_MODAL = `.${$8593c12df4688393$var$CLASS_NAME_MODAL}`;
const $8593c12df4688393$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $8593c12df4688393$var$TRIGGER_HOVER = "hover";
const $8593c12df4688393$var$TRIGGER_FOCUS = "focus";
const $8593c12df4688393$var$TRIGGER_CLICK = "click";
const $8593c12df4688393$var$TRIGGER_MANUAL = "manual";
const $8593c12df4688393$var$EVENT_HIDE$2 = "hide";
const $8593c12df4688393$var$EVENT_HIDDEN$2 = "hidden";
const $8593c12df4688393$var$EVENT_SHOW$2 = "show";
const $8593c12df4688393$var$EVENT_SHOWN$2 = "shown";
const $8593c12df4688393$var$EVENT_INSERTED = "inserted";
const $8593c12df4688393$var$EVENT_CLICK$1 = "click";
const $8593c12df4688393$var$EVENT_FOCUSIN$1 = "focusin";
const $8593c12df4688393$var$EVENT_FOCUSOUT$1 = "focusout";
const $8593c12df4688393$var$EVENT_MOUSEENTER = "mouseenter";
const $8593c12df4688393$var$EVENT_MOUSELEAVE = "mouseleave";
const $8593c12df4688393$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $8593c12df4688393$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $8593c12df4688393$var$isRTL() ? "right" : "left"
};
const $8593c12df4688393$var$Default$3 = {
    allowList: $8593c12df4688393$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $8593c12df4688393$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $8593c12df4688393$export$28c660c63b792dea extends $8593c12df4688393$var$BaseComponent {
    constructor(element, config){
        if (typeof $5ebaad8d9c96015f$exports === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $8593c12df4688393$var$Default$3;
    }
    static get DefaultType() {
        return $8593c12df4688393$var$DefaultType$3;
    }
    static get NAME() {
        return $8593c12df4688393$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $8593c12df4688393$var$EventHandler.off(this._element.closest($8593c12df4688393$var$SELECTOR_MODAL), $8593c12df4688393$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, this.constructor.eventName($8593c12df4688393$var$EVENT_SHOW$2));
        const shadowRoot = $8593c12df4688393$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $8593c12df4688393$var$EventHandler.trigger(this._element, this.constructor.eventName($8593c12df4688393$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($8593c12df4688393$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$8593c12df4688393$var$EventHandler.on(element, "mouseover", $8593c12df4688393$var$noop);
        const complete = ()=>{
            $8593c12df4688393$var$EventHandler.trigger(this._element, this.constructor.eventName($8593c12df4688393$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, this.constructor.eventName($8593c12df4688393$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($8593c12df4688393$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$8593c12df4688393$var$EventHandler.off(element, "mouseover", $8593c12df4688393$var$noop);
        this._activeTrigger[$8593c12df4688393$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$8593c12df4688393$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$8593c12df4688393$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $8593c12df4688393$var$EventHandler.trigger(this._element, this.constructor.eventName($8593c12df4688393$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($8593c12df4688393$var$CLASS_NAME_FADE$2, $8593c12df4688393$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $8593c12df4688393$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($8593c12df4688393$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $8593c12df4688393$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$8593c12df4688393$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($8593c12df4688393$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($8593c12df4688393$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $8593c12df4688393$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $8593c12df4688393$var$AttachmentMap[placement.toUpperCase()];
        return $5ebaad8d9c96015f$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $8593c12df4688393$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$8593c12df4688393$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $8593c12df4688393$var$EventHandler.on(this._element, this.constructor.eventName($8593c12df4688393$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $8593c12df4688393$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $8593c12df4688393$var$TRIGGER_HOVER ? this.constructor.eventName($8593c12df4688393$var$EVENT_MOUSEENTER) : this.constructor.eventName($8593c12df4688393$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $8593c12df4688393$var$TRIGGER_HOVER ? this.constructor.eventName($8593c12df4688393$var$EVENT_MOUSELEAVE) : this.constructor.eventName($8593c12df4688393$var$EVENT_FOCUSOUT$1);
                $8593c12df4688393$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $8593c12df4688393$var$TRIGGER_FOCUS : $8593c12df4688393$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $8593c12df4688393$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $8593c12df4688393$var$TRIGGER_FOCUS : $8593c12df4688393$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $8593c12df4688393$var$EventHandler.on(this._element.closest($8593c12df4688393$var$SELECTOR_MODAL), $8593c12df4688393$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $8593c12df4688393$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($8593c12df4688393$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $8593c12df4688393$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8593c12df4688393$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $8593c12df4688393$var$defineJQueryPlugin($8593c12df4688393$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$3 = "popover";
const $8593c12df4688393$var$SELECTOR_TITLE = ".popover-header";
const $8593c12df4688393$var$SELECTOR_CONTENT = ".popover-body";
const $8593c12df4688393$var$Default$2 = {
    ...$8593c12df4688393$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $8593c12df4688393$var$DefaultType$2 = {
    ...$8593c12df4688393$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $8593c12df4688393$export$5b6b19405a83ff9d extends $8593c12df4688393$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $8593c12df4688393$var$Default$2;
    }
    static get DefaultType() {
        return $8593c12df4688393$var$DefaultType$2;
    }
    static get NAME() {
        return $8593c12df4688393$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$8593c12df4688393$var$SELECTOR_TITLE]: this._getTitle(),
            [$8593c12df4688393$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8593c12df4688393$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $8593c12df4688393$var$defineJQueryPlugin($8593c12df4688393$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$2 = "scrollspy";
const $8593c12df4688393$var$DATA_KEY$2 = "bs.scrollspy";
const $8593c12df4688393$var$EVENT_KEY$2 = `.${$8593c12df4688393$var$DATA_KEY$2}`;
const $8593c12df4688393$var$DATA_API_KEY = ".data-api";
const $8593c12df4688393$var$EVENT_ACTIVATE = `activate${$8593c12df4688393$var$EVENT_KEY$2}`;
const $8593c12df4688393$var$EVENT_CLICK = `click${$8593c12df4688393$var$EVENT_KEY$2}`;
const $8593c12df4688393$var$EVENT_LOAD_DATA_API$1 = `load${$8593c12df4688393$var$EVENT_KEY$2}${$8593c12df4688393$var$DATA_API_KEY}`;
const $8593c12df4688393$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $8593c12df4688393$var$CLASS_NAME_ACTIVE$1 = "active";
const $8593c12df4688393$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $8593c12df4688393$var$SELECTOR_TARGET_LINKS = "[href]";
const $8593c12df4688393$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $8593c12df4688393$var$SELECTOR_NAV_LINKS = ".nav-link";
const $8593c12df4688393$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $8593c12df4688393$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $8593c12df4688393$var$SELECTOR_LINK_ITEMS = `${$8593c12df4688393$var$SELECTOR_NAV_LINKS}, ${$8593c12df4688393$var$SELECTOR_NAV_ITEMS} > ${$8593c12df4688393$var$SELECTOR_NAV_LINKS}, ${$8593c12df4688393$var$SELECTOR_LIST_ITEMS}`;
const $8593c12df4688393$var$SELECTOR_DROPDOWN = ".dropdown";
const $8593c12df4688393$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $8593c12df4688393$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $8593c12df4688393$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $8593c12df4688393$export$a6472a5298a374be extends $8593c12df4688393$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $8593c12df4688393$var$Default$1;
    }
    static get DefaultType() {
        return $8593c12df4688393$var$DefaultType$1;
    }
    static get NAME() {
        return $8593c12df4688393$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $8593c12df4688393$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $8593c12df4688393$var$EventHandler.off(this._config.target, $8593c12df4688393$var$EVENT_CLICK);
        $8593c12df4688393$var$EventHandler.on(this._config.target, $8593c12df4688393$var$EVENT_CLICK, $8593c12df4688393$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $8593c12df4688393$var$SelectorEngine.find($8593c12df4688393$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $8593c12df4688393$var$isDisabled(anchor)) continue;
            const observableSection = $8593c12df4688393$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($8593c12df4688393$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($8593c12df4688393$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($8593c12df4688393$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $8593c12df4688393$var$SelectorEngine.findOne($8593c12df4688393$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($8593c12df4688393$var$SELECTOR_DROPDOWN)).classList.add($8593c12df4688393$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $8593c12df4688393$var$SelectorEngine.parents(target, $8593c12df4688393$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $8593c12df4688393$var$SelectorEngine.prev(listGroup, $8593c12df4688393$var$SELECTOR_LINK_ITEMS))item.classList.add($8593c12df4688393$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($8593c12df4688393$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $8593c12df4688393$var$SelectorEngine.find(`${$8593c12df4688393$var$SELECTOR_TARGET_LINKS}.${$8593c12df4688393$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($8593c12df4688393$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8593c12df4688393$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $8593c12df4688393$var$EventHandler.on(window, $8593c12df4688393$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $8593c12df4688393$var$SelectorEngine.find($8593c12df4688393$var$SELECTOR_DATA_SPY))$8593c12df4688393$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $8593c12df4688393$var$defineJQueryPlugin($8593c12df4688393$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME$1 = "tab";
const $8593c12df4688393$var$DATA_KEY$1 = "bs.tab";
const $8593c12df4688393$var$EVENT_KEY$1 = `.${$8593c12df4688393$var$DATA_KEY$1}`;
const $8593c12df4688393$var$EVENT_HIDE$1 = `hide${$8593c12df4688393$var$EVENT_KEY$1}`;
const $8593c12df4688393$var$EVENT_HIDDEN$1 = `hidden${$8593c12df4688393$var$EVENT_KEY$1}`;
const $8593c12df4688393$var$EVENT_SHOW$1 = `show${$8593c12df4688393$var$EVENT_KEY$1}`;
const $8593c12df4688393$var$EVENT_SHOWN$1 = `shown${$8593c12df4688393$var$EVENT_KEY$1}`;
const $8593c12df4688393$var$EVENT_CLICK_DATA_API = `click${$8593c12df4688393$var$EVENT_KEY$1}`;
const $8593c12df4688393$var$EVENT_KEYDOWN = `keydown${$8593c12df4688393$var$EVENT_KEY$1}`;
const $8593c12df4688393$var$EVENT_LOAD_DATA_API = `load${$8593c12df4688393$var$EVENT_KEY$1}`;
const $8593c12df4688393$var$ARROW_LEFT_KEY = "ArrowLeft";
const $8593c12df4688393$var$ARROW_RIGHT_KEY = "ArrowRight";
const $8593c12df4688393$var$ARROW_UP_KEY = "ArrowUp";
const $8593c12df4688393$var$ARROW_DOWN_KEY = "ArrowDown";
const $8593c12df4688393$var$HOME_KEY = "Home";
const $8593c12df4688393$var$END_KEY = "End";
const $8593c12df4688393$var$CLASS_NAME_ACTIVE = "active";
const $8593c12df4688393$var$CLASS_NAME_FADE$1 = "fade";
const $8593c12df4688393$var$CLASS_NAME_SHOW$1 = "show";
const $8593c12df4688393$var$CLASS_DROPDOWN = "dropdown";
const $8593c12df4688393$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $8593c12df4688393$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $8593c12df4688393$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$8593c12df4688393$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $8593c12df4688393$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $8593c12df4688393$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $8593c12df4688393$var$SELECTOR_INNER = `.nav-link${$8593c12df4688393$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$8593c12df4688393$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$8593c12df4688393$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $8593c12df4688393$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $8593c12df4688393$var$SELECTOR_INNER_ELEM = `${$8593c12df4688393$var$SELECTOR_INNER}, ${$8593c12df4688393$var$SELECTOR_DATA_TOGGLE}`;
const $8593c12df4688393$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$8593c12df4688393$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$8593c12df4688393$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$8593c12df4688393$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $8593c12df4688393$export$3e41faf802a29e71 extends $8593c12df4688393$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($8593c12df4688393$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $8593c12df4688393$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $8593c12df4688393$var$EventHandler.trigger(active, $8593c12df4688393$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $8593c12df4688393$var$EventHandler.trigger(innerElem, $8593c12df4688393$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($8593c12df4688393$var$CLASS_NAME_ACTIVE);
        this._activate($8593c12df4688393$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($8593c12df4688393$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $8593c12df4688393$var$EventHandler.trigger(element, $8593c12df4688393$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($8593c12df4688393$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($8593c12df4688393$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($8593c12df4688393$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($8593c12df4688393$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $8593c12df4688393$var$EventHandler.trigger(element, $8593c12df4688393$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($8593c12df4688393$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $8593c12df4688393$var$ARROW_LEFT_KEY,
            $8593c12df4688393$var$ARROW_RIGHT_KEY,
            $8593c12df4688393$var$ARROW_UP_KEY,
            $8593c12df4688393$var$ARROW_DOWN_KEY,
            $8593c12df4688393$var$HOME_KEY,
            $8593c12df4688393$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$8593c12df4688393$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $8593c12df4688393$var$HOME_KEY,
            $8593c12df4688393$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $8593c12df4688393$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $8593c12df4688393$var$ARROW_RIGHT_KEY,
                $8593c12df4688393$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $8593c12df4688393$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $8593c12df4688393$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $8593c12df4688393$var$SelectorEngine.find($8593c12df4688393$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $8593c12df4688393$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($8593c12df4688393$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $8593c12df4688393$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($8593c12df4688393$var$SELECTOR_DROPDOWN_TOGGLE, $8593c12df4688393$var$CLASS_NAME_ACTIVE);
        toggle($8593c12df4688393$var$SELECTOR_DROPDOWN_MENU, $8593c12df4688393$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($8593c12df4688393$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($8593c12df4688393$var$SELECTOR_INNER_ELEM) ? elem : $8593c12df4688393$var$SelectorEngine.findOne($8593c12df4688393$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($8593c12df4688393$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8593c12df4688393$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $8593c12df4688393$var$EventHandler.on(document, $8593c12df4688393$var$EVENT_CLICK_DATA_API, $8593c12df4688393$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($8593c12df4688393$var$isDisabled(this)) return;
    $8593c12df4688393$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $8593c12df4688393$var$EventHandler.on(window, $8593c12df4688393$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $8593c12df4688393$var$SelectorEngine.find($8593c12df4688393$var$SELECTOR_DATA_TOGGLE_ACTIVE))$8593c12df4688393$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $8593c12df4688393$var$defineJQueryPlugin($8593c12df4688393$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $8593c12df4688393$var$NAME = "toast";
const $8593c12df4688393$var$DATA_KEY = "bs.toast";
const $8593c12df4688393$var$EVENT_KEY = `.${$8593c12df4688393$var$DATA_KEY}`;
const $8593c12df4688393$var$EVENT_MOUSEOVER = `mouseover${$8593c12df4688393$var$EVENT_KEY}`;
const $8593c12df4688393$var$EVENT_MOUSEOUT = `mouseout${$8593c12df4688393$var$EVENT_KEY}`;
const $8593c12df4688393$var$EVENT_FOCUSIN = `focusin${$8593c12df4688393$var$EVENT_KEY}`;
const $8593c12df4688393$var$EVENT_FOCUSOUT = `focusout${$8593c12df4688393$var$EVENT_KEY}`;
const $8593c12df4688393$var$EVENT_HIDE = `hide${$8593c12df4688393$var$EVENT_KEY}`;
const $8593c12df4688393$var$EVENT_HIDDEN = `hidden${$8593c12df4688393$var$EVENT_KEY}`;
const $8593c12df4688393$var$EVENT_SHOW = `show${$8593c12df4688393$var$EVENT_KEY}`;
const $8593c12df4688393$var$EVENT_SHOWN = `shown${$8593c12df4688393$var$EVENT_KEY}`;
const $8593c12df4688393$var$CLASS_NAME_FADE = "fade";
const $8593c12df4688393$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $8593c12df4688393$var$CLASS_NAME_SHOW = "show";
const $8593c12df4688393$var$CLASS_NAME_SHOWING = "showing";
const $8593c12df4688393$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $8593c12df4688393$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $8593c12df4688393$export$8d8dc7d5f743331b extends $8593c12df4688393$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $8593c12df4688393$var$Default;
    }
    static get DefaultType() {
        return $8593c12df4688393$var$DefaultType;
    }
    static get NAME() {
        return $8593c12df4688393$var$NAME;
    }
    // Public
    show() {
        const showEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($8593c12df4688393$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_SHOWING);
            $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_HIDE); // @deprecated
        $8593c12df4688393$var$reflow(this._element);
        this._element.classList.add($8593c12df4688393$var$CLASS_NAME_SHOW, $8593c12df4688393$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($8593c12df4688393$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_SHOWING, $8593c12df4688393$var$CLASS_NAME_SHOW);
            $8593c12df4688393$var$EventHandler.trigger(this._element, $8593c12df4688393$var$EVENT_HIDDEN);
        };
        this._element.classList.add($8593c12df4688393$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($8593c12df4688393$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($8593c12df4688393$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $8593c12df4688393$var$EventHandler.on(this._element, $8593c12df4688393$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $8593c12df4688393$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $8593c12df4688393$var$enableDismissTrigger($8593c12df4688393$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $8593c12df4688393$var$defineJQueryPlugin($8593c12df4688393$export$8d8dc7d5f743331b);


var $adf38128cd050da0$exports = {};
!function(e, t) {
    $adf38128cd050da0$exports = t();
}($adf38128cd050da0$exports, function() {
    return function(e) {
        function t(o) {
            if (n[o]) return n[o].exports;
            var i = n[o] = {
                exports: {},
                id: o,
                loaded: !1
            };
            return e[o].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.p = "dist/", t(0);
    }([
        function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var i = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
                }
                return e;
            }, r = n(1), a = (o(r), n(6)), u = o(a), c = n(7), s = o(c), f = n(8), d = o(f), l = n(9), p = o(l), m = n(10), b = o(m), v = n(11), y = o(v), g = n(14), h = o(g), w = [], k = !1, x = {
                offset: 120,
                delay: 0,
                easing: "ease",
                duration: 400,
                disable: !1,
                once: !1,
                startEvent: "DOMContentLoaded",
                throttleDelay: 99,
                debounceDelay: 50,
                disableMutationObserver: !1
            }, j = function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (e && (k = !0), k) return w = (0, y.default)(w, x), (0, b.default)(w, x.once), w;
            }, O = function() {
                w = (0, h.default)(), j();
            }, M = function() {
                w.forEach(function(e, t) {
                    e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay");
                });
            }, S = function(e) {
                return e === !0 || "mobile" === e && p.default.mobile() || "phone" === e && p.default.phone() || "tablet" === e && p.default.tablet() || "function" == typeof e && e() === !0;
            }, _ = function(e) {
                x = i(x, e), w = (0, h.default)();
                var t = document.all && !window.atob;
                return S(x.disable) || t ? M() : (x.disableMutationObserver || d.default.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), x.disableMutationObserver = !0), document.querySelector("body").setAttribute("data-aos-easing", x.easing), document.querySelector("body").setAttribute("data-aos-duration", x.duration), document.querySelector("body").setAttribute("data-aos-delay", x.delay), "DOMContentLoaded" === x.startEvent && [
                    "complete",
                    "interactive"
                ].indexOf(document.readyState) > -1 ? j(!0) : "load" === x.startEvent ? window.addEventListener(x.startEvent, function() {
                    j(!0);
                }) : document.addEventListener(x.startEvent, function() {
                    j(!0);
                }), window.addEventListener("resize", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("orientationchange", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("scroll", (0, u.default)(function() {
                    (0, b.default)(w, x.once);
                }, x.throttleDelay)), x.disableMutationObserver || d.default.ready("[data-aos]", O), w);
            };
            e.exports = {
                init: _,
                refresh: j,
                refreshHard: O
            };
        },
        function(e, t) {},
        ,
        ,
        ,
        ,
        function(e, t) {
            (function(t) {
                "use strict";
                function n(e, t, n) {
                    function o(t) {
                        var n = b, o = v;
                        return b = v = void 0, k = t, g = e.apply(o, n);
                    }
                    function r(e) {
                        return k = e, h = setTimeout(f, t), M ? o(e) : g;
                    }
                    function a(e) {
                        var n = e - w, o = e - k, i = t - n;
                        return S ? j(i, y - o) : i;
                    }
                    function c(e) {
                        var n = e - w, o = e - k;
                        return void 0 === w || n >= t || n < 0 || S && o >= y;
                    }
                    function f() {
                        var e = O();
                        return c(e) ? d(e) : void (h = setTimeout(f, a(e)));
                    }
                    function d(e) {
                        return h = void 0, _ && b ? o(e) : (b = v = void 0, g);
                    }
                    function l() {
                        void 0 !== h && clearTimeout(h), k = 0, b = w = v = h = void 0;
                    }
                    function p() {
                        return void 0 === h ? g : d(O());
                    }
                    function m() {
                        var e = O(), n = c(e);
                        if (b = arguments, v = this, w = e, n) {
                            if (void 0 === h) return r(w);
                            if (S) return h = setTimeout(f, t), o(w);
                        }
                        return void 0 === h && (h = setTimeout(f, t)), g;
                    }
                    var b, v, y, g, h, w, k = 0, M = !1, S = !1, _ = !0;
                    if ("function" != typeof e) throw new TypeError(s);
                    return t = u(t) || 0, i(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? x(u(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
                }
                function o(e, t, o) {
                    var r = !0, a = !0;
                    if ("function" != typeof e) throw new TypeError(s);
                    return i(o) && (r = "leading" in o ? !!o.leading : r, a = "trailing" in o ? !!o.trailing : a), n(e, t, {
                        leading: r,
                        maxWait: t,
                        trailing: a
                    });
                }
                function i(e) {
                    var t = "undefined" == typeof e ? "undefined" : c(e);
                    return !!e && ("object" == t || "function" == t);
                }
                function r(e) {
                    return !!e && "object" == ("undefined" == typeof e ? "undefined" : c(e));
                }
                function a(e) {
                    return "symbol" == ("undefined" == typeof e ? "undefined" : c(e)) || r(e) && k.call(e) == d;
                }
                function u(e) {
                    if ("number" == typeof e) return e;
                    if (a(e)) return f;
                    if (i(e)) {
                        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                        e = i(t) ? t + "" : t;
                    }
                    if ("string" != typeof e) return 0 === e ? e : +e;
                    e = e.replace(l, "");
                    var n = m.test(e);
                    return n || b.test(e) ? v(e.slice(2), n ? 2 : 8) : p.test(e) ? f : +e;
                }
                var c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, s = "Expected a function", f = NaN, d = "[object Symbol]", l = /^\s+|\s+$/g, p = /^[-+]0x[0-9a-f]+$/i, m = /^0b[01]+$/i, b = /^0o[0-7]+$/i, v = parseInt, y = "object" == ("undefined" == typeof t ? "undefined" : c(t)) && t && t.Object === Object && t, g = "object" == ("undefined" == typeof self ? "undefined" : c(self)) && self && self.Object === Object && self, h = y || g || Function("return this")(), w = Object.prototype, k = w.toString, x = Math.max, j = Math.min, O = function() {
                    return h.Date.now();
                };
                e.exports = o;
            }).call(t, function() {
                return this;
            }());
        },
        function(e, t) {
            (function(t) {
                "use strict";
                function n(e, t, n) {
                    function i(t) {
                        var n = b, o = v;
                        return b = v = void 0, O = t, g = e.apply(o, n);
                    }
                    function r(e) {
                        return O = e, h = setTimeout(f, t), M ? i(e) : g;
                    }
                    function u(e) {
                        var n = e - w, o = e - O, i = t - n;
                        return S ? x(i, y - o) : i;
                    }
                    function s(e) {
                        var n = e - w, o = e - O;
                        return void 0 === w || n >= t || n < 0 || S && o >= y;
                    }
                    function f() {
                        var e = j();
                        return s(e) ? d(e) : void (h = setTimeout(f, u(e)));
                    }
                    function d(e) {
                        return h = void 0, _ && b ? i(e) : (b = v = void 0, g);
                    }
                    function l() {
                        void 0 !== h && clearTimeout(h), O = 0, b = w = v = h = void 0;
                    }
                    function p() {
                        return void 0 === h ? g : d(j());
                    }
                    function m() {
                        var e = j(), n = s(e);
                        if (b = arguments, v = this, w = e, n) {
                            if (void 0 === h) return r(w);
                            if (S) return h = setTimeout(f, t), i(w);
                        }
                        return void 0 === h && (h = setTimeout(f, t)), g;
                    }
                    var b, v, y, g, h, w, O = 0, M = !1, S = !1, _ = !0;
                    if ("function" != typeof e) throw new TypeError(c);
                    return t = a(t) || 0, o(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? k(a(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
                }
                function o(e) {
                    var t = "undefined" == typeof e ? "undefined" : u(e);
                    return !!e && ("object" == t || "function" == t);
                }
                function i(e) {
                    return !!e && "object" == ("undefined" == typeof e ? "undefined" : u(e));
                }
                function r(e) {
                    return "symbol" == ("undefined" == typeof e ? "undefined" : u(e)) || i(e) && w.call(e) == f;
                }
                function a(e) {
                    if ("number" == typeof e) return e;
                    if (r(e)) return s;
                    if (o(e)) {
                        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                        e = o(t) ? t + "" : t;
                    }
                    if ("string" != typeof e) return 0 === e ? e : +e;
                    e = e.replace(d, "");
                    var n = p.test(e);
                    return n || m.test(e) ? b(e.slice(2), n ? 2 : 8) : l.test(e) ? s : +e;
                }
                var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                }, c = "Expected a function", s = NaN, f = "[object Symbol]", d = /^\s+|\s+$/g, l = /^[-+]0x[0-9a-f]+$/i, p = /^0b[01]+$/i, m = /^0o[0-7]+$/i, b = parseInt, v = "object" == ("undefined" == typeof t ? "undefined" : u(t)) && t && t.Object === Object && t, y = "object" == ("undefined" == typeof self ? "undefined" : u(self)) && self && self.Object === Object && self, g = v || y || Function("return this")(), h = Object.prototype, w = h.toString, k = Math.max, x = Math.min, j = function() {
                    return g.Date.now();
                };
                e.exports = n;
            }).call(t, function() {
                return this;
            }());
        },
        function(e, t) {
            "use strict";
            function n(e) {
                var t = void 0, o = void 0, i = void 0;
                for(t = 0; t < e.length; t += 1){
                    if (o = e[t], o.dataset && o.dataset.aos) return !0;
                    if (i = o.children && n(o.children)) return !0;
                }
                return !1;
            }
            function o() {
                return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
            }
            function i() {
                return !!o();
            }
            function r(e, t) {
                var n = window.document, i = o(), r = new i(a);
                u = t, r.observe(n.documentElement, {
                    childList: !0,
                    subtree: !0,
                    removedNodes: !0
                });
            }
            function a(e) {
                e && e.forEach(function(e) {
                    var t = Array.prototype.slice.call(e.addedNodes), o = Array.prototype.slice.call(e.removedNodes), i = t.concat(o);
                    if (n(i)) return u();
                });
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var u = function() {};
            t.default = {
                isSupported: i,
                ready: r
            };
        },
        function(e, t) {
            "use strict";
            function n(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function o() {
                return navigator.userAgent || navigator.vendor || window.opera || "";
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = function() {
                function e(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var o = t[n];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
                    }
                }
                return function(t, n, o) {
                    return n && e(t.prototype, n), o && e(t, o), t;
                };
            }(), r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i, a = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, u = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i, c = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i, s = function() {
                function e() {
                    n(this, e);
                }
                return i(e, [
                    {
                        key: "phone",
                        value: function() {
                            var e = o();
                            return !(!r.test(e) && !a.test(e.substr(0, 4)));
                        }
                    },
                    {
                        key: "mobile",
                        value: function() {
                            var e = o();
                            return !(!u.test(e) && !c.test(e.substr(0, 4)));
                        }
                    },
                    {
                        key: "tablet",
                        value: function() {
                            return this.mobile() && !this.phone();
                        }
                    }
                ]), e;
            }();
            t.default = new s;
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e, t, n) {
                var o = e.node.getAttribute("data-aos-once");
                t > e.position ? e.node.classList.add("aos-animate") : "undefined" != typeof o && ("false" === o || !n && "true" !== o) && e.node.classList.remove("aos-animate");
            }, o = function(e, t) {
                var o = window.pageYOffset, i = window.innerHeight;
                e.forEach(function(e, r) {
                    n(e, i + o, t);
                });
            };
            t.default = o;
        },
        function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(12), r = o(i), a = function(e, t) {
                return e.forEach(function(e, n) {
                    e.node.classList.add("aos-init"), e.position = (0, r.default)(e.node, t.offset);
                }), e;
            };
            t.default = a;
        },
        function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(13), r = o(i), a = function(e, t) {
                var n = 0, o = 0, i = window.innerHeight, a = {
                    offset: e.getAttribute("data-aos-offset"),
                    anchor: e.getAttribute("data-aos-anchor"),
                    anchorPlacement: e.getAttribute("data-aos-anchor-placement")
                };
                switch(a.offset && !isNaN(a.offset) && (o = parseInt(a.offset)), a.anchor && document.querySelectorAll(a.anchor) && (e = document.querySelectorAll(a.anchor)[0]), n = (0, r.default)(e).top, a.anchorPlacement){
                    case "top-bottom":
                        break;
                    case "center-bottom":
                        n += e.offsetHeight / 2;
                        break;
                    case "bottom-bottom":
                        n += e.offsetHeight;
                        break;
                    case "top-center":
                        n += i / 2;
                        break;
                    case "bottom-center":
                        n += i / 2 + e.offsetHeight;
                        break;
                    case "center-center":
                        n += i / 2 + e.offsetHeight / 2;
                        break;
                    case "top-top":
                        n += i;
                        break;
                    case "bottom-top":
                        n += e.offsetHeight + i;
                        break;
                    case "center-top":
                        n += e.offsetHeight / 2 + i;
                }
                return a.anchorPlacement || a.offset || isNaN(t) || (o = t), n + o;
            };
            t.default = a;
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e) {
                for(var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);)t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;
                return {
                    top: n,
                    left: t
                };
            };
            t.default = n;
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function(e) {
                return e = e || document.querySelectorAll("[data-aos]"), Array.prototype.map.call(e, function(e) {
                    return {
                        node: e
                    };
                });
            };
            t.default = n;
        }
    ]);
});


/**
 * Swiper 10.2.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 17, 2023
 */ /**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $709edbf6299cccbc$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $709edbf6299cccbc$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($709edbf6299cccbc$var$isObject(src[key]) && $709edbf6299cccbc$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $709edbf6299cccbc$var$extend(target[key], src[key]);
    });
}
const $709edbf6299cccbc$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $709edbf6299cccbc$export$39b482c5e57630a8() {
    const doc = typeof document !== "undefined" ? document : {};
    $709edbf6299cccbc$var$extend(doc, $709edbf6299cccbc$var$ssrDocument);
    return doc;
}
const $709edbf6299cccbc$var$ssrWindow = {
    document: $709edbf6299cccbc$var$ssrDocument,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $709edbf6299cccbc$export$407448d2b89b1813() {
    const win = typeof window !== "undefined" ? window : {};
    $709edbf6299cccbc$var$extend(win, $709edbf6299cccbc$var$ssrWindow);
    return win;
}



function $737414888e8d31b2$export$43caf9889c228507(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $737414888e8d31b2$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $737414888e8d31b2$export$4368d992c4eafac0() {
    return Date.now();
}
function $737414888e8d31b2$var$getComputedStyle(el) {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $737414888e8d31b2$export$dda1d9f60106f0e9(el, axis) {
    if (axis === void 0) axis = "x";
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $737414888e8d31b2$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map((a)=>a.replace(",", ".")).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $737414888e8d31b2$export$35e795649ee09318(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $737414888e8d31b2$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $737414888e8d31b2$export$9e5f44173e64f162() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$737414888e8d31b2$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($737414888e8d31b2$export$35e795649ee09318(to[nextKey]) && $737414888e8d31b2$export$35e795649ee09318(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $737414888e8d31b2$export$9e5f44173e64f162(to[nextKey], nextSource[nextKey]);
                    } else if (!$737414888e8d31b2$export$35e795649ee09318(to[nextKey]) && $737414888e8d31b2$export$35e795649ee09318(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $737414888e8d31b2$export$9e5f44173e64f162(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $737414888e8d31b2$export$2408f22a0fab9ae5(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $737414888e8d31b2$export$ffb5f4729a158638(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? "next" : "prev";
    const isOutOfBound = (current, target)=>{
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $737414888e8d31b2$export$342063e11d6c3cad(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowRoot && slideEl.shadowRoot.querySelector(".swiper-slide-transform") || slideEl;
}
function $737414888e8d31b2$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = "";
    return [
        ...element.children
    ].filter((el)=>el.matches(selector));
}
function $737414888e8d31b2$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : [
        classes
    ]);
    return el;
}
function $737414888e8d31b2$export$8b22cf2602fb60ce(el) {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $737414888e8d31b2$export$ae1af26003f05816(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $737414888e8d31b2$export$953cecd6e717a553(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $737414888e8d31b2$export$882b5998b3b9117c(el, prop) {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $737414888e8d31b2$export$39b482c5e57630a8(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $737414888e8d31b2$export$407448d2b89b1813(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $737414888e8d31b2$export$23f2a1d2818174ef(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $737414888e8d31b2$export$2d1720544b23b823(el, size, includeMargins) {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}


let $f564a415f4d19b8d$var$support;
function $f564a415f4d19b8d$var$calcSupport() {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && "scrollBehavior" in document1.documentElement.style,
        touch: !!("ontouchstart" in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $f564a415f4d19b8d$var$getSupport() {
    if (!$f564a415f4d19b8d$var$support) $f564a415f4d19b8d$var$support = $f564a415f4d19b8d$var$calcSupport();
    return $f564a415f4d19b8d$var$support;
}
let $f564a415f4d19b8d$var$deviceCached;
function $f564a415f4d19b8d$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $f564a415f4d19b8d$var$getSupport();
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === "Win32";
    let macos = platform === "MacIntel";
    // iPadOs 13 fix
    const iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $f564a415f4d19b8d$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$f564a415f4d19b8d$var$deviceCached) $f564a415f4d19b8d$var$deviceCached = $f564a415f4d19b8d$var$calcDevice(overrides);
    return $f564a415f4d19b8d$var$deviceCached;
}
let $f564a415f4d19b8d$var$browser;
function $f564a415f4d19b8d$var$calcBrowser() {
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes("Version/")) {
            const [major, minor] = ua.split("Version/")[1].split(" ")[0].split(".").map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    return {
        isSafari: needPerspectiveFix || isSafari(),
        needPerspectiveFix: needPerspectiveFix,
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent)
    };
}
function $f564a415f4d19b8d$var$getBrowser() {
    if (!$f564a415f4d19b8d$var$browser) $f564a415f4d19b8d$var$browser = $f564a415f4d19b8d$var$calcBrowser();
    return $f564a415f4d19b8d$var$browser;
}
function $f564a415f4d19b8d$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window1.addEventListener("resize", resizeHandler);
        window1.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", ()=>{
        removeObserver();
        window1.removeEventListener("resize", resizeHandler);
        window1.removeEventListener("orientationchange", orientationChangeHandler);
    });
}
function $f564a415f4d19b8d$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $737414888e8d31b2$export$407448d2b89b1813)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}
/* eslint-disable no-underscore-dangle */ var $f564a415f4d19b8d$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        events.split(" ").forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        const method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach((event)=>{
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $f564a415f4d19b8d$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $737414888e8d31b2$export$882b5998b3b9117c)(el, "padding-left") || 0, 10) - parseInt((0, $737414888e8d31b2$export$882b5998b3b9117c)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $737414888e8d31b2$export$882b5998b3b9117c)(el, "padding-top") || 0, 10) - parseInt((0, $737414888e8d31b2$export$882b5998b3b9117c)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $f564a415f4d19b8d$var$updateSlides() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slides[i] && (0, $737414888e8d31b2$export$882b5998b3b9117c)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $737414888e8d31b2$export$2d1720544b23b823)(slide, "width", true) : (0, $737414888e8d31b2$export$2d1720544b23b823)(slide, "height", true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, "width");
                const paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                const paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                const marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                const marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                const boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-before", `${-snapGrid[0]}px`);
        (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(wrapperEl, "--swiper-centered-offset-after", `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $f564a415f4d19b8d$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $f564a415f4d19b8d$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
function $f564a415f4d19b8d$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    // Visible Slides
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideVisibleClass);
    });
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides[i].classList.add(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $f564a415f4d19b8d$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === "undefined") {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}
function $f564a415f4d19b8d$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const getFilteredSlide = (selector)=>{
        return (0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    slides.forEach((slideEl)=>{
        slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
    });
    let activeSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        // Active classes
        activeSlide.classList.add(params.slideActiveClass);
        // Next Slide
        let nextSlide = (0, $737414888e8d31b2$export$953cecd6e717a553)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        if (params.loop && !nextSlide) nextSlide = slides[0];
        if (nextSlide) nextSlide.classList.add(params.slideNextClass);
        // Prev Slide
        let prevSlide = (0, $737414888e8d31b2$export$ae1af26003f05816)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
        params.loop;
        if (prevSlide) prevSlide.classList.add(params.slidePrevClass);
    }
    swiper.emitSlidesClasses();
}
const $f564a415f4d19b8d$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (lazyEl) lazyEl.remove();
    }
};
const $f564a415f4d19b8d$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
const $f564a415f4d19b8d$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $f564a415f4d19b8d$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $f564a415f4d19b8d$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $f564a415f4d19b8d$var$unlazy(swiper, i);
    }
};
function $f564a415f4d19b8d$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $f564a415f4d19b8d$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $f564a415f4d19b8d$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (swiper.slides[activeIndex]) realIndex = parseInt(swiper.slides[activeIndex].getAttribute("data-swiper-slide-index") || activeIndex, 10);
    else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $f564a415f4d19b8d$var$preload(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}
function $f564a415f4d19b8d$var$updateClickedSlide(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = e.closest(`.${params.slideClass}, swiper-slide`);
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $f564a415f4d19b8d$var$update = {
    updateSize: $f564a415f4d19b8d$var$updateSize,
    updateSlides: $f564a415f4d19b8d$var$updateSlides,
    updateAutoHeight: $f564a415f4d19b8d$var$updateAutoHeight,
    updateSlidesOffset: $f564a415f4d19b8d$var$updateSlidesOffset,
    updateSlidesProgress: $f564a415f4d19b8d$var$updateSlidesProgress,
    updateProgress: $f564a415f4d19b8d$var$updateProgress,
    updateSlidesClasses: $f564a415f4d19b8d$var$updateSlidesClasses,
    updateActiveIndex: $f564a415f4d19b8d$var$updateActiveIndex,
    updateClickedSlide: $f564a415f4d19b8d$var$updateClickedSlide
};
function $f564a415f4d19b8d$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? "x" : "y";
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $737414888e8d31b2$export$dda1d9f60106f0e9)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $f564a415f4d19b8d$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}
function $f564a415f4d19b8d$var$minTranslate() {
    return -this.snapGrid[0];
}
function $f564a415f4d19b8d$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $f564a415f4d19b8d$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $737414888e8d31b2$export$ffb5f4729a158638)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: -newTranslate,
                behavior: "smooth"
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $f564a415f4d19b8d$var$translate = {
    getTranslate: $f564a415f4d19b8d$var$getSwiperTranslate,
    setTranslate: $f564a415f4d19b8d$var$setTranslate,
    minTranslate: $f564a415f4d19b8d$var$minTranslate,
    maxTranslate: $f564a415f4d19b8d$var$maxTranslate,
    translateTo: $f564a415f4d19b8d$var$translateTo
};
function $f564a415f4d19b8d$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : "";
    }
    swiper.emit("setTransition", duration, byController);
}
function $f564a415f4d19b8d$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === "next") swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $f564a415f4d19b8d$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $f564a415f4d19b8d$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}
function $f564a415f4d19b8d$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $f564a415f4d19b8d$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}
var $f564a415f4d19b8d$var$transition = {
    setTransition: $f564a415f4d19b8d$var$setTransition,
    transitionStart: $f564a415f4d19b8d$var$transitionStart,
    transitionEnd: $f564a415f4d19b8d$var$transitionEnd
};
function $f564a415f4d19b8d$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $737414888e8d31b2$export$ffb5f4729a158638)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? "left" : "top"]: t,
                behavior: "smooth"
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $f564a415f4d19b8d$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === "string") {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else newIndex = swiper.getSlideIndexByData(newIndex);
    }
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $f564a415f4d19b8d$var$slideNext(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $f564a415f4d19b8d$var$slidePrev(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled) return swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $f564a415f4d19b8d$var$slideReset(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $f564a415f4d19b8d$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $f564a415f4d19b8d$var$slideToClickedSlide() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $f564a415f4d19b8d$var$slide = {
    slideTo: $f564a415f4d19b8d$var$slideTo,
    slideToLoop: $f564a415f4d19b8d$var$slideToLoop,
    slideNext: $f564a415f4d19b8d$var$slideNext,
    slidePrev: $f564a415f4d19b8d$var$slidePrev,
    slideReset: $f564a415f4d19b8d$var$slideReset,
    slideToClosest: $f564a415f4d19b8d$var$slideToClosest,
    slideToClickedSlide: $f564a415f4d19b8d$var$slideToClickedSlide
};
function $f564a415f4d19b8d$var$loopCreate(slideRealIndex) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const slides = (0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    slides.forEach((el, index)=>{
        el.setAttribute("data-swiper-slide-index", index);
    });
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}
function $f564a415f4d19b8d$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    const slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10));
    let loopedSlides = params.loopedSlides || slidesPerView;
    if (loopedSlides % params.slidesPerGroup !== 0) loopedSlides += params.slidesPerGroup - loopedSlides % params.slidesPerGroup;
    swiper.loopedSlides = loopedSlides;
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    let activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(swiper.slides.filter((el)=>el.classList.contains(params.slideActiveClass))[0]);
    else activeIndex = activeSlideIndex;
    const isNext = direction === "next" || !direction;
    const isPrev = direction === "prev" || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    // prepend last slides before start
    if (activeSlideIndex < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeSlideIndex, params.slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeSlideIndex; i += 1){
            const index = i - Math.floor(i / slides.length) * slides.length;
            prependSlidesIndexes.push(slides.length - index - 1);
        }
    } else if (activeSlideIndex /* + slidesPerView */  > swiper.slides.length - loopedSlides * 2) {
        slidesAppended = Math.max(activeSlideIndex - (swiper.slides.length - loopedSlides * 2), params.slidesPerGroup);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / slides.length) * slides.length;
            appendSlidesIndexes.push(index);
        }
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
                    if (setTranslate) {
                        swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff;
                        swiper.touchEventsData.currentTranslate = swiper.translate;
                    }
                }
            } else if (setTranslate) {
                swiper.slideToLoop(slideRealIndex, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff;
                        swiper.touchEventsData.currentTranslate = swiper.translate;
                    }
                }
            } else swiper.slideToLoop(slideRealIndex, 0, false, true);
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit("loopFix");
}
function $f564a415f4d19b8d$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $f564a415f4d19b8d$var$loop = {
    loopCreate: $f564a415f4d19b8d$var$loopCreate,
    loopFix: $f564a415f4d19b8d$var$loopFix,
    loopDestroy: $f564a415f4d19b8d$var$loopDestroy
};
function $f564a415f4d19b8d$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $f564a415f4d19b8d$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $f564a415f4d19b8d$var$grabCursor = {
    setGrabCursor: $f564a415f4d19b8d$var$setGrabCursor,
    unsetGrabCursor: $f564a415f4d19b8d$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $f564a415f4d19b8d$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $709edbf6299cccbc$export$39b482c5e57630a8)() || el === (0, $709edbf6299cccbc$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $f564a415f4d19b8d$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const data = swiper.touchEventsData;
    data.evCache.push(event);
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!swiper.wrapperEl.contains(targetEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $f564a415f4d19b8d$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $737414888e8d31b2$export$4368d992c4eafac0)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}
function $f564a415f4d19b8d$var$onTouchMove(event) {
    const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    const pointerIndex = data.evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
    if (pointerIndex >= 0) data.evCache[pointerIndex] = e;
    const targetTouch = data.evCache.length > 1 ? data.evCache[0] : e;
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                prevX: swiper.touches.currentX,
                prevY: swiper.touches.currentY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $737414888e8d31b2$export$4368d992c4eafac0)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || swiper.zoom && swiper.params.zoom && swiper.params.zoom.enabled && data.evCache.length > 1) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    const isLoop = swiper.params.loop && !params.cssMode;
    if (!data.isMoved) {
        if (isLoop) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    let loopFixed;
    if (data.isMoved && prevTouchesDirection !== swiper.touchesDirection && isLoop && Math.abs(diff) >= 1) {
        // need another loop fix
        swiper.loopFix({
            direction: swiper.swipeDirection,
            setTranslate: true
        });
        loopFixed = true;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && !loopFixed && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.size / 2 : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && !loopFixed && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.size / 2 : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $f564a415f4d19b8d$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const pointerIndex = data.evCache.findIndex((cachedEv)=>cachedEv.pointerId === event.pointerId);
    if (pointerIndex >= 0) data.evCache.splice(pointerIndex, 1);
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave",
        "contextmenu"
    ].includes(event.type)) {
        const proceed = [
            "pointercancel",
            "contextmenu"
        ].includes(event.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $737414888e8d31b2$export$4368d992c4eafac0)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $737414888e8d31b2$export$4368d992c4eafac0)();
    (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $f564a415f4d19b8d$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $f564a415f4d19b8d$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $f564a415f4d19b8d$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}
function $f564a415f4d19b8d$var$onLoad(e) {
    const swiper = this;
    $f564a415f4d19b8d$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}
let $f564a415f4d19b8d$var$dummyEventAttached = false;
function $f564a415f4d19b8d$var$dummyEventListener() {}
const $f564a415f4d19b8d$var$events = (swiper, method)=>{
    const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    const swiperMethod = method;
    // Touch Events
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]("contextmenu", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $f564a415f4d19b8d$var$onResize, true);
    else swiper[swiperMethod]("observerUpdate", $f564a415f4d19b8d$var$onResize, true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $f564a415f4d19b8d$var$attachEvents() {
    const swiper = this;
    const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    const { params: params } = swiper;
    swiper.onTouchStart = $f564a415f4d19b8d$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $f564a415f4d19b8d$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $f564a415f4d19b8d$var$onTouchEnd.bind(swiper);
    if (params.cssMode) swiper.onScroll = $f564a415f4d19b8d$var$onScroll.bind(swiper);
    swiper.onClick = $f564a415f4d19b8d$var$onClick.bind(swiper);
    swiper.onLoad = $f564a415f4d19b8d$var$onLoad.bind(swiper);
    if (!$f564a415f4d19b8d$var$dummyEventAttached) {
        document1.addEventListener("touchstart", $f564a415f4d19b8d$var$dummyEventListener);
        $f564a415f4d19b8d$var$dummyEventAttached = true;
    }
    $f564a415f4d19b8d$var$events(swiper, "on");
}
function $f564a415f4d19b8d$var$detachEvents() {
    const swiper = this;
    $f564a415f4d19b8d$var$events(swiper, "off");
}
var $f564a415f4d19b8d$var$events$1 = {
    attachEvents: $f564a415f4d19b8d$var$attachEvents,
    detachEvents: $f564a415f4d19b8d$var$detachEvents
};
const $f564a415f4d19b8d$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $f564a415f4d19b8d$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $f564a415f4d19b8d$var$isGridEnabled(swiper, params);
    const isMultiRow = $f564a415f4d19b8d$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === "undefined") return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $737414888e8d31b2$export$9e5f44173e64f162)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate(realIndex);
        swiper.updateSlides();
    }
    swiper.emit("breakpoint", breakpointParams);
}
function $f564a415f4d19b8d$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = "window";
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    const currentHeight = base === "window" ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === "string" && point.indexOf("@") === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === "window") {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}
var $f564a415f4d19b8d$var$breakpoints = {
    setBreakpoint: $f564a415f4d19b8d$var$setBreakpoint,
    getBreakpoint: $f564a415f4d19b8d$var$getBreakpoint
};
function $f564a415f4d19b8d$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === "object") Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $f564a415f4d19b8d$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $f564a415f4d19b8d$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $f564a415f4d19b8d$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $f564a415f4d19b8d$var$classes = {
    addClasses: $f564a415f4d19b8d$var$addClasses,
    removeClasses: $f564a415f4d19b8d$var$removeClasses
};
function $f564a415f4d19b8d$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $f564a415f4d19b8d$var$checkOverflow$1 = {
    checkOverflow: $f564a415f4d19b8d$var$checkOverflow
};
var $f564a415f4d19b8d$export$4368d992c4eafac0 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopedSlides: null,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $f564a415f4d19b8d$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $737414888e8d31b2$export$9e5f44173e64f162)(allModulesParams, obj);
            return;
        }
        if ([
            "navigation",
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $737414888e8d31b2$export$9e5f44173e64f162)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $737414888e8d31b2$export$9e5f44173e64f162)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $f564a415f4d19b8d$var$prototypes = {
    eventsEmitter: $f564a415f4d19b8d$var$eventsEmitter,
    update: $f564a415f4d19b8d$var$update,
    translate: $f564a415f4d19b8d$var$translate,
    transition: $f564a415f4d19b8d$var$transition,
    slide: $f564a415f4d19b8d$var$slide,
    loop: $f564a415f4d19b8d$var$loop,
    grabCursor: $f564a415f4d19b8d$var$grabCursor,
    events: $f564a415f4d19b8d$var$events$1,
    breakpoints: $f564a415f4d19b8d$var$breakpoints,
    checkOverflow: $f564a415f4d19b8d$var$checkOverflow$1,
    classes: $f564a415f4d19b8d$var$classes
};
const $f564a415f4d19b8d$var$extendedDefaults = {};
class $f564a415f4d19b8d$export$25ce5a424b770e84 {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $737414888e8d31b2$export$9e5f44173e64f162)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $737414888e8d31b2$export$9e5f44173e64f162)({}, params, {
                    el: containerEl
                });
                swipers.push(new $f564a415f4d19b8d$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $f564a415f4d19b8d$var$getSupport();
        swiper.device = $f564a415f4d19b8d$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $f564a415f4d19b8d$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $f564a415f4d19b8d$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $737414888e8d31b2$export$9e5f44173e64f162)({}, $f564a415f4d19b8d$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $737414888e8d31b2$export$9e5f44173e64f162)({}, swiperParams, $f564a415f4d19b8d$var$extendedDefaults, params);
        swiper.originalParams = (0, $737414888e8d31b2$export$9e5f44173e64f162)({}, swiper.params);
        swiper.passedParams = (0, $737414888e8d31b2$export$9e5f44173e64f162)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === "horizontal";
            },
            isVertical () {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                evCache: []
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $737414888e8d31b2$export$39b482c5e57630a8)(slides[0]);
        return (0, $737414888e8d31b2$export$39b482c5e57630a8)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") * 1 === index)[0]);
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $737414888e8d31b2$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit("enable");
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit("disable");
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(" ").filter((className)=>{
            return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit("_containerClasses", cls.join(" "));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return "";
        return slideEl.className.split(" ").filter((className)=>{
            return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(" ");
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit("_slideClass", slideEl, classNames);
        });
        swiper.emit("_slideClasses", updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = "current";
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? slides[activeIndex].swiperSlideSize : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === "current") for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $f564a415f4d19b8d$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit("update");
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
        if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === "vertical") slideEl.style.width = "";
            else slideEl.style.height = "";
        });
        swiper.emit("changeDirection");
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
        swiper.rtl = direction === "rtl";
        swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "rtl";
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = "ltr";
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === "string") el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === "SWIPER-CONTAINER") swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || "").trim().split(" ").join(".")}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $737414888e8d31b2$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $737414888e8d31b2$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === "rtl" || (0, $737414888e8d31b2$export$882b5998b3b9117c)(el, "direction") === "rtl",
            rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $737414888e8d31b2$export$882b5998b3b9117c)(el, "direction") === "rtl"),
            wrongRTL: (0, $737414888e8d31b2$export$882b5998b3b9117c)(wrapperEl, "display") === "-webkit-box"
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit("beforeInit");
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate();
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $f564a415f4d19b8d$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener("load", (e)=>{
                $f564a415f4d19b8d$var$processLazyPreloader(swiper, e.target);
            });
        });
        $f564a415f4d19b8d$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $f564a415f4d19b8d$var$preload(swiper);
        // Emit
        swiper.emit("init");
        swiper.emit("afterInit");
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
        swiper.emit("beforeDestroy");
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            el.removeAttribute("style");
            wrapperEl.removeAttribute("style");
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute("style");
                slideEl.removeAttribute("data-swiper-slide-index");
            });
        }
        swiper.emit("destroy");
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.el.swiper = null;
            (0, $737414888e8d31b2$export$43caf9889c228507)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $737414888e8d31b2$export$9e5f44173e64f162)($f564a415f4d19b8d$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $f564a415f4d19b8d$var$extendedDefaults;
    }
    static get defaults() {
        return $f564a415f4d19b8d$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$f564a415f4d19b8d$export$25ce5a424b770e84.prototype.__modules__) $f564a415f4d19b8d$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $f564a415f4d19b8d$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$f564a415f4d19b8d$export$25ce5a424b770e84.installModule(m));
            return $f564a415f4d19b8d$export$25ce5a424b770e84;
        }
        $f564a415f4d19b8d$export$25ce5a424b770e84.installModule(module);
        return $f564a415f4d19b8d$export$25ce5a424b770e84;
    }
}
Object.keys($f564a415f4d19b8d$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($f564a415f4d19b8d$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $f564a415f4d19b8d$export$25ce5a424b770e84.prototype[protoMethod] = $f564a415f4d19b8d$var$prototypes[prototypeGroup][protoMethod];
    });
});
$f564a415f4d19b8d$export$25ce5a424b770e84.use([
    $f564a415f4d19b8d$var$Resize,
    $f564a415f4d19b8d$var$Observer
]);






function $ba0542580cadfb4c$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement("div");
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === "string") {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("swiper-slide");
        else slideEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", swiper.params.slideClass);
        slideEl.setAttribute("data-swiper-slide-index", index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, loop: isLoop } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slidesEl.querySelectorAll(`.${swiper.params.slideClass}, swiper-slide`).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slidesEl.querySelectorAll(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === "undefined" || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $737414888e8d31b2$export$f1e1789686576879)(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
                if (cachedElIndex) cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on("beforeInit", ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === "undefined") {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on("init update resize", ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $737414888e8d31b2$export$2408f22a0fab9ae5)(swiper.wrapperEl, "--swiper-virtual-size", `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $0abcf5eeb4def3b2$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $737414888e8d31b2$export$407448d2b89b1813)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $737414888e8d31b2$export$407448d2b89b1813)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $737414888e8d31b2$export$8b22cf2602fb60ce)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener("keydown", handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener("keydown", handle);
        swiper.keyboard.enabled = false;
    }
    on("init", ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $11aaaff5c52a2005$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $737414888e8d31b2$export$4368d992c4eafac0)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $737414888e8d31b2$export$4368d992c4eafac0)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $737414888e8d31b2$export$4368d992c4eafac0)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $737414888e8d31b2$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $737414888e8d31b2$export$4368d992c4eafac0)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? "next" : "prev",
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]("mouseenter", handleMouseEnter);
        targetEl[method]("mouseleave", handleMouseLeave);
        targetEl[method]("wheel", handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("addEventListener");
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("removeEventListener");
        swiper.mousewheel.enabled = false;
        return true;
    }
    on("init", ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $d97b353fb4cc475d$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $737414888e8d31b2$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}


function $eaaaf8b39da376c0$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    const makeElementsArray = (el)=>(Array.isArray(el) ? el : [
            el
        ]).filter((e)=>!!e);
    function getEl(el) {
        let res;
        if (el && typeof el === "string" && swiper.isElement) {
            res = swiper.el.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === "string") res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === "string" && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? "add" : "remove"](...params.disabledClass.split(" "));
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $d97b353fb4cc475d$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(" "));
        };
        nextEl.forEach((el)=>initButton(el, "next"));
        prevEl.forEach((el)=>initButton(el, "prev"));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(" "));
        };
        nextEl.forEach((el)=>destroyButton(el, "next"));
        prevEl.forEach((el)=>destroyButton(el, "prev"));
    }
    on("init", ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", ()=>{
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList[swiper.enabled ? "remove" : "add"](swiper.params.navigation.lockClass));
    });
    on("click", (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !prevEl.includes(targetEl) && !nextEl.includes(targetEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(" "));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(" "));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $d9d2cfaa8c2f08b1$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = "";
    return `.${classes.trim().replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, ".")}`;
}




function $e9d5694a0a5e5ad4$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    const makeElementsArray = (el)=>(Array.isArray(el) ? el : [
            el
        ]).filter((e)=>!!e);
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === "prev" ? "previous" : "next"}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $737414888e8d31b2$export$39b482c5e57630a8)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const realIndex = swiper.realIndex;
            const newSlideIndex = swiper.getSlideIndexByData(index);
            const currentSlideIndex = swiper.getSlideIndexByData(swiper.realIndex);
            if (newSlideIndex > swiper.slides.length - swiper.loopedSlides) {
                const indexBeforeLoopFix = swiper.activeIndex;
                swiper.loopFix({
                    direction: newSlideIndex > currentSlideIndex ? "next" : "prev",
                    activeSlideIndex: newSlideIndex,
                    slideTo: false
                });
                const indexAfterFix = swiper.activeIndex;
                if (indexBeforeLoopFix === indexAfterFix) swiper.slideToLoop(realIndex, 0, false, true);
            }
            swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = makeElementsArray(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $737414888e8d31b2$export$2d1720544b23b823)(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? "width" : "height"] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        "",
                        "-next",
                        "-next-next",
                        "-prev",
                        "-prev-prev",
                        "-main"
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === "string" && s.includes(" ") ? s.split(" ") : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $737414888e8d31b2$export$39b482c5e57630a8)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(" "));
                else if (swiper.isElement) bullet.setAttribute("part", "bullet");
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets(bullet, "next");
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(" "));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(" "));
                    setSideBullets(firstDisplayedBullet, "prev");
                    setSideBullets(lastDisplayedBullet, "next");
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? "right" : "left";
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === "fraction") {
                subEl.querySelectorAll((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === "progressbar") {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
                else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === "horizontal") scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === "custom" && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit("paginationRender", subEl);
            } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        let el = swiper.pagination.el;
        el = makeElementsArray(el);
        let paginationHTML = "";
        if (params.type === "bullets") {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ""} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + " / " + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== "custom") subEl.innerHTML = paginationHTML || "";
            if (params.type === "bullets") swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== "custom") emit("paginationRender", el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $d97b353fb4cc475d$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.filter((subEl)=>{
                if ((0, $737414888e8d31b2$export$407448d2b89b1813)(subEl, ".swiper")[0] !== swiper.el) return false;
                return true;
            })[0];
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            if (params.type === "bullets" && params.clickable) subEl.classList.add(...(params.clickableClass || "").split(" "));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === "progressbar" && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener("click", onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || "").split(" "));
                    subEl.removeEventListener("click", onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(" ")));
    }
    on("changeDirection", ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", ()=>{
        if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", ()=>{
        update();
    });
    on("snapGridLengthChange", ()=>{
        render();
        update();
    });
    on("destroy", ()=>{
        destroy();
    });
    on("enable disable", ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass));
        }
    });
    on("lock unlock", ()=>{
        update();
    });
    on("click", (_s, e)=>{
        const targetEl = e.target;
        const el = makeElementsArray(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = makeElementsArray(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}





function $d0931fa014098cca$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = "";
        dragEl.style.height = "";
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = "none";
        else el.style.display = "";
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $737414888e8d31b2$export$8b22cf2602fb60ce)(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = "100ms";
        dragEl.style.transitionDuration = "100ms";
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = "0ms";
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style["scroll-snap-type"] = "none";
        emit("scrollbarDragStart", e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = "0ms";
        el.style.transitionDuration = "0ms";
        dragEl.style.transitionDuration = "0ms";
        emit("scrollbarDragMove", e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style["scroll-snap-type"] = "";
            wrapperEl.style.transitionDuration = "";
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        target[eventMethod]("pointerdown", onDragStart, activeListener);
        document[eventMethod]("pointermove", onDragMove, activeListener);
        document[eventMethod]("pointerup", onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $d97b353fb4cc475d$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === "string") el = document.querySelectorAll(params.el);
        else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector(`.${swiper.params.scrollbar.dragClass}`);
            if (!dragEl) {
                dragEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on("init", ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock", ()=>{
        updateSize();
    });
    on("setTranslate", ()=>{
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        setTransition(duration);
    });
    on("enable disable", ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    });
    on("destroy", ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $ee7539a46857f0eb$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]";
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute("data-swiper-parallax") || "0";
        let x = el.getAttribute("data-swiper-parallax-x");
        let y = el.getAttribute("data-swiper-parallax-y");
        const scale = el.getAttribute("data-swiper-parallax-scale");
        const opacity = el.getAttribute("data-swiper-parallax-opacity");
        const rotate = el.getAttribute("data-swiper-parallax-rotate");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf("%") >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== "undefined" && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== "undefined" && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== "undefined" && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $737414888e8d31b2$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $737414888e8d31b2$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on("beforeInit", ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $759564f7265016ff$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === "mouse") evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $737414888e8d31b2$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = "0ms";
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === "mouse" && e.type === "pointerout") return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth;
            image.height = gesture.imageEl.offsetHeight;
            image.startX = (0, $737414888e8d31b2$export$dda1d9f60106f0e9)(gesture.imageWrapEl, "x") || 0;
            image.startY = (0, $737414888e8d31b2$export$dda1d9f60106f0e9)(gesture.imageWrapEl, "y") || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = "0ms";
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $737414888e8d31b2$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $737414888e8d31b2$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const forceZoomRatio = typeof e === "number" ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
        }
        zoom.scale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        currentScale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $737414888e8d31b2$export$8b22cf2602fb60ce)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $737414888e8d31b2$export$8b22cf2602fb60ce)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth;
            imageHeight = gesture.imageEl.offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $737414888e8d31b2$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $737414888e8d31b2$export$407448d2b89b1813)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    }
    on("init", ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", ()=>{
        disable();
    });
    on("touchStart", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on("doubleTap", (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $d32a53564318ff98$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $737414888e8d31b2$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $737414888e8d31b2$export$23f2a1d2818174ef)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on("beforeInit", ()=>{
        if (typeof window !== "undefined" && // eslint-disable-line
        (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElement = document.querySelector(swiper.params.controller.control);
            if (controlElement && controlElement.swiper) swiper.controller.control = controlElement.swiper;
            else if (controlElement) {
                const onControllerSwiper = (e)=>{
                    swiper.controller.control = e.detail[0];
                    swiper.update();
                    controlElement.removeEventListener("init", onControllerSwiper);
                };
                controlElement.addEventListener("init", onControllerSwiper);
            }
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", ()=>{
        removeSpline();
    });
    on("resize", ()=>{
        removeSpline();
    });
    on("observerUpdate", ()=>{
        removeSpline();
    });
    on("setTranslate", (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $ddec56a6d154f225$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = "";
        notification.innerHTML = message;
    }
    const makeElementsArray = (el)=>(Array.isArray(el) ? el : [
            el
        ]).filter((e)=>!!e);
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return "x".repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "0");
        });
    }
    function makeElNotFocusable(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("tabIndex", "-1");
        });
    }
    function addElRole(el, role) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("role", role);
        });
    }
    function addElRoleDescription(el, description) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-roledescription", description);
        });
    }
    function addElControls(el, controls) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-controls", controls);
        });
    }
    function addElLabel(el, label) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-label", label);
        });
    }
    function addElId(el, id) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("id", id);
        });
    }
    function addElLive(el, live) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-live", live);
        });
    }
    function disableEl(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", true);
        });
    }
    function enableEl(el) {
        el = makeElementsArray(el);
        el.forEach((subEl)=>{
            subEl.setAttribute("aria-disabled", false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && targetEl.matches((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, "button");
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $737414888e8d31b2$export$39b482c5e57630a8)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $d9d2cfaa8c2f08b1$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute("aria-current", "true");
            else bulletEl.removeAttribute("aria-current");
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== "BUTTON") {
            addElRole(el, "button");
            el.addEventListener("keydown", onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute("id") || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [
                swiper.pagination.el
            ];
            paginationEl.forEach((el)=>{
                el.addEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("pointerdown", handlePointerDown, true);
        swiper.el.addEventListener("pointerup", handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener("keydown", onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [
                swiper.pagination.el
            ];
            paginationEl.forEach((el)=>{
                el.removeEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        swiper.el.removeEventListener("focus", handleFocus, true);
        swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
        swiper.el.removeEventListener("pointerup", handlePointerUp, true);
    }
    on("beforeInit", ()=>{
        liveRegion = (0, $737414888e8d31b2$export$db3b6bfb95261072)("span", swiper.params.a11y.notificationClass);
        liveRegion.setAttribute("aria-live", "assertive");
        liveRegion.setAttribute("aria-atomic", "true");
    });
    on("afterInit", ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $0a7f72abb390586e$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split("/").filter((part)=>part !== "");
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides[index];
        let value = slugify(slide.getAttribute("data-history"));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ""}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ""}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute("data-history"));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", ()=>{
        if (swiper.params.history.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $6a005130dbe95232$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, on: on } = _ref;
    let initialized = false;
    const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
    const window = (0, $709edbf6299cccbc$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.filter((slideEl)=>slideEl.getAttribute("data-hash") === hash)[0];
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $737414888e8d31b2$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit("hashChange");
        const newHash = document.location.hash.replace("#", "");
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === "undefined" || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || "");
            emit("hashSet");
        } else {
            document.location.hash = activeSlideHash || "";
            emit("hashSet");
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace("#", "");
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener("hashchange", onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener("hashchange", onHashChange);
    };
    on("init", ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", ()=>{
        if (initialized) setHash();
    });
    on("slideChange", ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $eaf75da0b716a547$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime;
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.filter((slideEl)=>slideEl.classList.contains("swiper-slide-active"))[0];
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit("autoplay");
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit("autoplay");
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        swiper.autoplay.running = true;
        run();
        emit("autoplayStart");
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit("autoplayStop");
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit("autoplayPause");
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit("autoplayResume");
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
        if (document.visibilityState === "hidden") {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === "visible") resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== "mouse") return;
        pausedByInteraction = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== "mouse") return;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener("pointerenter", onPointerEnter);
            swiper.el.addEventListener("pointerleave", onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        swiper.el.removeEventListener("pointerenter", onPointerEnter);
        swiper.el.removeEventListener("pointerleave", onPointerLeave);
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
        document.addEventListener("visibilitychange", onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            autoplayStartTime = new Date().getTime();
            start();
        }
    });
    on("destroy", ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on("beforeTransitionStart", (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("sliderFirstMove", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on("touchEnd", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on("slideChange", ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $3fb235b8df1172c3$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $737414888e8d31b2$export$35e795649ee09318)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $737414888e8d31b2$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.filter((slideEl)=>slideEl.getAttribute("data-swiper-slide-index") === `${swiper.realIndex}`)[0];
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on("beforeInit", ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $709edbf6299cccbc$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener("init", onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener("init", onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on("slideChange update resize observerUpdate", ()=>{
        update();
    });
    on("setTransition", (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $ecce813767c35ba6$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, once: once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $737414888e8d31b2$export$4368d992c4eafac0)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos: currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $737414888e8d31b2$export$4368d992c4eafac0)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $737414888e8d31b2$export$4368d992c4eafac0)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $737414888e8d31b2$export$23f2a1d2818174ef)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $737414888e8d31b2$export$23f2a1d2818174ef)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $737414888e8d31b2$export$23f2a1d2818174ef)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $0c0d2c4292134b5f$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
        else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === "row" && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style[getDirectionLabel("margin-top")] = row !== 0 ? spaceBetween && `${spaceBetween}px` : "";
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.wrapperEl.style[getDirectionLabel("width")] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $4b64943e8b7d45e9$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $4b64943e8b7d45e9$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === "string") {
            const tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $4b64943e8b7d45e9$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $4b64943e8b7d45e9$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $4b64943e8b7d45e9$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $4b64943e8b7d45e9$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: $4b64943e8b7d45e9$var$appendSlide.bind(swiper),
        prependSlide: $4b64943e8b7d45e9$var$prependSlide.bind(swiper),
        addSlide: $4b64943e8b7d45e9$var$addSlide.bind(swiper),
        removeSlide: $4b64943e8b7d45e9$var$removeSlide.bind(swiper),
        removeAllSlides: $4b64943e8b7d45e9$var$removeAllSlides.bind(swiper)
    });
}


function $3e1d86cf3c3014a7$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on("beforeInit", ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on("virtualUpdate", ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $2badf9babbb38496$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $737414888e8d31b2$export$342063e11d6c3cad)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = "hidden";
        transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
}



function $3e1430f6f6738d78$export$f1e1789686576879(_ref) {
    let { swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides } = _ref;
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.filter((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode)[0];
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $737414888e8d31b2$export$23f2a1d2818174ef)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent("transitionend", {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $db93034b7b46e880$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $2badf9babbb38496$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $737414888e8d31b2$export$342063e11d6c3cad)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $3e1430f6f6738d78$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $3e1d86cf3c3014a7$export$f1e1789686576879)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $d18dd749558189dc$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) {
            shadowBefore = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "left" : "top"}`.split(" "));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? "right" : "bottom"}`.split(" "));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", "swiper-cube-shadow");
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style["-webkit-transform-origin"] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`;
        wrapperEl.style.setProperty("--swiper-cube-translate-z", `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector(".swiper-cube-shadow");
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $3e1d86cf3c3014a7$export$f1e1789686576879)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $5df6f81c0cc16aec$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ""}${suffix ? ` swiper-slide-shadow-${suffix}` : ""}`;
    const shadowContainer = (0, $737414888e8d31b2$export$342063e11d6c3cad)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(" ").join(".")}`);
    if (!shadowEl) {
        shadowEl = (0, $737414888e8d31b2$export$db3b6bfb95261072)("div", shadowClass.split(" "));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $28c6414a32cbb537$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) shadowBefore = (0, $5df6f81c0cc16aec$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "left" : "top");
        if (!shadowAfter) shadowAfter = (0, $5df6f81c0cc16aec$export$db3b6bfb95261072)("flip", slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const targetEl = (0, $2badf9babbb38496$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $737414888e8d31b2$export$342063e11d6c3cad)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3e1430f6f6738d78$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $3e1d86cf3c3014a7$export$f1e1789686576879)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $5aa9633bcb8b10eb$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const targetEl = (0, $2badf9babbb38496$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
                let shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) shadowBeforeEl = (0, $5df6f81c0cc16aec$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "left" : "top");
                if (!shadowAfterEl) shadowAfterEl = (0, $5df6f81c0cc16aec$export$db3b6bfb95261072)("coverflow", slideEl, isHorizontal ? "right" : "bottom");
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $737414888e8d31b2$export$342063e11d6c3cad)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $3e1d86cf3c3014a7$export$f1e1789686576879)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $e2ffef07309caf7b$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === "string") return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(", ");
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) shadowEl = (0, $5df6f81c0cc16aec$export$db3b6bfb95261072)("creative", slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $2badf9babbb38496$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $737414888e8d31b2$export$342063e11d6c3cad)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3e1430f6f6738d78$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $3e1d86cf3c3014a7$export$f1e1789686576879)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $c4048b77982f3827$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? "-" : "+"} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) shadowEl = (0, $5df6f81c0cc16aec$export$db3b6bfb95261072)("cards", slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $2badf9babbb38496$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $737414888e8d31b2$export$342063e11d6c3cad)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll(".swiper-slide-shadow").forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $3e1430f6f6738d78$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $3e1d86cf3c3014a7$export$f1e1789686576879)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




//Jquery


var $k7705 = parcelRequire("k7705");
!function(t) {
    var n = {};
    function e(r) {
        if (n[r]) return n[r].exports;
        var i = n[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return t[r].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
    }
    e.m = t, e.c = n, e.d = function(t, n, r) {
        e.o(t, n) || Object.defineProperty(t, n, {
            enumerable: !0,
            get: r
        });
    }, e.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        });
    }, e.t = function(t, n) {
        if (1 & n && (t = e(t)), 8 & n) return t;
        if (4 & n && "object" == typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (e.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: t
        }), 2 & n && "string" != typeof t) for(var i in t)e.d(r, i, (function(n) {
            return t[n];
        }).bind(null, i));
        return r;
    }, e.n = function(t) {
        var n = t && t.__esModule ? function() {
            return t.default;
        } : function() {
            return t;
        };
        return e.d(n, "a", n), n;
    }, e.o = function(t, n) {
        return Object.prototype.hasOwnProperty.call(t, n);
    }, e.p = "", e(e.s = 129);
}([
    function(t, n, e) {
        var r = e(1), i = e(7), o = e(14), u = e(11), c = e(17), a = function(t, n, e) {
            var s, f, l, h, p = t & a.F, v = t & a.G, d = t & a.S, y = t & a.P, g = t & a.B, m = v ? r : d ? r[n] || (r[n] = {}) : (r[n] || {}).prototype, _ = v ? i : i[n] || (i[n] = {}), b = _.prototype || (_.prototype = {});
            for(s in v && (e = n), e)l = ((f = !p && m && void 0 !== m[s]) ? m : e)[s], h = g && f ? c(l, r) : y && "function" == typeof l ? c(Function.call, l) : l, m && u(m, s, l, t & a.U), _[s] != l && o(_, s, h), y && b[s] != l && (b[s] = l);
        };
        r.core = i, a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, a.U = 64, a.R = 128, t.exports = a;
    },
    function(t, n) {
        var e = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
        "number" == typeof __g && (__g = e);
    },
    function(t, n) {
        t.exports = function(t) {
            try {
                return !!t();
            } catch (t) {
                return !0;
            }
        };
    },
    function(t, n, e) {
        var r = e(4);
        t.exports = function(t) {
            if (!r(t)) throw TypeError(t + " is not an object!");
            return t;
        };
    },
    function(t, n) {
        t.exports = function(t) {
            return "object" == typeof t ? null !== t : "function" == typeof t;
        };
    },
    function(t, n, e) {
        var r = e(48)("wks"), i = e(29), o = e(1).Symbol, u = "function" == typeof o;
        (t.exports = function(t) {
            return r[t] || (r[t] = u && o[t] || (u ? o : i)("Symbol." + t));
        }).store = r;
    },
    function(t, n, e) {
        var r = e(19), i = Math.min;
        t.exports = function(t) {
            return t > 0 ? i(r(t), 9007199254740991) : 0;
        };
    },
    function(t, n) {
        var e = t.exports = {
            version: "2.6.11"
        };
        "number" == typeof __e && (__e = e);
    },
    function(t, n, e) {
        t.exports = !e(2)(function() {
            return 7 != Object.defineProperty({}, "a", {
                get: function() {
                    return 7;
                }
            }).a;
        });
    },
    function(t, n, e) {
        var r = e(3), i = e(96), o = e(26), u = Object.defineProperty;
        n.f = e(8) ? Object.defineProperty : function(t, n, e) {
            if (r(t), n = o(n, !0), r(e), i) try {
                return u(t, n, e);
            } catch (t) {}
            if ("get" in e || "set" in e) throw TypeError("Accessors not supported!");
            return "value" in e && (t[n] = e.value), t;
        };
    },
    function(t, n, e) {
        var r = e(24);
        t.exports = function(t) {
            return Object(r(t));
        };
    },
    function(t, n, e) {
        var r = e(1), i = e(14), o = e(13), u = e(29)("src"), c = e(144), a = ("" + c).split("toString");
        e(7).inspectSource = function(t) {
            return c.call(t);
        }, (t.exports = function(t, n, e, c) {
            var s = "function" == typeof e;
            s && (o(e, "name") || i(e, "name", n)), t[n] !== e && (s && (o(e, u) || i(e, u, t[n] ? "" + t[n] : a.join(String(n)))), t === r ? t[n] = e : c ? t[n] ? t[n] = e : i(t, n, e) : (delete t[n], i(t, n, e)));
        })(Function.prototype, "toString", function() {
            return "function" == typeof this && this[u] || c.call(this);
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(2), o = e(24), u = /"/g, c = function(t, n, e, r) {
            var i = String(o(t)), c = "<" + n;
            return "" !== e && (c += " " + e + '="' + String(r).replace(u, "&quot;") + '"'), c + ">" + i + "</" + n + ">";
        };
        t.exports = function(t, n) {
            var e = {};
            e[t] = n(c), r(r.P + r.F * i(function() {
                var n = ""[t]('"');
                return n !== n.toLowerCase() || n.split('"').length > 3;
            }), "String", e);
        };
    },
    function(t, n) {
        var e = {}.hasOwnProperty;
        t.exports = function(t, n) {
            return e.call(t, n);
        };
    },
    function(t, n, e) {
        var r = e(9), i = e(28);
        t.exports = e(8) ? function(t, n, e) {
            return r.f(t, n, i(1, e));
        } : function(t, n, e) {
            return t[n] = e, t;
        };
    },
    function(t, n, e) {
        var r = e(44), i = e(24);
        t.exports = function(t) {
            return r(i(t));
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(2);
        t.exports = function(t, n) {
            return !!t && r(function() {
                n ? t.call(null, function() {}, 1) : t.call(null);
            });
        };
    },
    function(t, n, e) {
        var r = e(18);
        t.exports = function(t, n, e) {
            if (r(t), void 0 === n) return t;
            switch(e){
                case 1:
                    return function(e) {
                        return t.call(n, e);
                    };
                case 2:
                    return function(e, r) {
                        return t.call(n, e, r);
                    };
                case 3:
                    return function(e, r, i) {
                        return t.call(n, e, r, i);
                    };
            }
            return function() {
                return t.apply(n, arguments);
            };
        };
    },
    function(t, n) {
        t.exports = function(t) {
            if ("function" != typeof t) throw TypeError(t + " is not a function!");
            return t;
        };
    },
    function(t, n) {
        var e = Math.ceil, r = Math.floor;
        t.exports = function(t) {
            return isNaN(t = +t) ? 0 : (t > 0 ? r : e)(t);
        };
    },
    function(t, n, e) {
        var r = e(45), i = e(28), o = e(15), u = e(26), c = e(13), a = e(96), s = Object.getOwnPropertyDescriptor;
        n.f = e(8) ? s : function(t, n) {
            if (t = o(t), n = u(n, !0), a) try {
                return s(t, n);
            } catch (t) {}
            if (c(t, n)) return i(!r.f.call(t, n), t[n]);
        };
    },
    function(t, n, e) {
        var r = e(0), i = e(7), o = e(2);
        t.exports = function(t, n) {
            var e = (i.Object || {})[t] || Object[t], u = {};
            u[t] = n(e), r(r.S + r.F * o(function() {
                e(1);
            }), "Object", u);
        };
    },
    function(t, n, e) {
        var r = e(17), i = e(44), o = e(10), u = e(6), c = e(112);
        t.exports = function(t, n) {
            var e = 1 == t, a = 2 == t, s = 3 == t, f = 4 == t, l = 6 == t, h = 5 == t || l, p = n || c;
            return function(n, c, v) {
                for(var d, y, g = o(n), m = i(g), _ = r(c, v, 3), b = u(m.length), x = 0, S = e ? p(n, b) : a ? p(n, 0) : void 0; b > x; x++)if ((h || x in m) && (y = _(d = m[x], x, g), t)) {
                    if (e) S[x] = y;
                    else if (y) switch(t){
                        case 3:
                            return !0;
                        case 5:
                            return d;
                        case 6:
                            return x;
                        case 2:
                            S.push(d);
                    }
                    else if (f) return !1;
                }
                return l ? -1 : s || f ? f : S;
            };
        };
    },
    function(t, n) {
        var e = {}.toString;
        t.exports = function(t) {
            return e.call(t).slice(8, -1);
        };
    },
    function(t, n) {
        t.exports = function(t) {
            if (null == t) throw TypeError("Can't call method on  " + t);
            return t;
        };
    },
    function(t, n, e) {
        "use strict";
        if (e(8)) {
            var r = e(30), i = e(1), o = e(2), u = e(0), c = e(59), a = e(86), s = e(17), f = e(42), l = e(28), h = e(14), p = e(43), v = e(19), d = e(6), y = e(123), g = e(32), m = e(26), _ = e(13), b = e(46), x = e(4), S = e(10), w = e(78), E = e(33), O = e(35), P = e(34).f, F = e(80), j = e(29), M = e(5), A = e(22), I = e(49), k = e(47), N = e(82), L = e(40), T = e(52), R = e(41), C = e(81), D = e(114), B = e(9), W = e(20), V = B.f, $ = W.f, G = i.RangeError, U = i.TypeError, z = i.Uint8Array, q = Array.prototype, Y = a.ArrayBuffer, H = a.DataView, Z = A(0), K = A(2), J = A(3), X = A(4), Q = A(5), tt = A(6), nt = I(!0), et = I(!1), rt = N.values, it = N.keys, ot = N.entries, ut = q.lastIndexOf, ct = q.reduce, at = q.reduceRight, st = q.join, ft = q.sort, lt = q.slice, ht = q.toString, pt = q.toLocaleString, vt = M("iterator"), dt = M("toStringTag"), yt = j("typed_constructor"), gt = j("def_constructor"), mt = c.CONSTR, _t = c.TYPED, bt = c.VIEW, xt = A(1, function(t, n) {
                return Pt(k(t, t[gt]), n);
            }), St = o(function() {
                return 1 === new z(new Uint16Array([
                    1
                ]).buffer)[0];
            }), wt = !!z && !!z.prototype.set && o(function() {
                new z(1).set({});
            }), Et = function(t, n) {
                var e = v(t);
                if (e < 0 || e % n) throw G("Wrong offset!");
                return e;
            }, Ot = function(t) {
                if (x(t) && _t in t) return t;
                throw U(t + " is not a typed array!");
            }, Pt = function(t, n) {
                if (!x(t) || !(yt in t)) throw U("It is not a typed array constructor!");
                return new t(n);
            }, Ft = function(t, n) {
                return jt(k(t, t[gt]), n);
            }, jt = function(t, n) {
                for(var e = 0, r = n.length, i = Pt(t, r); r > e;)i[e] = n[e++];
                return i;
            }, Mt = function(t, n, e) {
                V(t, n, {
                    get: function() {
                        return this._d[e];
                    }
                });
            }, At = function(t) {
                var n, e, r, i, o, u, c = S(t), a = arguments.length, f = a > 1 ? arguments[1] : void 0, l = void 0 !== f, h = F(c);
                if (null != h && !w(h)) {
                    for(u = h.call(c), r = [], n = 0; !(o = u.next()).done; n++)r.push(o.value);
                    c = r;
                }
                for(l && a > 2 && (f = s(f, arguments[2], 2)), n = 0, e = d(c.length), i = Pt(this, e); e > n; n++)i[n] = l ? f(c[n], n) : c[n];
                return i;
            }, It = function() {
                for(var t = 0, n = arguments.length, e = Pt(this, n); n > t;)e[t] = arguments[t++];
                return e;
            }, kt = !!z && o(function() {
                pt.call(new z(1));
            }), Nt = function() {
                return pt.apply(kt ? lt.call(Ot(this)) : Ot(this), arguments);
            }, Lt = {
                copyWithin: function(t, n) {
                    return D.call(Ot(this), t, n, arguments.length > 2 ? arguments[2] : void 0);
                },
                every: function(t) {
                    return X(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
                },
                fill: function(t) {
                    return C.apply(Ot(this), arguments);
                },
                filter: function(t) {
                    return Ft(this, K(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0));
                },
                find: function(t) {
                    return Q(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
                },
                findIndex: function(t) {
                    return tt(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
                },
                forEach: function(t) {
                    Z(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
                },
                indexOf: function(t) {
                    return et(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
                },
                includes: function(t) {
                    return nt(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
                },
                join: function(t) {
                    return st.apply(Ot(this), arguments);
                },
                lastIndexOf: function(t) {
                    return ut.apply(Ot(this), arguments);
                },
                map: function(t) {
                    return xt(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
                },
                reduce: function(t) {
                    return ct.apply(Ot(this), arguments);
                },
                reduceRight: function(t) {
                    return at.apply(Ot(this), arguments);
                },
                reverse: function() {
                    for(var t, n = Ot(this).length, e = Math.floor(n / 2), r = 0; r < e;)t = this[r], this[r++] = this[--n], this[n] = t;
                    return this;
                },
                some: function(t) {
                    return J(Ot(this), t, arguments.length > 1 ? arguments[1] : void 0);
                },
                sort: function(t) {
                    return ft.call(Ot(this), t);
                },
                subarray: function(t, n) {
                    var e = Ot(this), r = e.length, i = g(t, r);
                    return new (k(e, e[gt]))(e.buffer, e.byteOffset + i * e.BYTES_PER_ELEMENT, d((void 0 === n ? r : g(n, r)) - i));
                }
            }, Tt = function(t, n) {
                return Ft(this, lt.call(Ot(this), t, n));
            }, Rt = function(t) {
                Ot(this);
                var n = Et(arguments[1], 1), e = this.length, r = S(t), i = d(r.length), o = 0;
                if (i + n > e) throw G("Wrong length!");
                for(; o < i;)this[n + o] = r[o++];
            }, Ct = {
                entries: function() {
                    return ot.call(Ot(this));
                },
                keys: function() {
                    return it.call(Ot(this));
                },
                values: function() {
                    return rt.call(Ot(this));
                }
            }, Dt = function(t, n) {
                return x(t) && t[_t] && "symbol" != typeof n && n in t && String(+n) == String(n);
            }, Bt = function(t, n) {
                return Dt(t, n = m(n, !0)) ? l(2, t[n]) : $(t, n);
            }, Wt = function(t, n, e) {
                return !(Dt(t, n = m(n, !0)) && x(e) && _(e, "value")) || _(e, "get") || _(e, "set") || e.configurable || _(e, "writable") && !e.writable || _(e, "enumerable") && !e.enumerable ? V(t, n, e) : (t[n] = e.value, t);
            };
            mt || (W.f = Bt, B.f = Wt), u(u.S + u.F * !mt, "Object", {
                getOwnPropertyDescriptor: Bt,
                defineProperty: Wt
            }), o(function() {
                ht.call({});
            }) && (ht = pt = function() {
                return st.call(this);
            });
            var Vt = p({}, Lt);
            p(Vt, Ct), h(Vt, vt, Ct.values), p(Vt, {
                slice: Tt,
                set: Rt,
                constructor: function() {},
                toString: ht,
                toLocaleString: Nt
            }), Mt(Vt, "buffer", "b"), Mt(Vt, "byteOffset", "o"), Mt(Vt, "byteLength", "l"), Mt(Vt, "length", "e"), V(Vt, dt, {
                get: function() {
                    return this[_t];
                }
            }), t.exports = function(t, n, e, a) {
                var s = t + ((a = !!a) ? "Clamped" : "") + "Array", l = "get" + t, p = "set" + t, v = i[s], g = v || {}, m = v && O(v), _ = !v || !c.ABV, S = {}, w = v && v.prototype, F = function(t, e) {
                    V(t, e, {
                        get: function() {
                            return function(t, e) {
                                var r = t._d;
                                return r.v[l](e * n + r.o, St);
                            }(this, e);
                        },
                        set: function(t) {
                            return function(t, e, r) {
                                var i = t._d;
                                a && (r = (r = Math.round(r)) < 0 ? 0 : r > 255 ? 255 : 255 & r), i.v[p](e * n + i.o, r, St);
                            }(this, e, t);
                        },
                        enumerable: !0
                    });
                };
                _ ? (v = e(function(t, e, r, i) {
                    f(t, v, s, "_d");
                    var o, u, c, a, l = 0, p = 0;
                    if (x(e)) {
                        if (!(e instanceof Y || "ArrayBuffer" == (a = b(e)) || "SharedArrayBuffer" == a)) return _t in e ? jt(v, e) : At.call(v, e);
                        o = e, p = Et(r, n);
                        var g = e.byteLength;
                        if (void 0 === i) {
                            if (g % n) throw G("Wrong length!");
                            if ((u = g - p) < 0) throw G("Wrong length!");
                        } else if ((u = d(i) * n) + p > g) throw G("Wrong length!");
                        c = u / n;
                    } else c = y(e), o = new Y(u = c * n);
                    for(h(t, "_d", {
                        b: o,
                        o: p,
                        l: u,
                        e: c,
                        v: new H(o)
                    }); l < c;)F(t, l++);
                }), w = v.prototype = E(Vt), h(w, "constructor", v)) : o(function() {
                    v(1);
                }) && o(function() {
                    new v(-1);
                }) && T(function(t) {
                    new v, new v(null), new v(1.5), new v(t);
                }, !0) || (v = e(function(t, e, r, i) {
                    var o;
                    return f(t, v, s), x(e) ? e instanceof Y || "ArrayBuffer" == (o = b(e)) || "SharedArrayBuffer" == o ? void 0 !== i ? new g(e, Et(r, n), i) : void 0 !== r ? new g(e, Et(r, n)) : new g(e) : _t in e ? jt(v, e) : At.call(v, e) : new g(y(e));
                }), Z(m !== Function.prototype ? P(g).concat(P(m)) : P(g), function(t) {
                    t in v || h(v, t, g[t]);
                }), v.prototype = w, r || (w.constructor = v));
                var j = w[vt], M = !!j && ("values" == j.name || null == j.name), A = Ct.values;
                h(v, yt, !0), h(w, _t, s), h(w, bt, !0), h(w, gt, v), (a ? new v(1)[dt] == s : dt in w) || V(w, dt, {
                    get: function() {
                        return s;
                    }
                }), S[s] = v, u(u.G + u.W + u.F * (v != g), S), u(u.S, s, {
                    BYTES_PER_ELEMENT: n
                }), u(u.S + u.F * o(function() {
                    g.of.call(v, 1);
                }), s, {
                    from: At,
                    of: It
                }), "BYTES_PER_ELEMENT" in w || h(w, "BYTES_PER_ELEMENT", n), u(u.P, s, Lt), R(s), u(u.P + u.F * wt, s, {
                    set: Rt
                }), u(u.P + u.F * !M, s, Ct), r || w.toString == ht || (w.toString = ht), u(u.P + u.F * o(function() {
                    new v(1).slice();
                }), s, {
                    slice: Tt
                }), u(u.P + u.F * (o(function() {
                    return [
                        1,
                        2
                    ].toLocaleString() != new v([
                        1,
                        2
                    ]).toLocaleString();
                }) || !o(function() {
                    w.toLocaleString.call([
                        1,
                        2
                    ]);
                })), s, {
                    toLocaleString: Nt
                }), L[s] = M ? j : A, r || M || h(w, vt, A);
            };
        } else t.exports = function() {};
    },
    function(t, n, e) {
        var r = e(4);
        t.exports = function(t, n) {
            if (!r(t)) return t;
            var e, i;
            if (n && "function" == typeof (e = t.toString) && !r(i = e.call(t))) return i;
            if ("function" == typeof (e = t.valueOf) && !r(i = e.call(t))) return i;
            if (!n && "function" == typeof (e = t.toString) && !r(i = e.call(t))) return i;
            throw TypeError("Can't convert object to primitive value");
        };
    },
    function(t, n, e) {
        var r = e(29)("meta"), i = e(4), o = e(13), u = e(9).f, c = 0, a = Object.isExtensible || function() {
            return !0;
        }, s = !e(2)(function() {
            return a(Object.preventExtensions({}));
        }), f = function(t) {
            u(t, r, {
                value: {
                    i: "O" + ++c,
                    w: {}
                }
            });
        }, l = t.exports = {
            KEY: r,
            NEED: !1,
            fastKey: function(t, n) {
                if (!i(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;
                if (!o(t, r)) {
                    if (!a(t)) return "F";
                    if (!n) return "E";
                    f(t);
                }
                return t[r].i;
            },
            getWeak: function(t, n) {
                if (!o(t, r)) {
                    if (!a(t)) return !0;
                    if (!n) return !1;
                    f(t);
                }
                return t[r].w;
            },
            onFreeze: function(t) {
                return s && l.NEED && a(t) && !o(t, r) && f(t), t;
            }
        };
    },
    function(t, n) {
        t.exports = function(t, n) {
            return {
                enumerable: !(1 & t),
                configurable: !(2 & t),
                writable: !(4 & t),
                value: n
            };
        };
    },
    function(t, n) {
        var e = 0, r = Math.random();
        t.exports = function(t) {
            return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++e + r).toString(36));
        };
    },
    function(t, n) {
        t.exports = !1;
    },
    function(t, n, e) {
        var r = e(98), i = e(65);
        t.exports = Object.keys || function(t) {
            return r(t, i);
        };
    },
    function(t, n, e) {
        var r = e(19), i = Math.max, o = Math.min;
        t.exports = function(t, n) {
            return (t = r(t)) < 0 ? i(t + n, 0) : o(t, n);
        };
    },
    function(t, n, e) {
        var r = e(3), i = e(99), o = e(65), u = e(64)("IE_PROTO"), c = function() {}, a = function() {
            var t, n = e(62)("iframe"), r = o.length;
            for(n.style.display = "none", e(66).appendChild(n), n.src = "javascript:", (t = n.contentWindow.document).open(), t.write("<script>document.F=Object</script>"), t.close(), a = t.F; r--;)delete a.prototype[o[r]];
            return a();
        };
        t.exports = Object.create || function(t, n) {
            var e;
            return null !== t ? (c.prototype = r(t), e = new c, c.prototype = null, e[u] = t) : e = a(), void 0 === n ? e : i(e, n);
        };
    },
    function(t, n, e) {
        var r = e(98), i = e(65).concat("length", "prototype");
        n.f = Object.getOwnPropertyNames || function(t) {
            return r(t, i);
        };
    },
    function(t, n, e) {
        var r = e(13), i = e(10), o = e(64)("IE_PROTO"), u = Object.prototype;
        t.exports = Object.getPrototypeOf || function(t) {
            return t = i(t), r(t, o) ? t[o] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null;
        };
    },
    function(t, n, e) {
        var r = e(5)("unscopables"), i = Array.prototype;
        null == i[r] && e(14)(i, r, {}), t.exports = function(t) {
            i[r][t] = !0;
        };
    },
    function(t, n, e) {
        var r = e(4);
        t.exports = function(t, n) {
            if (!r(t) || t._t !== n) throw TypeError("Incompatible receiver, " + n + " required!");
            return t;
        };
    },
    function(t, n, e) {
        var r = e(9).f, i = e(13), o = e(5)("toStringTag");
        t.exports = function(t, n, e) {
            t && !i(t = e ? t : t.prototype, o) && r(t, o, {
                configurable: !0,
                value: n
            });
        };
    },
    function(t, n, e) {
        var r = e(0), i = e(24), o = e(2), u = e(68), c = "[" + u + "]", a = RegExp("^" + c + c + "*"), s = RegExp(c + c + "*$"), f = function(t, n, e) {
            var i = {}, c = o(function() {
                return !!u[t]() || "​\x85" != "​\x85"[t]();
            }), a = i[t] = c ? n(l) : u[t];
            e && (i[e] = a), r(r.P + r.F * c, "String", i);
        }, l = f.trim = function(t, n) {
            return t = String(i(t)), 1 & n && (t = t.replace(a, "")), 2 & n && (t = t.replace(s, "")), t;
        };
        t.exports = f;
    },
    function(t, n) {
        t.exports = {};
    },
    function(t, n, e) {
        "use strict";
        var r = e(1), i = e(9), o = e(8), u = e(5)("species");
        t.exports = function(t) {
            var n = r[t];
            o && n && !n[u] && i.f(n, u, {
                configurable: !0,
                get: function() {
                    return this;
                }
            });
        };
    },
    function(t, n) {
        t.exports = function(t, n, e, r) {
            if (!(t instanceof n) || void 0 !== r && r in t) throw TypeError(e + ": incorrect invocation!");
            return t;
        };
    },
    function(t, n, e) {
        var r = e(11);
        t.exports = function(t, n, e) {
            for(var i in n)r(t, i, n[i], e);
            return t;
        };
    },
    function(t, n, e) {
        var r = e(23);
        t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(t) {
            return "String" == r(t) ? t.split("") : Object(t);
        };
    },
    function(t, n) {
        n.f = ({}).propertyIsEnumerable;
    },
    function(t, n, e) {
        var r = e(23), i = e(5)("toStringTag"), o = "Arguments" == r(function() {
            return arguments;
        }());
        t.exports = function(t) {
            var n, e, u;
            return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (e = function(t, n) {
                try {
                    return t[n];
                } catch (t) {}
            }(n = Object(t), i)) ? e : o ? r(n) : "Object" == (u = r(n)) && "function" == typeof n.callee ? "Arguments" : u;
        };
    },
    function(t, n, e) {
        var r = e(3), i = e(18), o = e(5)("species");
        t.exports = function(t, n) {
            var e, u = r(t).constructor;
            return void 0 === u || null == (e = r(u)[o]) ? n : i(e);
        };
    },
    function(t, n, e) {
        var r = e(7), i = e(1), o = i["__core-js_shared__"] || (i["__core-js_shared__"] = {});
        (t.exports = function(t, n) {
            return o[t] || (o[t] = void 0 !== n ? n : {});
        })("versions", []).push({
            version: r.version,
            mode: e(30) ? "pure" : "global",
            copyright: "\xa9 2019 Denis Pushkarev (zloirock.ru)"
        });
    },
    function(t, n, e) {
        var r = e(15), i = e(6), o = e(32);
        t.exports = function(t) {
            return function(n, e, u) {
                var c, a = r(n), s = i(a.length), f = o(u, s);
                if (t && e != e) {
                    for(; s > f;)if ((c = a[f++]) != c) return !0;
                } else for(; s > f; f++)if ((t || f in a) && a[f] === e) return t || f || 0;
                return !t && -1;
            };
        };
    },
    function(t, n) {
        n.f = Object.getOwnPropertySymbols;
    },
    function(t, n, e) {
        var r = e(23);
        t.exports = Array.isArray || function(t) {
            return "Array" == r(t);
        };
    },
    function(t, n, e) {
        var r = e(5)("iterator"), i = !1;
        try {
            var o = [
                7
            ][r]();
            o.return = function() {
                i = !0;
            }, Array.from(o, function() {
                throw 2;
            });
        } catch (t) {}
        t.exports = function(t, n) {
            if (!n && !i) return !1;
            var e = !1;
            try {
                var o = [
                    7
                ], u = o[r]();
                u.next = function() {
                    return {
                        done: e = !0
                    };
                }, o[r] = function() {
                    return u;
                }, t(o);
            } catch (t) {}
            return e;
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(3);
        t.exports = function() {
            var t = r(this), n = "";
            return t.global && (n += "g"), t.ignoreCase && (n += "i"), t.multiline && (n += "m"), t.unicode && (n += "u"), t.sticky && (n += "y"), n;
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(46), i = RegExp.prototype.exec;
        t.exports = function(t, n) {
            var e = t.exec;
            if ("function" == typeof e) {
                var o = e.call(t, n);
                if ("object" != typeof o) throw new TypeError("RegExp exec method returned something other than an Object or null");
                return o;
            }
            if ("RegExp" !== r(t)) throw new TypeError("RegExp#exec called on incompatible receiver");
            return i.call(t, n);
        };
    },
    function(t, n, e) {
        "use strict";
        e(116);
        var r = e(11), i = e(14), o = e(2), u = e(24), c = e(5), a = e(83), s = c("species"), f = !o(function() {
            var t = /./;
            return t.exec = function() {
                var t = [];
                return t.groups = {
                    a: "7"
                }, t;
            }, "7" !== "".replace(t, "$<a>");
        }), l = function() {
            var t = /(?:)/, n = t.exec;
            t.exec = function() {
                return n.apply(this, arguments);
            };
            var e = "ab".split(t);
            return 2 === e.length && "a" === e[0] && "b" === e[1];
        }();
        t.exports = function(t, n, e) {
            var h = c(t), p = !o(function() {
                var n = {};
                return n[h] = function() {
                    return 7;
                }, 7 != ""[t](n);
            }), v = p ? !o(function() {
                var n = !1, e = /a/;
                return e.exec = function() {
                    return n = !0, null;
                }, "split" === t && (e.constructor = {}, e.constructor[s] = function() {
                    return e;
                }), e[h](""), !n;
            }) : void 0;
            if (!p || !v || "replace" === t && !f || "split" === t && !l) {
                var d = /./[h], y = e(u, h, ""[t], function(t, n, e, r, i) {
                    return n.exec === a ? p && !i ? {
                        done: !0,
                        value: d.call(n, e, r)
                    } : {
                        done: !0,
                        value: t.call(e, n, r)
                    } : {
                        done: !1
                    };
                }), g = y[0], m = y[1];
                r(String.prototype, t, g), i(RegExp.prototype, h, 2 == n ? function(t, n) {
                    return m.call(t, this, n);
                } : function(t) {
                    return m.call(t, this);
                });
            }
        };
    },
    function(t, n, e) {
        var r = e(17), i = e(111), o = e(78), u = e(3), c = e(6), a = e(80), s = {}, f = {};
        (n = t.exports = function(t, n, e, l, h) {
            var p, v, d, y, g = h ? function() {
                return t;
            } : a(t), m = r(e, l, n ? 2 : 1), _ = 0;
            if ("function" != typeof g) throw TypeError(t + " is not iterable!");
            if (o(g)) {
                for(p = c(t.length); p > _; _++)if ((y = n ? m(u(v = t[_])[0], v[1]) : m(t[_])) === s || y === f) return y;
            } else for(d = g.call(t); !(v = d.next()).done;)if ((y = i(d, m, v.value, n)) === s || y === f) return y;
        }).BREAK = s, n.RETURN = f;
    },
    function(t, n, e) {
        var r = e(1).navigator;
        t.exports = r && r.userAgent || "";
    },
    function(t, n, e) {
        "use strict";
        var r = e(1), i = e(0), o = e(11), u = e(43), c = e(27), a = e(56), s = e(42), f = e(4), l = e(2), h = e(52), p = e(38), v = e(69);
        t.exports = function(t, n, e, d, y, g) {
            var m = r[t], _ = m, b = y ? "set" : "add", x = _ && _.prototype, S = {}, w = function(t) {
                var n = x[t];
                o(x, t, "delete" == t || "has" == t ? function(t) {
                    return !(g && !f(t)) && n.call(this, 0 === t ? 0 : t);
                } : "get" == t ? function(t) {
                    return g && !f(t) ? void 0 : n.call(this, 0 === t ? 0 : t);
                } : "add" == t ? function(t) {
                    return n.call(this, 0 === t ? 0 : t), this;
                } : function(t, e) {
                    return n.call(this, 0 === t ? 0 : t, e), this;
                });
            };
            if ("function" == typeof _ && (g || x.forEach && !l(function() {
                (new _).entries().next();
            }))) {
                var E = new _, O = E[b](g ? {} : -0, 1) != E, P = l(function() {
                    E.has(1);
                }), F = h(function(t) {
                    new _(t);
                }), j = !g && l(function() {
                    for(var t = new _, n = 5; n--;)t[b](n, n);
                    return !t.has(-0);
                });
                F || ((_ = n(function(n, e) {
                    s(n, _, t);
                    var r = v(new m, n, _);
                    return null != e && a(e, y, r[b], r), r;
                })).prototype = x, x.constructor = _), (P || j) && (w("delete"), w("has"), y && w("get")), (j || O) && w(b), g && x.clear && delete x.clear;
            } else _ = d.getConstructor(n, t, y, b), u(_.prototype, e), c.NEED = !0;
            return p(_, t), S[t] = _, i(i.G + i.W + i.F * (_ != m), S), g || d.setStrong(_, t, y), _;
        };
    },
    function(t, n, e) {
        for(var r, i = e(1), o = e(14), u = e(29), c = u("typed_array"), a = u("view"), s = !(!i.ArrayBuffer || !i.DataView), f = s, l = 0, h = "Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array".split(","); l < 9;)(r = i[h[l++]]) ? (o(r.prototype, c, !0), o(r.prototype, a, !0)) : f = !1;
        t.exports = {
            ABV: s,
            CONSTR: f,
            TYPED: c,
            VIEW: a
        };
    },
    function(t, n) {
        t.exports = function(t) {
            return t && t.__esModule ? t : {
                default: t
            };
        };
    },
    function(t, n) {
        function e(n, r) {
            return t.exports = e = Object.setPrototypeOf || function(t, n) {
                return t.__proto__ = n, t;
            }, e(n, r);
        }
        t.exports = e;
    },
    function(t, n, e) {
        var r = e(4), i = e(1).document, o = r(i) && r(i.createElement);
        t.exports = function(t) {
            return o ? i.createElement(t) : {};
        };
    },
    function(t, n, e) {
        n.f = e(5);
    },
    function(t, n, e) {
        var r = e(48)("keys"), i = e(29);
        t.exports = function(t) {
            return r[t] || (r[t] = i(t));
        };
    },
    function(t, n) {
        t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
    },
    function(t, n, e) {
        var r = e(1).document;
        t.exports = r && r.documentElement;
    },
    function(t, n, e) {
        var r = e(4), i = e(3), o = function(t, n) {
            if (i(t), !r(n) && null !== n) throw TypeError(n + ": can't set as prototype!");
        };
        t.exports = {
            set: Object.setPrototypeOf || ("__proto__" in {} ? function(t, n, r) {
                try {
                    (r = e(17)(Function.call, e(20).f(Object.prototype, "__proto__").set, 2))(t, []), n = !(t instanceof Array);
                } catch (t) {
                    n = !0;
                }
                return function(t, e) {
                    return o(t, e), n ? t.__proto__ = e : r(t, e), t;
                };
            }({}, !1) : void 0),
            check: o
        };
    },
    function(t, n) {
        t.exports = "	\n\v\f\r \xa0 ᠎             　\u2028\u2029\uFEFF";
    },
    function(t, n, e) {
        var r = e(4), i = e(67).set;
        t.exports = function(t, n, e) {
            var o, u = n.constructor;
            return u !== e && "function" == typeof u && (o = u.prototype) !== e.prototype && r(o) && i && i(t, o), t;
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(19), i = e(24);
        t.exports = function(t) {
            var n = String(i(this)), e = "", o = r(t);
            if (o < 0 || o == 1 / 0) throw RangeError("Count can't be negative");
            for(; o > 0; (o >>>= 1) && (n += n))1 & o && (e += n);
            return e;
        };
    },
    function(t, n) {
        t.exports = Math.sign || function(t) {
            return 0 == (t = +t) || t != t ? t : t < 0 ? -1 : 1;
        };
    },
    function(t, n) {
        var e = Math.expm1;
        t.exports = !e || e(10) > 22025.465794806718 || e(10) < 22025.465794806718 || -0.00000000000000002 != e(-0.00000000000000002) ? function(t) {
            return 0 == (t = +t) ? t : t > -0.000001 && t < 1e-6 ? t + t * t / 2 : Math.exp(t) - 1;
        } : e;
    },
    function(t, n, e) {
        var r = e(19), i = e(24);
        t.exports = function(t) {
            return function(n, e) {
                var o, u, c = String(i(n)), a = r(e), s = c.length;
                return a < 0 || a >= s ? t ? "" : void 0 : (o = c.charCodeAt(a)) < 55296 || o > 56319 || a + 1 === s || (u = c.charCodeAt(a + 1)) < 56320 || u > 57343 ? t ? c.charAt(a) : o : t ? c.slice(a, a + 2) : u - 56320 + (o - 55296 << 10) + 65536;
            };
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(30), i = e(0), o = e(11), u = e(14), c = e(40), a = e(110), s = e(38), f = e(35), l = e(5)("iterator"), h = !([].keys && "next" in [].keys()), p = function() {
            return this;
        };
        t.exports = function(t, n, e, v, d, y, g) {
            a(e, n, v);
            var m, _, b, x = function(t) {
                if (!h && t in O) return O[t];
                switch(t){
                    case "keys":
                    case "values":
                        return function() {
                            return new e(this, t);
                        };
                }
                return function() {
                    return new e(this, t);
                };
            }, S = n + " Iterator", w = "values" == d, E = !1, O = t.prototype, P = O[l] || O["@@iterator"] || d && O[d], F = P || x(d), j = d ? w ? x("entries") : F : void 0, M = "Array" == n && O.entries || P;
            if (M && (b = f(M.call(new t))) !== Object.prototype && b.next && (s(b, S, !0), r || "function" == typeof b[l] || u(b, l, p)), w && P && "values" !== P.name && (E = !0, F = function() {
                return P.call(this);
            }), r && !g || !h && !E && O[l] || u(O, l, F), c[n] = F, c[S] = p, d) {
                if (m = {
                    values: w ? F : x("values"),
                    keys: y ? F : x("keys"),
                    entries: j
                }, g) for(_ in m)_ in O || o(O, _, m[_]);
                else i(i.P + i.F * (h || E), n, m);
            }
            return m;
        };
    },
    function(t, n, e) {
        var r = e(76), i = e(24);
        t.exports = function(t, n, e) {
            if (r(n)) throw TypeError("String#" + e + " doesn't accept regex!");
            return String(i(t));
        };
    },
    function(t, n, e) {
        var r = e(4), i = e(23), o = e(5)("match");
        t.exports = function(t) {
            var n;
            return r(t) && (void 0 !== (n = t[o]) ? !!n : "RegExp" == i(t));
        };
    },
    function(t, n, e) {
        var r = e(5)("match");
        t.exports = function(t) {
            var n = /./;
            try {
                "/./"[t](n);
            } catch (e) {
                try {
                    return n[r] = !1, !"/./"[t](n);
                } catch (t) {}
            }
            return !0;
        };
    },
    function(t, n, e) {
        var r = e(40), i = e(5)("iterator"), o = Array.prototype;
        t.exports = function(t) {
            return void 0 !== t && (r.Array === t || o[i] === t);
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(9), i = e(28);
        t.exports = function(t, n, e) {
            n in t ? r.f(t, n, i(0, e)) : t[n] = e;
        };
    },
    function(t, n, e) {
        var r = e(46), i = e(5)("iterator"), o = e(40);
        t.exports = e(7).getIteratorMethod = function(t) {
            if (null != t) return t[i] || t["@@iterator"] || o[r(t)];
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(10), i = e(32), o = e(6);
        t.exports = function(t) {
            for(var n = r(this), e = o(n.length), u = arguments.length, c = i(u > 1 ? arguments[1] : void 0, e), a = u > 2 ? arguments[2] : void 0, s = void 0 === a ? e : i(a, e); s > c;)n[c++] = t;
            return n;
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(36), i = e(115), o = e(40), u = e(15);
        t.exports = e(74)(Array, "Array", function(t, n) {
            this._t = u(t), this._i = 0, this._k = n;
        }, function() {
            var t = this._t, n = this._k, e = this._i++;
            return !t || e >= t.length ? (this._t = void 0, i(1)) : i(0, "keys" == n ? e : "values" == n ? t[e] : [
                e,
                t[e]
            ]);
        }, "values"), o.Arguments = o.Array, r("keys"), r("values"), r("entries");
    },
    function(t, n, e) {
        "use strict";
        var r, i, o = e(53), u = RegExp.prototype.exec, c = String.prototype.replace, a = u, s = (r = /a/, i = /b*/g, u.call(r, "a"), u.call(i, "a"), 0 !== r.lastIndex || 0 !== i.lastIndex), f = void 0 !== /()??/.exec("")[1];
        (s || f) && (a = function(t) {
            var n, e, r, i, a = this;
            return f && (e = new RegExp("^" + a.source + "$(?!\\s)", o.call(a))), s && (n = a.lastIndex), r = u.call(a, t), s && r && (a.lastIndex = a.global ? r.index + r[0].length : n), f && r && r.length > 1 && c.call(r[0], e, function() {
                for(i = 1; i < arguments.length - 2; i++)void 0 === arguments[i] && (r[i] = void 0);
            }), r;
        }), t.exports = a;
    },
    function(t, n, e) {
        "use strict";
        var r = e(73)(!0);
        t.exports = function(t, n, e) {
            return n + (e ? r(t, n).length : 1);
        };
    },
    function(t, n, e) {
        var r, i, o, u = e(17), c = e(104), a = e(66), s = e(62), f = e(1), l = f.process, h = f.setImmediate, p = f.clearImmediate, v = f.MessageChannel, d = f.Dispatch, y = 0, g = {}, m = function() {
            var t = +this;
            if (g.hasOwnProperty(t)) {
                var n = g[t];
                delete g[t], n();
            }
        }, _ = function(t) {
            m.call(t.data);
        };
        h && p || (h = function(t) {
            for(var n = [], e = 1; arguments.length > e;)n.push(arguments[e++]);
            return g[++y] = function() {
                c("function" == typeof t ? t : Function(t), n);
            }, r(y), y;
        }, p = function(t) {
            delete g[t];
        }, "process" == e(23)(l) ? r = function(t) {
            l.nextTick(u(m, t, 1));
        } : d && d.now ? r = function(t) {
            d.now(u(m, t, 1));
        } : v ? (o = (i = new v).port2, i.port1.onmessage = _, r = u(o.postMessage, o, 1)) : f.addEventListener && "function" == typeof postMessage && !f.importScripts ? (r = function(t) {
            f.postMessage(t + "", "*");
        }, f.addEventListener("message", _, !1)) : r = "onreadystatechange" in s("script") ? function(t) {
            a.appendChild(s("script")).onreadystatechange = function() {
                a.removeChild(this), m.call(t);
            };
        } : function(t) {
            setTimeout(u(m, t, 1), 0);
        }), t.exports = {
            set: h,
            clear: p
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(1), i = e(8), o = e(30), u = e(59), c = e(14), a = e(43), s = e(2), f = e(42), l = e(19), h = e(6), p = e(123), v = e(34).f, d = e(9).f, y = e(81), g = e(38), m = r.ArrayBuffer, _ = r.DataView, b = r.Math, x = r.RangeError, S = r.Infinity, w = m, E = b.abs, O = b.pow, P = b.floor, F = b.log, j = b.LN2, M = i ? "_b" : "buffer", A = i ? "_l" : "byteLength", I = i ? "_o" : "byteOffset";
        function k(t, n, e) {
            var r, i, o, u = new Array(e), c = 8 * e - n - 1, a = (1 << c) - 1, s = a >> 1, f = 23 === n ? O(2, -24) - O(2, -77) : 0, l = 0, h = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
            for((t = E(t)) != t || t === S ? (i = t != t ? 1 : 0, r = a) : (r = P(F(t) / j), t * (o = O(2, -r)) < 1 && (r--, o *= 2), (t += r + s >= 1 ? f / o : f * O(2, 1 - s)) * o >= 2 && (r++, o /= 2), r + s >= a ? (i = 0, r = a) : r + s >= 1 ? (i = (t * o - 1) * O(2, n), r += s) : (i = t * O(2, s - 1) * O(2, n), r = 0)); n >= 8; u[l++] = 255 & i, i /= 256, n -= 8);
            for(r = r << n | i, c += n; c > 0; u[l++] = 255 & r, r /= 256, c -= 8);
            return u[--l] |= 128 * h, u;
        }
        function N(t, n, e) {
            var r, i = 8 * e - n - 1, o = (1 << i) - 1, u = o >> 1, c = i - 7, a = e - 1, s = t[a--], f = 127 & s;
            for(s >>= 7; c > 0; f = 256 * f + t[a], a--, c -= 8);
            for(r = f & (1 << -c) - 1, f >>= -c, c += n; c > 0; r = 256 * r + t[a], a--, c -= 8);
            if (0 === f) f = 1 - u;
            else {
                if (f === o) return r ? NaN : s ? -S : S;
                r += O(2, n), f -= u;
            }
            return (s ? -1 : 1) * r * O(2, f - n);
        }
        function L(t) {
            return t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0];
        }
        function T(t) {
            return [
                255 & t
            ];
        }
        function R(t) {
            return [
                255 & t,
                t >> 8 & 255
            ];
        }
        function C(t) {
            return [
                255 & t,
                t >> 8 & 255,
                t >> 16 & 255,
                t >> 24 & 255
            ];
        }
        function D(t) {
            return k(t, 52, 8);
        }
        function B(t) {
            return k(t, 23, 4);
        }
        function W(t, n, e) {
            d(t.prototype, n, {
                get: function() {
                    return this[e];
                }
            });
        }
        function V(t, n, e, r) {
            var i = p(+e);
            if (i + n > t[A]) throw x("Wrong index!");
            var o = t[M]._b, u = i + t[I], c = o.slice(u, u + n);
            return r ? c : c.reverse();
        }
        function $(t, n, e, r, i, o) {
            var u = p(+e);
            if (u + n > t[A]) throw x("Wrong index!");
            for(var c = t[M]._b, a = u + t[I], s = r(+i), f = 0; f < n; f++)c[a + f] = s[o ? f : n - f - 1];
        }
        if (u.ABV) {
            if (!s(function() {
                m(1);
            }) || !s(function() {
                new m(-1);
            }) || s(function() {
                return new m, new m(1.5), new m(NaN), "ArrayBuffer" != m.name;
            })) {
                for(var G, U = (m = function(t) {
                    return f(this, m), new w(p(t));
                }).prototype = w.prototype, z = v(w), q = 0; z.length > q;)(G = z[q++]) in m || c(m, G, w[G]);
                o || (U.constructor = m);
            }
            var Y = new _(new m(2)), H = _.prototype.setInt8;
            Y.setInt8(0, 2147483648), Y.setInt8(1, 2147483649), !Y.getInt8(0) && Y.getInt8(1) || a(_.prototype, {
                setInt8: function(t, n) {
                    H.call(this, t, n << 24 >> 24);
                },
                setUint8: function(t, n) {
                    H.call(this, t, n << 24 >> 24);
                }
            }, !0);
        } else m = function(t) {
            f(this, m, "ArrayBuffer");
            var n = p(t);
            this._b = y.call(new Array(n), 0), this[A] = n;
        }, _ = function(t, n, e) {
            f(this, _, "DataView"), f(t, m, "DataView");
            var r = t[A], i = l(n);
            if (i < 0 || i > r) throw x("Wrong offset!");
            if (i + (e = void 0 === e ? r - i : h(e)) > r) throw x("Wrong length!");
            this[M] = t, this[I] = i, this[A] = e;
        }, i && (W(m, "byteLength", "_l"), W(_, "buffer", "_b"), W(_, "byteLength", "_l"), W(_, "byteOffset", "_o")), a(_.prototype, {
            getInt8: function(t) {
                return V(this, 1, t)[0] << 24 >> 24;
            },
            getUint8: function(t) {
                return V(this, 1, t)[0];
            },
            getInt16: function(t) {
                var n = V(this, 2, t, arguments[1]);
                return (n[1] << 8 | n[0]) << 16 >> 16;
            },
            getUint16: function(t) {
                var n = V(this, 2, t, arguments[1]);
                return n[1] << 8 | n[0];
            },
            getInt32: function(t) {
                return L(V(this, 4, t, arguments[1]));
            },
            getUint32: function(t) {
                return L(V(this, 4, t, arguments[1])) >>> 0;
            },
            getFloat32: function(t) {
                return N(V(this, 4, t, arguments[1]), 23, 4);
            },
            getFloat64: function(t) {
                return N(V(this, 8, t, arguments[1]), 52, 8);
            },
            setInt8: function(t, n) {
                $(this, 1, t, T, n);
            },
            setUint8: function(t, n) {
                $(this, 1, t, T, n);
            },
            setInt16: function(t, n) {
                $(this, 2, t, R, n, arguments[2]);
            },
            setUint16: function(t, n) {
                $(this, 2, t, R, n, arguments[2]);
            },
            setInt32: function(t, n) {
                $(this, 4, t, C, n, arguments[2]);
            },
            setUint32: function(t, n) {
                $(this, 4, t, C, n, arguments[2]);
            },
            setFloat32: function(t, n) {
                $(this, 4, t, B, n, arguments[2]);
            },
            setFloat64: function(t, n) {
                $(this, 8, t, D, n, arguments[2]);
            }
        });
        g(m, "ArrayBuffer"), g(_, "DataView"), c(_.prototype, u.VIEW, !0), n.ArrayBuffer = m, n.DataView = _;
    },
    function(t, n) {
        var e = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
        "number" == typeof __g && (__g = e);
    },
    function(t, n) {
        t.exports = function(t) {
            return "object" == typeof t ? null !== t : "function" == typeof t;
        };
    },
    function(t, n, e) {
        t.exports = !e(128)(function() {
            return 7 != Object.defineProperty({}, "a", {
                get: function() {
                    return 7;
                }
            }).a;
        });
    },
    function(t, n) {
        t.exports = function(t, n) {
            if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
        };
    },
    function(t, n) {
        function e(t, n) {
            for(var e = 0; e < n.length; e++){
                var r = n[e];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
            }
        }
        t.exports = function(t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
        };
    },
    function(t, n) {
        t.exports = function(t, n, e) {
            return n in t ? Object.defineProperty(t, n, {
                value: e,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[n] = e, t;
        };
    },
    function(t, n, e) {
        "use strict";
        (function(n) {
            var r = e(60), i = r(e(94)), o = r(e(133)), u = (r(e(134)), r(e(95)), r(e(136)));
            function c(t, n) {
                c = function(t, n) {
                    return new s(t, void 0, n);
                };
                var e = (0, u.default)(RegExp), r = RegExp.prototype, a = new WeakMap;
                function s(t, n, r) {
                    var i = e.call(this, t, n);
                    return a.set(i, r || a.get(t)), i;
                }
                function f(t, n) {
                    var e = a.get(n);
                    return Object.keys(e).reduce(function(n, r) {
                        return n[r] = t[e[r]], n;
                    }, Object.create(null));
                }
                return (0, o.default)(s, e), s.prototype.exec = function(t) {
                    var n = r.exec.call(this, t);
                    return n && (n.groups = f(n, this)), n;
                }, s.prototype[Symbol.replace] = function(t, n) {
                    if ("string" == typeof n) {
                        var e = a.get(this);
                        return r[Symbol.replace].call(this, t, n.replace(/\$<([^>]+)>/g, function(t, n) {
                            return "$" + e[n];
                        }));
                    }
                    if ("function" == typeof n) {
                        var o = this;
                        return r[Symbol.replace].call(this, t, function() {
                            var t = [];
                            return t.push.apply(t, arguments), "object" !== (0, i.default)(t[t.length - 1]) && t.push(f(t, o)), n.apply(this, t);
                        });
                    }
                    return r[Symbol.replace].call(this, t, n);
                }, c.apply(this, arguments);
            }
            var a = {
                get isBrowserSide () {
                    return "undefined" != typeof window && "undefined" != typeof document;
                },
                get isServerSide () {
                    return void 0 !== t.exports && void 0 !== n;
                },
                getFormElements: function(t) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], e = t.querySelectorAll('            input:not([type="hidden"]):not([disabled]),            select:not([disabled]),            textarea:not([disabled])        ');
                    return n ? Array.from(e) : e;
                },
                appendSelector: function(t, n, e) {
                    if (t.startsWith(".")) e.classList.add(t.slice(1));
                    else if (t.startsWith("#")) e.id = t.slice(1);
                    else {
                        var r = c(/^.*\[([\.:@-Z\\a-z]+)(=["'\|]?([\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uFEFE\uFF00-\uFFFF]+)["'\|]?)?\]$/, {
                            datakey: 1,
                            dataval: 3
                        }), i = t.match(r);
                        if (i && i.length) {
                            var o = i.groups.datakey || i[1] || null, u = n || i.groups.dataval || i[3] || "";
                            o && e.setAttribute(o, u);
                        }
                    }
                    return e;
                },
                prependPolyfills: function() {
                    (a.isServerSide && !n._babelPolyfill || a.isBrowserSide && !window._babelPolyfill) && e(140);
                },
                uuid: function() {
                    return "xxxxxxxx-xxxx-4xxx".replace(/x/g, function(t) {
                        var n = 16 * Math.random() | 0;
                        return ("x" === t ? n : 3 & n | 8).toString(16);
                    });
                }
            };
            t.exports = a;
        }).call(this, e(132));
    },
    function(t, n) {
        function e(n) {
            return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? t.exports = e = function(t) {
                return typeof t;
            } : t.exports = e = function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, e(n);
        }
        t.exports = e;
    },
    function(t, n) {
        function e(n) {
            return t.exports = e = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            }, e(n);
        }
        t.exports = e;
    },
    function(t, n, e) {
        t.exports = !e(8) && !e(2)(function() {
            return 7 != Object.defineProperty(e(62)("div"), "a", {
                get: function() {
                    return 7;
                }
            }).a;
        });
    },
    function(t, n, e) {
        var r = e(1), i = e(7), o = e(30), u = e(63), c = e(9).f;
        t.exports = function(t) {
            var n = i.Symbol || (i.Symbol = o ? {} : r.Symbol || {});
            "_" == t.charAt(0) || t in n || c(n, t, {
                value: u.f(t)
            });
        };
    },
    function(t, n, e) {
        var r = e(13), i = e(15), o = e(49)(!1), u = e(64)("IE_PROTO");
        t.exports = function(t, n) {
            var e, c = i(t), a = 0, s = [];
            for(e in c)e != u && r(c, e) && s.push(e);
            for(; n.length > a;)r(c, e = n[a++]) && (~o(s, e) || s.push(e));
            return s;
        };
    },
    function(t, n, e) {
        var r = e(9), i = e(3), o = e(31);
        t.exports = e(8) ? Object.defineProperties : function(t, n) {
            i(t);
            for(var e, u = o(n), c = u.length, a = 0; c > a;)r.f(t, e = u[a++], n[e]);
            return t;
        };
    },
    function(t, n, e) {
        var r = e(15), i = e(34).f, o = {}.toString, u = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
        t.exports.f = function(t) {
            return u && "[object Window]" == o.call(t) ? function(t) {
                try {
                    return i(t);
                } catch (t) {
                    return u.slice();
                }
            }(t) : i(r(t));
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(8), i = e(31), o = e(50), u = e(45), c = e(10), a = e(44), s = Object.assign;
        t.exports = !s || e(2)(function() {
            var t = {}, n = {}, e = Symbol(), r = "abcdefghijklmnopqrst";
            return t[e] = 7, r.split("").forEach(function(t) {
                n[t] = t;
            }), 7 != s({}, t)[e] || Object.keys(s({}, n)).join("") != r;
        }) ? function(t, n) {
            for(var e = c(t), s = arguments.length, f = 1, l = o.f, h = u.f; s > f;)for(var p, v = a(arguments[f++]), d = l ? i(v).concat(l(v)) : i(v), y = d.length, g = 0; y > g;)p = d[g++], r && !h.call(v, p) || (e[p] = v[p]);
            return e;
        } : s;
    },
    function(t, n) {
        t.exports = Object.is || function(t, n) {
            return t === n ? 0 !== t || 1 / t == 1 / n : t != t && n != n;
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(18), i = e(4), o = e(104), u = [].slice, c = {}, a = function(t, n, e) {
            if (!(n in c)) {
                for(var r = [], i = 0; i < n; i++)r[i] = "a[" + i + "]";
                c[n] = Function("F,a", "return new F(" + r.join(",") + ")");
            }
            return c[n](t, e);
        };
        t.exports = Function.bind || function(t) {
            var n = r(this), e = u.call(arguments, 1), c = function() {
                var r = e.concat(u.call(arguments));
                return this instanceof c ? a(n, r.length, r) : o(n, r, t);
            };
            return i(n.prototype) && (c.prototype = n.prototype), c;
        };
    },
    function(t, n) {
        t.exports = function(t, n, e) {
            var r = void 0 === e;
            switch(n.length){
                case 0:
                    return r ? t() : t.call(e);
                case 1:
                    return r ? t(n[0]) : t.call(e, n[0]);
                case 2:
                    return r ? t(n[0], n[1]) : t.call(e, n[0], n[1]);
                case 3:
                    return r ? t(n[0], n[1], n[2]) : t.call(e, n[0], n[1], n[2]);
                case 4:
                    return r ? t(n[0], n[1], n[2], n[3]) : t.call(e, n[0], n[1], n[2], n[3]);
            }
            return t.apply(e, n);
        };
    },
    function(t, n, e) {
        var r = e(1).parseInt, i = e(39).trim, o = e(68), u = /^[-+]?0[xX]/;
        t.exports = 8 !== r(o + "08") || 22 !== r(o + "0x16") ? function(t, n) {
            var e = i(String(t), 3);
            return r(e, n >>> 0 || (u.test(e) ? 16 : 10));
        } : r;
    },
    function(t, n, e) {
        var r = e(1).parseFloat, i = e(39).trim;
        t.exports = 1 / r(e(68) + "-0") != -1 / 0 ? function(t) {
            var n = i(String(t), 3), e = r(n);
            return 0 === e && "-" == n.charAt(0) ? -0 : e;
        } : r;
    },
    function(t, n, e) {
        var r = e(23);
        t.exports = function(t, n) {
            if ("number" != typeof t && "Number" != r(t)) throw TypeError(n);
            return +t;
        };
    },
    function(t, n, e) {
        var r = e(4), i = Math.floor;
        t.exports = function(t) {
            return !r(t) && isFinite(t) && i(t) === t;
        };
    },
    function(t, n) {
        t.exports = Math.log1p || function(t) {
            return (t = +t) > -0.00000001 && t < 1e-8 ? t - t * t / 2 : Math.log(1 + t);
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(33), i = e(28), o = e(38), u = {};
        e(14)(u, e(5)("iterator"), function() {
            return this;
        }), t.exports = function(t, n, e) {
            t.prototype = r(u, {
                next: i(1, e)
            }), o(t, n + " Iterator");
        };
    },
    function(t, n, e) {
        var r = e(3);
        t.exports = function(t, n, e, i) {
            try {
                return i ? n(r(e)[0], e[1]) : n(e);
            } catch (n) {
                var o = t.return;
                throw void 0 !== o && r(o.call(t)), n;
            }
        };
    },
    function(t, n, e) {
        var r = e(234);
        t.exports = function(t, n) {
            return new (r(t))(n);
        };
    },
    function(t, n, e) {
        var r = e(18), i = e(10), o = e(44), u = e(6);
        t.exports = function(t, n, e, c, a) {
            r(n);
            var s = i(t), f = o(s), l = u(s.length), h = a ? l - 1 : 0, p = a ? -1 : 1;
            if (e < 2) for(;;){
                if (h in f) {
                    c = f[h], h += p;
                    break;
                }
                if (h += p, a ? h < 0 : l <= h) throw TypeError("Reduce of empty array with no initial value");
            }
            for(; a ? h >= 0 : l > h; h += p)h in f && (c = n(c, f[h], h, s));
            return c;
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(10), i = e(32), o = e(6);
        t.exports = [].copyWithin || function(t, n) {
            var e = r(this), u = o(e.length), c = i(t, u), a = i(n, u), s = arguments.length > 2 ? arguments[2] : void 0, f = Math.min((void 0 === s ? u : i(s, u)) - a, u - c), l = 1;
            for(a < c && c < a + f && (l = -1, a += f - 1, c += f - 1); f-- > 0;)a in e ? e[c] = e[a] : delete e[c], c += l, a += l;
            return e;
        };
    },
    function(t, n) {
        t.exports = function(t, n) {
            return {
                value: n,
                done: !!t
            };
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(83);
        e(0)({
            target: "RegExp",
            proto: !0,
            forced: r !== /./.exec
        }, {
            exec: r
        });
    },
    function(t, n, e) {
        e(8) && "g" != /./g.flags && e(9).f(RegExp.prototype, "flags", {
            configurable: !0,
            get: e(53)
        });
    },
    function(t, n, e) {
        "use strict";
        var r, i, o, u, c = e(30), a = e(1), s = e(17), f = e(46), l = e(0), h = e(4), p = e(18), v = e(42), d = e(56), y = e(47), g = e(85).set, m = e(254)(), _ = e(119), b = e(255), x = e(57), S = e(120), w = a.TypeError, E = a.process, O = E && E.versions, P = O && O.v8 || "", F = a.Promise, j = "process" == f(E), M = function() {}, A = i = _.f, I = !!function() {
            try {
                var t = F.resolve(1), n = (t.constructor = {})[e(5)("species")] = function(t) {
                    t(M, M);
                };
                return (j || "function" == typeof PromiseRejectionEvent) && t.then(M) instanceof n && 0 !== P.indexOf("6.6") && -1 === x.indexOf("Chrome/66");
            } catch (t) {}
        }(), k = function(t) {
            var n;
            return !(!h(t) || "function" != typeof (n = t.then)) && n;
        }, N = function(t, n) {
            if (!t._n) {
                t._n = !0;
                var e = t._c;
                m(function() {
                    for(var r = t._v, i = 1 == t._s, o = 0, u = function(n) {
                        var e, o, u, c = i ? n.ok : n.fail, a = n.resolve, s = n.reject, f = n.domain;
                        try {
                            c ? (i || (2 == t._h && R(t), t._h = 1), !0 === c ? e = r : (f && f.enter(), e = c(r), f && (f.exit(), u = !0)), e === n.promise ? s(w("Promise-chain cycle")) : (o = k(e)) ? o.call(e, a, s) : a(e)) : s(r);
                        } catch (t) {
                            f && !u && f.exit(), s(t);
                        }
                    }; e.length > o;)u(e[o++]);
                    t._c = [], t._n = !1, n && !t._h && L(t);
                });
            }
        }, L = function(t) {
            g.call(a, function() {
                var n, e, r, i = t._v, o = T(t);
                if (o && (n = b(function() {
                    j ? E.emit("unhandledRejection", i, t) : (e = a.onunhandledrejection) ? e({
                        promise: t,
                        reason: i
                    }) : (r = a.console) && r.error && r.error("Unhandled promise rejection", i);
                }), t._h = j || T(t) ? 2 : 1), t._a = void 0, o && n.e) throw n.v;
            });
        }, T = function(t) {
            return 1 !== t._h && 0 === (t._a || t._c).length;
        }, R = function(t) {
            g.call(a, function() {
                var n;
                j ? E.emit("rejectionHandled", t) : (n = a.onrejectionhandled) && n({
                    promise: t,
                    reason: t._v
                });
            });
        }, C = function(t) {
            var n = this;
            n._d || (n._d = !0, (n = n._w || n)._v = t, n._s = 2, n._a || (n._a = n._c.slice()), N(n, !0));
        }, D = function(t) {
            var n, e = this;
            if (!e._d) {
                e._d = !0, e = e._w || e;
                try {
                    if (e === t) throw w("Promise can't be resolved itself");
                    (n = k(t)) ? m(function() {
                        var r = {
                            _w: e,
                            _d: !1
                        };
                        try {
                            n.call(t, s(D, r, 1), s(C, r, 1));
                        } catch (t) {
                            C.call(r, t);
                        }
                    }) : (e._v = t, e._s = 1, N(e, !1));
                } catch (t) {
                    C.call({
                        _w: e,
                        _d: !1
                    }, t);
                }
            }
        };
        I || (F = function(t) {
            v(this, F, "Promise", "_h"), p(t), r.call(this);
            try {
                t(s(D, this, 1), s(C, this, 1));
            } catch (t) {
                C.call(this, t);
            }
        }, (r = function(t) {
            this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1;
        }).prototype = e(43)(F.prototype, {
            then: function(t, n) {
                var e = A(y(this, F));
                return e.ok = "function" != typeof t || t, e.fail = "function" == typeof n && n, e.domain = j ? E.domain : void 0, this._c.push(e), this._a && this._a.push(e), this._s && N(this, !1), e.promise;
            },
            catch: function(t) {
                return this.then(void 0, t);
            }
        }), o = function() {
            var t = new r;
            this.promise = t, this.resolve = s(D, t, 1), this.reject = s(C, t, 1);
        }, _.f = A = function(t) {
            return t === F || t === u ? new o(t) : i(t);
        }), l(l.G + l.W + l.F * !I, {
            Promise: F
        }), e(38)(F, "Promise"), e(41)("Promise"), u = e(7).Promise, l(l.S + l.F * !I, "Promise", {
            reject: function(t) {
                var n = A(this);
                return (0, n.reject)(t), n.promise;
            }
        }), l(l.S + l.F * (c || !I), "Promise", {
            resolve: function(t) {
                return S(c && this === u ? F : this, t);
            }
        }), l(l.S + l.F * !(I && e(52)(function(t) {
            F.all(t).catch(M);
        })), "Promise", {
            all: function(t) {
                var n = this, e = A(n), r = e.resolve, i = e.reject, o = b(function() {
                    var e = [], o = 0, u = 1;
                    d(t, !1, function(t) {
                        var c = o++, a = !1;
                        e.push(void 0), u++, n.resolve(t).then(function(t) {
                            a || (a = !0, e[c] = t, --u || r(e));
                        }, i);
                    }), --u || r(e);
                });
                return o.e && i(o.v), e.promise;
            },
            race: function(t) {
                var n = this, e = A(n), r = e.reject, i = b(function() {
                    d(t, !1, function(t) {
                        n.resolve(t).then(e.resolve, r);
                    });
                });
                return i.e && r(i.v), e.promise;
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(18);
        function i(t) {
            var n, e;
            this.promise = new t(function(t, r) {
                if (void 0 !== n || void 0 !== e) throw TypeError("Bad Promise constructor");
                n = t, e = r;
            }), this.resolve = r(n), this.reject = r(e);
        }
        t.exports.f = function(t) {
            return new i(t);
        };
    },
    function(t, n, e) {
        var r = e(3), i = e(4), o = e(119);
        t.exports = function(t, n) {
            if (r(t), i(n) && n.constructor === t) return n;
            var e = o.f(t);
            return (0, e.resolve)(n), e.promise;
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(9).f, i = e(33), o = e(43), u = e(17), c = e(42), a = e(56), s = e(74), f = e(115), l = e(41), h = e(8), p = e(27).fastKey, v = e(37), d = h ? "_s" : "size", y = function(t, n) {
            var e, r = p(n);
            if ("F" !== r) return t._i[r];
            for(e = t._f; e; e = e.n)if (e.k == n) return e;
        };
        t.exports = {
            getConstructor: function(t, n, e, s) {
                var f = t(function(t, r) {
                    c(t, f, n, "_i"), t._t = n, t._i = i(null), t._f = void 0, t._l = void 0, t[d] = 0, null != r && a(r, e, t[s], t);
                });
                return o(f.prototype, {
                    clear: function() {
                        for(var t = v(this, n), e = t._i, r = t._f; r; r = r.n)r.r = !0, r.p && (r.p = r.p.n = void 0), delete e[r.i];
                        t._f = t._l = void 0, t[d] = 0;
                    },
                    delete: function(t) {
                        var e = v(this, n), r = y(e, t);
                        if (r) {
                            var i = r.n, o = r.p;
                            delete e._i[r.i], r.r = !0, o && (o.n = i), i && (i.p = o), e._f == r && (e._f = i), e._l == r && (e._l = o), e[d]--;
                        }
                        return !!r;
                    },
                    forEach: function(t) {
                        v(this, n);
                        for(var e, r = u(t, arguments.length > 1 ? arguments[1] : void 0, 3); e = e ? e.n : this._f;)for(r(e.v, e.k, this); e && e.r;)e = e.p;
                    },
                    has: function(t) {
                        return !!y(v(this, n), t);
                    }
                }), h && r(f.prototype, "size", {
                    get: function() {
                        return v(this, n)[d];
                    }
                }), f;
            },
            def: function(t, n, e) {
                var r, i, o = y(t, n);
                return o ? o.v = e : (t._l = o = {
                    i: i = p(n, !0),
                    k: n,
                    v: e,
                    p: r = t._l,
                    n: void 0,
                    r: !1
                }, t._f || (t._f = o), r && (r.n = o), t[d]++, "F" !== i && (t._i[i] = o)), t;
            },
            getEntry: y,
            setStrong: function(t, n, e) {
                s(t, n, function(t, e) {
                    this._t = v(t, n), this._k = e, this._l = void 0;
                }, function() {
                    for(var t = this._k, n = this._l; n && n.r;)n = n.p;
                    return this._t && (this._l = n = n ? n.n : this._t._f) ? f(0, "keys" == t ? n.k : "values" == t ? n.v : [
                        n.k,
                        n.v
                    ]) : (this._t = void 0, f(1));
                }, e ? "entries" : "values", !e, !0), l(n);
            }
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(43), i = e(27).getWeak, o = e(3), u = e(4), c = e(42), a = e(56), s = e(22), f = e(13), l = e(37), h = s(5), p = s(6), v = 0, d = function(t) {
            return t._l || (t._l = new y);
        }, y = function() {
            this.a = [];
        }, g = function(t, n) {
            return h(t.a, function(t) {
                return t[0] === n;
            });
        };
        y.prototype = {
            get: function(t) {
                var n = g(this, t);
                if (n) return n[1];
            },
            has: function(t) {
                return !!g(this, t);
            },
            set: function(t, n) {
                var e = g(this, t);
                e ? e[1] = n : this.a.push([
                    t,
                    n
                ]);
            },
            delete: function(t) {
                var n = p(this.a, function(n) {
                    return n[0] === t;
                });
                return ~n && this.a.splice(n, 1), !!~n;
            }
        }, t.exports = {
            getConstructor: function(t, n, e, o) {
                var s = t(function(t, r) {
                    c(t, s, n, "_i"), t._t = n, t._i = v++, t._l = void 0, null != r && a(r, e, t[o], t);
                });
                return r(s.prototype, {
                    delete: function(t) {
                        if (!u(t)) return !1;
                        var e = i(t);
                        return !0 === e ? d(l(this, n)).delete(t) : e && f(e, this._i) && delete e[this._i];
                    },
                    has: function(t) {
                        if (!u(t)) return !1;
                        var e = i(t);
                        return !0 === e ? d(l(this, n)).has(t) : e && f(e, this._i);
                    }
                }), s;
            },
            def: function(t, n, e) {
                var r = i(o(n), !0);
                return !0 === r ? d(t).set(n, e) : r[t._i] = e, t;
            },
            ufstore: d
        };
    },
    function(t, n, e) {
        var r = e(19), i = e(6);
        t.exports = function(t) {
            if (void 0 === t) return 0;
            var n = r(t), e = i(n);
            if (n !== e) throw RangeError("Wrong length!");
            return e;
        };
    },
    function(t, n, e) {
        var r = e(34), i = e(50), o = e(3), u = e(1).Reflect;
        t.exports = u && u.ownKeys || function(t) {
            var n = r.f(o(t)), e = i.f;
            return e ? n.concat(e(t)) : n;
        };
    },
    function(t, n, e) {
        var r = e(6), i = e(70), o = e(24);
        t.exports = function(t, n, e, u) {
            var c = String(o(t)), a = c.length, s = void 0 === e ? " " : String(e), f = r(n);
            if (f <= a || "" == s) return c;
            var l = f - a, h = i.call(s, Math.ceil(l / s.length));
            return h.length > l && (h = h.slice(0, l)), u ? h + c : c + h;
        };
    },
    function(t, n, e) {
        var r = e(8), i = e(31), o = e(15), u = e(45).f;
        t.exports = function(t) {
            return function(n) {
                for(var e, c = o(n), a = i(c), s = a.length, f = 0, l = []; s > f;)e = a[f++], r && !u.call(c, e) || l.push(t ? [
                    e,
                    c[e]
                ] : c[e]);
                return l;
            };
        };
    },
    function(t, n) {
        var e = t.exports = {
            version: "2.6.11"
        };
        "number" == typeof __e && (__e = e);
    },
    function(t, n) {
        t.exports = function(t) {
            try {
                return !!t();
            } catch (t) {
                return !0;
            }
        };
    },
    function(t, n, e) {
        t.exports = e(130);
    },
    function(t, n, e) {
        "use strict";
        var r = e(60), i = r(e(90)), o = r(e(91)), u = r(e(92));
        function c(t, n) {
            var e = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(t);
                n && (r = r.filter(function(n) {
                    return Object.getOwnPropertyDescriptor(t, n).enumerable;
                })), e.push.apply(e, r);
            }
            return e;
        }
        function a(t) {
            for(var n = 1; n < arguments.length; n++){
                var e = null != arguments[n] ? arguments[n] : {};
                n % 2 ? c(Object(e), !0).forEach(function(n) {
                    (0, u.default)(t, n, e[n]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : c(Object(e)).forEach(function(n) {
                    Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
                });
            }
            return t;
        }
        var s = e(131), f = e(93), l = f.appendSelector, h = f.prependPolyfills, p = f.uuid, v = f.isBrowserSide, d = f.isServerSide;
        h();
        var y = {
            step_selector: "[data-step]",
            prev_step_selector: "[data-prev]",
            next_step_selector: "[data-next]",
            submit_selector: '[type="submit"]',
            active_step_index: 0,
            unique_id_prefix: "zangdar_form_",
            classes: {
                form: "zangdar__wizard",
                prev_button: "zangdar__prev",
                next_button: "zangdar__next",
                step: "zangdar__step",
                step_active: "zangdar__step__active"
            },
            bypass_validation: !1,
            onSubmit: null,
            onStepChange: null,
            onValidation: null,
            customValidation: null
        }, g = function() {
            function t(n) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if ((0, i.default)(this, t), (0, u.default)(this, "_$form", null), (0, u.default)(this, "_params", {}), (0, u.default)(this, "_$prevButtons", null), (0, u.default)(this, "_steps", []), (0, u.default)(this, "_currentIndex", 0), (0, u.default)(this, "_uuid", ""), this._$form = n instanceof HTMLFormElement ? n : document.querySelector(n), null !== this._$form && this._$form.constructor !== HTMLFormElement) throw new Error("[Err] Zangdar.constructor - the container must be a valid HTML form element");
                this._params = a({}, y, {}, e), this._$prevButtons = null, this._steps = [], this._currentIndex = this._params.active_step_index, this._uuid = this._params.unique_id_prefix + p(), this.onSubmit = this.onSubmit.bind(this), this.onPrevStep = this.onPrevStep.bind(this), this.onNextStep = this.onNextStep.bind(this), this._bindEventsContext(), this._init();
            }
            return (0, o.default)(t, [
                {
                    key: "count",
                    value: function() {
                        return this._steps.length;
                    }
                },
                {
                    key: "refresh",
                    value: function() {
                        return this._buildPrevButton(), this._buildSteps(), this;
                    }
                },
                {
                    key: "destroy",
                    value: function() {
                        var t = this;
                        try {
                            !1 !== this._params.prev_step_selector && document.querySelectorAll(this._params.prev_step_selector).forEach(function(n) {
                                n.removeEventListener("click", t.onPrevStep);
                            });
                        } catch (t) {
                            console.error("[Err] Zangdar.destroy - Cannot remove Event Listeners on prev buttons - ".concat(t.message));
                        }
                        try {
                            !1 !== this._params.next_step_selector && document.querySelectorAll(this._params.next_step_selector).forEach(function(n) {
                                n.removeEventListener("click", t.onNextStep);
                            });
                        } catch (t) {
                            console.error("[Err] Zangdar.destroy - Cannot remove Event Listeners on next buttons - ".concat(t.message));
                        }
                        try {
                            this._$form.removeEventListener("submit", this.onSubmit);
                        } catch (t) {
                            console.error("[Err] Zangdar.destroy - Cannot remove Event Listeners on form submit buttons - ".concat(t.message));
                        }
                    }
                },
                {
                    key: "getStep",
                    value: function(t) {
                        return t.constructor === String ? this._steps.find(function(n) {
                            return n.labeled(t);
                        }) : t.constructor === Number ? this._steps[t] : null;
                    }
                },
                {
                    key: "getFormElement",
                    value: function() {
                        return this._$form;
                    }
                },
                {
                    key: "getCurrentStep",
                    value: function() {
                        return this.getStep(this._currentIndex);
                    }
                },
                {
                    key: "removeStep",
                    value: function(t) {
                        var n;
                        return !!(n = t instanceof s ? t : this.getStep(t)) && (n.removeElement(), this._steps = this._steps.filter(function(t) {
                            return !t.indexed(n.index);
                        }), this.refresh(), n.index);
                    }
                },
                {
                    key: "first",
                    value: function() {
                        return this._firstStep(), this;
                    }
                },
                {
                    key: "last",
                    value: function() {
                        return this._lastStep(), this;
                    }
                },
                {
                    key: "prev",
                    value: function() {
                        return this._prevStep(), this;
                    }
                },
                {
                    key: "next",
                    value: function() {
                        return this._nextStep(), this;
                    }
                },
                {
                    key: "setOption",
                    value: function(t, n) {
                        return t in this._params && (this._params[t] = n), this;
                    }
                },
                {
                    key: "revealStep",
                    value: function(t) {
                        try {
                            var n = null;
                            if (t.constructor === String ? n = this._steps.findIndex(function(n) {
                                return n.labeled(t);
                            }) : t instanceof s ? n = t.index : t.constructor === Number && (n = t), (null == n || n < 0) && (n = 0), n !== this._currentIndex) {
                                var e = this.getCurrentStep(), r = e && e.index > n ? -1 : 1;
                                (r < 0 || this._validateCurrentStep()) && (this._currentIndex = n, this._revealStep(), this._onStepChange(e, r));
                            }
                            return this;
                        } catch (t) {
                            throw new Error("[Err] Zangdar.revealStep - Cannot found step :: ".concat(t.message));
                        }
                    }
                },
                {
                    key: "createFromTemplate",
                    value: function(t) {
                        var n = this, e = 0, r = function(r) {
                            if (++e, t.hasOwnProperty(r)) {
                                var i = t[r], o = n._buildSection(r);
                                if (i.forEach(function(t) {
                                    var e = n._$form.querySelector(t);
                                    if (null !== e) {
                                        var i = e.cloneNode(!0);
                                        o.dataset.step = r, o.appendChild(i), e.parentNode.removeChild(e);
                                    }
                                }), e < Object.keys(t).length && !1 !== n._params.next_step_selector && null === o.querySelector(n._params.next_step_selector)) {
                                    var u = document.createElement("button");
                                    (u = l(n._params.next_step_selector, null, u)).dataset.next = "next", u.innerText = "Next", o.appendChild(u);
                                }
                                if (e === Object.keys(t).length && !1 !== n._params.submit_selector) {
                                    var c = n._$form.querySelector(n._params.submit_selector);
                                    if (null !== c) {
                                        var a = c.cloneNode(!0);
                                        o.appendChild(a), c.parentNode.removeChild(c);
                                    }
                                }
                                n._$form.appendChild(o);
                            }
                        };
                        for(var i in t)r(i);
                        return this._init(), this;
                    }
                },
                {
                    key: "getBreadcrumb",
                    value: function() {
                        return this._steps.reduce(function(t, n) {
                            return a({}, t, {}, (0, u.default)({}, n.label, n));
                        }, {});
                    }
                },
                {
                    key: "onNextStep",
                    value: function(t) {
                        t.preventDefault(), this._validateCurrentStep() && this._nextStep();
                    }
                },
                {
                    key: "onPrevStep",
                    value: function(t) {
                        t.preventDefault(), this._prevStep();
                    }
                },
                {
                    key: "onSubmit",
                    value: function(t) {
                        this._validateCurrentStep() && (this._params.onSubmit && this._params.onSubmit.constructor === Function ? this._params.onSubmit(t) : t.target.submit());
                    }
                },
                {
                    key: "_init",
                    value: function() {
                        this._$form.querySelectorAll(this._params.step_selector).length && (this._buildForm(), this._buildPrevButton(), this._buildSteps());
                    }
                },
                {
                    key: "_buildForm",
                    value: function() {
                        this._$form.classList.add(this._params.classes.form), this._$form.dataset.wizard = this._uuid, !this._$form.hasAttribute("name") && this._$form.setAttribute("name", this._uuid), this._$form.removeEventListener("submit", this.onSubmit), this._$form.addEventListener("submit", this.onSubmit);
                    }
                },
                {
                    key: "_buildPrevButton",
                    value: function() {
                        var t = this;
                        if (!1 !== this._params.prev_step_selector) {
                            if (this._$prevButtons = this._$form.querySelectorAll(this._params.prev_step_selector), this._$prevButtons && this._$prevButtons.length) Array.from(this._$prevButtons).forEach(function(n) {
                                n.classList.add(t._params.classes.prev_button), n.removeEventListener("click", t.onPrevStep), n.addEventListener("click", t.onPrevStep);
                            });
                            else {
                                var n = document.createElement("button");
                                n.setAttribute("data-prev", ""), n.innerText = "Prev.", this._$form.insertBefore(n, this._$form.firstChild), this._buildPrevButton();
                            }
                        }
                    }
                },
                {
                    key: "_buildSteps",
                    value: function() {
                        var t = this, n = Array.from(this._$form.querySelectorAll(this._params.step_selector));
                        this._steps = n.reduce(function(e, r, i) {
                            var o;
                            return e.push(t._buildStep(r, i, n.length - 1 === i)), i < n.length - 1 && null !== (o = r.querySelector(t._params.next_step_selector)) && (o.classList.add(t._params.classes.next_button), o.removeEventListener("click", t.onNextStep), o.addEventListener("click", t.onNextStep)), e;
                        }, []), this._currentIndex = this._params.active_step_index, this._revealStep();
                    }
                },
                {
                    key: "_buildSection",
                    value: function(t) {
                        var n = document.createElement("section");
                        return l(this._params.step_selector, t, n);
                    }
                },
                {
                    key: "_buildStep",
                    value: function(t, n, e) {
                        var r = t.dataset.step, i = n === this._params.active_step_index;
                        return t.classList.add(this._params.classes.step), i && (t.classList.add(this._params.classes.step_active), this._currentIndex = n), new s(n, t, r, i, e);
                    }
                },
                {
                    key: "_revealStep",
                    value: function() {
                        var t = this;
                        this._steps.forEach(function(n, e) {
                            t._steps[e].active = n.indexed(t._currentIndex), n.active ? n.element.classList.add(t._params.classes.step_active) : n.element.classList.remove(t._params.classes.step_active);
                        }), this._hidePrevBtns();
                    }
                },
                {
                    key: "_hidePrevBtns",
                    value: function() {
                        var t = this;
                        this._$prevButtons && this._$prevButtons.length ? Array.from(this._$prevButtons).forEach(function(n) {
                            n.style.display = 0 === t._currentIndex ? "none" : "";
                        }) : this._buildPrevButton();
                    }
                },
                {
                    key: "_prevStep",
                    value: function() {
                        var t = this.getCurrentStep();
                        t.completed = !1, this._currentIndex = this._currentIndex - 1 < 0 ? 0 : this._currentIndex - 1, this._revealStep(), this._onStepChange(t, -1);
                    }
                },
                {
                    key: "_nextStep",
                    value: function() {
                        var t = this.getCurrentStep();
                        t.completed = !0, this._currentIndex = this._currentIndex < this._steps.length - 1 ? this._currentIndex + 1 : this._steps.length, this._revealStep(), this._onStepChange(t, 1);
                    }
                },
                {
                    key: "_firstStep",
                    value: function() {
                        var t = this.getCurrentStep();
                        this._steps.map(function(t) {
                            t.completed = !1, t.active = !1;
                        }), this._currentIndex = 0, this._revealStep(), this._onStepChange(t, -1);
                    }
                },
                {
                    key: "_lastStep",
                    value: function() {
                        var t = this, n = this.getCurrentStep();
                        this._currentIndex = this._steps.length - 1, this._steps.map(function(n) {
                            n.completed = !n.indexed(t._currentIndex), n.active = !1;
                        }), this._revealStep(), this._onStepChange(n, 1);
                    }
                },
                {
                    key: "_onStepChange",
                    value: function(t, n) {
                        this._params.onStepChange && this._params.onStepChange.constructor === Function && this._params.onStepChange(this.getCurrentStep(), t, n, this._$form);
                    }
                },
                {
                    key: "_validateCurrentStep",
                    value: function() {
                        if (!0 === this._params.bypass_validation) return !0;
                        var t = this.getCurrentStep();
                        if (void 0 === t) return !0;
                        if (this._params.customValidation && this._params.customValidation.constructor === Function) return this._$form.setAttribute("novalidate", ""), this._params.customValidation(t, t.fields, this._$form);
                        this._$form.removeAttribute("novalidate");
                        var n = t.validate(), e = !0;
                        return this._params.onValidation && this._params.onValidation.constructor === Function && (e = this._params.onValidation(t, t.fields, this._$form)), n && e;
                    }
                },
                {
                    key: "_bindEventsContext",
                    value: function() {
                        var t = this;
                        [
                            "onSubmit",
                            "onStepChange",
                            "onValidation",
                            "customValidation"
                        ].forEach(function(n) {
                            t._params[n] && t._params[n].constructor === Function && (t._params[n] = t._params[n].bind(t));
                        });
                    }
                },
                {
                    key: "currentIndex",
                    get: function() {
                        return this._currentIndex;
                    }
                },
                {
                    key: "steps",
                    get: function() {
                        return this._steps;
                    }
                },
                {
                    key: "uniqueId",
                    get: function() {
                        return this._uuid;
                    }
                }
            ]), t;
        }();
        d && (t.exports = g), v && (!window.hasOwnProperty("Zangdar") && (window.Zangdar = g), HTMLFormElement.prototype.zangdar || (HTMLFormElement.prototype.zangdar = function(t) {
            return new g(this, t);
        }));
    },
    function(t, n, e) {
        "use strict";
        var r = e(60), i = r(e(90)), o = r(e(91)), u = r(e(92));
        function c(t, n) {
            var e = Object.keys(t);
            if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(t);
                n && (r = r.filter(function(n) {
                    return Object.getOwnPropertyDescriptor(t, n).enumerable;
                })), e.push.apply(e, r);
            }
            return e;
        }
        var a = e(93).getFormElements, s = function() {
            function t(n, e, r) {
                var o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], c = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                (0, i.default)(this, t), (0, u.default)(this, "index", 0), (0, u.default)(this, "element", null), (0, u.default)(this, "label", ""), (0, u.default)(this, "active", !1), (0, u.default)(this, "last", !1), (0, u.default)(this, "_completed", !1), (0, u.default)(this, "_errors", {}), (0, u.default)(this, "_fields", {}), this.index = n, this.element = e, this.label = r, this.active = o, this.last = c, this._completed = !1, this._errors = {}, this._fields = {}, this._setFields();
            }
            return (0, o.default)(t, [
                {
                    key: "indexed",
                    value: function(t) {
                        return this.index === t;
                    }
                },
                {
                    key: "labeled",
                    value: function(t) {
                        return this.label === t;
                    }
                },
                {
                    key: "isActive",
                    value: function() {
                        return !0 === this.active;
                    }
                },
                {
                    key: "isComplete",
                    value: function() {
                        return !0 === this.completed;
                    }
                },
                {
                    key: "isFirst",
                    value: function() {
                        return 0 === this.index;
                    }
                },
                {
                    key: "isLast",
                    value: function() {
                        return !0 === this.last;
                    }
                },
                {
                    key: "validate",
                    value: function() {
                        var t = this;
                        this.clearErrors();
                        var n = !0;
                        return Object.values(this._fields).reverse().forEach(function(e) {
                            e.checkValidity() || (n = !1, t.addError(e.name, e.validationMessage), e.reportValidity());
                        }), n;
                    }
                },
                {
                    key: "hasErrors",
                    value: function() {
                        return Object.keys(this._errors).length > 0;
                    }
                },
                {
                    key: "addError",
                    value: function(t, n) {
                        return this._errors[t] || (this._errors[t] = []), this._errors[t].push(n), this;
                    }
                },
                {
                    key: "clearErrors",
                    value: function() {
                        return this._errors = {}, this;
                    }
                },
                {
                    key: "removeElement",
                    value: function() {
                        this.element.parentNode && this.element.parentNode.removeChild(this.element);
                    }
                },
                {
                    key: "_setFields",
                    value: function() {
                        this._fields = a(this.element, !0).reduce(function(t, n) {
                            var e = n.getAttribute("name");
                            return e ? function(t) {
                                for(var n = 1; n < arguments.length; n++){
                                    var e = null != arguments[n] ? arguments[n] : {};
                                    n % 2 ? c(Object(e), !0).forEach(function(n) {
                                        (0, u.default)(t, n, e[n]);
                                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : c(Object(e)).forEach(function(n) {
                                        Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
                                    });
                                }
                                return t;
                            }({}, t, {}, (0, u.default)({}, e, n)) : t;
                        }, {});
                    }
                },
                {
                    key: "completed",
                    get: function() {
                        return this._completed;
                    },
                    set: function(t) {
                        return this._completed = t, this;
                    }
                },
                {
                    key: "fields",
                    get: function() {
                        return this._fields;
                    }
                },
                {
                    key: "errors",
                    get: function() {
                        return this._errors;
                    }
                }
            ]), t;
        }();
        t.exports = s;
    },
    function(t, n) {
        var e;
        e = function() {
            return this;
        }();
        try {
            e = e || new Function("return this")();
        } catch (t) {
            "object" == typeof window && (e = window);
        }
        t.exports = e;
    },
    function(t, n, e) {
        var r = e(61);
        t.exports = function(t, n) {
            if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(n && n.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), n && r(t, n);
        };
    },
    function(t, n, e) {
        var r = e(94), i = e(135);
        t.exports = function(t, n) {
            return !n || "object" !== r(n) && "function" != typeof n ? i(t) : n;
        };
    },
    function(t, n) {
        t.exports = function(t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        };
    },
    function(t, n, e) {
        var r = e(95), i = e(61), o = e(137), u = e(138);
        function c(n) {
            var e = "function" == typeof Map ? new Map : void 0;
            return t.exports = c = function(t) {
                if (null === t || !o(t)) return t;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, n);
                }
                function n() {
                    return u(t, arguments, r(this).constructor);
                }
                return n.prototype = Object.create(t.prototype, {
                    constructor: {
                        value: n,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), i(n, t);
            }, c(n);
        }
        t.exports = c;
    },
    function(t, n) {
        t.exports = function(t) {
            return -1 !== Function.toString.call(t).indexOf("[native code]");
        };
    },
    function(t, n, e) {
        var r = e(61), i = e(139);
        function o(n, e, u) {
            return i() ? t.exports = o = Reflect.construct : t.exports = o = function(t, n, e) {
                var i = [
                    null
                ];
                i.push.apply(i, n);
                var o = new (Function.bind.apply(t, i));
                return e && r(o, e.prototype), o;
            }, o.apply(null, arguments);
        }
        t.exports = o;
    },
    function(t, n) {
        t.exports = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
            } catch (t) {
                return !1;
            }
        };
    },
    function(t, n, e) {
        "use strict";
        e(141);
        var r, i = (r = e(313)) && r.__esModule ? r : {
            default: r
        };
        i.default._babelPolyfill && "undefined" != typeof console && console.warn && console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended and may have consequences if different versions of the polyfills are applied sequentially. If you do need to load the polyfill more than once, use @babel/polyfill/noConflict instead to bypass the warning."), i.default._babelPolyfill = !0;
    },
    function(t, n, e) {
        "use strict";
        e(142), e(285), e(287), e(290), e(292), e(294), e(296), e(298), e(300), e(302), e(304), e(306), e(308), e(312);
    },
    function(t, n, e) {
        e(143), e(146), e(147), e(148), e(149), e(150), e(151), e(152), e(153), e(154), e(155), e(156), e(157), e(158), e(159), e(160), e(161), e(162), e(163), e(164), e(165), e(166), e(167), e(168), e(169), e(170), e(171), e(172), e(173), e(174), e(175), e(176), e(177), e(178), e(179), e(180), e(181), e(182), e(183), e(184), e(185), e(186), e(187), e(189), e(190), e(191), e(192), e(193), e(194), e(195), e(196), e(197), e(198), e(199), e(200), e(201), e(202), e(203), e(204), e(205), e(206), e(207), e(208), e(209), e(210), e(211), e(212), e(213), e(214), e(215), e(216), e(217), e(218), e(219), e(220), e(221), e(222), e(224), e(225), e(227), e(228), e(229), e(230), e(231), e(232), e(233), e(235), e(236), e(237), e(238), e(239), e(240), e(241), e(242), e(243), e(244), e(245), e(246), e(247), e(82), e(248), e(116), e(249), e(117), e(250), e(251), e(252), e(253), e(118), e(256), e(257), e(258), e(259), e(260), e(261), e(262), e(263), e(264), e(265), e(266), e(267), e(268), e(269), e(270), e(271), e(272), e(273), e(274), e(275), e(276), e(277), e(278), e(279), e(280), e(281), e(282), e(283), e(284), t.exports = e(7);
    },
    function(t, n, e) {
        "use strict";
        var r = e(1), i = e(13), o = e(8), u = e(0), c = e(11), a = e(27).KEY, s = e(2), f = e(48), l = e(38), h = e(29), p = e(5), v = e(63), d = e(97), y = e(145), g = e(51), m = e(3), _ = e(4), b = e(10), x = e(15), S = e(26), w = e(28), E = e(33), O = e(100), P = e(20), F = e(50), j = e(9), M = e(31), A = P.f, I = j.f, k = O.f, N = r.Symbol, L = r.JSON, T = L && L.stringify, R = p("_hidden"), C = p("toPrimitive"), D = {}.propertyIsEnumerable, B = f("symbol-registry"), W = f("symbols"), V = f("op-symbols"), $ = Object.prototype, G = "function" == typeof N && !!F.f, U = r.QObject, z = !U || !U.prototype || !U.prototype.findChild, q = o && s(function() {
            return 7 != E(I({}, "a", {
                get: function() {
                    return I(this, "a", {
                        value: 7
                    }).a;
                }
            })).a;
        }) ? function(t, n, e) {
            var r = A($, n);
            r && delete $[n], I(t, n, e), r && t !== $ && I($, n, r);
        } : I, Y = function(t) {
            var n = W[t] = E(N.prototype);
            return n._k = t, n;
        }, H = G && "symbol" == typeof N.iterator ? function(t) {
            return "symbol" == typeof t;
        } : function(t) {
            return t instanceof N;
        }, Z = function(t, n, e) {
            return t === $ && Z(V, n, e), m(t), n = S(n, !0), m(e), i(W, n) ? (e.enumerable ? (i(t, R) && t[R][n] && (t[R][n] = !1), e = E(e, {
                enumerable: w(0, !1)
            })) : (i(t, R) || I(t, R, w(1, {})), t[R][n] = !0), q(t, n, e)) : I(t, n, e);
        }, K = function(t, n) {
            m(t);
            for(var e, r = y(n = x(n)), i = 0, o = r.length; o > i;)Z(t, e = r[i++], n[e]);
            return t;
        }, J = function(t) {
            var n = D.call(this, t = S(t, !0));
            return !(this === $ && i(W, t) && !i(V, t)) && (!(n || !i(this, t) || !i(W, t) || i(this, R) && this[R][t]) || n);
        }, X = function(t, n) {
            if (t = x(t), n = S(n, !0), t !== $ || !i(W, n) || i(V, n)) {
                var e = A(t, n);
                return !e || !i(W, n) || i(t, R) && t[R][n] || (e.enumerable = !0), e;
            }
        }, Q = function(t) {
            for(var n, e = k(x(t)), r = [], o = 0; e.length > o;)i(W, n = e[o++]) || n == R || n == a || r.push(n);
            return r;
        }, tt = function(t) {
            for(var n, e = t === $, r = k(e ? V : x(t)), o = [], u = 0; r.length > u;)!i(W, n = r[u++]) || e && !i($, n) || o.push(W[n]);
            return o;
        };
        G || (c((N = function() {
            if (this instanceof N) throw TypeError("Symbol is not a constructor!");
            var t = h(arguments.length > 0 ? arguments[0] : void 0), n = function(e) {
                this === $ && n.call(V, e), i(this, R) && i(this[R], t) && (this[R][t] = !1), q(this, t, w(1, e));
            };
            return o && z && q($, t, {
                configurable: !0,
                set: n
            }), Y(t);
        }).prototype, "toString", function() {
            return this._k;
        }), P.f = X, j.f = Z, e(34).f = O.f = Q, e(45).f = J, F.f = tt, o && !e(30) && c($, "propertyIsEnumerable", J, !0), v.f = function(t) {
            return Y(p(t));
        }), u(u.G + u.W + u.F * !G, {
            Symbol: N
        });
        for(var nt = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), et = 0; nt.length > et;)p(nt[et++]);
        for(var rt = M(p.store), it = 0; rt.length > it;)d(rt[it++]);
        u(u.S + u.F * !G, "Symbol", {
            for: function(t) {
                return i(B, t += "") ? B[t] : B[t] = N(t);
            },
            keyFor: function(t) {
                if (!H(t)) throw TypeError(t + " is not a symbol!");
                for(var n in B)if (B[n] === t) return n;
            },
            useSetter: function() {
                z = !0;
            },
            useSimple: function() {
                z = !1;
            }
        }), u(u.S + u.F * !G, "Object", {
            create: function(t, n) {
                return void 0 === n ? E(t) : K(E(t), n);
            },
            defineProperty: Z,
            defineProperties: K,
            getOwnPropertyDescriptor: X,
            getOwnPropertyNames: Q,
            getOwnPropertySymbols: tt
        });
        var ot = s(function() {
            F.f(1);
        });
        u(u.S + u.F * ot, "Object", {
            getOwnPropertySymbols: function(t) {
                return F.f(b(t));
            }
        }), L && u(u.S + u.F * (!G || s(function() {
            var t = N();
            return "[null]" != T([
                t
            ]) || "{}" != T({
                a: t
            }) || "{}" != T(Object(t));
        })), "JSON", {
            stringify: function(t) {
                for(var n, e, r = [
                    t
                ], i = 1; arguments.length > i;)r.push(arguments[i++]);
                if (e = n = r[1], (_(n) || void 0 !== t) && !H(t)) return g(n) || (n = function(t, n) {
                    if ("function" == typeof e && (n = e.call(this, t, n)), !H(n)) return n;
                }), r[1] = n, T.apply(L, r);
            }
        }), N.prototype[C] || e(14)(N.prototype, C, N.prototype.valueOf), l(N, "Symbol"), l(Math, "Math", !0), l(r.JSON, "JSON", !0);
    },
    function(t, n, e) {
        t.exports = e(48)("native-function-to-string", Function.toString);
    },
    function(t, n, e) {
        var r = e(31), i = e(50), o = e(45);
        t.exports = function(t) {
            var n = r(t), e = i.f;
            if (e) for(var u, c = e(t), a = o.f, s = 0; c.length > s;)a.call(t, u = c[s++]) && n.push(u);
            return n;
        };
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Object", {
            create: e(33)
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S + r.F * !e(8), "Object", {
            defineProperty: e(9).f
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S + r.F * !e(8), "Object", {
            defineProperties: e(99)
        });
    },
    function(t, n, e) {
        var r = e(15), i = e(20).f;
        e(21)("getOwnPropertyDescriptor", function() {
            return function(t, n) {
                return i(r(t), n);
            };
        });
    },
    function(t, n, e) {
        var r = e(10), i = e(35);
        e(21)("getPrototypeOf", function() {
            return function(t) {
                return i(r(t));
            };
        });
    },
    function(t, n, e) {
        var r = e(10), i = e(31);
        e(21)("keys", function() {
            return function(t) {
                return i(r(t));
            };
        });
    },
    function(t, n, e) {
        e(21)("getOwnPropertyNames", function() {
            return e(100).f;
        });
    },
    function(t, n, e) {
        var r = e(4), i = e(27).onFreeze;
        e(21)("freeze", function(t) {
            return function(n) {
                return t && r(n) ? t(i(n)) : n;
            };
        });
    },
    function(t, n, e) {
        var r = e(4), i = e(27).onFreeze;
        e(21)("seal", function(t) {
            return function(n) {
                return t && r(n) ? t(i(n)) : n;
            };
        });
    },
    function(t, n, e) {
        var r = e(4), i = e(27).onFreeze;
        e(21)("preventExtensions", function(t) {
            return function(n) {
                return t && r(n) ? t(i(n)) : n;
            };
        });
    },
    function(t, n, e) {
        var r = e(4);
        e(21)("isFrozen", function(t) {
            return function(n) {
                return !r(n) || !!t && t(n);
            };
        });
    },
    function(t, n, e) {
        var r = e(4);
        e(21)("isSealed", function(t) {
            return function(n) {
                return !r(n) || !!t && t(n);
            };
        });
    },
    function(t, n, e) {
        var r = e(4);
        e(21)("isExtensible", function(t) {
            return function(n) {
                return !!r(n) && (!t || t(n));
            };
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S + r.F, "Object", {
            assign: e(101)
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Object", {
            is: e(102)
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Object", {
            setPrototypeOf: e(67).set
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(46), i = {};
        i[e(5)("toStringTag")] = "z", i + "" != "[object z]" && e(11)(Object.prototype, "toString", function() {
            return "[object " + r(this) + "]";
        }, !0);
    },
    function(t, n, e) {
        var r = e(0);
        r(r.P, "Function", {
            bind: e(103)
        });
    },
    function(t, n, e) {
        var r = e(9).f, i = Function.prototype, o = /^\s*function ([^ (]*)/;
        "name" in i || e(8) && r(i, "name", {
            configurable: !0,
            get: function() {
                try {
                    return ("" + this).match(o)[1];
                } catch (t) {
                    return "";
                }
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(4), i = e(35), o = e(5)("hasInstance"), u = Function.prototype;
        o in u || e(9).f(u, o, {
            value: function(t) {
                if ("function" != typeof this || !r(t)) return !1;
                if (!r(this.prototype)) return t instanceof this;
                for(; t = i(t);)if (this.prototype === t) return !0;
                return !1;
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(105);
        r(r.G + r.F * (parseInt != i), {
            parseInt: i
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(106);
        r(r.G + r.F * (parseFloat != i), {
            parseFloat: i
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(1), i = e(13), o = e(23), u = e(69), c = e(26), a = e(2), s = e(34).f, f = e(20).f, l = e(9).f, h = e(39).trim, p = r.Number, v = p, d = p.prototype, y = "Number" == o(e(33)(d)), g = "trim" in String.prototype, m = function(t) {
            var n = c(t, !1);
            if ("string" == typeof n && n.length > 2) {
                var e, r, i, o = (n = g ? n.trim() : h(n, 3)).charCodeAt(0);
                if (43 === o || 45 === o) {
                    if (88 === (e = n.charCodeAt(2)) || 120 === e) return NaN;
                } else if (48 === o) {
                    switch(n.charCodeAt(1)){
                        case 66:
                        case 98:
                            r = 2, i = 49;
                            break;
                        case 79:
                        case 111:
                            r = 8, i = 55;
                            break;
                        default:
                            return +n;
                    }
                    for(var u, a = n.slice(2), s = 0, f = a.length; s < f; s++)if ((u = a.charCodeAt(s)) < 48 || u > i) return NaN;
                    return parseInt(a, r);
                }
            }
            return +n;
        };
        if (!p(" 0o1") || !p("0b1") || p("+0x1")) {
            p = function(t) {
                var n = arguments.length < 1 ? 0 : t, e = this;
                return e instanceof p && (y ? a(function() {
                    d.valueOf.call(e);
                }) : "Number" != o(e)) ? u(new v(m(n)), e, p) : m(n);
            };
            for(var _, b = e(8) ? s(v) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","), x = 0; b.length > x; x++)i(v, _ = b[x]) && !i(p, _) && l(p, _, f(v, _));
            p.prototype = d, d.constructor = p, e(11)(r, "Number", p);
        }
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(19), o = e(107), u = e(70), c = 1..toFixed, a = Math.floor, s = [
            0,
            0,
            0,
            0,
            0,
            0
        ], f = "Number.toFixed: incorrect invocation!", l = function(t, n) {
            for(var e = -1, r = n; ++e < 6;)r += t * s[e], s[e] = r % 1e7, r = a(r / 1e7);
        }, h = function(t) {
            for(var n = 6, e = 0; --n >= 0;)e += s[n], s[n] = a(e / t), e = e % t * 1e7;
        }, p = function() {
            for(var t = 6, n = ""; --t >= 0;)if ("" !== n || 0 === t || 0 !== s[t]) {
                var e = String(s[t]);
                n = "" === n ? e : n + u.call("0", 7 - e.length) + e;
            }
            return n;
        }, v = function(t, n, e) {
            return 0 === n ? e : n % 2 == 1 ? v(t, n - 1, e * t) : v(t * t, n / 2, e);
        };
        r(r.P + r.F * (!!c && ("0.000" !== 8e-5.toFixed(3) || "1" !== .9.toFixed(0) || "1.25" !== 1.255.toFixed(2) || "1000000000000000128" !== 0xde0b6b3a7640080.toFixed(0)) || !e(2)(function() {
            c.call({});
        })), "Number", {
            toFixed: function(t) {
                var n, e, r, c, a = o(this, f), s = i(t), d = "", y = "0";
                if (s < 0 || s > 20) throw RangeError(f);
                if (a != a) return "NaN";
                if (a <= -1000000000000000000000 || a >= 1e21) return String(a);
                if (a < 0 && (d = "-", a = -a), a > 1e-21) {
                    if (e = (n = function(t) {
                        for(var n = 0, e = t; e >= 4096;)n += 12, e /= 4096;
                        for(; e >= 2;)n += 1, e /= 2;
                        return n;
                    }(a * v(2, 69, 1)) - 69) < 0 ? a * v(2, -n, 1) : a / v(2, n, 1), e *= 4503599627370496, (n = 52 - n) > 0) {
                        for(l(0, e), r = s; r >= 7;)l(1e7, 0), r -= 7;
                        for(l(v(10, r, 1), 0), r = n - 1; r >= 23;)h(8388608), r -= 23;
                        h(1 << r), l(1, 1), h(2), y = p();
                    } else l(0, e), l(1 << -n, 0), y = p() + u.call("0", s);
                }
                return y = s > 0 ? d + ((c = y.length) <= s ? "0." + u.call("0", s - c) + y : y.slice(0, c - s) + "." + y.slice(c - s)) : d + y;
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(2), o = e(107), u = 1..toPrecision;
        r(r.P + r.F * (i(function() {
            return "1" !== u.call(1, void 0);
        }) || !i(function() {
            u.call({});
        })), "Number", {
            toPrecision: function(t) {
                var n = o(this, "Number#toPrecision: incorrect invocation!");
                return void 0 === t ? u.call(n) : u.call(n, t);
            }
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Number", {
            EPSILON: Math.pow(2, -52)
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(1).isFinite;
        r(r.S, "Number", {
            isFinite: function(t) {
                return "number" == typeof t && i(t);
            }
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Number", {
            isInteger: e(108)
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Number", {
            isNaN: function(t) {
                return t != t;
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(108), o = Math.abs;
        r(r.S, "Number", {
            isSafeInteger: function(t) {
                return i(t) && o(t) <= 9007199254740991;
            }
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Number", {
            MAX_SAFE_INTEGER: 9007199254740991
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Number", {
            MIN_SAFE_INTEGER: -9007199254740991
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(106);
        r(r.S + r.F * (Number.parseFloat != i), "Number", {
            parseFloat: i
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(105);
        r(r.S + r.F * (Number.parseInt != i), "Number", {
            parseInt: i
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(109), o = Math.sqrt, u = Math.acosh;
        r(r.S + r.F * !(u && 710 == Math.floor(u(Number.MAX_VALUE)) && u(1 / 0) == 1 / 0), "Math", {
            acosh: function(t) {
                return (t = +t) < 1 ? NaN : t > 94906265.62425156 ? Math.log(t) + Math.LN2 : i(t - 1 + o(t - 1) * o(t + 1));
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = Math.asinh;
        r(r.S + r.F * !(i && 1 / i(0) > 0), "Math", {
            asinh: function t(n) {
                return isFinite(n = +n) && 0 != n ? n < 0 ? -t(-n) : Math.log(n + Math.sqrt(n * n + 1)) : n;
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = Math.atanh;
        r(r.S + r.F * !(i && 1 / i(-0) < 0), "Math", {
            atanh: function(t) {
                return 0 == (t = +t) ? t : Math.log((1 + t) / (1 - t)) / 2;
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(71);
        r(r.S, "Math", {
            cbrt: function(t) {
                return i(t = +t) * Math.pow(Math.abs(t), 1 / 3);
            }
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Math", {
            clz32: function(t) {
                return (t >>>= 0) ? 31 - Math.floor(Math.log(t + .5) * Math.LOG2E) : 32;
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = Math.exp;
        r(r.S, "Math", {
            cosh: function(t) {
                return (i(t = +t) + i(-t)) / 2;
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(72);
        r(r.S + r.F * (i != Math.expm1), "Math", {
            expm1: i
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Math", {
            fround: e(188)
        });
    },
    function(t, n, e) {
        var r = e(71), i = Math.pow, o = i(2, -52), u = i(2, -23), c = i(2, 127) * (2 - u), a = i(2, -126);
        t.exports = Math.fround || function(t) {
            var n, e, i = Math.abs(t), s = r(t);
            return i < a ? s * (i / a / u + 1 / o - 1 / o) * a * u : (e = (n = (1 + u / o) * i) - (n - i)) > c || e != e ? s * (1 / 0) : s * e;
        };
    },
    function(t, n, e) {
        var r = e(0), i = Math.abs;
        r(r.S, "Math", {
            hypot: function(t, n) {
                for(var e, r, o = 0, u = 0, c = arguments.length, a = 0; u < c;)a < (e = i(arguments[u++])) ? (o = o * (r = a / e) * r + 1, a = e) : o += e > 0 ? (r = e / a) * r : e;
                return a === 1 / 0 ? 1 / 0 : a * Math.sqrt(o);
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = Math.imul;
        r(r.S + r.F * e(2)(function() {
            return -5 != i(4294967295, 5) || 2 != i.length;
        }), "Math", {
            imul: function(t, n) {
                var e = +t, r = +n, i = 65535 & e, o = 65535 & r;
                return 0 | i * o + ((65535 & e >>> 16) * o + i * (65535 & r >>> 16) << 16 >>> 0);
            }
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Math", {
            log10: function(t) {
                return Math.log(t) * Math.LOG10E;
            }
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Math", {
            log1p: e(109)
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Math", {
            log2: function(t) {
                return Math.log(t) / Math.LN2;
            }
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Math", {
            sign: e(71)
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(72), o = Math.exp;
        r(r.S + r.F * e(2)(function() {
            return -0.00000000000000002 != !Math.sinh(-0.00000000000000002);
        }), "Math", {
            sinh: function(t) {
                return Math.abs(t = +t) < 1 ? (i(t) - i(-t)) / 2 : (o(t - 1) - o(-t - 1)) * (Math.E / 2);
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(72), o = Math.exp;
        r(r.S, "Math", {
            tanh: function(t) {
                var n = i(t = +t), e = i(-t);
                return n == 1 / 0 ? 1 : e == 1 / 0 ? -1 : (n - e) / (o(t) + o(-t));
            }
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Math", {
            trunc: function(t) {
                return (t > 0 ? Math.floor : Math.ceil)(t);
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(32), o = String.fromCharCode, u = String.fromCodePoint;
        r(r.S + r.F * (!!u && 1 != u.length), "String", {
            fromCodePoint: function(t) {
                for(var n, e = [], r = arguments.length, u = 0; r > u;){
                    if (n = +arguments[u++], i(n, 1114111) !== n) throw RangeError(n + " is not a valid code point");
                    e.push(n < 65536 ? o(n) : o(55296 + ((n -= 65536) >> 10), n % 1024 + 56320));
                }
                return e.join("");
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(15), o = e(6);
        r(r.S, "String", {
            raw: function(t) {
                for(var n = i(t.raw), e = o(n.length), r = arguments.length, u = [], c = 0; e > c;)u.push(String(n[c++])), c < r && u.push(String(arguments[c]));
                return u.join("");
            }
        });
    },
    function(t, n, e) {
        "use strict";
        e(39)("trim", function(t) {
            return function() {
                return t(this, 3);
            };
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(73)(!0);
        e(74)(String, "String", function(t) {
            this._t = String(t), this._i = 0;
        }, function() {
            var t, n = this._t, e = this._i;
            return e >= n.length ? {
                value: void 0,
                done: !0
            } : (t = r(n, e), this._i += t.length, {
                value: t,
                done: !1
            });
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(73)(!1);
        r(r.P, "String", {
            codePointAt: function(t) {
                return i(this, t);
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(6), o = e(75), u = "".endsWith;
        r(r.P + r.F * e(77)("endsWith"), "String", {
            endsWith: function(t) {
                var n = o(this, t, "endsWith"), e = arguments.length > 1 ? arguments[1] : void 0, r = i(n.length), c = void 0 === e ? r : Math.min(i(e), r), a = String(t);
                return u ? u.call(n, a, c) : n.slice(c - a.length, c) === a;
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(75);
        r(r.P + r.F * e(77)("includes"), "String", {
            includes: function(t) {
                return !!~i(this, t, "includes").indexOf(t, arguments.length > 1 ? arguments[1] : void 0);
            }
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.P, "String", {
            repeat: e(70)
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(6), o = e(75), u = "".startsWith;
        r(r.P + r.F * e(77)("startsWith"), "String", {
            startsWith: function(t) {
                var n = o(this, t, "startsWith"), e = i(Math.min(arguments.length > 1 ? arguments[1] : void 0, n.length)), r = String(t);
                return u ? u.call(n, r, e) : n.slice(e, e + r.length) === r;
            }
        });
    },
    function(t, n, e) {
        "use strict";
        e(12)("anchor", function(t) {
            return function(n) {
                return t(this, "a", "name", n);
            };
        });
    },
    function(t, n, e) {
        "use strict";
        e(12)("big", function(t) {
            return function() {
                return t(this, "big", "", "");
            };
        });
    },
    function(t, n, e) {
        "use strict";
        e(12)("blink", function(t) {
            return function() {
                return t(this, "blink", "", "");
            };
        });
    },
    function(t, n, e) {
        "use strict";
        e(12)("bold", function(t) {
            return function() {
                return t(this, "b", "", "");
            };
        });
    },
    function(t, n, e) {
        "use strict";
        e(12)("fixed", function(t) {
            return function() {
                return t(this, "tt", "", "");
            };
        });
    },
    function(t, n, e) {
        "use strict";
        e(12)("fontcolor", function(t) {
            return function(n) {
                return t(this, "font", "color", n);
            };
        });
    },
    function(t, n, e) {
        "use strict";
        e(12)("fontsize", function(t) {
            return function(n) {
                return t(this, "font", "size", n);
            };
        });
    },
    function(t, n, e) {
        "use strict";
        e(12)("italics", function(t) {
            return function() {
                return t(this, "i", "", "");
            };
        });
    },
    function(t, n, e) {
        "use strict";
        e(12)("link", function(t) {
            return function(n) {
                return t(this, "a", "href", n);
            };
        });
    },
    function(t, n, e) {
        "use strict";
        e(12)("small", function(t) {
            return function() {
                return t(this, "small", "", "");
            };
        });
    },
    function(t, n, e) {
        "use strict";
        e(12)("strike", function(t) {
            return function() {
                return t(this, "strike", "", "");
            };
        });
    },
    function(t, n, e) {
        "use strict";
        e(12)("sub", function(t) {
            return function() {
                return t(this, "sub", "", "");
            };
        });
    },
    function(t, n, e) {
        "use strict";
        e(12)("sup", function(t) {
            return function() {
                return t(this, "sup", "", "");
            };
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Date", {
            now: function() {
                return (new Date).getTime();
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(10), o = e(26);
        r(r.P + r.F * e(2)(function() {
            return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({
                toISOString: function() {
                    return 1;
                }
            });
        }), "Date", {
            toJSON: function(t) {
                var n = i(this), e = o(n);
                return "number" != typeof e || isFinite(e) ? n.toISOString() : null;
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(223);
        r(r.P + r.F * (Date.prototype.toISOString !== i), "Date", {
            toISOString: i
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(2), i = Date.prototype.getTime, o = Date.prototype.toISOString, u = function(t) {
            return t > 9 ? t : "0" + t;
        };
        t.exports = r(function() {
            return "0385-07-25T07:06:39.999Z" != o.call(new Date(-50000000000001));
        }) || !r(function() {
            o.call(new Date(NaN));
        }) ? function() {
            if (!isFinite(i.call(this))) throw RangeError("Invalid time value");
            var t = this, n = t.getUTCFullYear(), e = t.getUTCMilliseconds(), r = n < 0 ? "-" : n > 9999 ? "+" : "";
            return r + ("00000" + Math.abs(n)).slice(r ? -6 : -4) + "-" + u(t.getUTCMonth() + 1) + "-" + u(t.getUTCDate()) + "T" + u(t.getUTCHours()) + ":" + u(t.getUTCMinutes()) + ":" + u(t.getUTCSeconds()) + "." + (e > 99 ? e : "0" + u(e)) + "Z";
        } : o;
    },
    function(t, n, e) {
        var r = Date.prototype, i = r.toString, o = r.getTime;
        new Date(NaN) + "" != "Invalid Date" && e(11)(r, "toString", function() {
            var t = o.call(this);
            return t == t ? i.call(this) : "Invalid Date";
        });
    },
    function(t, n, e) {
        var r = e(5)("toPrimitive"), i = Date.prototype;
        r in i || e(14)(i, r, e(226));
    },
    function(t, n, e) {
        "use strict";
        var r = e(3), i = e(26);
        t.exports = function(t) {
            if ("string" !== t && "number" !== t && "default" !== t) throw TypeError("Incorrect hint");
            return i(r(this), "number" != t);
        };
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Array", {
            isArray: e(51)
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(17), i = e(0), o = e(10), u = e(111), c = e(78), a = e(6), s = e(79), f = e(80);
        i(i.S + i.F * !e(52)(function(t) {
            Array.from(t);
        }), "Array", {
            from: function(t) {
                var n, e, i, l, h = o(t), p = "function" == typeof this ? this : Array, v = arguments.length, d = v > 1 ? arguments[1] : void 0, y = void 0 !== d, g = 0, m = f(h);
                if (y && (d = r(d, v > 2 ? arguments[2] : void 0, 2)), null == m || p == Array && c(m)) for(e = new p(n = a(h.length)); n > g; g++)s(e, g, y ? d(h[g], g) : h[g]);
                else for(l = m.call(h), e = new p; !(i = l.next()).done; g++)s(e, g, y ? u(l, d, [
                    i.value,
                    g
                ], !0) : i.value);
                return e.length = g, e;
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(79);
        r(r.S + r.F * e(2)(function() {
            function t() {}
            return !(Array.of.call(t) instanceof t);
        }), "Array", {
            of: function() {
                for(var t = 0, n = arguments.length, e = new ("function" == typeof this ? this : Array)(n); n > t;)i(e, t, arguments[t++]);
                return e.length = n, e;
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(15), o = [].join;
        r(r.P + r.F * (e(44) != Object || !e(16)(o)), "Array", {
            join: function(t) {
                return o.call(i(this), void 0 === t ? "," : t);
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(66), o = e(23), u = e(32), c = e(6), a = [].slice;
        r(r.P + r.F * e(2)(function() {
            i && a.call(i);
        }), "Array", {
            slice: function(t, n) {
                var e = c(this.length), r = o(this);
                if (n = void 0 === n ? e : n, "Array" == r) return a.call(this, t, n);
                for(var i = u(t, e), s = u(n, e), f = c(s - i), l = new Array(f), h = 0; h < f; h++)l[h] = "String" == r ? this.charAt(i + h) : this[i + h];
                return l;
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(18), o = e(10), u = e(2), c = [].sort, a = [
            1,
            2,
            3
        ];
        r(r.P + r.F * (u(function() {
            a.sort(void 0);
        }) || !u(function() {
            a.sort(null);
        }) || !e(16)(c)), "Array", {
            sort: function(t) {
                return void 0 === t ? c.call(o(this)) : c.call(o(this), i(t));
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(22)(0), o = e(16)([].forEach, !0);
        r(r.P + r.F * !o, "Array", {
            forEach: function(t) {
                return i(this, t, arguments[1]);
            }
        });
    },
    function(t, n, e) {
        var r = e(4), i = e(51), o = e(5)("species");
        t.exports = function(t) {
            var n;
            return i(t) && ("function" != typeof (n = t.constructor) || n !== Array && !i(n.prototype) || (n = void 0), r(n) && null === (n = n[o]) && (n = void 0)), void 0 === n ? Array : n;
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(22)(1);
        r(r.P + r.F * !e(16)([].map, !0), "Array", {
            map: function(t) {
                return i(this, t, arguments[1]);
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(22)(2);
        r(r.P + r.F * !e(16)([].filter, !0), "Array", {
            filter: function(t) {
                return i(this, t, arguments[1]);
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(22)(3);
        r(r.P + r.F * !e(16)([].some, !0), "Array", {
            some: function(t) {
                return i(this, t, arguments[1]);
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(22)(4);
        r(r.P + r.F * !e(16)([].every, !0), "Array", {
            every: function(t) {
                return i(this, t, arguments[1]);
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(113);
        r(r.P + r.F * !e(16)([].reduce, !0), "Array", {
            reduce: function(t) {
                return i(this, t, arguments.length, arguments[1], !1);
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(113);
        r(r.P + r.F * !e(16)([].reduceRight, !0), "Array", {
            reduceRight: function(t) {
                return i(this, t, arguments.length, arguments[1], !0);
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(49)(!1), o = [].indexOf, u = !!o && 1 / [
            1
        ].indexOf(1, -0) < 0;
        r(r.P + r.F * (u || !e(16)(o)), "Array", {
            indexOf: function(t) {
                return u ? o.apply(this, arguments) || 0 : i(this, t, arguments[1]);
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(15), o = e(19), u = e(6), c = [].lastIndexOf, a = !!c && 1 / [
            1
        ].lastIndexOf(1, -0) < 0;
        r(r.P + r.F * (a || !e(16)(c)), "Array", {
            lastIndexOf: function(t) {
                if (a) return c.apply(this, arguments) || 0;
                var n = i(this), e = u(n.length), r = e - 1;
                for(arguments.length > 1 && (r = Math.min(r, o(arguments[1]))), r < 0 && (r = e + r); r >= 0; r--)if (r in n && n[r] === t) return r || 0;
                return -1;
            }
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.P, "Array", {
            copyWithin: e(114)
        }), e(36)("copyWithin");
    },
    function(t, n, e) {
        var r = e(0);
        r(r.P, "Array", {
            fill: e(81)
        }), e(36)("fill");
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(22)(5), o = !0;
        "find" in [] && Array(1).find(function() {
            o = !1;
        }), r(r.P + r.F * o, "Array", {
            find: function(t) {
                return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
            }
        }), e(36)("find");
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(22)(6), o = "findIndex", u = !0;
        o in [] && Array(1)[o](function() {
            u = !1;
        }), r(r.P + r.F * u, "Array", {
            findIndex: function(t) {
                return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
            }
        }), e(36)(o);
    },
    function(t, n, e) {
        e(41)("Array");
    },
    function(t, n, e) {
        var r = e(1), i = e(69), o = e(9).f, u = e(34).f, c = e(76), a = e(53), s = r.RegExp, f = s, l = s.prototype, h = /a/g, p = /a/g, v = new s(h) !== h;
        if (e(8) && (!v || e(2)(function() {
            return p[e(5)("match")] = !1, s(h) != h || s(p) == p || "/a/i" != s(h, "i");
        }))) {
            s = function(t, n) {
                var e = this instanceof s, r = c(t), o = void 0 === n;
                return !e && r && t.constructor === s && o ? t : i(v ? new f(r && !o ? t.source : t, n) : f((r = t instanceof s) ? t.source : t, r && o ? a.call(t) : n), e ? this : l, s);
            };
            for(var d = function(t) {
                (t in s) || o(s, t, {
                    configurable: !0,
                    get: function() {
                        return f[t];
                    },
                    set: function(n) {
                        f[t] = n;
                    }
                });
            }, y = u(f), g = 0; y.length > g;)d(y[g++]);
            l.constructor = s, s.prototype = l, e(11)(r, "RegExp", s);
        }
        e(41)("RegExp");
    },
    function(t, n, e) {
        "use strict";
        e(117);
        var r = e(3), i = e(53), o = e(8), u = /./.toString, c = function(t) {
            e(11)(RegExp.prototype, "toString", t, !0);
        };
        e(2)(function() {
            return "/a/b" != u.call({
                source: "a",
                flags: "b"
            });
        }) ? c(function() {
            var t = r(this);
            return "/".concat(t.source, "/", "flags" in t ? t.flags : !o && t instanceof RegExp ? i.call(t) : void 0);
        }) : "toString" != u.name && c(function() {
            return u.call(this);
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(3), i = e(6), o = e(84), u = e(54);
        e(55)("match", 1, function(t, n, e, c) {
            return [
                function(e) {
                    var r = t(this), i = null == e ? void 0 : e[n];
                    return void 0 !== i ? i.call(e, r) : new RegExp(e)[n](String(r));
                },
                function(t) {
                    var n = c(e, t, this);
                    if (n.done) return n.value;
                    var a = r(t), s = String(this);
                    if (!a.global) return u(a, s);
                    var f = a.unicode;
                    a.lastIndex = 0;
                    for(var l, h = [], p = 0; null !== (l = u(a, s));){
                        var v = String(l[0]);
                        h[p] = v, "" === v && (a.lastIndex = o(s, i(a.lastIndex), f)), p++;
                    }
                    return 0 === p ? null : h;
                }
            ];
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(3), i = e(10), o = e(6), u = e(19), c = e(84), a = e(54), s = Math.max, f = Math.min, l = Math.floor, h = /\$([$&`']|\d\d?|<[^>]*>)/g, p = /\$([$&`']|\d\d?)/g;
        e(55)("replace", 2, function(t, n, e, v) {
            return [
                function(r, i) {
                    var o = t(this), u = null == r ? void 0 : r[n];
                    return void 0 !== u ? u.call(r, o, i) : e.call(String(o), r, i);
                },
                function(t, n) {
                    var i = v(e, t, this, n);
                    if (i.done) return i.value;
                    var l = r(t), h = String(this), p = "function" == typeof n;
                    p || (n = String(n));
                    var y = l.global;
                    if (y) {
                        var g = l.unicode;
                        l.lastIndex = 0;
                    }
                    for(var m = [];;){
                        var _ = a(l, h);
                        if (null === _) break;
                        if (m.push(_), !y) break;
                        "" === String(_[0]) && (l.lastIndex = c(h, o(l.lastIndex), g));
                    }
                    for(var b, x = "", S = 0, w = 0; w < m.length; w++){
                        _ = m[w];
                        for(var E = String(_[0]), O = s(f(u(_.index), h.length), 0), P = [], F = 1; F < _.length; F++)P.push(void 0 === (b = _[F]) ? b : String(b));
                        var j = _.groups;
                        if (p) {
                            var M = [
                                E
                            ].concat(P, O, h);
                            void 0 !== j && M.push(j);
                            var A = String(n.apply(void 0, M));
                        } else A = d(E, h, O, P, j, n);
                        O >= S && (x += h.slice(S, O) + A, S = O + E.length);
                    }
                    return x + h.slice(S);
                }
            ];
            function d(t, n, r, o, u, c) {
                var a = r + t.length, s = o.length, f = p;
                return void 0 !== u && (u = i(u), f = h), e.call(c, f, function(e, i) {
                    var c;
                    switch(i.charAt(0)){
                        case "$":
                            return "$";
                        case "&":
                            return t;
                        case "`":
                            return n.slice(0, r);
                        case "'":
                            return n.slice(a);
                        case "<":
                            c = u[i.slice(1, -1)];
                            break;
                        default:
                            var f = +i;
                            if (0 === f) return e;
                            if (f > s) {
                                var h = l(f / 10);
                                return 0 === h ? e : h <= s ? void 0 === o[h - 1] ? i.charAt(1) : o[h - 1] + i.charAt(1) : e;
                            }
                            c = o[f - 1];
                    }
                    return void 0 === c ? "" : c;
                });
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(3), i = e(102), o = e(54);
        e(55)("search", 1, function(t, n, e, u) {
            return [
                function(e) {
                    var r = t(this), i = null == e ? void 0 : e[n];
                    return void 0 !== i ? i.call(e, r) : new RegExp(e)[n](String(r));
                },
                function(t) {
                    var n = u(e, t, this);
                    if (n.done) return n.value;
                    var c = r(t), a = String(this), s = c.lastIndex;
                    i(s, 0) || (c.lastIndex = 0);
                    var f = o(c, a);
                    return i(c.lastIndex, s) || (c.lastIndex = s), null === f ? -1 : f.index;
                }
            ];
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(76), i = e(3), o = e(47), u = e(84), c = e(6), a = e(54), s = e(83), f = e(2), l = Math.min, h = [].push, p = "length", v = !f(function() {
            RegExp(4294967295, "y");
        });
        e(55)("split", 2, function(t, n, e, f) {
            var d;
            return d = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1)[p] || 2 != "ab".split(/(?:ab)*/)[p] || 4 != ".".split(/(.?)(.?)/)[p] || ".".split(/()()/)[p] > 1 || "".split(/.?/)[p] ? function(t, n) {
                var i = String(this);
                if (void 0 === t && 0 === n) return [];
                if (!r(t)) return e.call(i, t, n);
                for(var o, u, c, a = [], f = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), l = 0, v = void 0 === n ? 4294967295 : n >>> 0, d = new RegExp(t.source, f + "g"); (o = s.call(d, i)) && !((u = d.lastIndex) > l && (a.push(i.slice(l, o.index)), o[p] > 1 && o.index < i[p] && h.apply(a, o.slice(1)), c = o[0][p], l = u, a[p] >= v));)d.lastIndex === o.index && d.lastIndex++;
                return l === i[p] ? !c && d.test("") || a.push("") : a.push(i.slice(l)), a[p] > v ? a.slice(0, v) : a;
            } : "0".split(void 0, 0)[p] ? function(t, n) {
                return void 0 === t && 0 === n ? [] : e.call(this, t, n);
            } : e, [
                function(e, r) {
                    var i = t(this), o = null == e ? void 0 : e[n];
                    return void 0 !== o ? o.call(e, i, r) : d.call(String(i), e, r);
                },
                function(t, n) {
                    var r = f(d, t, this, n, d !== e);
                    if (r.done) return r.value;
                    var s = i(t), h = String(this), p = o(s, RegExp), y = s.unicode, g = (s.ignoreCase ? "i" : "") + (s.multiline ? "m" : "") + (s.unicode ? "u" : "") + (v ? "y" : "g"), m = new p(v ? s : "^(?:" + s.source + ")", g), _ = void 0 === n ? 4294967295 : n >>> 0;
                    if (0 === _) return [];
                    if (0 === h.length) return null === a(m, h) ? [
                        h
                    ] : [];
                    for(var b = 0, x = 0, S = []; x < h.length;){
                        m.lastIndex = v ? x : 0;
                        var w, E = a(m, v ? h : h.slice(x));
                        if (null === E || (w = l(c(m.lastIndex + (v ? 0 : x)), h.length)) === b) x = u(h, x, y);
                        else {
                            if (S.push(h.slice(b, x)), S.length === _) return S;
                            for(var O = 1; O <= E.length - 1; O++)if (S.push(E[O]), S.length === _) return S;
                            x = b = w;
                        }
                    }
                    return S.push(h.slice(b)), S;
                }
            ];
        });
    },
    function(t, n, e) {
        var r = e(1), i = e(85).set, o = r.MutationObserver || r.WebKitMutationObserver, u = r.process, c = r.Promise, a = "process" == e(23)(u);
        t.exports = function() {
            var t, n, e, s = function() {
                var r, i;
                for(a && (r = u.domain) && r.exit(); t;){
                    i = t.fn, t = t.next;
                    try {
                        i();
                    } catch (r) {
                        throw t ? e() : n = void 0, r;
                    }
                }
                n = void 0, r && r.enter();
            };
            if (a) e = function() {
                u.nextTick(s);
            };
            else if (!o || r.navigator && r.navigator.standalone) {
                if (c && c.resolve) {
                    var f = c.resolve(void 0);
                    e = function() {
                        f.then(s);
                    };
                } else e = function() {
                    i.call(r, s);
                };
            } else {
                var l = !0, h = document.createTextNode("");
                new o(s).observe(h, {
                    characterData: !0
                }), e = function() {
                    h.data = l = !l;
                };
            }
            return function(r) {
                var i = {
                    fn: r,
                    next: void 0
                };
                n && (n.next = i), t || (t = i, e()), n = i;
            };
        };
    },
    function(t, n) {
        t.exports = function(t) {
            try {
                return {
                    e: !1,
                    v: t()
                };
            } catch (t) {
                return {
                    e: !0,
                    v: t
                };
            }
        };
    },
    function(t, n, e) {
        "use strict";
        var r = e(121), i = e(37);
        t.exports = e(58)("Map", function(t) {
            return function() {
                return t(this, arguments.length > 0 ? arguments[0] : void 0);
            };
        }, {
            get: function(t) {
                var n = r.getEntry(i(this, "Map"), t);
                return n && n.v;
            },
            set: function(t, n) {
                return r.def(i(this, "Map"), 0 === t ? 0 : t, n);
            }
        }, r, !0);
    },
    function(t, n, e) {
        "use strict";
        var r = e(121), i = e(37);
        t.exports = e(58)("Set", function(t) {
            return function() {
                return t(this, arguments.length > 0 ? arguments[0] : void 0);
            };
        }, {
            add: function(t) {
                return r.def(i(this, "Set"), t = 0 === t ? 0 : t, t);
            }
        }, r);
    },
    function(t, n, e) {
        "use strict";
        var r, i = e(1), o = e(22)(0), u = e(11), c = e(27), a = e(101), s = e(122), f = e(4), l = e(37), h = e(37), p = !i.ActiveXObject && "ActiveXObject" in i, v = c.getWeak, d = Object.isExtensible, y = s.ufstore, g = function(t) {
            return function() {
                return t(this, arguments.length > 0 ? arguments[0] : void 0);
            };
        }, m = {
            get: function(t) {
                if (f(t)) {
                    var n = v(t);
                    return !0 === n ? y(l(this, "WeakMap")).get(t) : n ? n[this._i] : void 0;
                }
            },
            set: function(t, n) {
                return s.def(l(this, "WeakMap"), t, n);
            }
        }, _ = t.exports = e(58)("WeakMap", g, m, s, !0, !0);
        h && p && (a((r = s.getConstructor(g, "WeakMap")).prototype, m), c.NEED = !0, o([
            "delete",
            "has",
            "get",
            "set"
        ], function(t) {
            var n = _.prototype, e = n[t];
            u(n, t, function(n, i) {
                if (f(n) && !d(n)) {
                    this._f || (this._f = new r);
                    var o = this._f[t](n, i);
                    return "set" == t ? this : o;
                }
                return e.call(this, n, i);
            });
        }));
    },
    function(t, n, e) {
        "use strict";
        var r = e(122), i = e(37);
        e(58)("WeakSet", function(t) {
            return function() {
                return t(this, arguments.length > 0 ? arguments[0] : void 0);
            };
        }, {
            add: function(t) {
                return r.def(i(this, "WeakSet"), t, !0);
            }
        }, r, !1, !0);
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(59), o = e(86), u = e(3), c = e(32), a = e(6), s = e(4), f = e(1).ArrayBuffer, l = e(47), h = o.ArrayBuffer, p = o.DataView, v = i.ABV && f.isView, d = h.prototype.slice, y = i.VIEW;
        r(r.G + r.W + r.F * (f !== h), {
            ArrayBuffer: h
        }), r(r.S + r.F * !i.CONSTR, "ArrayBuffer", {
            isView: function(t) {
                return v && v(t) || s(t) && y in t;
            }
        }), r(r.P + r.U + r.F * e(2)(function() {
            return !new h(2).slice(1, void 0).byteLength;
        }), "ArrayBuffer", {
            slice: function(t, n) {
                if (void 0 !== d && void 0 === n) return d.call(u(this), t);
                for(var e = u(this).byteLength, r = c(t, e), i = c(void 0 === n ? e : n, e), o = new (l(this, h))(a(i - r)), s = new p(this), f = new p(o), v = 0; r < i;)f.setUint8(v++, s.getUint8(r++));
                return o;
            }
        }), e(41)("ArrayBuffer");
    },
    function(t, n, e) {
        var r = e(0);
        r(r.G + r.W + r.F * !e(59).ABV, {
            DataView: e(86).DataView
        });
    },
    function(t, n, e) {
        e(25)("Int8", 1, function(t) {
            return function(n, e, r) {
                return t(this, n, e, r);
            };
        });
    },
    function(t, n, e) {
        e(25)("Uint8", 1, function(t) {
            return function(n, e, r) {
                return t(this, n, e, r);
            };
        });
    },
    function(t, n, e) {
        e(25)("Uint8", 1, function(t) {
            return function(n, e, r) {
                return t(this, n, e, r);
            };
        }, !0);
    },
    function(t, n, e) {
        e(25)("Int16", 2, function(t) {
            return function(n, e, r) {
                return t(this, n, e, r);
            };
        });
    },
    function(t, n, e) {
        e(25)("Uint16", 2, function(t) {
            return function(n, e, r) {
                return t(this, n, e, r);
            };
        });
    },
    function(t, n, e) {
        e(25)("Int32", 4, function(t) {
            return function(n, e, r) {
                return t(this, n, e, r);
            };
        });
    },
    function(t, n, e) {
        e(25)("Uint32", 4, function(t) {
            return function(n, e, r) {
                return t(this, n, e, r);
            };
        });
    },
    function(t, n, e) {
        e(25)("Float32", 4, function(t) {
            return function(n, e, r) {
                return t(this, n, e, r);
            };
        });
    },
    function(t, n, e) {
        e(25)("Float64", 8, function(t) {
            return function(n, e, r) {
                return t(this, n, e, r);
            };
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(18), o = e(3), u = (e(1).Reflect || {}).apply, c = Function.apply;
        r(r.S + r.F * !e(2)(function() {
            u(function() {});
        }), "Reflect", {
            apply: function(t, n, e) {
                var r = i(t), a = o(e);
                return u ? u(r, n, a) : c.call(r, n, a);
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(33), o = e(18), u = e(3), c = e(4), a = e(2), s = e(103), f = (e(1).Reflect || {}).construct, l = a(function() {
            function t() {}
            return !(f(function() {}, [], t) instanceof t);
        }), h = !a(function() {
            f(function() {});
        });
        r(r.S + r.F * (l || h), "Reflect", {
            construct: function(t, n) {
                o(t), u(n);
                var e = arguments.length < 3 ? t : o(arguments[2]);
                if (h && !l) return f(t, n, e);
                if (t == e) {
                    switch(n.length){
                        case 0:
                            return new t;
                        case 1:
                            return new t(n[0]);
                        case 2:
                            return new t(n[0], n[1]);
                        case 3:
                            return new t(n[0], n[1], n[2]);
                        case 4:
                            return new t(n[0], n[1], n[2], n[3]);
                    }
                    var r = [
                        null
                    ];
                    return r.push.apply(r, n), new (s.apply(t, r));
                }
                var a = e.prototype, p = i(c(a) ? a : Object.prototype), v = Function.apply.call(t, p, n);
                return c(v) ? v : p;
            }
        });
    },
    function(t, n, e) {
        var r = e(9), i = e(0), o = e(3), u = e(26);
        i(i.S + i.F * e(2)(function() {
            Reflect.defineProperty(r.f({}, 1, {
                value: 1
            }), 1, {
                value: 2
            });
        }), "Reflect", {
            defineProperty: function(t, n, e) {
                o(t), n = u(n, !0), o(e);
                try {
                    return r.f(t, n, e), !0;
                } catch (t) {
                    return !1;
                }
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(20).f, o = e(3);
        r(r.S, "Reflect", {
            deleteProperty: function(t, n) {
                var e = i(o(t), n);
                return !(e && !e.configurable) && delete t[n];
            }
        });
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(3), o = function(t) {
            this._t = i(t), this._i = 0;
            var n, e = this._k = [];
            for(n in t)e.push(n);
        };
        e(110)(o, "Object", function() {
            var t, n = this._k;
            do {
                if (this._i >= n.length) return {
                    value: void 0,
                    done: !0
                };
            }while (!((t = n[this._i++]) in this._t));
            return {
                value: t,
                done: !1
            };
        }), r(r.S, "Reflect", {
            enumerate: function(t) {
                return new o(t);
            }
        });
    },
    function(t, n, e) {
        var r = e(20), i = e(35), o = e(13), u = e(0), c = e(4), a = e(3);
        u(u.S, "Reflect", {
            get: function t(n, e) {
                var u, s, f = arguments.length < 3 ? n : arguments[2];
                return a(n) === f ? n[e] : (u = r.f(n, e)) ? o(u, "value") ? u.value : void 0 !== u.get ? u.get.call(f) : void 0 : c(s = i(n)) ? t(s, e, f) : void 0;
            }
        });
    },
    function(t, n, e) {
        var r = e(20), i = e(0), o = e(3);
        i(i.S, "Reflect", {
            getOwnPropertyDescriptor: function(t, n) {
                return r.f(o(t), n);
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(35), o = e(3);
        r(r.S, "Reflect", {
            getPrototypeOf: function(t) {
                return i(o(t));
            }
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Reflect", {
            has: function(t, n) {
                return n in t;
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(3), o = Object.isExtensible;
        r(r.S, "Reflect", {
            isExtensible: function(t) {
                return i(t), !o || o(t);
            }
        });
    },
    function(t, n, e) {
        var r = e(0);
        r(r.S, "Reflect", {
            ownKeys: e(124)
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(3), o = Object.preventExtensions;
        r(r.S, "Reflect", {
            preventExtensions: function(t) {
                i(t);
                try {
                    return o && o(t), !0;
                } catch (t) {
                    return !1;
                }
            }
        });
    },
    function(t, n, e) {
        var r = e(9), i = e(20), o = e(35), u = e(13), c = e(0), a = e(28), s = e(3), f = e(4);
        c(c.S, "Reflect", {
            set: function t(n, e, c) {
                var l, h, p = arguments.length < 4 ? n : arguments[3], v = i.f(s(n), e);
                if (!v) {
                    if (f(h = o(n))) return t(h, e, c, p);
                    v = a(0);
                }
                if (u(v, "value")) {
                    if (!1 === v.writable || !f(p)) return !1;
                    if (l = i.f(p, e)) {
                        if (l.get || l.set || !1 === l.writable) return !1;
                        l.value = c, r.f(p, e, l);
                    } else r.f(p, e, a(0, c));
                    return !0;
                }
                return void 0 !== v.set && (v.set.call(p, c), !0);
            }
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(67);
        i && r(r.S, "Reflect", {
            setPrototypeOf: function(t, n) {
                i.check(t, n);
                try {
                    return i.set(t, n), !0;
                } catch (t) {
                    return !1;
                }
            }
        });
    },
    function(t, n, e) {
        e(286), t.exports = e(7).Array.includes;
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(49)(!0);
        r(r.P, "Array", {
            includes: function(t) {
                return i(this, t, arguments.length > 1 ? arguments[1] : void 0);
            }
        }), e(36)("includes");
    },
    function(t, n, e) {
        e(288), t.exports = e(7).Array.flatMap;
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(289), o = e(10), u = e(6), c = e(18), a = e(112);
        r(r.P, "Array", {
            flatMap: function(t) {
                var n, e, r = o(this);
                return c(t), n = u(r.length), e = a(r, 0), i(e, r, r, n, 0, 1, t, arguments[1]), e;
            }
        }), e(36)("flatMap");
    },
    function(t, n, e) {
        "use strict";
        var r = e(51), i = e(4), o = e(6), u = e(17), c = e(5)("isConcatSpreadable");
        t.exports = function t(n, e, a, s, f, l, h, p) {
            for(var v, d, y = f, g = 0, m = !!h && u(h, p, 3); g < s;){
                if (g in a) {
                    if (v = m ? m(a[g], g, e) : a[g], d = !1, i(v) && (d = void 0 !== (d = v[c]) ? !!d : r(v)), d && l > 0) y = t(n, e, v, o(v.length), y, l - 1) - 1;
                    else {
                        if (y >= 9007199254740991) throw TypeError();
                        n[y] = v;
                    }
                    y++;
                }
                g++;
            }
            return y;
        };
    },
    function(t, n, e) {
        e(291), t.exports = e(7).String.padStart;
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(125), o = e(57), u = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(o);
        r(r.P + r.F * u, "String", {
            padStart: function(t) {
                return i(this, t, arguments.length > 1 ? arguments[1] : void 0, !0);
            }
        });
    },
    function(t, n, e) {
        e(293), t.exports = e(7).String.padEnd;
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(125), o = e(57), u = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(o);
        r(r.P + r.F * u, "String", {
            padEnd: function(t) {
                return i(this, t, arguments.length > 1 ? arguments[1] : void 0, !1);
            }
        });
    },
    function(t, n, e) {
        e(295), t.exports = e(7).String.trimLeft;
    },
    function(t, n, e) {
        "use strict";
        e(39)("trimLeft", function(t) {
            return function() {
                return t(this, 1);
            };
        }, "trimStart");
    },
    function(t, n, e) {
        e(297), t.exports = e(7).String.trimRight;
    },
    function(t, n, e) {
        "use strict";
        e(39)("trimRight", function(t) {
            return function() {
                return t(this, 2);
            };
        }, "trimEnd");
    },
    function(t, n, e) {
        e(299), t.exports = e(63).f("asyncIterator");
    },
    function(t, n, e) {
        e(97)("asyncIterator");
    },
    function(t, n, e) {
        e(301), t.exports = e(7).Object.getOwnPropertyDescriptors;
    },
    function(t, n, e) {
        var r = e(0), i = e(124), o = e(15), u = e(20), c = e(79);
        r(r.S, "Object", {
            getOwnPropertyDescriptors: function(t) {
                for(var n, e, r = o(t), a = u.f, s = i(r), f = {}, l = 0; s.length > l;)void 0 !== (e = a(r, n = s[l++])) && c(f, n, e);
                return f;
            }
        });
    },
    function(t, n, e) {
        e(303), t.exports = e(7).Object.values;
    },
    function(t, n, e) {
        var r = e(0), i = e(126)(!1);
        r(r.S, "Object", {
            values: function(t) {
                return i(t);
            }
        });
    },
    function(t, n, e) {
        e(305), t.exports = e(7).Object.entries;
    },
    function(t, n, e) {
        var r = e(0), i = e(126)(!0);
        r(r.S, "Object", {
            entries: function(t) {
                return i(t);
            }
        });
    },
    function(t, n, e) {
        "use strict";
        e(118), e(307), t.exports = e(7).Promise.finally;
    },
    function(t, n, e) {
        "use strict";
        var r = e(0), i = e(7), o = e(1), u = e(47), c = e(120);
        r(r.P + r.R, "Promise", {
            finally: function(t) {
                var n = u(this, i.Promise || o.Promise), e = "function" == typeof t;
                return this.then(e ? function(e) {
                    return c(n, t()).then(function() {
                        return e;
                    });
                } : t, e ? function(e) {
                    return c(n, t()).then(function() {
                        throw e;
                    });
                } : t);
            }
        });
    },
    function(t, n, e) {
        e(309), e(310), e(311), t.exports = e(7);
    },
    function(t, n, e) {
        var r = e(1), i = e(0), o = e(57), u = [].slice, c = /MSIE .\./.test(o), a = function(t) {
            return function(n, e) {
                var r = arguments.length > 2, i = !!r && u.call(arguments, 2);
                return t(r ? function() {
                    ("function" == typeof n ? n : Function(n)).apply(this, i);
                } : n, e);
            };
        };
        i(i.G + i.B + i.F * c, {
            setTimeout: a(r.setTimeout),
            setInterval: a(r.setInterval)
        });
    },
    function(t, n, e) {
        var r = e(0), i = e(85);
        r(r.G + r.B, {
            setImmediate: i.set,
            clearImmediate: i.clear
        });
    },
    function(t, n, e) {
        for(var r = e(82), i = e(31), o = e(11), u = e(1), c = e(14), a = e(40), s = e(5), f = s("iterator"), l = s("toStringTag"), h = a.Array, p = {
            CSSRuleList: !0,
            CSSStyleDeclaration: !1,
            CSSValueList: !1,
            ClientRectList: !1,
            DOMRectList: !1,
            DOMStringList: !1,
            DOMTokenList: !0,
            DataTransferItemList: !1,
            FileList: !1,
            HTMLAllCollection: !1,
            HTMLCollection: !1,
            HTMLFormElement: !1,
            HTMLSelectElement: !1,
            MediaList: !0,
            MimeTypeArray: !1,
            NamedNodeMap: !1,
            NodeList: !0,
            PaintRequestList: !1,
            Plugin: !1,
            PluginArray: !1,
            SVGLengthList: !1,
            SVGNumberList: !1,
            SVGPathSegList: !1,
            SVGPointList: !1,
            SVGStringList: !1,
            SVGTransformList: !1,
            SourceBufferList: !1,
            StyleSheetList: !0,
            TextTrackCueList: !1,
            TextTrackList: !1,
            TouchList: !1
        }, v = i(p), d = 0; d < v.length; d++){
            var y, g = v[d], m = p[g], _ = u[g], b = _ && _.prototype;
            if (b && (b[f] || c(b, f, h), b[l] || c(b, l, g), a[g] = h, m)) for(y in r)b[y] || o(b, y, r[y], !0);
        }
    },
    function(t, n, e) {
        var r = function(t) {
            "use strict";
            var n = Object.prototype, e = n.hasOwnProperty, r = "function" == typeof Symbol ? Symbol : {}, i = r.iterator || "@@iterator", o = r.asyncIterator || "@@asyncIterator", u = r.toStringTag || "@@toStringTag";
            function c(t, n, e, r) {
                var i = n && n.prototype instanceof f ? n : f, o = Object.create(i.prototype), u = new S(r || []);
                return o._invoke = function(t, n, e) {
                    var r = "suspendedStart";
                    return function(i, o) {
                        if ("executing" === r) throw new Error("Generator is already running");
                        if ("completed" === r) {
                            if ("throw" === i) throw o;
                            return E();
                        }
                        for(e.method = i, e.arg = o;;){
                            var u = e.delegate;
                            if (u) {
                                var c = _(u, e);
                                if (c) {
                                    if (c === s) continue;
                                    return c;
                                }
                            }
                            if ("next" === e.method) e.sent = e._sent = e.arg;
                            else if ("throw" === e.method) {
                                if ("suspendedStart" === r) throw r = "completed", e.arg;
                                e.dispatchException(e.arg);
                            } else "return" === e.method && e.abrupt("return", e.arg);
                            r = "executing";
                            var f = a(t, n, e);
                            if ("normal" === f.type) {
                                if (r = e.done ? "completed" : "suspendedYield", f.arg === s) continue;
                                return {
                                    value: f.arg,
                                    done: e.done
                                };
                            }
                            "throw" === f.type && (r = "completed", e.method = "throw", e.arg = f.arg);
                        }
                    };
                }(t, e, u), o;
            }
            function a(t, n, e) {
                try {
                    return {
                        type: "normal",
                        arg: t.call(n, e)
                    };
                } catch (t) {
                    return {
                        type: "throw",
                        arg: t
                    };
                }
            }
            t.wrap = c;
            var s = {};
            function f() {}
            function l() {}
            function h() {}
            var p = {};
            p[i] = function() {
                return this;
            };
            var v = Object.getPrototypeOf, d = v && v(v(w([])));
            d && d !== n && e.call(d, i) && (p = d);
            var y = h.prototype = f.prototype = Object.create(p);
            function g(t) {
                [
                    "next",
                    "throw",
                    "return"
                ].forEach(function(n) {
                    t[n] = function(t) {
                        return this._invoke(n, t);
                    };
                });
            }
            function m(t, n) {
                var r;
                this._invoke = function(i, o) {
                    function u() {
                        return new n(function(r, u) {
                            !function r(i, o, u, c) {
                                var s = a(t[i], t, o);
                                if ("throw" !== s.type) {
                                    var f = s.arg, l = f.value;
                                    return l && "object" == typeof l && e.call(l, "__await") ? n.resolve(l.__await).then(function(t) {
                                        r("next", t, u, c);
                                    }, function(t) {
                                        r("throw", t, u, c);
                                    }) : n.resolve(l).then(function(t) {
                                        f.value = t, u(f);
                                    }, function(t) {
                                        return r("throw", t, u, c);
                                    });
                                }
                                c(s.arg);
                            }(i, o, r, u);
                        });
                    }
                    return r = r ? r.then(u, u) : u();
                };
            }
            function _(t, n) {
                var e = t.iterator[n.method];
                if (void 0 === e) {
                    if (n.delegate = null, "throw" === n.method) {
                        if (t.iterator.return && (n.method = "return", n.arg = void 0, _(t, n), "throw" === n.method)) return s;
                        n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
                    }
                    return s;
                }
                var r = a(e, t.iterator, n.arg);
                if ("throw" === r.type) return n.method = "throw", n.arg = r.arg, n.delegate = null, s;
                var i = r.arg;
                return i ? i.done ? (n[t.resultName] = i.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = void 0), n.delegate = null, s) : i : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, s);
            }
            function b(t) {
                var n = {
                    tryLoc: t[0]
                };
                1 in t && (n.catchLoc = t[1]), 2 in t && (n.finallyLoc = t[2], n.afterLoc = t[3]), this.tryEntries.push(n);
            }
            function x(t) {
                var n = t.completion || {};
                n.type = "normal", delete n.arg, t.completion = n;
            }
            function S(t) {
                this.tryEntries = [
                    {
                        tryLoc: "root"
                    }
                ], t.forEach(b, this), this.reset(!0);
            }
            function w(t) {
                if (t) {
                    var n = t[i];
                    if (n) return n.call(t);
                    if ("function" == typeof t.next) return t;
                    if (!isNaN(t.length)) {
                        var r = -1, o = function n() {
                            for(; ++r < t.length;)if (e.call(t, r)) return n.value = t[r], n.done = !1, n;
                            return n.value = void 0, n.done = !0, n;
                        };
                        return o.next = o;
                    }
                }
                return {
                    next: E
                };
            }
            function E() {
                return {
                    value: void 0,
                    done: !0
                };
            }
            return l.prototype = y.constructor = h, h.constructor = l, h[u] = l.displayName = "GeneratorFunction", t.isGeneratorFunction = function(t) {
                var n = "function" == typeof t && t.constructor;
                return !!n && (n === l || "GeneratorFunction" === (n.displayName || n.name));
            }, t.mark = function(t) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(t, h) : (t.__proto__ = h, u in t || (t[u] = "GeneratorFunction")), t.prototype = Object.create(y), t;
            }, t.awrap = function(t) {
                return {
                    __await: t
                };
            }, g(m.prototype), m.prototype[o] = function() {
                return this;
            }, t.AsyncIterator = m, t.async = function(n, e, r, i, o) {
                void 0 === o && (o = Promise);
                var u = new m(c(n, e, r, i), o);
                return t.isGeneratorFunction(e) ? u : u.next().then(function(t) {
                    return t.done ? t.value : u.next();
                });
            }, g(y), y[u] = "Generator", y[i] = function() {
                return this;
            }, y.toString = function() {
                return "[object Generator]";
            }, t.keys = function(t) {
                var n = [];
                for(var e in t)n.push(e);
                return n.reverse(), function e() {
                    for(; n.length;){
                        var r = n.pop();
                        if (r in t) return e.value = r, e.done = !1, e;
                    }
                    return e.done = !0, e;
                };
            }, t.values = w, S.prototype = {
                constructor: S,
                reset: function(t) {
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(x), !t) for(var n in this)"t" === n.charAt(0) && e.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = void 0);
                },
                stop: function() {
                    this.done = !0;
                    var t = this.tryEntries[0].completion;
                    if ("throw" === t.type) throw t.arg;
                    return this.rval;
                },
                dispatchException: function(t) {
                    if (this.done) throw t;
                    var n = this;
                    function r(e, r) {
                        return u.type = "throw", u.arg = t, n.next = e, r && (n.method = "next", n.arg = void 0), !!r;
                    }
                    for(var i = this.tryEntries.length - 1; i >= 0; --i){
                        var o = this.tryEntries[i], u = o.completion;
                        if ("root" === o.tryLoc) return r("end");
                        if (o.tryLoc <= this.prev) {
                            var c = e.call(o, "catchLoc"), a = e.call(o, "finallyLoc");
                            if (c && a) {
                                if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                                if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                            } else if (c) {
                                if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
                            } else {
                                if (!a) throw new Error("try statement without catch or finally");
                                if (this.prev < o.finallyLoc) return r(o.finallyLoc);
                            }
                        }
                    }
                },
                abrupt: function(t, n) {
                    for(var r = this.tryEntries.length - 1; r >= 0; --r){
                        var i = this.tryEntries[r];
                        if (i.tryLoc <= this.prev && e.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                            var o = i;
                            break;
                        }
                    }
                    o && ("break" === t || "continue" === t) && o.tryLoc <= n && n <= o.finallyLoc && (o = null);
                    var u = o ? o.completion : {};
                    return u.type = t, u.arg = n, o ? (this.method = "next", this.next = o.finallyLoc, s) : this.complete(u);
                },
                complete: function(t, n) {
                    if ("throw" === t.type) throw t.arg;
                    return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && n && (this.next = n), s;
                },
                finish: function(t) {
                    for(var n = this.tryEntries.length - 1; n >= 0; --n){
                        var e = this.tryEntries[n];
                        if (e.finallyLoc === t) return this.complete(e.completion, e.afterLoc), x(e), s;
                    }
                },
                catch: function(t) {
                    for(var n = this.tryEntries.length - 1; n >= 0; --n){
                        var e = this.tryEntries[n];
                        if (e.tryLoc === t) {
                            var r = e.completion;
                            if ("throw" === r.type) {
                                var i = r.arg;
                                x(e);
                            }
                            return i;
                        }
                    }
                    throw new Error("illegal catch attempt");
                },
                delegateYield: function(t, n, e) {
                    return this.delegate = {
                        iterator: w(t),
                        resultName: n,
                        nextLoc: e
                    }, "next" === this.method && (this.arg = void 0), s;
                }
            }, t;
        }(t.exports);
        try {
            regeneratorRuntime = r;
        } catch (t) {
            Function("r", "regeneratorRuntime = r")(r);
        }
    },
    function(t, n, e) {
        e(314), t.exports = e(127).global;
    },
    function(t, n, e) {
        var r = e(315);
        r(r.G, {
            global: e(87)
        });
    },
    function(t, n, e) {
        var r = e(87), i = e(127), o = e(316), u = e(318), c = e(325), a = function(t, n, e) {
            var s, f, l, h = t & a.F, p = t & a.G, v = t & a.S, d = t & a.P, y = t & a.B, g = t & a.W, m = p ? i : i[n] || (i[n] = {}), _ = m.prototype, b = p ? r : v ? r[n] : (r[n] || {}).prototype;
            for(s in p && (e = n), e)(f = !h && b && void 0 !== b[s]) && c(m, s) || (l = f ? b[s] : e[s], m[s] = p && "function" != typeof b[s] ? e[s] : y && f ? o(l, r) : g && b[s] == l ? function(t) {
                var n = function(n, e, r) {
                    if (this instanceof t) {
                        switch(arguments.length){
                            case 0:
                                return new t;
                            case 1:
                                return new t(n);
                            case 2:
                                return new t(n, e);
                        }
                        return new t(n, e, r);
                    }
                    return t.apply(this, arguments);
                };
                return n.prototype = t.prototype, n;
            }(l) : d && "function" == typeof l ? o(Function.call, l) : l, d && ((m.virtual || (m.virtual = {}))[s] = l, t & a.R && _ && !_[s] && u(_, s, l)));
        };
        a.F = 1, a.G = 2, a.S = 4, a.P = 8, a.B = 16, a.W = 32, a.U = 64, a.R = 128, t.exports = a;
    },
    function(t, n, e) {
        var r = e(317);
        t.exports = function(t, n, e) {
            if (r(t), void 0 === n) return t;
            switch(e){
                case 1:
                    return function(e) {
                        return t.call(n, e);
                    };
                case 2:
                    return function(e, r) {
                        return t.call(n, e, r);
                    };
                case 3:
                    return function(e, r, i) {
                        return t.call(n, e, r, i);
                    };
            }
            return function() {
                return t.apply(n, arguments);
            };
        };
    },
    function(t, n) {
        t.exports = function(t) {
            if ("function" != typeof t) throw TypeError(t + " is not a function!");
            return t;
        };
    },
    function(t, n, e) {
        var r = e(319), i = e(324);
        t.exports = e(89) ? function(t, n, e) {
            return r.f(t, n, i(1, e));
        } : function(t, n, e) {
            return t[n] = e, t;
        };
    },
    function(t, n, e) {
        var r = e(320), i = e(321), o = e(323), u = Object.defineProperty;
        n.f = e(89) ? Object.defineProperty : function(t, n, e) {
            if (r(t), n = o(n, !0), r(e), i) try {
                return u(t, n, e);
            } catch (t) {}
            if ("get" in e || "set" in e) throw TypeError("Accessors not supported!");
            return "value" in e && (t[n] = e.value), t;
        };
    },
    function(t, n, e) {
        var r = e(88);
        t.exports = function(t) {
            if (!r(t)) throw TypeError(t + " is not an object!");
            return t;
        };
    },
    function(t, n, e) {
        t.exports = !e(89) && !e(128)(function() {
            return 7 != Object.defineProperty(e(322)("div"), "a", {
                get: function() {
                    return 7;
                }
            }).a;
        });
    },
    function(t, n, e) {
        var r = e(88), i = e(87).document, o = r(i) && r(i.createElement);
        t.exports = function(t) {
            return o ? i.createElement(t) : {};
        };
    },
    function(t, n, e) {
        var r = e(88);
        t.exports = function(t, n) {
            if (!r(t)) return t;
            var e, i;
            if (n && "function" == typeof (e = t.toString) && !r(i = e.call(t))) return i;
            if ("function" == typeof (e = t.valueOf) && !r(i = e.call(t))) return i;
            if (!n && "function" == typeof (e = t.toString) && !r(i = e.call(t))) return i;
            throw TypeError("Can't convert object to primitive value");
        };
    },
    function(t, n) {
        t.exports = function(t, n) {
            return {
                enumerable: !(1 & t),
                configurable: !(2 & t),
                writable: !(4 & t),
                value: n
            };
        };
    },
    function(t, n) {
        var e = {}.hasOwnProperty;
        t.exports = function(t, n) {
            return e.call(t, n);
        };
    }
]);


function $e4381b4d92026ad0$export$a7c2c94bb9dfaf8f() {
    let contactFormElement = document.getElementById("contactFormWizard");
    if (contactFormElement) {
        const wizard = new Zangdar("#contactFormWizard", {
            onStepChange: ()=>{
                $e4381b4d92026ad0$var$onStepChange(wizard, "contactWizardSteps");
            },
            customValidation (step, fields, form) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(form).valid();
            }
        });
        $e4381b4d92026ad0$var$onStepChange(wizard, "contactWizardSteps");
    }
}
function $e4381b4d92026ad0$var$onStepChange(wizard, selector) {
    const steps = wizard.getBreadcrumb();
    $e4381b4d92026ad0$var$buildStepsBreadcrumb(wizard, selector, steps);
}
function $e4381b4d92026ad0$var$buildStepsBreadcrumb(wizard, element, steps) {
    const $steps = document.getElementById(element);
    $steps.innerHTML = "";
    let counter = 1;
    for(let label in steps)if (steps.hasOwnProperty(label)) {
        const $parent = document.createElement("div");
        const $a = document.createElement("a");
        const $textElement = `<div class="text-center fw-bold"><span class="d-inline-block d-md-block">${counter}</span><span class="d-inline-block d-md-none">.</span><span class="d-inline-block d-md-block">${label}</span></div>`;
        $parent.classList = `col ${counter === 2 ? "col-md-6 col-lg-8" : "col-md-3 col-lg-2"} form-wizard-step text-start text-md-center ${steps[label].active ? "" : "d-none d-md-block"}`;
        $a.classList = "d-inline-block w-auto text-decoration-none";
        if (steps[label].active) $a.classList.add("step-active");
        $a.setAttribute("href", "#");
        $a.innerHTML = $textElement;
        $a.addEventListener("click", (e)=>{
            e.preventDefault();
            wizard.revealStep(label);
        });
        $parent.appendChild($a);
        $steps.appendChild($parent);
        counter++;
    }
}


function $adfea27fcc05dea0$export$9477d5792fdd966f() {
    window.recaptchaOnLoad = function() {
        grecaptcha.enterprise.ready(function() {
            document.querySelectorAll("[data-recaptcha-holder]").forEach(function(element) {
                let form = element.closest("form");
                let isCheckboxType = element.dataset.ischeckbox;
                if (isCheckboxType == "False") grecaptcha.enterprise.execute(element.dataset.sitekey).then(function(token) {
                    element.innerHTML = element.innerHTML + '<input type="hidden" name="g-recaptcha-response" value="' + token + '">';
                });
                else {
                    form.dataset.noRecaptcha = true;
                    form.addEventListener("submit", function(event) {
                        if (form.dataset.noRecaptcha) {
                            event.preventDefault();
                            alert("Please submit Recaptcha");
                        }
                    });
                    let button = form.querySelector('button[type="submit"], input[type="submit"]');
                    button.setAttribute("disabled", "disabled");
                    grecaptcha.enterprise.render(element.id, {
                        "sitekey": element.dataset.sitekey,
                        callback: function() {
                            button.removeAttribute("disabled");
                            form.removeAttribute("data-no-recaptcha");
                        }
                    });
                }
            });
        });
    };
}


/*!
 * CookieConsent v2.9.2
 * https://www.github.com/orestbida/cookieconsent
 * Author Orest Bida
 * Released under the MIT License
 */ !function() {
    "use strict";
    var n = "initCookieConsent";
    "undefined" != typeof window && "function" != typeof window[n] && (window[n] = function(n) {
        var t, o, e, i, r, a, c, u, f, d, v, l, s, p, b, m, y, g, h, _, w, k, x, S, J, O, j, N, T, D, C, U, z, E, I, L = {
            mode: "opt-in",
            current_lang: "en",
            auto_language: null,
            autorun: !0,
            page_scripts: !0,
            hide_from_bots: !0,
            cookie_name: "cc_cookie",
            cookie_expiration: 182,
            cookie_domain: location.hostname,
            cookie_path: "/",
            cookie_same_site: "Lax",
            use_rfc_cookie: !1,
            autoclear_cookies: !0,
            revision: 0,
            script_selector: "data-cookiecategory"
        }, M = {}, R = {}, A = null, G = !0, H = !1, P = !1, q = !1, B = !1, F = !0, K = [], Q = !1, V = [], W = [], X = [], Y = !1, Z = [], $ = [], nn = [], tn = [], on = [], en = document.documentElement, rn = function(n) {
            "number" == typeof (t = n).cookie_expiration && (L.cookie_expiration = t.cookie_expiration), "number" == typeof t.cookie_necessary_only_expiration && (L.cookie_necessary_only_expiration = t.cookie_necessary_only_expiration), "boolean" == typeof t.autorun && (L.autorun = t.autorun), "string" == typeof t.cookie_domain && (L.cookie_domain = t.cookie_domain), "string" == typeof t.cookie_same_site && (L.cookie_same_site = t.cookie_same_site), "string" == typeof t.cookie_path && (L.cookie_path = t.cookie_path), "string" == typeof t.cookie_name && (L.cookie_name = t.cookie_name), "function" == typeof t.onAccept && (v = t.onAccept), "function" == typeof t.onFirstAction && (s = t.onFirstAction), "function" == typeof t.onChange && (l = t.onChange), "opt-out" === t.mode && (L.mode = "opt-out"), "number" == typeof t.revision && (t.revision > -1 && (L.revision = t.revision), B = !0), "boolean" == typeof t.autoclear_cookies && (L.autoclear_cookies = t.autoclear_cookies), !0 === t.use_rfc_cookie && (L.use_rfc_cookie = !0), "boolean" == typeof t.hide_from_bots && (L.hide_from_bots = t.hide_from_bots), L.hide_from_bots && (Y = navigator && (navigator.userAgent && /bot|crawl|spider|slurp|teoma/i.test(navigator.userAgent) || navigator.webdriver)), L.page_scripts = !0 === t.page_scripts, "browser" === t.auto_language || !0 === t.auto_language ? L.auto_language = "browser" : "document" === t.auto_language && (L.auto_language = "document"), L.auto_language, L.current_lang = sn(t.languages, t.current_lang);
        }, an = function(n) {
            for(var t = "accept-", o = c("c-settings"), e = c(t + "all"), i = c(t + "necessary"), r = c(t + "custom"), a = 0; a < o.length; a++)o[a].setAttribute("aria-haspopup", "dialog"), wn(o[a], "click", function(n) {
                n.preventDefault(), M.showSettings(0);
            });
            for(a = 0; a < e.length; a++)wn(e[a], "click", function(n) {
                u(n, "all");
            });
            for(a = 0; a < r.length; a++)wn(r[a], "click", function(n) {
                u(n);
            });
            for(a = 0; a < i.length; a++)wn(i[a], "click", function(n) {
                u(n, []);
            });
            function c(t) {
                return (n || document).querySelectorAll('[data-cc="' + t + '"]');
            }
            function u(n, t) {
                n.preventDefault(), M.accept(t), M.hideSettings(), M.hide();
            }
        }, cn = function(n, t) {
            return t.hasOwnProperty(n) ? n : kn(t).length > 0 ? t.hasOwnProperty(L.current_lang) ? L.current_lang : kn(t)[0] : void 0;
        }, un = function(n) {
            if (!0 === t.force_consent && xn(en, "force--consent"), !h) {
                h = ln("div");
                var o = ln("div"), e = ln("div");
                h.id = "cm", o.id = "c-inr-i", e.id = "cm-ov", h.tabIndex = -1, h.setAttribute("role", "dialog"), h.setAttribute("aria-modal", "true"), h.setAttribute("aria-hidden", "false"), h.setAttribute("aria-labelledby", "c-ttl"), h.setAttribute("aria-describedby", "c-txt"), g.appendChild(h), g.appendChild(e), h.style.visibility = e.style.visibility = "hidden", e.style.opacity = 0;
            }
            var i = t.languages[n].consent_modal.title;
            i && (_ || ((_ = ln("h2")).id = "c-ttl", o.appendChild(_)), _.innerHTML = i);
            var r = t.languages[n].consent_modal.description;
            B && (r = F ? r.replace("{{revision_message}}", "") : r.replace("{{revision_message}}", t.languages[n].consent_modal.revision_message || "")), w || ((w = ln("div")).id = "c-txt", o.appendChild(w)), w.innerHTML = r;
            var a, c = t.languages[n].consent_modal.primary_btn, u = t.languages[n].consent_modal.secondary_btn;
            c && (k || ((k = ln("button")).id = "c-p-bn", k.className = "c-bn", k.appendChild(On(1)), "accept_all" === c.role && (a = "all"), wn(k, "click", function() {
                M.hide(), M.accept(a);
            })), k.firstElementChild.innerHTML = t.languages[n].consent_modal.primary_btn.text), u && (x || ((x = ln("button")).id = "c-s-bn", x.className = "c-bn c_link", x.appendChild(On(1)), "accept_necessary" === u.role ? wn(x, "click", function() {
                M.hide(), M.accept([]);
            }) : wn(x, "click", function() {
                M.showSettings(0);
            })), x.firstElementChild.innerHTML = t.languages[n].consent_modal.secondary_btn.text);
            var f = t.gui_options;
            J || ((J = ln("div")).id = "c-inr", J.appendChild(o)), S || ((S = ln("div")).id = "c-bns", f && f.consent_modal && !0 === f.consent_modal.swap_buttons ? (u && S.appendChild(x), c && S.appendChild(k), S.className = "swap") : (c && S.appendChild(k), u && S.appendChild(x)), (c || u) && J.appendChild(S), h.appendChild(J)), H = !0, an(J);
        }, fn = function(n) {
            if (O) (C = ln("div")).id = "s-bl";
            else {
                (O = ln("div")).tabIndex = -1;
                var o = ln("div"), e = ln("div"), i = ln("div");
                j = ln("div"), N = ln("h2");
                var r = ln("div");
                (T = ln("button")).appendChild(On(2));
                var a = ln("div");
                D = ln("div");
                var c = ln("div"), u = !1;
                wn(O, "mouseup", function(n) {
                    !q || u || j.contains(n.target) || M.hideSettings();
                }), wn(O, "mousedown", function(n) {
                    q && (u = j.contains(n.target));
                }), O.id = "s-cnt", o.id = "c-vln", i.id = "c-s-in", e.id = "cs", N.id = "s-ttl", j.id = "s-inr", r.id = "s-hdr", D.id = "s-bl", T.id = "s-c-bn", c.id = "cs-ov", a.id = "s-c-bnc", T.className = "c-bn", O.setAttribute("role", "dialog"), O.setAttribute("aria-modal", "true"), O.setAttribute("aria-hidden", "true"), O.setAttribute("aria-labelledby", "s-ttl"), O.style.visibility = c.style.visibility = "hidden", c.style.opacity = 0, a.appendChild(T), wn(document, "keydown", function(n) {
                    27 === n.keyCode && q && M.hideSettings();
                }, !0), wn(T, "click", function() {
                    M.hideSettings();
                });
            }
            var v = t.languages[n].settings_modal;
            T.setAttribute("aria-label", v.close_btn_label || "Close"), d = v.blocks, f = v.cookie_table_headers;
            var l = v.cookie_table_caption, s = d.length;
            N.innerHTML = v.title;
            for(var p = 0; p < s; ++p){
                var b = d[p].title, m = d[p].description, y = d[p].toggle, h = d[p].cookie_table, _ = !0 === t.remove_cookie_tables, w = !!m || !_ && !!h, k = ln("div"), x = ln("div");
                if (m) {
                    var S = ln("div");
                    S.className = "p", S.insertAdjacentHTML("beforeend", m);
                }
                var J = ln("div");
                if (J.className = "title", k.className = "c-bl", x.className = "desc", void 0 !== y) {
                    var L = "c-ac-" + p, A = ln(w ? "button" : "div"), H = ln("label"), P = ln("input"), B = ln("span"), F = ln("span"), K = ln("span"), Q = ln("span");
                    A.className = w ? "b-tl exp" : "b-tl", H.className = "b-tg", P.className = "c-tgl", K.className = "on-i", Q.className = "off-i", B.className = "c-tg", F.className = "t-lb", w && (A.setAttribute("aria-expanded", "false"), A.setAttribute("aria-controls", L)), P.type = "checkbox", B.setAttribute("aria-hidden", "true");
                    var V = y.value;
                    P.value = V, F.textContent = b, A.insertAdjacentHTML("beforeend", b), J.appendChild(A), B.appendChild(K), B.appendChild(Q), G ? y.enabled ? (P.checked = !0, !C && nn.push(!0), y.enabled && !C && X.push(V)) : !C && nn.push(!1) : vn(R.categories, V) > -1 ? (P.checked = !0, !C && nn.push(!0)) : !C && nn.push(!1), !C && tn.push(V), y.readonly && (P.disabled = !0, xn(B, "c-ro"), !C && on.push(V)), xn(x, "b-acc"), xn(J, "b-bn"), xn(k, "b-ex"), x.id = L, x.setAttribute("aria-hidden", "true"), H.appendChild(P), H.appendChild(B), H.appendChild(F), J.appendChild(H), w && function(n, t, o) {
                        wn(A, "click", function() {
                            Jn(t, "act") ? (Sn(t, "act"), o.setAttribute("aria-expanded", "false"), n.setAttribute("aria-hidden", "true")) : (xn(t, "act"), o.setAttribute("aria-expanded", "true"), n.setAttribute("aria-hidden", "false"));
                        }, !1);
                    }(x, k, A);
                } else if (b) {
                    var W = ln("div");
                    W.className = "b-tl", W.setAttribute("role", "heading"), W.setAttribute("aria-level", "3"), W.insertAdjacentHTML("beforeend", b), J.appendChild(W);
                }
                if (b && k.appendChild(J), m && x.appendChild(S), !_ && void 0 !== h) {
                    for(var Y = document.createDocumentFragment(), Z = 0; Z < f.length; ++Z){
                        var $ = ln("th"), en = f[Z];
                        if ($.setAttribute("scope", "col"), en) {
                            var rn = en && kn(en)[0];
                            $.textContent = f[Z][rn], Y.appendChild($);
                        }
                    }
                    var an = ln("tr");
                    an.appendChild(Y);
                    var cn = ln("thead");
                    cn.appendChild(an);
                    var un = ln("table");
                    if (l) {
                        var fn = ln("caption");
                        fn.innerHTML = l, un.appendChild(fn);
                    }
                    un.appendChild(cn);
                    for(var dn = document.createDocumentFragment(), sn = 0; sn < h.length; sn++){
                        for(var pn = ln("tr"), bn = 0; bn < f.length; ++bn)if (en = f[bn]) {
                            rn = kn(en)[0];
                            var mn = ln("td");
                            mn.insertAdjacentHTML("beforeend", h[sn][rn]), mn.setAttribute("data-column", en[rn]), pn.appendChild(mn);
                        }
                        dn.appendChild(pn);
                    }
                    var yn = ln("tbody");
                    yn.appendChild(dn), un.appendChild(yn), x.appendChild(un);
                }
                (y && b || !y && (b || m)) && (k.appendChild(x), C ? C.appendChild(k) : D.appendChild(k));
            }
            U || ((U = ln("div")).id = "s-bns"), E || ((E = ln("button")).id = "s-all-bn", E.className = "c-bn", U.appendChild(E), wn(E, "click", function() {
                M.accept("all"), M.hideSettings(), M.hide();
            })), E.innerHTML = v.accept_all_btn;
            var gn = v.reject_all_btn;
            if (gn && (I || ((I = ln("button")).id = "s-rall-bn", I.className = "c-bn", wn(I, "click", function() {
                M.accept([]), M.hideSettings(), M.hide();
            }), j.className = "bns-t", U.appendChild(I)), I.innerHTML = gn), z || ((z = ln("button")).id = "s-sv-bn", z.className = "c-bn", U.appendChild(z), wn(z, "click", function() {
                M.accept(), M.hideSettings(), M.hide();
            })), z.innerHTML = v.save_settings_btn, C) return j.replaceChild(C, D), void (D = C);
            r.appendChild(N), r.appendChild(a), j.appendChild(r), j.appendChild(D), j.appendChild(U), i.appendChild(j), e.appendChild(i), o.appendChild(e), O.appendChild(o), g.appendChild(O), g.appendChild(c);
        };
        M.updateLanguage = function(n, o) {
            if ("string" == typeof n) {
                var e = cn(n, t.languages);
                return (e !== L.current_lang || !0 === o) && (L.current_lang = e, H && un(e), fn(e), !0);
            }
        };
        var dn = function(n) {
            var t = d.length, o = -1;
            Q = !1;
            var e = hn("", "all"), i = [
                L.cookie_domain,
                "." + L.cookie_domain
            ];
            if ("www." === L.cookie_domain.slice(0, 4)) {
                var r = L.cookie_domain.substr(4);
                i.push(r), i.push("." + r);
            }
            for(var a = 0; a < t; a++){
                var c = d[a];
                if (c.hasOwnProperty("toggle")) {
                    var u = vn(K, c.toggle.value) > -1;
                    if (!nn[++o] && c.hasOwnProperty("cookie_table") && (n || u)) {
                        var v = c.cookie_table, l = kn(f[0])[0], s = v.length;
                        "on_disable" === c.toggle.reload && u && (Q = !0);
                        for(var p = 0; p < s; p++){
                            var b = i, m = v[p], y = [], g = m[l], h = m.is_regex || !1, _ = m.domain || null, w = m.path || !1;
                            if (_ && (b = [
                                _,
                                "." + _
                            ]), h) for(var k = 0; k < e.length; k++)e[k].match(g) && y.push(e[k]);
                            else {
                                var x = vn(e, g);
                                x > -1 && y.push(e[x]);
                            }
                            y.length > 0 && (_n(y, w, b), "on_clear" === c.toggle.reload && (Q = !0));
                        }
                    }
                }
            }
        }, vn = function(n, t) {
            return n.indexOf(t);
        }, ln = function(n) {
            var t = document.createElement(n);
            return "button" === n && t.setAttribute("type", n), t;
        }, sn = function(n, t) {
            return "browser" === L.auto_language ? cn(pn(), n) : "document" === L.auto_language ? cn(document.documentElement.lang, n) : "string" == typeof t ? L.current_lang = cn(t, n) : (L.current_lang, L.current_lang);
        }, pn = function() {
            var n = navigator.language || navigator.browserLanguage;
            return n.length > 2 && (n = n[0] + n[1]), n.toLowerCase();
        };
        M.allowedCategory = function(n) {
            if (G && "opt-in" !== L.mode) t = X;
            else var t = JSON.parse(hn(L.cookie_name, "one", !0) || "{}").categories || [];
            return vn(t, n) > -1;
        }, M.run = function(t) {
            if (!document.getElementById("cc_div")) {
                if (rn(t), Y) return;
                R = JSON.parse(hn(L.cookie_name, "one", !0) || "{}");
                var c = void 0 !== (i = R.consent_uuid);
                if ((o = R.consent_date) && (o = new Date(o)), (e = R.last_consent_update) && (e = new Date(e)), A = void 0 !== R.data ? R.data : null, B && R.revision !== L.revision && (F = !1), H = G = !(c && F && o && e && i), function() {
                    (y = ln("div")).id = "cc--main", y.style.position = "fixed", y.innerHTML = '<div id="cc_div" class="cc_div"></div>', g = y.children[0];
                    var t = L.current_lang;
                    H && un(t), fn(t), (n || document.body).appendChild(y);
                }(), function() {
                    var n = [
                        "[href]",
                        "button",
                        "input",
                        "details",
                        '[tabindex="0"]'
                    ];
                    function t(t, o) {
                        try {
                            var e = t.querySelectorAll(n.join(':not([tabindex="-1"]), '));
                        } catch (o) {
                            return t.querySelectorAll(n.join(", "));
                        }
                        o[0] = e[0], o[1] = e[e.length - 1];
                    }
                    t(j, $), H && t(h, Z);
                }(), function(n, t) {
                    if ("object" == typeof n) {
                        var o = n.consent_modal, e = n.settings_modal;
                        H && o && i(h, [
                            "box",
                            "bar",
                            "cloud"
                        ], [
                            "top",
                            "middle",
                            "bottom"
                        ], [
                            "zoom",
                            "slide"
                        ], o.layout, o.position, o.transition), e && i(O, [
                            "bar"
                        ], [
                            "left",
                            "right"
                        ], [
                            "zoom",
                            "slide"
                        ], e.layout, e.position, e.transition);
                    }
                    function i(n, t, o, e, i, r, a) {
                        if (r = r && r.split(" ") || [], vn(t, i) > -1 && (xn(n, i), ("bar" !== i || "middle" !== r[0]) && vn(o, r[0]) > -1)) for(var c = 0; c < r.length; c++)xn(n, r[c]);
                        vn(e, a) > -1 && xn(n, a);
                    }
                }(t.gui_options), an(), L.autorun && H && M.show(t.delay || 0), setTimeout(function() {
                    xn(y, "c--anim");
                }, 30), setTimeout(function() {
                    wn(document, "keydown", function(n) {
                        if ("Tab" === n.key && (P || q) && r) {
                            var t = Tn();
                            n.shiftKey ? t !== r[0] && a.contains(t) || (n.preventDefault(), jn(r[1])) : t !== r[1] && a.contains(t) || (n.preventDefault(), jn(r[0]));
                        }
                    });
                }, 100), G) "opt-out" === L.mode && (L.mode, bn());
                else {
                    var u = "boolean" == typeof R.rfc_cookie;
                    (!u || u && R.rfc_cookie !== L.use_rfc_cookie) && (R.rfc_cookie = L.use_rfc_cookie, gn(L.cookie_name, JSON.stringify(R))), p = yn(mn()), bn(), "function" == typeof v && v(R);
                }
            }
        };
        var bn = function() {
            if (L.page_scripts) {
                var n = R.categories || [];
                G && "opt-out" === L.mode && (n = X);
                var t = document.querySelectorAll("script[" + L.script_selector + "]"), o = function(t, e) {
                    if (e < t.length) {
                        var i = t[e], r = i.getAttribute(L.script_selector);
                        if (vn(n, r) > -1) {
                            i.type = i.getAttribute("data-type") || "text/javascript", i.removeAttribute(L.script_selector);
                            var a = i.getAttribute("data-src");
                            a && i.removeAttribute("data-src");
                            var c = ln("script");
                            if (c.textContent = i.innerHTML, function(n, t) {
                                for(var o = t.attributes, e = o.length, i = 0; i < e; i++){
                                    var r = o[i].nodeName;
                                    n.setAttribute(r, t[r] || t.getAttribute(r));
                                }
                            }(c, i), a ? c.src = a : a = i.src, a && (c.readyState ? c.onreadystatechange = function() {
                                "loaded" !== c.readyState && "complete" !== c.readyState || (c.onreadystatechange = null, o(t, ++e));
                            } : c.onload = function() {
                                c.onload = null, o(t, ++e);
                            }), i.parentNode.replaceChild(c, i), a) return;
                        }
                        o(t, ++e);
                    }
                };
                o(t, 0);
            }
        };
        M.set = function(n, t) {
            return "data" === n && function(n, t) {
                var o = !1;
                if ("update" === t) {
                    var e = typeof (A = M.get("data")) == typeof n;
                    if (e && "object" == typeof A) for(var i in !A && (A = {}), n)A[i] !== n[i] && (A[i] = n[i], o = !0);
                    else !e && A || A === n || (A = n, o = !0);
                } else A = n, o = !0;
                return o && (R.data = A, gn(L.cookie_name, JSON.stringify(R))), o;
            }(t.value, t.mode);
        }, M.get = function(n, t) {
            return JSON.parse(hn(t || L.cookie_name, "one", !0) || "{}")[n];
        }, M.getConfig = function(n) {
            return L[n] || t[n];
        };
        var mn = function() {
            return V = R.categories || [], W = tn.filter(function(n) {
                return -1 === vn(V, n);
            }), {
                accepted: V,
                rejected: W
            };
        }, yn = function(n) {
            var t = "custom", o = on.length;
            return n.accepted.length === tn.length ? t = "all" : n.accepted.length === o && (t = "necessary"), t;
        };
        M.getUserPreferences = function() {
            var n = mn();
            return {
                accept_type: yn(n),
                accepted_categories: n.accepted,
                rejected_categories: n.rejected
            };
        }, M.loadScript = function(n, t, o) {
            var e = "function" == typeof t;
            if (document.querySelector('script[src="' + n + '"]')) e && t();
            else {
                var i = ln("script");
                if (o && o.length > 0) for(var r = 0; r < o.length; ++r)o[r] && i.setAttribute(o[r].name, o[r].value);
                e && (i.onload = t), i.src = n, document.head.appendChild(i);
            }
        }, M.updateScripts = function() {
            bn();
        }, M.show = function(n, t) {
            !0 === t && un(L.current_lang), H && (b = Tn(), r = Z, a = h, P = !0, h.removeAttribute("aria-hidden"), setTimeout(function() {
                xn(en, "show--consent");
            }, n > 0 ? n : t ? 30 : 0));
        }, M.hide = function() {
            H && (P = !1, jn(c), h.setAttribute("aria-hidden", "true"), Sn(en, "show--consent"), jn(b), b = null);
        }, M.showSettings = function(n) {
            q = !0, O.removeAttribute("aria-hidden"), P ? m = Tn() : b = Tn(), a = O, r = $, setTimeout(function() {
                xn(en, "show--settings");
            }, n > 0 ? n : 0);
        }, M.hideSettings = function() {
            q = !1, Nn(), jn(u), O.setAttribute("aria-hidden", "true"), Sn(en, "show--settings"), P ? (jn(m), m = null, a = h, r = Z) : (jn(b), b = null);
        }, M.accept = function(n, t) {
            var r = n || void 0, a = t || [], c = [];
            if (r) {
                if ("object" == typeof r && "number" == typeof r.length) for(var u = 0; u < r.length; u++)-1 !== vn(tn, r[u]) && c.push(r[u]);
                else "string" == typeof r && ("all" === r ? c = tn.slice() : -1 !== vn(tn, r) && c.push(r));
            } else c = function() {
                for(var n = document.querySelectorAll(".c-tgl") || [], t = [], o = 0; o < n.length; o++)n[o].checked && t.push(n[o].value);
                return t;
            }();
            if (a.length >= 1) for(u = 0; u < a.length; u++)c = c.filter(function(n) {
                return n !== a[u];
            });
            for(u = 0; u < tn.length; u++)!0 === on.includes(tn[u]) && -1 === vn(c, tn[u]) && c.push(tn[u]);
            !function(n) {
                K = [];
                var t = O.querySelectorAll(".c-tgl") || [];
                if (t.length > 0) for(var r = 0; r < t.length; r++)-1 !== vn(n, tn[r]) ? (t[r].checked = !0, nn[r] || (K.push(tn[r]), nn[r] = !0)) : (t[r].checked = !1, nn[r] && (K.push(tn[r]), nn[r] = !1));
                !G && L.autoclear_cookies && K.length > 0 && dn(), o || (o = new Date), i || (i = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function(n) {
                    try {
                        return (n ^ (window.crypto || window.msCrypto).getRandomValues(new Uint8Array(1))[0] & 15 >> n / 4).toString(16);
                    } catch (n) {
                        return "";
                    }
                })), R = {
                    categories: n,
                    level: n,
                    revision: L.revision,
                    data: A,
                    rfc_cookie: L.use_rfc_cookie,
                    consent_date: o.toISOString(),
                    consent_uuid: i
                }, (G || K.length > 0) && (F = !0, e = e ? new Date : o, R.last_consent_update = e.toISOString(), p = yn(mn()), gn(L.cookie_name, JSON.stringify(R)), bn()), G && (L.autoclear_cookies && dn(!0), "function" == typeof s && s(M.getUserPreferences(), R), "function" == typeof v && v(R), G = !1, "opt-in" === L.mode) || ("function" == typeof l && K.length > 0 && l(R, K), Q && location.reload());
            }(c);
        }, M.eraseCookies = function(n, t, o) {
            var e = [], i = o ? [
                o,
                "." + o
            ] : [
                L.cookie_domain,
                "." + L.cookie_domain
            ];
            if ("object" == typeof n && n.length > 0) for(var r = 0; r < n.length; r++)this.validCookie(n[r]) && e.push(n[r]);
            else this.validCookie(n) && e.push(n);
            _n(e, t, i);
        };
        var gn = function(n, t) {
            var o = L.cookie_expiration;
            "number" == typeof L.cookie_necessary_only_expiration && "necessary" === p && (o = L.cookie_necessary_only_expiration), t = L.use_rfc_cookie ? encodeURIComponent(t) : t;
            var e = new Date;
            e.setTime(e.getTime() + 24 * o * 3600000);
            var i = n + "=" + (t || "") + "; expires=" + e.toUTCString() + "; Path=" + L.cookie_path + ";";
            i += " SameSite=" + L.cookie_same_site + ";", location.hostname.indexOf(".") > -1 && L.cookie_domain && (i += " Domain=" + L.cookie_domain + ";"), "https:" === location.protocol && (i += " Secure;"), document.cookie = i;
        }, hn = function(n, t, o) {
            var e;
            if ("one" === t) {
                if ((e = (e = document.cookie.match("(^|;)\\s*" + n + "\\s*=\\s*([^;]+)")) ? o ? e.pop() : n : "") && n === L.cookie_name) {
                    try {
                        e = JSON.parse(e);
                    } catch (n) {
                        try {
                            e = JSON.parse(decodeURIComponent(e));
                        } catch (n) {
                            e = {};
                        }
                    }
                    e = JSON.stringify(e);
                }
            } else if ("all" === t) {
                var i = document.cookie.split(/;\s*/);
                e = [];
                for(var r = 0; r < i.length; r++)e.push(i[r].split("=")[0]);
            }
            return e;
        }, _n = function(n, t, o) {
            for(var e = t || "/", i = 0; i < n.length; i++){
                for(var r = 0; r < o.length; r++)document.cookie = n[i] + "=; path=" + e + (0 == o[r].indexOf(".") ? "; domain=" + o[r] : "") + "; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                n[i];
            }
        };
        M.validCookie = function(n) {
            return "" !== hn(n, "one", !0);
        }, M.validConsent = function() {
            return !G;
        };
        var wn = function(n, t, o, e) {
            n.addEventListener(t, o, !0 === e && {
                passive: !0
            });
        }, kn = function(n) {
            if ("object" == typeof n) return Object.keys(n);
        }, xn = function(n, t) {
            n.classList.add(t);
        }, Sn = function(n, t) {
            n.classList.remove(t);
        }, Jn = function(n, t) {
            return n.classList.contains(t);
        }, On = function(n) {
            var t = ln("span");
            return t.tabIndex = -1, 1 === n ? c = t : u = t, t;
        }, jn = function(n) {
            n && n instanceof HTMLElement && n.focus();
        }, Nn = function() {
            for(var n = j.querySelectorAll(".c-tgl"), t = 0; t < n.length; t++){
                var o = n[t].value, e = on.includes(o);
                n[t].checked = e || M.allowedCategory(o);
            }
        }, Tn = function() {
            return document.activeElement;
        };
        return M;
    });
}();


function $ecd5e57691808421$export$5bb2e8100a315ad2() {
    let cc = initCookieConsent();
    let cookieTemplate = {
        consentModalDescription: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
        consentModalTitle: "We use cookies!",
        moreInformationDescription: `For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/contact-us">contact us</a>.`,
        moreInformationTitle: "More information",
        settingsModalDescription: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="/cookie-policy" class="cc-link">privacy policy</a>.',
        settingsModalTitle: "Cookie usage \uD83D\uDCE2"
    };
    cc.run({
        current_lang: "en",
        autoclear_cookies: true,
        page_scripts: true,
        // revision: 0,
        gui_options: {
            consent_modal: {
                layout: "cloud",
                position: "middle center",
                transition: "slide",
                swap_buttons: false
            },
            settings_modal: {
                layout: "box",
                transition: "slide"
            }
        },
        languages: {
            "en": {
                consent_modal: {
                    title: cookieTemplate.consentModalTitle,
                    description: cookieTemplate.consentModalDescription,
                    primary_btn: {
                        text: "Accept all",
                        role: "accept_all"
                    },
                    secondary_btn: {
                        text: "Reject all",
                        role: "accept_necessary"
                    }
                },
                settings_modal: {
                    title: "Cookie preferences",
                    save_settings_btn: "Save settings",
                    accept_all_btn: "Accept all",
                    reject_all_btn: "Reject all",
                    close_btn_label: "Close",
                    cookie_table_headers: [
                        {
                            col1: "Name"
                        },
                        {
                            col2: "Domain"
                        },
                        {
                            col3: "Expiration"
                        },
                        {
                            col4: "Description"
                        }
                    ],
                    blocks: [
                        {
                            title: cookieTemplate.settingsModalTitle,
                            description: cookieTemplate.settingsModalDescription
                        },
                        {
                            title: "Strictly necessary cookies",
                            description: "These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly",
                            toggle: {
                                value: "necessary",
                                enabled: true,
                                readonly: true
                            },
                            cookie_table: [
                                {
                                    col1: "ARRAffinity",
                                    col2: "/",
                                    col3: "ARRAffinity cookie is set by Azure app service, and allows the service to choose the right instance established by a user to deliver subsequent requests made by that user.",
                                    col4: "session"
                                },
                                {
                                    col1: "ARRAffinitySameSite",
                                    col2: "/",
                                    col3: "This cookie is set by Windows Azure cloud, and is used for load balancing to make sure the visitor page requests are routed to the same server in any browsing session.",
                                    col4: "session"
                                },
                                {
                                    col1: ".AspNetCore.Antiforgery.^",
                                    col2: "/",
                                    col3: "No description.",
                                    col4: "Helps prevent Cross-Site Request Forgery (CSRF) attacks.",
                                    is_regex: true
                                },
                                {
                                    col1: "RequestVerificationToken",
                                    col2: "/",
                                    col3: "No description.",
                                    col4: "session"
                                },
                                {
                                    col1: "current.usersessionGuid",
                                    col2: "/",
                                    col3: "No description.",
                                    col4: "3 months"
                                },
                                {
                                    col1: "CookieConsent",
                                    col2: "/",
                                    col3: "Stores the user's cookie consent state for the current domain",
                                    col4: "1 year"
                                }
                            ]
                        },
                        {
                            title: "Performance and Analytics cookies",
                            description: "These cookies allow the website to remember the choices you have made in the past",
                            toggle: {
                                value: "analytics",
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [
                                {
                                    col1: "ai_user",
                                    col2: "/",
                                    col3: "1 year",
                                    col4: "A unique user identifier cookie, set by Microsoft Application Insights software, that enables counting of the number of users accessing the application over time."
                                },
                                {
                                    col1: "ai_session",
                                    col2: "/",
                                    col3: "30 minutes",
                                    col4: "This is a unique anonymous session identifier cookie set by Microsoft Application Insights software to gather statistical usage and telemetry data for apps built on the Azure cloud platform."
                                },
                                {
                                    col1: "AI_sentBuffer",
                                    col2: "/",
                                    col3: "Session",
                                    col4: "Used in context with the &quot;AI_buffer&quot; in order to limit the number of data-server-updates (Azure). This synergy also allows the website to detect any duplicate data-server-updates."
                                },
                                {
                                    col1: "AI_buffer",
                                    col2: "/",
                                    col3: "Session",
                                    col4: "Used in context with the &quot;AI_sentBuffer&quot; in order to limit the number of data-server-updates (Azure).  This synergy also allows the website to detect any duplicate data-server-updates."
                                },
                                {
                                    col1: "_ga",
                                    col2: ".google.com",
                                    col3: "2 years",
                                    col4: "Used to distinguish users."
                                },
                                {
                                    col1: "_ga_^",
                                    col2: ".google.com",
                                    col3: "2 years",
                                    col4: "Used to persist session state.",
                                    is_regex: true
                                },
                                {
                                    col1: "_gid",
                                    col2: ".google.com",
                                    col3: "24 hours",
                                    col4: "Used to distinguish users."
                                },
                                {
                                    col1: "_gat",
                                    col2: ".google.com",
                                    col3: "1 minute",
                                    col4: `Used to throttle request rate. If Google Analytics is deployed via
      Google Tag Manager, this cookie will be named <code translate="no" dir="ltr">_<wbr>dc_<wbr>gtm_<wbr>&lt;property-
      id&gt;</code>.`
                                },
                                {
                                    col1: "_gac_^",
                                    col2: ".google.com",
                                    col3: "90 days",
                                    col4: `Contains campaign related information for the user. If you have
      linked your Google Analytics and Google Ads accounts, Google Ads
      website conversion tags will read this cookie unless you opt-out.
      <a href="//support..google.com/google-ads/answer/7521212">Learn more</a>.`,
                                    is_regex: true
                                }
                            ]
                        },
                        {
                            title: "Advertisement and Targeting cookies",
                            description: "These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you",
                            toggle: {
                                value: "targeting",
                                enabled: false,
                                readonly: false
                            }
                        },
                        {
                            title: cookieTemplate.moreInformationTitle,
                            description: cookieTemplate.moreInformationDescription
                        }
                    ]
                }
            }
        }
    });
}


// ==================================================
// fancyBox v3.5.7
//
// Licensed GPLv3 for open source use
// or fancyBox Commercial License for commercial use
//
// http://fancyapps.com/fancybox/
// Copyright 2019 fancyApps
//
// ==================================================
(function(window1, document1, $, undefined1) {
    "use strict";
    window1.console = window1.console || {
        info: function(stuff) {}
    };
    // If there's no jQuery, fancyBox can't work
    // =========================================
    if (!$) return;
    // Check if fancyBox is already initialized
    // ========================================
    if ($.fn.fancybox) {
        console.info("fancyBox already initialized");
        return;
    }
    // Private default settings
    // ========================
    var defaults = {
        // Close existing modals
        // Set this to false if you do not need to stack multiple instances
        closeExisting: false,
        // Enable infinite gallery navigation
        loop: false,
        // Horizontal space between slides
        gutter: 50,
        // Enable keyboard navigation
        keyboard: true,
        // Should allow caption to overlap the content
        preventCaptionOverlap: true,
        // Should display navigation arrows at the screen edges
        arrows: true,
        // Should display counter at the top left corner
        infobar: true,
        // Should display close button (using `btnTpl.smallBtn` template) over the content
        // Can be true, false, "auto"
        // If "auto" - will be automatically enabled for "html", "inline" or "ajax" items
        smallBtn: "auto",
        // Should display toolbar (buttons at the top)
        // Can be true, false, "auto"
        // If "auto" - will be automatically hidden if "smallBtn" is enabled
        toolbar: "auto",
        // What buttons should appear in the top right corner.
        // Buttons will be created using templates from `btnTpl` option
        // and they will be placed into toolbar (class="fancybox-toolbar"` element)
        buttons: [
            "zoom",
            //"share",
            "slideShow",
            //"fullScreen",
            //"download",
            "thumbs",
            "close"
        ],
        // Detect "idle" time in seconds
        idleTime: 3,
        // Disable right-click and use simple image protection for images
        protect: false,
        // Shortcut to make content "modal" - disable keyboard navigtion, hide buttons, etc
        modal: false,
        image: {
            // Wait for images to load before displaying
            //   true  - wait for image to load and then display;
            //   false - display thumbnail and load the full-sized image over top,
            //           requires predefined image dimensions (`data-width` and `data-height` attributes)
            preload: false
        },
        ajax: {
            // Object containing settings for ajax request
            settings: {
                // This helps to indicate that request comes from the modal
                // Feel free to change naming
                data: {
                    fancybox: true
                }
            }
        },
        iframe: {
            // Iframe template
            tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
            // Preload iframe before displaying it
            // This allows to calculate iframe content width and height
            // (note: Due to "Same Origin Policy", you can't get cross domain data).
            preload: true,
            // Custom CSS styling for iframe wrapping element
            // You can use this to set custom iframe dimensions
            css: {},
            // Iframe tag attributes
            attr: {
                scrolling: "auto"
            }
        },
        // For HTML5 video only
        video: {
            tpl: '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
            format: "",
            autoStart: true
        },
        // Default content type if cannot be detected automatically
        defaultType: "image",
        // Open/close animation type
        // Possible values:
        //   false            - disable
        //   "zoom"           - zoom images from/to thumbnail
        //   "fade"
        //   "zoom-in-out"
        //
        animationEffect: "zoom",
        // Duration in ms for open/close animation
        animationDuration: 366,
        // Should image change opacity while zooming
        // If opacity is "auto", then opacity will be changed if image and thumbnail have different aspect ratios
        zoomOpacity: "auto",
        // Transition effect between slides
        //
        // Possible values:
        //   false            - disable
        //   "fade'
        //   "slide'
        //   "circular'
        //   "tube'
        //   "zoom-in-out'
        //   "rotate'
        //
        transitionEffect: "fade",
        // Duration in ms for transition animation
        transitionDuration: 366,
        // Custom CSS class for slide element
        slideClass: "",
        // Custom CSS class for layout
        baseClass: "",
        // Base template for layout
        baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
        // Loading indicator template
        spinnerTpl: '<div class="fancybox-loading"></div>',
        // Error message template
        errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
        btnTpl: {
            download: '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
            zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
            close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
            // Arrows
            arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
            arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
            // This small close button will be appended to your html/inline/ajax content by default,
            // if "smallBtn" option is not set to false
            smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>'
        },
        // Container is injected into this element
        parentEl: "body",
        // Hide browser vertical scrollbars; use at your own risk
        hideScrollbar: true,
        // Focus handling
        // ==============
        // Try to focus on the first focusable element after opening
        autoFocus: true,
        // Put focus back to active element after closing
        backFocus: true,
        // Do not let user to focus on element outside modal content
        trapFocus: true,
        // Module specific options
        // =======================
        fullScreen: {
            autoStart: false
        },
        // Set `touch: false` to disable panning/swiping
        touch: {
            vertical: true,
            momentum: true // Continue movement after releasing mouse/touch when panning
        },
        // Hash value when initializing manually,
        // set `false` to disable hash change
        hash: null,
        // Customize or add new media types
        // Example:
        /*
      media : {
        youtube : {
          params : {
            autoplay : 0
          }
        }
      }
    */ media: {},
        slideShow: {
            autoStart: false,
            speed: 3000
        },
        thumbs: {
            autoStart: false,
            hideOnClose: true,
            parentEl: ".fancybox-container",
            axis: "y" // Vertical (y) or horizontal (x) scrolling
        },
        // Use mousewheel to navigate gallery
        // If 'auto' - enabled for images only
        wheel: "auto",
        // Callbacks
        //==========
        // See Documentation/API/Events for more information
        // Example:
        /*
      afterShow: function( instance, current ) {
        console.info( 'Clicked element:' );
        console.info( current.opts.$orig );
      }
    */ onInit: $.noop,
        beforeLoad: $.noop,
        afterLoad: $.noop,
        beforeShow: $.noop,
        afterShow: $.noop,
        beforeClose: $.noop,
        afterClose: $.noop,
        onActivate: $.noop,
        onDeactivate: $.noop,
        // Interaction
        // ===========
        // Use options below to customize taken action when user clicks or double clicks on the fancyBox area,
        // each option can be string or method that returns value.
        //
        // Possible values:
        //   "close"           - close instance
        //   "next"            - move to next gallery item
        //   "nextOrClose"     - move to next gallery item or close if gallery has only one item
        //   "toggleControls"  - show/hide controls
        //   "zoom"            - zoom image (if loaded)
        //   false             - do nothing
        // Clicked on the content
        clickContent: function(current, event) {
            return current.type === "image" ? "zoom" : false;
        },
        // Clicked on the slide
        clickSlide: "close",
        // Clicked on the background (backdrop) element;
        // if you have not changed the layout, then most likely you need to use `clickSlide` option
        clickOutside: "close",
        // Same as previous two, but for double click
        dblclickContent: false,
        dblclickSlide: false,
        dblclickOutside: false,
        // Custom options when mobile device is detected
        // =============================================
        mobile: {
            preventCaptionOverlap: false,
            idleTime: false,
            clickContent: function(current, event) {
                return current.type === "image" ? "toggleControls" : false;
            },
            clickSlide: function(current, event) {
                return current.type === "image" ? "toggleControls" : "close";
            },
            dblclickContent: function(current, event) {
                return current.type === "image" ? "zoom" : false;
            },
            dblclickSlide: function(current, event) {
                return current.type === "image" ? "zoom" : false;
            }
        },
        // Internationalization
        // ====================
        lang: "en",
        i18n: {
            en: {
                CLOSE: "Close",
                NEXT: "Next",
                PREV: "Previous",
                ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                PLAY_START: "Start slideshow",
                PLAY_STOP: "Pause slideshow",
                FULL_SCREEN: "Full screen",
                THUMBS: "Thumbnails",
                DOWNLOAD: "Download",
                SHARE: "Share",
                ZOOM: "Zoom"
            },
            de: {
                CLOSE: "Schlie&szlig;en",
                NEXT: "Weiter",
                PREV: "Zur&uuml;ck",
                ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
                PLAY_START: "Diaschau starten",
                PLAY_STOP: "Diaschau beenden",
                FULL_SCREEN: "Vollbild",
                THUMBS: "Vorschaubilder",
                DOWNLOAD: "Herunterladen",
                SHARE: "Teilen",
                ZOOM: "Vergr&ouml;&szlig;ern"
            }
        }
    };
    // Few useful variables and methods
    // ================================
    var $W = $(window1);
    var $D = $(document1);
    var called = 0;
    // Check if an object is a jQuery object and not a native JavaScript object
    // ========================================================================
    var isQuery = function(obj) {
        return obj && obj.hasOwnProperty && obj instanceof $;
    };
    // Handle multiple browsers for "requestAnimationFrame" and "cancelAnimationFrame"
    // ===============================================================================
    var requestAFrame = function() {
        return window1.requestAnimationFrame || window1.webkitRequestAnimationFrame || window1.mozRequestAnimationFrame || window1.oRequestAnimationFrame || // if all else fails, use setTimeout
        function(callback) {
            return window1.setTimeout(callback, 1000 / 60);
        };
    }();
    var cancelAFrame = function() {
        return window1.cancelAnimationFrame || window1.webkitCancelAnimationFrame || window1.mozCancelAnimationFrame || window1.oCancelAnimationFrame || function(id) {
            window1.clearTimeout(id);
        };
    }();
    // Detect the supported transition-end event property name
    // =======================================================
    var transitionEnd = function() {
        var el = document1.createElement("fakeelement"), t;
        var transitions = {
            transition: "transitionend",
            OTransition: "oTransitionEnd",
            MozTransition: "transitionend",
            WebkitTransition: "webkitTransitionEnd"
        };
        for(t in transitions){
            if (el.style[t] !== undefined1) return transitions[t];
        }
        return "transitionend";
    }();
    // Force redraw on an element.
    // This helps in cases where the browser doesn't redraw an updated element properly
    // ================================================================================
    var forceRedraw = function($el) {
        return $el && $el.length && $el[0].offsetHeight;
    };
    // Exclude array (`buttons`) options from deep merging
    // ===================================================
    var mergeOpts = function(opts1, opts2) {
        var rez = $.extend(true, {}, opts1, opts2);
        $.each(opts2, function(key, value) {
            if ($.isArray(value)) rez[key] = value;
        });
        return rez;
    };
    // How much of an element is visible in viewport
    // =============================================
    var inViewport = function(elem) {
        var elemCenter, rez;
        if (!elem || elem.ownerDocument !== document1) return false;
        $(".fancybox-container").css("pointer-events", "none");
        elemCenter = {
            x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
            y: elem.getBoundingClientRect().top + elem.offsetHeight / 2
        };
        rez = document1.elementFromPoint(elemCenter.x, elemCenter.y) === elem;
        $(".fancybox-container").css("pointer-events", "");
        return rez;
    };
    // Class definition
    // ================
    var FancyBox = function(content, opts, index) {
        var self = this;
        self.opts = mergeOpts({
            index: index
        }, $.fancybox.defaults);
        if ($.isPlainObject(opts)) self.opts = mergeOpts(self.opts, opts);
        if ($.fancybox.isMobile) self.opts = mergeOpts(self.opts, self.opts.mobile);
        self.id = self.opts.id || ++called;
        self.currIndex = parseInt(self.opts.index, 10) || 0;
        self.prevIndex = null;
        self.prevPos = null;
        self.currPos = 0;
        self.firstRun = true;
        // All group items
        self.group = [];
        // Existing slides (for current, next and previous gallery items)
        self.slides = {};
        // Create group elements
        self.addContent(content);
        if (!self.group.length) return;
        self.init();
    };
    $.extend(FancyBox.prototype, {
        // Create DOM structure
        // ====================
        init: function() {
            var self = this, firstItem = self.group[self.currIndex], firstItemOpts = firstItem.opts, $container, buttonStr;
            if (firstItemOpts.closeExisting) $.fancybox.close(true);
            // Hide scrollbars
            // ===============
            $("body").addClass("fancybox-active");
            if (!$.fancybox.getInstance() && firstItemOpts.hideScrollbar !== false && !$.fancybox.isMobile && document1.body.scrollHeight > window1.innerHeight) {
                $("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' + (window1.innerWidth - document1.documentElement.clientWidth) + "px;}</style>");
                $("body").addClass("compensate-for-scrollbar");
            }
            // Build html markup and set references
            // ====================================
            // Build html code for buttons and insert into main template
            buttonStr = "";
            $.each(firstItemOpts.buttons, function(index, value) {
                buttonStr += firstItemOpts.btnTpl[value] || "";
            });
            // Create markup from base template, it will be initially hidden to
            // avoid unnecessary work like painting while initializing is not complete
            $container = $(self.translate(self, firstItemOpts.baseTpl.replace("{{buttons}}", buttonStr).replace("{{arrows}}", firstItemOpts.btnTpl.arrowLeft + firstItemOpts.btnTpl.arrowRight))).attr("id", "fancybox-container-" + self.id).addClass(firstItemOpts.baseClass).data("FancyBox", self).appendTo(firstItemOpts.parentEl);
            // Create object holding references to jQuery wrapped nodes
            self.$refs = {
                container: $container
            };
            [
                "bg",
                "inner",
                "infobar",
                "toolbar",
                "stage",
                "caption",
                "navigation"
            ].forEach(function(item) {
                self.$refs[item] = $container.find(".fancybox-" + item);
            });
            self.trigger("onInit");
            // Enable events, deactive previous instances
            self.activate();
            // Build slides, load and reveal content
            self.jumpTo(self.currIndex);
        },
        // Simple i18n support - replaces object keys found in template
        // with corresponding values
        // ============================================================
        translate: function(obj, str) {
            var arr = obj.opts.i18n[obj.opts.lang] || obj.opts.i18n.en;
            return str.replace(/\{\{(\w+)\}\}/g, function(match, n) {
                return arr[n] === undefined1 ? match : arr[n];
            });
        },
        // Populate current group with fresh content
        // Check if each object has valid type and content
        // ===============================================
        addContent: function(content) {
            var self = this, items = $.makeArray(content), thumbs;
            $.each(items, function(i, item) {
                var obj = {}, opts = {}, $item, type, found, src, srcParts;
                // Step 1 - Make sure we have an object
                // ====================================
                if ($.isPlainObject(item)) {
                    // We probably have manual usage here, something like
                    // $.fancybox.open( [ { src : "image.jpg", type : "image" } ] )
                    obj = item;
                    opts = item.opts || item;
                } else if ($.type(item) === "object" && $(item).length) {
                    // Here we probably have jQuery collection returned by some selector
                    $item = $(item);
                    // Support attributes like `data-options='{"touch" : false}'` and `data-touch='false'`
                    opts = $item.data() || {};
                    opts = $.extend(true, {}, opts, opts.options);
                    // Here we store clicked element
                    opts.$orig = $item;
                    obj.src = self.opts.src || opts.src || $item.attr("href");
                    // Assume that simple syntax is used, for example:
                    //   `$.fancybox.open( $("#test"), {} );`
                    if (!obj.type && !obj.src) {
                        obj.type = "inline";
                        obj.src = item;
                    }
                } else // Assume we have a simple html code, for example:
                //   $.fancybox.open( '<div><h1>Hi!</h1></div>' );
                obj = {
                    type: "html",
                    src: item + ""
                };
                // Each gallery object has full collection of options
                obj.opts = $.extend(true, {}, self.opts, opts);
                // Do not merge buttons array
                if ($.isArray(opts.buttons)) obj.opts.buttons = opts.buttons;
                if ($.fancybox.isMobile && obj.opts.mobile) obj.opts = mergeOpts(obj.opts, obj.opts.mobile);
                // Step 2 - Make sure we have content type, if not - try to guess
                // ==============================================================
                type = obj.type || obj.opts.type;
                src = obj.src || "";
                if (!type && src) {
                    if (found = src.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) {
                        type = "video";
                        if (!obj.opts.video.format) obj.opts.video.format = "video/" + (found[1] === "ogv" ? "ogg" : found[1]);
                    } else if (src.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i)) type = "image";
                    else if (src.match(/\.(pdf)((\?|#).*)?$/i)) {
                        type = "iframe";
                        obj = $.extend(true, obj, {
                            contentType: "pdf",
                            opts: {
                                iframe: {
                                    preload: false
                                }
                            }
                        });
                    } else if (src.charAt(0) === "#") type = "inline";
                }
                if (type) obj.type = type;
                else self.trigger("objectNeedsType", obj);
                if (!obj.contentType) obj.contentType = $.inArray(obj.type, [
                    "html",
                    "inline",
                    "ajax"
                ]) > -1 ? "html" : obj.type;
                // Step 3 - Some adjustments
                // =========================
                obj.index = self.group.length;
                if (obj.opts.smallBtn == "auto") obj.opts.smallBtn = $.inArray(obj.type, [
                    "html",
                    "inline",
                    "ajax"
                ]) > -1;
                if (obj.opts.toolbar === "auto") obj.opts.toolbar = !obj.opts.smallBtn;
                // Find thumbnail image, check if exists and if is in the viewport
                obj.$thumb = obj.opts.$thumb || null;
                if (obj.opts.$trigger && obj.index === self.opts.index) {
                    obj.$thumb = obj.opts.$trigger.find("img:first");
                    if (obj.$thumb.length) obj.opts.$orig = obj.opts.$trigger;
                }
                if (!(obj.$thumb && obj.$thumb.length) && obj.opts.$orig) obj.$thumb = obj.opts.$orig.find("img:first");
                if (obj.$thumb && !obj.$thumb.length) obj.$thumb = null;
                obj.thumb = obj.opts.thumb || (obj.$thumb ? obj.$thumb[0].src : null);
                // "caption" is a "special" option, it can be used to customize caption per gallery item
                if ($.type(obj.opts.caption) === "function") obj.opts.caption = obj.opts.caption.apply(item, [
                    self,
                    obj
                ]);
                if ($.type(self.opts.caption) === "function") obj.opts.caption = self.opts.caption.apply(item, [
                    self,
                    obj
                ]);
                // Make sure we have caption as a string or jQuery object
                if (!(obj.opts.caption instanceof $)) obj.opts.caption = obj.opts.caption === undefined1 ? "" : obj.opts.caption + "";
                // Check if url contains "filter" used to filter the content
                // Example: "ajax.html #something"
                if (obj.type === "ajax") {
                    srcParts = src.split(/\s+/, 2);
                    if (srcParts.length > 1) {
                        obj.src = srcParts.shift();
                        obj.opts.filter = srcParts.shift();
                    }
                }
                // Hide all buttons and disable interactivity for modal items
                if (obj.opts.modal) obj.opts = $.extend(true, obj.opts, {
                    trapFocus: true,
                    // Remove buttons
                    infobar: 0,
                    toolbar: 0,
                    smallBtn: 0,
                    // Disable keyboard navigation
                    keyboard: 0,
                    // Disable some modules
                    slideShow: 0,
                    fullScreen: 0,
                    thumbs: 0,
                    touch: 0,
                    // Disable click event handlers
                    clickContent: false,
                    clickSlide: false,
                    clickOutside: false,
                    dblclickContent: false,
                    dblclickSlide: false,
                    dblclickOutside: false
                });
                // Step 4 - Add processed object to group
                // ======================================
                self.group.push(obj);
            });
            // Update controls if gallery is already opened
            if (Object.keys(self.slides).length) {
                self.updateControls();
                // Update thumbnails, if needed
                thumbs = self.Thumbs;
                if (thumbs && thumbs.isActive) {
                    thumbs.create();
                    thumbs.focus();
                }
            }
        },
        // Attach an event handler functions for:
        //   - navigation buttons
        //   - browser scrolling, resizing;
        //   - focusing
        //   - keyboard
        //   - detecting inactivity
        // ======================================
        addEvents: function() {
            var self = this;
            self.removeEvents();
            // Make navigation elements clickable
            // ==================================
            self.$refs.container.on("click.fb-close", "[data-fancybox-close]", function(e) {
                e.stopPropagation();
                e.preventDefault();
                self.close(e);
            }).on("touchstart.fb-prev click.fb-prev", "[data-fancybox-prev]", function(e) {
                e.stopPropagation();
                e.preventDefault();
                self.previous();
            }).on("touchstart.fb-next click.fb-next", "[data-fancybox-next]", function(e) {
                e.stopPropagation();
                e.preventDefault();
                self.next();
            }).on("click.fb", "[data-fancybox-zoom]", function(e) {
                // Click handler for zoom button
                self[self.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
            });
            // Handle page scrolling and browser resizing
            // ==========================================
            $W.on("orientationchange.fb resize.fb", function(e) {
                if (e && e.originalEvent && e.originalEvent.type === "resize") {
                    if (self.requestId) cancelAFrame(self.requestId);
                    self.requestId = requestAFrame(function() {
                        self.update(e);
                    });
                } else {
                    if (self.current && self.current.type === "iframe") self.$refs.stage.hide();
                    setTimeout(function() {
                        self.$refs.stage.show();
                        self.update(e);
                    }, $.fancybox.isMobile ? 600 : 250);
                }
            });
            $D.on("keydown.fb", function(e) {
                var instance = $.fancybox ? $.fancybox.getInstance() : null, current = instance.current, keycode = e.keyCode || e.which;
                // Trap keyboard focus inside of the modal
                // =======================================
                if (keycode == 9) {
                    if (current.opts.trapFocus) self.focus(e);
                    return;
                }
                // Enable keyboard navigation
                // ==========================
                if (!current.opts.keyboard || e.ctrlKey || e.altKey || e.shiftKey || $(e.target).is("input,textarea,video,audio,select")) return;
                // Backspace and Esc keys
                if (keycode === 8 || keycode === 27) {
                    e.preventDefault();
                    self.close(e);
                    return;
                }
                // Left arrow and Up arrow
                if (keycode === 37 || keycode === 38) {
                    e.preventDefault();
                    self.previous();
                    return;
                }
                // Righ arrow and Down arrow
                if (keycode === 39 || keycode === 40) {
                    e.preventDefault();
                    self.next();
                    return;
                }
                self.trigger("afterKeydown", e, keycode);
            });
            // Hide controls after some inactivity period
            if (self.group[self.currIndex].opts.idleTime) {
                self.idleSecondsCounter = 0;
                $D.on("mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle", function(e) {
                    self.idleSecondsCounter = 0;
                    if (self.isIdle) self.showControls();
                    self.isIdle = false;
                });
                self.idleInterval = window1.setInterval(function() {
                    self.idleSecondsCounter++;
                    if (self.idleSecondsCounter >= self.group[self.currIndex].opts.idleTime && !self.isDragging) {
                        self.isIdle = true;
                        self.idleSecondsCounter = 0;
                        self.hideControls();
                    }
                }, 1000);
            }
        },
        // Remove events added by the core
        // ===============================
        removeEvents: function() {
            var self = this;
            $W.off("orientationchange.fb resize.fb");
            $D.off("keydown.fb .fb-idle");
            this.$refs.container.off(".fb-close .fb-prev .fb-next");
            if (self.idleInterval) {
                window1.clearInterval(self.idleInterval);
                self.idleInterval = null;
            }
        },
        // Change to previous gallery item
        // ===============================
        previous: function(duration) {
            return this.jumpTo(this.currPos - 1, duration);
        },
        // Change to next gallery item
        // ===========================
        next: function(duration) {
            return this.jumpTo(this.currPos + 1, duration);
        },
        // Switch to selected gallery item
        // ===============================
        jumpTo: function(pos, duration) {
            var self = this, groupLen = self.group.length, firstRun, isMoved, loop, current, previous, slidePos, stagePos, prop, diff;
            if (self.isDragging || self.isClosing || self.isAnimating && self.firstRun) return;
            // Should loop?
            pos = parseInt(pos, 10);
            loop = self.current ? self.current.opts.loop : self.opts.loop;
            if (!loop && (pos < 0 || pos >= groupLen)) return false;
            // Check if opening for the first time; this helps to speed things up
            firstRun = self.firstRun = !Object.keys(self.slides).length;
            // Create slides
            previous = self.current;
            self.prevIndex = self.currIndex;
            self.prevPos = self.currPos;
            current = self.createSlide(pos);
            if (groupLen > 1) {
                if (loop || current.index < groupLen - 1) self.createSlide(pos + 1);
                if (loop || current.index > 0) self.createSlide(pos - 1);
            }
            self.current = current;
            self.currIndex = current.index;
            self.currPos = current.pos;
            self.trigger("beforeShow", firstRun);
            self.updateControls();
            // Validate duration length
            current.forcedDuration = undefined1;
            if ($.isNumeric(duration)) current.forcedDuration = duration;
            else duration = current.opts[firstRun ? "animationDuration" : "transitionDuration"];
            duration = parseInt(duration, 10);
            // Check if user has swiped the slides or if still animating
            isMoved = self.isMoved(current);
            // Make sure current slide is visible
            current.$slide.addClass("fancybox-slide--current");
            // Fresh start - reveal container, current slide and start loading content
            if (firstRun) {
                if (current.opts.animationEffect && duration) self.$refs.container.css("transition-duration", duration + "ms");
                self.$refs.container.addClass("fancybox-is-open").trigger("focus");
                // Attempt to load content into slide
                // This will later call `afterLoad` -> `revealContent`
                self.loadSlide(current);
                self.preload("image");
                return;
            }
            // Get actual slide/stage positions (before cleaning up)
            slidePos = $.fancybox.getTranslate(previous.$slide);
            stagePos = $.fancybox.getTranslate(self.$refs.stage);
            // Clean up all slides
            $.each(self.slides, function(index, slide) {
                $.fancybox.stop(slide.$slide, true);
            });
            if (previous.pos !== current.pos) previous.isComplete = false;
            previous.$slide.removeClass("fancybox-slide--complete fancybox-slide--current");
            // If slides are out of place, then animate them to correct position
            if (isMoved) {
                // Calculate horizontal swipe distance
                diff = slidePos.left - (previous.pos * slidePos.width + previous.pos * previous.opts.gutter);
                $.each(self.slides, function(index, slide) {
                    slide.$slide.removeClass("fancybox-animated").removeClass(function(index, className) {
                        return (className.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                    });
                    // Make sure that each slide is in equal distance
                    // This is mostly needed for freshly added slides, because they are not yet positioned
                    var leftPos = slide.pos * slidePos.width + slide.pos * slide.opts.gutter;
                    $.fancybox.setTranslate(slide.$slide, {
                        top: 0,
                        left: leftPos - stagePos.left + diff
                    });
                    if (slide.pos !== current.pos) slide.$slide.addClass("fancybox-slide--" + (slide.pos > current.pos ? "next" : "previous"));
                    // Redraw to make sure that transition will start
                    forceRedraw(slide.$slide);
                    // Animate the slide
                    $.fancybox.animate(slide.$slide, {
                        top: 0,
                        left: (slide.pos - current.pos) * slidePos.width + (slide.pos - current.pos) * slide.opts.gutter
                    }, duration, function() {
                        slide.$slide.css({
                            transform: "",
                            opacity: ""
                        }).removeClass("fancybox-slide--next fancybox-slide--previous");
                        if (slide.pos === self.currPos) self.complete();
                    });
                });
            } else if (duration && current.opts.transitionEffect) {
                // Set transition effect for previously active slide
                prop = "fancybox-animated fancybox-fx-" + current.opts.transitionEffect;
                previous.$slide.addClass("fancybox-slide--" + (previous.pos > current.pos ? "next" : "previous"));
                $.fancybox.animate(previous.$slide, prop, duration, function() {
                    previous.$slide.removeClass(prop).removeClass("fancybox-slide--next fancybox-slide--previous");
                }, false);
            }
            if (current.isLoaded) self.revealContent(current);
            else self.loadSlide(current);
            self.preload("image");
        },
        // Create new "slide" element
        // These are gallery items  that are actually added to DOM
        // =======================================================
        createSlide: function(pos) {
            var self = this, $slide, index;
            index = pos % self.group.length;
            index = index < 0 ? self.group.length + index : index;
            if (!self.slides[pos] && self.group[index]) {
                $slide = $('<div class="fancybox-slide"></div>').appendTo(self.$refs.stage);
                self.slides[pos] = $.extend(true, {}, self.group[index], {
                    pos: pos,
                    $slide: $slide,
                    isLoaded: false
                });
                self.updateSlide(self.slides[pos]);
            }
            return self.slides[pos];
        },
        // Scale image to the actual size of the image;
        // x and y values should be relative to the slide
        // ==============================================
        scaleToActual: function(x, y, duration) {
            var self = this, current = self.current, $content = current.$content, canvasWidth = $.fancybox.getTranslate(current.$slide).width, canvasHeight = $.fancybox.getTranslate(current.$slide).height, newImgWidth = current.width, newImgHeight = current.height, imgPos, posX, posY, scaleX, scaleY;
            if (self.isAnimating || self.isMoved() || !$content || !(current.type == "image" && current.isLoaded && !current.hasError)) return;
            self.isAnimating = true;
            $.fancybox.stop($content);
            x = x === undefined1 ? canvasWidth * 0.5 : x;
            y = y === undefined1 ? canvasHeight * 0.5 : y;
            imgPos = $.fancybox.getTranslate($content);
            imgPos.top -= $.fancybox.getTranslate(current.$slide).top;
            imgPos.left -= $.fancybox.getTranslate(current.$slide).left;
            scaleX = newImgWidth / imgPos.width;
            scaleY = newImgHeight / imgPos.height;
            // Get center position for original image
            posX = canvasWidth * 0.5 - newImgWidth * 0.5;
            posY = canvasHeight * 0.5 - newImgHeight * 0.5;
            // Make sure image does not move away from edges
            if (newImgWidth > canvasWidth) {
                posX = imgPos.left * scaleX - (x * scaleX - x);
                if (posX > 0) posX = 0;
                if (posX < canvasWidth - newImgWidth) posX = canvasWidth - newImgWidth;
            }
            if (newImgHeight > canvasHeight) {
                posY = imgPos.top * scaleY - (y * scaleY - y);
                if (posY > 0) posY = 0;
                if (posY < canvasHeight - newImgHeight) posY = canvasHeight - newImgHeight;
            }
            self.updateCursor(newImgWidth, newImgHeight);
            $.fancybox.animate($content, {
                top: posY,
                left: posX,
                scaleX: scaleX,
                scaleY: scaleY
            }, duration || 366, function() {
                self.isAnimating = false;
            });
            // Stop slideshow
            if (self.SlideShow && self.SlideShow.isActive) self.SlideShow.stop();
        },
        // Scale image to fit inside parent element
        // ========================================
        scaleToFit: function(duration) {
            var self = this, current = self.current, $content = current.$content, end;
            if (self.isAnimating || self.isMoved() || !$content || !(current.type == "image" && current.isLoaded && !current.hasError)) return;
            self.isAnimating = true;
            $.fancybox.stop($content);
            end = self.getFitPos(current);
            self.updateCursor(end.width, end.height);
            $.fancybox.animate($content, {
                top: end.top,
                left: end.left,
                scaleX: end.width / $content.width(),
                scaleY: end.height / $content.height()
            }, duration || 366, function() {
                self.isAnimating = false;
            });
        },
        // Calculate image size to fit inside viewport
        // ===========================================
        getFitPos: function(slide) {
            var self = this, $content = slide.$content, $slide = slide.$slide, width = slide.width || slide.opts.width, height = slide.height || slide.opts.height, maxWidth, maxHeight, minRatio, aspectRatio, rez = {};
            if (!slide.isLoaded || !$content || !$content.length) return false;
            maxWidth = $.fancybox.getTranslate(self.$refs.stage).width;
            maxHeight = $.fancybox.getTranslate(self.$refs.stage).height;
            maxWidth -= parseFloat($slide.css("paddingLeft")) + parseFloat($slide.css("paddingRight")) + parseFloat($content.css("marginLeft")) + parseFloat($content.css("marginRight"));
            maxHeight -= parseFloat($slide.css("paddingTop")) + parseFloat($slide.css("paddingBottom")) + parseFloat($content.css("marginTop")) + parseFloat($content.css("marginBottom"));
            if (!width || !height) {
                width = maxWidth;
                height = maxHeight;
            }
            minRatio = Math.min(1, maxWidth / width, maxHeight / height);
            width = minRatio * width;
            height = minRatio * height;
            // Adjust width/height to precisely fit into container
            if (width > maxWidth - 0.5) width = maxWidth;
            if (height > maxHeight - 0.5) height = maxHeight;
            if (slide.type === "image") {
                rez.top = Math.floor((maxHeight - height) * 0.5) + parseFloat($slide.css("paddingTop"));
                rez.left = Math.floor((maxWidth - width) * 0.5) + parseFloat($slide.css("paddingLeft"));
            } else if (slide.contentType === "video") {
                // Force aspect ratio for the video
                // "I say the whole world must learn of our peaceful ways… by force!"
                aspectRatio = slide.opts.width && slide.opts.height ? width / height : slide.opts.ratio || 16 / 9;
                if (height > width / aspectRatio) height = width / aspectRatio;
                else if (width > height * aspectRatio) width = height * aspectRatio;
            }
            rez.width = width;
            rez.height = height;
            return rez;
        },
        // Update content size and position for all slides
        // ==============================================
        update: function(e) {
            var self = this;
            $.each(self.slides, function(key, slide) {
                self.updateSlide(slide, e);
            });
        },
        // Update slide content position and size
        // ======================================
        updateSlide: function(slide, e) {
            var self = this, $content = slide && slide.$content, width = slide.width || slide.opts.width, height = slide.height || slide.opts.height, $slide = slide.$slide;
            // First, prevent caption overlap, if needed
            self.adjustCaption(slide);
            // Then resize content to fit inside the slide
            if ($content && (width || height || slide.contentType === "video") && !slide.hasError) {
                $.fancybox.stop($content);
                $.fancybox.setTranslate($content, self.getFitPos(slide));
                if (slide.pos === self.currPos) {
                    self.isAnimating = false;
                    self.updateCursor();
                }
            }
            // Then some adjustments
            self.adjustLayout(slide);
            if ($slide.length) {
                $slide.trigger("refresh");
                if (slide.pos === self.currPos) self.$refs.toolbar.add(self.$refs.navigation.find(".fancybox-button--arrow_right")).toggleClass("compensate-for-scrollbar", $slide.get(0).scrollHeight > $slide.get(0).clientHeight);
            }
            self.trigger("onUpdate", slide, e);
        },
        // Horizontally center slide
        // =========================
        centerSlide: function(duration) {
            var self = this, current = self.current, $slide = current.$slide;
            if (self.isClosing || !current) return;
            $slide.siblings().css({
                transform: "",
                opacity: ""
            });
            $slide.parent().children().removeClass("fancybox-slide--previous fancybox-slide--next");
            $.fancybox.animate($slide, {
                top: 0,
                left: 0,
                opacity: 1
            }, duration === undefined1 ? 0 : duration, function() {
                // Clean up
                $slide.css({
                    transform: "",
                    opacity: ""
                });
                if (!current.isComplete) self.complete();
            }, false);
        },
        // Check if current slide is moved (swiped)
        // ========================================
        isMoved: function(slide) {
            var current = slide || this.current, slidePos, stagePos;
            if (!current) return false;
            stagePos = $.fancybox.getTranslate(this.$refs.stage);
            slidePos = $.fancybox.getTranslate(current.$slide);
            return !current.$slide.hasClass("fancybox-animated") && (Math.abs(slidePos.top - stagePos.top) > 0.5 || Math.abs(slidePos.left - stagePos.left) > 0.5);
        },
        // Update cursor style depending if content can be zoomed
        // ======================================================
        updateCursor: function(nextWidth, nextHeight) {
            var self = this, current = self.current, $container = self.$refs.container, canPan, isZoomable;
            if (!current || self.isClosing || !self.Guestures) return;
            $container.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan");
            canPan = self.canPan(nextWidth, nextHeight);
            isZoomable = canPan ? true : self.isZoomable();
            $container.toggleClass("fancybox-is-zoomable", isZoomable);
            $("[data-fancybox-zoom]").prop("disabled", !isZoomable);
            if (canPan) $container.addClass("fancybox-can-pan");
            else if (isZoomable && (current.opts.clickContent === "zoom" || $.isFunction(current.opts.clickContent) && current.opts.clickContent(current) == "zoom")) $container.addClass("fancybox-can-zoomIn");
            else if (current.opts.touch && (current.opts.touch.vertical || self.group.length > 1) && current.contentType !== "video") $container.addClass("fancybox-can-swipe");
        },
        // Check if current slide is zoomable
        // ==================================
        isZoomable: function() {
            var self = this, current = self.current, fitPos;
            // Assume that slide is zoomable if:
            //   - image is still loading
            //   - actual size of the image is smaller than available area
            if (current && !self.isClosing && current.type === "image" && !current.hasError) {
                if (!current.isLoaded) return true;
                fitPos = self.getFitPos(current);
                if (fitPos && (current.width > fitPos.width || current.height > fitPos.height)) return true;
            }
            return false;
        },
        // Check if current image dimensions are smaller than actual
        // =========================================================
        isScaledDown: function(nextWidth, nextHeight) {
            var self = this, rez = false, current = self.current, $content = current.$content;
            if (nextWidth !== undefined1 && nextHeight !== undefined1) rez = nextWidth < current.width && nextHeight < current.height;
            else if ($content) {
                rez = $.fancybox.getTranslate($content);
                rez = rez.width < current.width && rez.height < current.height;
            }
            return rez;
        },
        // Check if image dimensions exceed parent element
        // ===============================================
        canPan: function(nextWidth, nextHeight) {
            var self = this, current = self.current, pos = null, rez = false;
            if (current.type === "image" && (current.isComplete || nextWidth && nextHeight) && !current.hasError) {
                rez = self.getFitPos(current);
                if (nextWidth !== undefined1 && nextHeight !== undefined1) pos = {
                    width: nextWidth,
                    height: nextHeight
                };
                else if (current.isComplete) pos = $.fancybox.getTranslate(current.$content);
                if (pos && rez) rez = Math.abs(pos.width - rez.width) > 1.5 || Math.abs(pos.height - rez.height) > 1.5;
            }
            return rez;
        },
        // Load content into the slide
        // ===========================
        loadSlide: function(slide) {
            var self = this, type, $slide, ajaxLoad;
            if (slide.isLoading || slide.isLoaded) return;
            slide.isLoading = true;
            if (self.trigger("beforeLoad", slide) === false) {
                slide.isLoading = false;
                return false;
            }
            type = slide.type;
            $slide = slide.$slide;
            $slide.off("refresh").trigger("onReset").addClass(slide.opts.slideClass);
            // Create content depending on the type
            switch(type){
                case "image":
                    self.setImage(slide);
                    break;
                case "iframe":
                    self.setIframe(slide);
                    break;
                case "html":
                    self.setContent(slide, slide.src || slide.content);
                    break;
                case "video":
                    self.setContent(slide, slide.opts.video.tpl.replace(/\{\{src\}\}/gi, slide.src).replace("{{format}}", slide.opts.videoFormat || slide.opts.video.format || "").replace("{{poster}}", slide.thumb || ""));
                    break;
                case "inline":
                    if ($(slide.src).length) self.setContent(slide, $(slide.src));
                    else self.setError(slide);
                    break;
                case "ajax":
                    self.showLoading(slide);
                    ajaxLoad = $.ajax($.extend({}, slide.opts.ajax.settings, {
                        url: slide.src,
                        success: function(data, textStatus) {
                            if (textStatus === "success") self.setContent(slide, data);
                        },
                        error: function(jqXHR, textStatus) {
                            if (jqXHR && textStatus !== "abort") self.setError(slide);
                        }
                    }));
                    $slide.one("onReset", function() {
                        ajaxLoad.abort();
                    });
                    break;
                default:
                    self.setError(slide);
                    break;
            }
            return true;
        },
        // Use thumbnail image, if possible
        // ================================
        setImage: function(slide) {
            var self = this, ghost;
            // Check if need to show loading icon
            setTimeout(function() {
                var $img = slide.$image;
                if (!self.isClosing && slide.isLoading && (!$img || !$img.length || !$img[0].complete) && !slide.hasError) self.showLoading(slide);
            }, 50);
            //Check if image has srcset
            self.checkSrcset(slide);
            // This will be wrapper containing both ghost and actual image
            slide.$content = $('<div class="fancybox-content"></div>').addClass("fancybox-is-hidden").appendTo(slide.$slide.addClass("fancybox-slide--image"));
            // If we have a thumbnail, we can display it while actual image is loading
            // Users will not stare at black screen and actual image will appear gradually
            if (slide.opts.preload !== false && slide.opts.width && slide.opts.height && slide.thumb) {
                slide.width = slide.opts.width;
                slide.height = slide.opts.height;
                ghost = document1.createElement("img");
                ghost.onerror = function() {
                    $(this).remove();
                    slide.$ghost = null;
                };
                ghost.onload = function() {
                    self.afterLoad(slide);
                };
                slide.$ghost = $(ghost).addClass("fancybox-image").appendTo(slide.$content).attr("src", slide.thumb);
            }
            // Start loading actual image
            self.setBigImage(slide);
        },
        // Check if image has srcset and get the source
        // ============================================
        checkSrcset: function(slide) {
            var srcset = slide.opts.srcset || slide.opts.image.srcset, found, temp, pxRatio, windowWidth;
            // If we have "srcset", then we need to find first matching "src" value.
            // This is necessary, because when you set an src attribute, the browser will preload the image
            // before any javascript or even CSS is applied.
            if (srcset) {
                pxRatio = window1.devicePixelRatio || 1;
                windowWidth = window1.innerWidth * pxRatio;
                temp = srcset.split(",").map(function(el) {
                    var ret = {};
                    el.trim().split(/\s+/).forEach(function(el, i) {
                        var value = parseInt(el.substring(0, el.length - 1), 10);
                        if (i === 0) return ret.url = el;
                        if (value) {
                            ret.value = value;
                            ret.postfix = el[el.length - 1];
                        }
                    });
                    return ret;
                });
                // Sort by value
                temp.sort(function(a, b) {
                    return a.value - b.value;
                });
                // Ok, now we have an array of all srcset values
                for(var j = 0; j < temp.length; j++){
                    var el = temp[j];
                    if (el.postfix === "w" && el.value >= windowWidth || el.postfix === "x" && el.value >= pxRatio) {
                        found = el;
                        break;
                    }
                }
                // If not found, take the last one
                if (!found && temp.length) found = temp[temp.length - 1];
                if (found) {
                    slide.src = found.url;
                    // If we have default width/height values, we can calculate height for matching source
                    if (slide.width && slide.height && found.postfix == "w") {
                        slide.height = slide.width / slide.height * found.value;
                        slide.width = found.value;
                    }
                    slide.opts.srcset = srcset;
                }
            }
        },
        // Create full-size image
        // ======================
        setBigImage: function(slide) {
            var self = this, img = document1.createElement("img"), $img = $(img);
            slide.$image = $img.one("error", function() {
                self.setError(slide);
            }).one("load", function() {
                var sizes;
                if (!slide.$ghost) {
                    self.resolveImageSlideSize(slide, this.naturalWidth, this.naturalHeight);
                    self.afterLoad(slide);
                }
                if (self.isClosing) return;
                if (slide.opts.srcset) {
                    sizes = slide.opts.sizes;
                    if (!sizes || sizes === "auto") sizes = (slide.width / slide.height > 1 && $W.width() / $W.height() > 1 ? "100" : Math.round(slide.width / slide.height * 100)) + "vw";
                    $img.attr("sizes", sizes).attr("srcset", slide.opts.srcset);
                }
                // Hide temporary image after some delay
                if (slide.$ghost) setTimeout(function() {
                    if (slide.$ghost && !self.isClosing) slide.$ghost.hide();
                }, Math.min(300, Math.max(1000, slide.height / 1600)));
                self.hideLoading(slide);
            }).addClass("fancybox-image").attr("src", slide.src).appendTo(slide.$content);
            if ((img.complete || img.readyState == "complete") && $img.naturalWidth && $img.naturalHeight) $img.trigger("load");
            else if (img.error) $img.trigger("error");
        },
        // Computes the slide size from image size and maxWidth/maxHeight
        // ==============================================================
        resolveImageSlideSize: function(slide, imgWidth, imgHeight) {
            var maxWidth = parseInt(slide.opts.width, 10), maxHeight = parseInt(slide.opts.height, 10);
            // Sets the default values from the image
            slide.width = imgWidth;
            slide.height = imgHeight;
            if (maxWidth > 0) {
                slide.width = maxWidth;
                slide.height = Math.floor(maxWidth * imgHeight / imgWidth);
            }
            if (maxHeight > 0) {
                slide.width = Math.floor(maxHeight * imgWidth / imgHeight);
                slide.height = maxHeight;
            }
        },
        // Create iframe wrapper, iframe and bindings
        // ==========================================
        setIframe: function(slide) {
            var self = this, opts = slide.opts.iframe, $slide = slide.$slide, $iframe;
            slide.$content = $('<div class="fancybox-content' + (opts.preload ? " fancybox-is-hidden" : "") + '"></div>').css(opts.css).appendTo($slide);
            $slide.addClass("fancybox-slide--" + slide.contentType);
            slide.$iframe = $iframe = $(opts.tpl.replace(/\{rnd\}/g, new Date().getTime())).attr(opts.attr).appendTo(slide.$content);
            if (opts.preload) {
                self.showLoading(slide);
                // Unfortunately, it is not always possible to determine if iframe is successfully loaded
                // (due to browser security policy)
                $iframe.on("load.fb error.fb", function(e) {
                    this.isReady = 1;
                    slide.$slide.trigger("refresh");
                    self.afterLoad(slide);
                });
                // Recalculate iframe content size
                // ===============================
                $slide.on("refresh.fb", function() {
                    var $content = slide.$content, frameWidth = opts.css.width, frameHeight = opts.css.height, $contents, $body;
                    if ($iframe[0].isReady !== 1) return;
                    try {
                        $contents = $iframe.contents();
                        $body = $contents.find("body");
                    } catch (ignore) {}
                    // Calculate content dimensions, if it is accessible
                    if ($body && $body.length && $body.children().length) {
                        // Avoid scrolling to top (if multiple instances)
                        $slide.css("overflow", "visible");
                        $content.css({
                            width: "100%",
                            "max-width": "100%",
                            height: "9999px"
                        });
                        if (frameWidth === undefined1) frameWidth = Math.ceil(Math.max($body[0].clientWidth, $body.outerWidth(true)));
                        $content.css("width", frameWidth ? frameWidth : "").css("max-width", "");
                        if (frameHeight === undefined1) frameHeight = Math.ceil(Math.max($body[0].clientHeight, $body.outerHeight(true)));
                        $content.css("height", frameHeight ? frameHeight : "");
                        $slide.css("overflow", "auto");
                    }
                    $content.removeClass("fancybox-is-hidden");
                });
            } else self.afterLoad(slide);
            $iframe.attr("src", slide.src);
            // Remove iframe if closing or changing gallery item
            $slide.one("onReset", function() {
                // This helps IE not to throw errors when closing
                try {
                    $(this).find("iframe").hide().unbind().attr("src", "//about:blank");
                } catch (ignore) {}
                $(this).off("refresh.fb").empty();
                slide.isLoaded = false;
                slide.isRevealed = false;
            });
        },
        // Wrap and append content to the slide
        // ======================================
        setContent: function(slide, content) {
            var self = this;
            if (self.isClosing) return;
            self.hideLoading(slide);
            if (slide.$content) $.fancybox.stop(slide.$content);
            slide.$slide.empty();
            // If content is a jQuery object, then it will be moved to the slide.
            // The placeholder is created so we will know where to put it back.
            if (isQuery(content) && content.parent().length) {
                // Make sure content is not already moved to fancyBox
                if (content.hasClass("fancybox-content") || content.parent().hasClass("fancybox-content")) content.parents(".fancybox-slide").trigger("onReset");
                // Create temporary element marking original place of the content
                slide.$placeholder = $("<div>").hide().insertAfter(content);
                // Make sure content is visible
                content.css("display", "inline-block");
            } else if (!slide.hasError) {
                // If content is just a plain text, try to convert it to html
                if ($.type(content) === "string") content = $("<div>").append($.trim(content)).contents();
                // If "filter" option is provided, then filter content
                if (slide.opts.filter) content = $("<div>").html(content).find(slide.opts.filter);
            }
            slide.$slide.one("onReset", function() {
                // Pause all html5 video/audio
                $(this).find("video,audio").trigger("pause");
                // Put content back
                if (slide.$placeholder) {
                    slide.$placeholder.after(content.removeClass("fancybox-content").hide()).remove();
                    slide.$placeholder = null;
                }
                // Remove custom close button
                if (slide.$smallBtn) {
                    slide.$smallBtn.remove();
                    slide.$smallBtn = null;
                }
                // Remove content and mark slide as not loaded
                if (!slide.hasError) {
                    $(this).empty();
                    slide.isLoaded = false;
                    slide.isRevealed = false;
                }
            });
            $(content).appendTo(slide.$slide);
            if ($(content).is("video,audio")) {
                $(content).addClass("fancybox-video");
                $(content).wrap("<div></div>");
                slide.contentType = "video";
                slide.opts.width = slide.opts.width || $(content).attr("width");
                slide.opts.height = slide.opts.height || $(content).attr("height");
            }
            slide.$content = slide.$slide.children().filter("div,form,main,video,audio,article,.fancybox-content").first();
            slide.$content.siblings().hide();
            // Re-check if there is a valid content
            // (in some cases, ajax response can contain various elements or plain text)
            if (!slide.$content.length) slide.$content = slide.$slide.wrapInner("<div></div>").children().first();
            slide.$content.addClass("fancybox-content");
            slide.$slide.addClass("fancybox-slide--" + slide.contentType);
            self.afterLoad(slide);
        },
        // Display error message
        // =====================
        setError: function(slide) {
            slide.hasError = true;
            slide.$slide.trigger("onReset").removeClass("fancybox-slide--" + slide.contentType).addClass("fancybox-slide--error");
            slide.contentType = "html";
            this.setContent(slide, this.translate(slide, slide.opts.errorTpl));
            if (slide.pos === this.currPos) this.isAnimating = false;
        },
        // Show loading icon inside the slide
        // ==================================
        showLoading: function(slide) {
            var self = this;
            slide = slide || self.current;
            if (slide && !slide.$spinner) slide.$spinner = $(self.translate(self, self.opts.spinnerTpl)).appendTo(slide.$slide).hide().fadeIn("fast");
        },
        // Remove loading icon from the slide
        // ==================================
        hideLoading: function(slide) {
            var self = this;
            slide = slide || self.current;
            if (slide && slide.$spinner) {
                slide.$spinner.stop().remove();
                delete slide.$spinner;
            }
        },
        // Adjustments after slide content has been loaded
        // ===============================================
        afterLoad: function(slide) {
            var self = this;
            if (self.isClosing) return;
            slide.isLoading = false;
            slide.isLoaded = true;
            self.trigger("afterLoad", slide);
            self.hideLoading(slide);
            // Add small close button
            if (slide.opts.smallBtn && (!slide.$smallBtn || !slide.$smallBtn.length)) slide.$smallBtn = $(self.translate(slide, slide.opts.btnTpl.smallBtn)).appendTo(slide.$content);
            // Disable right click
            if (slide.opts.protect && slide.$content && !slide.hasError) {
                slide.$content.on("contextmenu.fb", function(e) {
                    if (e.button == 2) e.preventDefault();
                    return true;
                });
                // Add fake element on top of the image
                // This makes a bit harder for user to select image
                if (slide.type === "image") $('<div class="fancybox-spaceball"></div>').appendTo(slide.$content);
            }
            self.adjustCaption(slide);
            self.adjustLayout(slide);
            if (slide.pos === self.currPos) self.updateCursor();
            self.revealContent(slide);
        },
        // Prevent caption overlap,
        // fix css inconsistency across browsers
        // =====================================
        adjustCaption: function(slide) {
            var self = this, current = slide || self.current, caption = current.opts.caption, preventOverlap = current.opts.preventCaptionOverlap, $caption = self.$refs.caption, $clone, captionH = false;
            $caption.toggleClass("fancybox-caption--separate", preventOverlap);
            if (preventOverlap && caption && caption.length) {
                if (current.pos !== self.currPos) {
                    $clone = $caption.clone().appendTo($caption.parent());
                    $clone.children().eq(0).empty().html(caption);
                    captionH = $clone.outerHeight(true);
                    $clone.empty().remove();
                } else if (self.$caption) captionH = self.$caption.outerHeight(true);
                current.$slide.css("padding-bottom", captionH || "");
            }
        },
        // Simple hack to fix inconsistency across browsers, described here (affects Edge, too):
        // https://bugzilla.mozilla.org/show_bug.cgi?id=748518
        // ====================================================================================
        adjustLayout: function(slide) {
            var self = this, current = slide || self.current, scrollHeight, marginBottom, inlinePadding, actualPadding;
            if (current.isLoaded && current.opts.disableLayoutFix !== true) {
                current.$content.css("margin-bottom", "");
                // If we would always set margin-bottom for the content,
                // then it would potentially break vertical align
                if (current.$content.outerHeight() > current.$slide.height() + 0.5) {
                    inlinePadding = current.$slide[0].style["padding-bottom"];
                    actualPadding = current.$slide.css("padding-bottom");
                    if (parseFloat(actualPadding) > 0) {
                        scrollHeight = current.$slide[0].scrollHeight;
                        current.$slide.css("padding-bottom", 0);
                        if (Math.abs(scrollHeight - current.$slide[0].scrollHeight) < 1) marginBottom = actualPadding;
                        current.$slide.css("padding-bottom", inlinePadding);
                    }
                }
                current.$content.css("margin-bottom", marginBottom);
            }
        },
        // Make content visible
        // This method is called right after content has been loaded or
        // user navigates gallery and transition should start
        // ============================================================
        revealContent: function(slide) {
            var self = this, $slide = slide.$slide, end = false, start = false, isMoved = self.isMoved(slide), isRevealed = slide.isRevealed, effect, effectClassName, duration, opacity;
            slide.isRevealed = true;
            effect = slide.opts[self.firstRun ? "animationEffect" : "transitionEffect"];
            duration = slide.opts[self.firstRun ? "animationDuration" : "transitionDuration"];
            duration = parseInt(slide.forcedDuration === undefined1 ? duration : slide.forcedDuration, 10);
            if (isMoved || slide.pos !== self.currPos || !duration) effect = false;
            // Check if can zoom
            if (effect === "zoom") {
                if (slide.pos === self.currPos && duration && slide.type === "image" && !slide.hasError && (start = self.getThumbPos(slide))) end = self.getFitPos(slide);
                else effect = "fade";
            }
            // Zoom animation
            // ==============
            if (effect === "zoom") {
                self.isAnimating = true;
                end.scaleX = end.width / start.width;
                end.scaleY = end.height / start.height;
                // Check if we need to animate opacity
                opacity = slide.opts.zoomOpacity;
                if (opacity == "auto") opacity = Math.abs(slide.width / slide.height - start.width / start.height) > 0.1;
                if (opacity) {
                    start.opacity = 0.1;
                    end.opacity = 1;
                }
                // Draw image at start position
                $.fancybox.setTranslate(slide.$content.removeClass("fancybox-is-hidden"), start);
                forceRedraw(slide.$content);
                // Start animation
                $.fancybox.animate(slide.$content, end, duration, function() {
                    self.isAnimating = false;
                    self.complete();
                });
                return;
            }
            self.updateSlide(slide);
            // Simply show content if no effect
            // ================================
            if (!effect) {
                slide.$content.removeClass("fancybox-is-hidden");
                if (!isRevealed && isMoved && slide.type === "image" && !slide.hasError) slide.$content.hide().fadeIn("fast");
                if (slide.pos === self.currPos) self.complete();
                return;
            }
            // Prepare for CSS transiton
            // =========================
            $.fancybox.stop($slide);
            //effectClassName = "fancybox-animated fancybox-slide--" + (slide.pos >= self.prevPos ? "next" : "previous") + " fancybox-fx-" + effect;
            effectClassName = "fancybox-slide--" + (slide.pos >= self.prevPos ? "next" : "previous") + " fancybox-animated fancybox-fx-" + effect;
            $slide.addClass(effectClassName).removeClass("fancybox-slide--current"); //.addClass(effectClassName);
            slide.$content.removeClass("fancybox-is-hidden");
            // Force reflow
            forceRedraw($slide);
            if (slide.type !== "image") slide.$content.hide().show(0);
            $.fancybox.animate($slide, "fancybox-slide--current", duration, function() {
                $slide.removeClass(effectClassName).css({
                    transform: "",
                    opacity: ""
                });
                if (slide.pos === self.currPos) self.complete();
            }, true);
        },
        // Check if we can and have to zoom from thumbnail
        //================================================
        getThumbPos: function(slide) {
            var rez = false, $thumb = slide.$thumb, thumbPos, btw, brw, bbw, blw;
            if (!$thumb || !inViewport($thumb[0])) return false;
            thumbPos = $.fancybox.getTranslate($thumb);
            btw = parseFloat($thumb.css("border-top-width") || 0);
            brw = parseFloat($thumb.css("border-right-width") || 0);
            bbw = parseFloat($thumb.css("border-bottom-width") || 0);
            blw = parseFloat($thumb.css("border-left-width") || 0);
            rez = {
                top: thumbPos.top + btw,
                left: thumbPos.left + blw,
                width: thumbPos.width - brw - blw,
                height: thumbPos.height - btw - bbw,
                scaleX: 1,
                scaleY: 1
            };
            return thumbPos.width > 0 && thumbPos.height > 0 ? rez : false;
        },
        // Final adjustments after current gallery item is moved to position
        // and it`s content is loaded
        // ==================================================================
        complete: function() {
            var self = this, current = self.current, slides = {}, $el;
            if (self.isMoved() || !current.isLoaded) return;
            if (!current.isComplete) {
                current.isComplete = true;
                current.$slide.siblings().trigger("onReset");
                self.preload("inline");
                // Trigger any CSS transiton inside the slide
                forceRedraw(current.$slide);
                current.$slide.addClass("fancybox-slide--complete");
                // Remove unnecessary slides
                $.each(self.slides, function(key, slide) {
                    if (slide.pos >= self.currPos - 1 && slide.pos <= self.currPos + 1) slides[slide.pos] = slide;
                    else if (slide) {
                        $.fancybox.stop(slide.$slide);
                        slide.$slide.off().remove();
                    }
                });
                self.slides = slides;
            }
            self.isAnimating = false;
            self.updateCursor();
            self.trigger("afterShow");
            // Autoplay first html5 video/audio
            if (!!current.opts.video.autoStart) current.$slide.find("video,audio").filter(":visible:first").trigger("play").one("ended", function() {
                if (Document.exitFullscreen) Document.exitFullscreen();
                else if (this.webkitExitFullscreen) this.webkitExitFullscreen();
                self.next();
            });
            // Try to focus on the first focusable element
            if (current.opts.autoFocus && current.contentType === "html") {
                // Look for the first input with autofocus attribute
                $el = current.$content.find("input[autofocus]:enabled:visible:first");
                if ($el.length) $el.trigger("focus");
                else self.focus(null, true);
            }
            // Avoid jumping
            current.$slide.scrollTop(0).scrollLeft(0);
        },
        // Preload next and previous slides
        // ================================
        preload: function(type) {
            var self = this, prev, next;
            if (self.group.length < 2) return;
            next = self.slides[self.currPos + 1];
            prev = self.slides[self.currPos - 1];
            if (prev && prev.type === type) self.loadSlide(prev);
            if (next && next.type === type) self.loadSlide(next);
        },
        // Try to find and focus on the first focusable element
        // ====================================================
        focus: function(e, firstRun) {
            var self = this, focusableStr = [
                "a[href]",
                "area[href]",
                'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
                "select:not([disabled]):not([aria-hidden])",
                "textarea:not([disabled]):not([aria-hidden])",
                "button:not([disabled]):not([aria-hidden])",
                "iframe",
                "object",
                "embed",
                "video",
                "audio",
                "[contenteditable]",
                '[tabindex]:not([tabindex^="-"])'
            ].join(","), focusableItems, focusedItemIndex;
            if (self.isClosing) return;
            if (e || !self.current || !self.current.isComplete) // Focus on any element inside fancybox
            focusableItems = self.$refs.container.find("*:visible");
            else // Focus inside current slide
            focusableItems = self.current.$slide.find("*:visible" + (firstRun ? ":not(.fancybox-close-small)" : ""));
            focusableItems = focusableItems.filter(focusableStr).filter(function() {
                return $(this).css("visibility") !== "hidden" && !$(this).hasClass("disabled");
            });
            if (focusableItems.length) {
                focusedItemIndex = focusableItems.index(document1.activeElement);
                if (e && e.shiftKey) // Back tab
                {
                    if (focusedItemIndex < 0 || focusedItemIndex == 0) {
                        e.preventDefault();
                        focusableItems.eq(focusableItems.length - 1).trigger("focus");
                    }
                } else // Outside or Forward tab
                if (focusedItemIndex < 0 || focusedItemIndex == focusableItems.length - 1) {
                    if (e) e.preventDefault();
                    focusableItems.eq(0).trigger("focus");
                }
            } else self.$refs.container.trigger("focus");
        },
        // Activates current instance - brings container to the front and enables keyboard,
        // notifies other instances about deactivating
        // =================================================================================
        activate: function() {
            var self = this;
            // Deactivate all instances
            $(".fancybox-container").each(function() {
                var instance = $(this).data("FancyBox");
                // Skip self and closing instances
                if (instance && instance.id !== self.id && !instance.isClosing) {
                    instance.trigger("onDeactivate");
                    instance.removeEvents();
                    instance.isVisible = false;
                }
            });
            self.isVisible = true;
            if (self.current || self.isIdle) {
                self.update();
                self.updateControls();
            }
            self.trigger("onActivate");
            self.addEvents();
        },
        // Start closing procedure
        // This will start "zoom-out" animation if needed and clean everything up afterwards
        // =================================================================================
        close: function(e, d) {
            var self = this, current = self.current, effect, duration, $content, domRect, opacity, start, end;
            var done = function() {
                self.cleanUp(e);
            };
            if (self.isClosing) return false;
            self.isClosing = true;
            // If beforeClose callback prevents closing, make sure content is centered
            if (self.trigger("beforeClose", e) === false) {
                self.isClosing = false;
                requestAFrame(function() {
                    self.update();
                });
                return false;
            }
            // Remove all events
            // If there are multiple instances, they will be set again by "activate" method
            self.removeEvents();
            $content = current.$content;
            effect = current.opts.animationEffect;
            duration = $.isNumeric(d) ? d : effect ? current.opts.animationDuration : 0;
            current.$slide.removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated");
            if (e !== true) $.fancybox.stop(current.$slide);
            else effect = false;
            // Remove other slides
            current.$slide.siblings().trigger("onReset").remove();
            // Trigger animations
            if (duration) self.$refs.container.removeClass("fancybox-is-open").addClass("fancybox-is-closing").css("transition-duration", duration + "ms");
            // Clean up
            self.hideLoading(current);
            self.hideControls(true);
            self.updateCursor();
            // Check if possible to zoom-out
            if (effect === "zoom" && !($content && duration && current.type === "image" && !self.isMoved() && !current.hasError && (end = self.getThumbPos(current)))) effect = "fade";
            if (effect === "zoom") {
                $.fancybox.stop($content);
                domRect = $.fancybox.getTranslate($content);
                start = {
                    top: domRect.top,
                    left: domRect.left,
                    scaleX: domRect.width / end.width,
                    scaleY: domRect.height / end.height,
                    width: end.width,
                    height: end.height
                };
                // Check if we need to animate opacity
                opacity = current.opts.zoomOpacity;
                if (opacity == "auto") opacity = Math.abs(current.width / current.height - end.width / end.height) > 0.1;
                if (opacity) end.opacity = 0;
                $.fancybox.setTranslate($content, start);
                forceRedraw($content);
                $.fancybox.animate($content, end, duration, done);
                return true;
            }
            if (effect && duration) $.fancybox.animate(current.$slide.addClass("fancybox-slide--previous").removeClass("fancybox-slide--current"), "fancybox-animated fancybox-fx-" + effect, duration, done);
            else // If skip animation
            if (e === true) setTimeout(done, duration);
            else done();
            return true;
        },
        // Final adjustments after removing the instance
        // =============================================
        cleanUp: function(e) {
            var self = this, instance, $focus = self.current.opts.$orig, x, y;
            self.current.$slide.trigger("onReset");
            self.$refs.container.empty().remove();
            self.trigger("afterClose", e);
            // Place back focus
            if (!!self.current.opts.backFocus) {
                if (!$focus || !$focus.length || !$focus.is(":visible")) $focus = self.$trigger;
                if ($focus && $focus.length) {
                    x = window1.scrollX;
                    y = window1.scrollY;
                    $focus.trigger("focus");
                    $("html, body").scrollTop(y).scrollLeft(x);
                }
            }
            self.current = null;
            // Check if there are other instances
            instance = $.fancybox.getInstance();
            if (instance) instance.activate();
            else {
                $("body").removeClass("fancybox-active compensate-for-scrollbar");
                $("#fancybox-style-noscroll").remove();
            }
        },
        // Call callback and trigger an event
        // ==================================
        trigger: function(name, slide) {
            var args = Array.prototype.slice.call(arguments, 1), self = this, obj = slide && slide.opts ? slide : self.current, rez;
            if (obj) args.unshift(obj);
            else obj = self;
            args.unshift(self);
            if ($.isFunction(obj.opts[name])) rez = obj.opts[name].apply(obj, args);
            if (rez === false) return rez;
            if (name === "afterClose" || !self.$refs) $D.trigger(name + ".fb", args);
            else self.$refs.container.trigger(name + ".fb", args);
        },
        // Update infobar values, navigation button states and reveal caption
        // ==================================================================
        updateControls: function() {
            var self = this, current = self.current, index = current.index, $container = self.$refs.container, $caption = self.$refs.caption, caption = current.opts.caption;
            // Recalculate content dimensions
            current.$slide.trigger("refresh");
            // Set caption
            if (caption && caption.length) {
                self.$caption = $caption;
                $caption.children().eq(0).html(caption);
            } else self.$caption = null;
            if (!self.hasHiddenControls && !self.isIdle) self.showControls();
            // Update info and navigation elements
            $container.find("[data-fancybox-count]").html(self.group.length);
            $container.find("[data-fancybox-index]").html(index + 1);
            $container.find("[data-fancybox-prev]").prop("disabled", !current.opts.loop && index <= 0);
            $container.find("[data-fancybox-next]").prop("disabled", !current.opts.loop && index >= self.group.length - 1);
            if (current.type === "image") // Re-enable buttons; update download button source
            $container.find("[data-fancybox-zoom]").show().end().find("[data-fancybox-download]").attr("href", current.opts.image.src || current.src).show();
            else if (current.opts.toolbar) $container.find("[data-fancybox-download],[data-fancybox-zoom]").hide();
            // Make sure focus is not on disabled button/element
            if ($(document1.activeElement).is(":hidden,[disabled]")) self.$refs.container.trigger("focus");
        },
        // Hide toolbar and caption
        // ========================
        hideControls: function(andCaption) {
            var self = this, arr = [
                "infobar",
                "toolbar",
                "nav"
            ];
            if (andCaption || !self.current.opts.preventCaptionOverlap) arr.push("caption");
            this.$refs.container.removeClass(arr.map(function(i) {
                return "fancybox-show-" + i;
            }).join(" "));
            this.hasHiddenControls = true;
        },
        showControls: function() {
            var self = this, opts = self.current ? self.current.opts : self.opts, $container = self.$refs.container;
            self.hasHiddenControls = false;
            self.idleSecondsCounter = 0;
            $container.toggleClass("fancybox-show-toolbar", !!(opts.toolbar && opts.buttons)).toggleClass("fancybox-show-infobar", !!(opts.infobar && self.group.length > 1)).toggleClass("fancybox-show-caption", !!self.$caption).toggleClass("fancybox-show-nav", !!(opts.arrows && self.group.length > 1)).toggleClass("fancybox-is-modal", !!opts.modal);
        },
        // Toggle toolbar and caption
        // ==========================
        toggleControls: function() {
            if (this.hasHiddenControls) this.showControls();
            else this.hideControls();
        }
    });
    $.fancybox = {
        version: "3.5.7",
        defaults: defaults,
        // Get current instance and execute a command.
        //
        // Examples of usage:
        //
        //   $instance = $.fancybox.getInstance();
        //   $.fancybox.getInstance().jumpTo( 1 );
        //   $.fancybox.getInstance( 'jumpTo', 1 );
        //   $.fancybox.getInstance( function() {
        //       console.info( this.currIndex );
        //   });
        // ======================================================
        getInstance: function(command) {
            var instance = $('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox"), args = Array.prototype.slice.call(arguments, 1);
            if (instance instanceof FancyBox) {
                if ($.type(command) === "string") instance[command].apply(instance, args);
                else if ($.type(command) === "function") command.apply(instance, args);
                return instance;
            }
            return false;
        },
        // Create new instance
        // ===================
        open: function(items, opts, index) {
            return new FancyBox(items, opts, index);
        },
        // Close current or all instances
        // ==============================
        close: function(all) {
            var instance = this.getInstance();
            if (instance) {
                instance.close();
                // Try to find and close next instance
                if (all === true) this.close(all);
            }
        },
        // Close all instances and unbind all events
        // =========================================
        destroy: function() {
            this.close(true);
            $D.add("body").off("click.fb-start", "**");
        },
        // Try to detect mobile devices
        // ============================
        isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        // Detect if 'translate3d' support is available
        // ============================================
        use3d: function() {
            var div = document1.createElement("div");
            return window1.getComputedStyle && window1.getComputedStyle(div) && window1.getComputedStyle(div).getPropertyValue("transform") && !(document1.documentMode && document1.documentMode < 11);
        }(),
        // Helper function to get current visual state of an element
        // returns array[ top, left, horizontal-scale, vertical-scale, opacity ]
        // =====================================================================
        getTranslate: function($el) {
            var domRect;
            if (!$el || !$el.length) return false;
            domRect = $el[0].getBoundingClientRect();
            return {
                top: domRect.top || 0,
                left: domRect.left || 0,
                width: domRect.width,
                height: domRect.height,
                opacity: parseFloat($el.css("opacity"))
            };
        },
        // Shortcut for setting "translate3d" properties for element
        // Can set be used to set opacity, too
        // ========================================================
        setTranslate: function($el, props) {
            var str = "", css = {};
            if (!$el || !props) return;
            if (props.left !== undefined1 || props.top !== undefined1) {
                str = (props.left === undefined1 ? $el.position().left : props.left) + "px, " + (props.top === undefined1 ? $el.position().top : props.top) + "px";
                if (this.use3d) str = "translate3d(" + str + ", 0px)";
                else str = "translate(" + str + ")";
            }
            if (props.scaleX !== undefined1 && props.scaleY !== undefined1) str += " scale(" + props.scaleX + ", " + props.scaleY + ")";
            else if (props.scaleX !== undefined1) str += " scaleX(" + props.scaleX + ")";
            if (str.length) css.transform = str;
            if (props.opacity !== undefined1) css.opacity = props.opacity;
            if (props.width !== undefined1) css.width = props.width;
            if (props.height !== undefined1) css.height = props.height;
            return $el.css(css);
        },
        // Simple CSS transition handler
        // =============================
        animate: function($el, to, duration, callback, leaveAnimationName) {
            var self = this, from;
            if ($.isFunction(duration)) {
                callback = duration;
                duration = null;
            }
            self.stop($el);
            from = self.getTranslate($el);
            $el.on(transitionEnd, function(e) {
                // Skip events from child elements and z-index change
                if (e && e.originalEvent && (!$el.is(e.originalEvent.target) || e.originalEvent.propertyName == "z-index")) return;
                self.stop($el);
                if ($.isNumeric(duration)) $el.css("transition-duration", "");
                if ($.isPlainObject(to)) {
                    if (to.scaleX !== undefined1 && to.scaleY !== undefined1) self.setTranslate($el, {
                        top: to.top,
                        left: to.left,
                        width: from.width * to.scaleX,
                        height: from.height * to.scaleY,
                        scaleX: 1,
                        scaleY: 1
                    });
                } else if (leaveAnimationName !== true) $el.removeClass(to);
                if ($.isFunction(callback)) callback(e);
            });
            if ($.isNumeric(duration)) $el.css("transition-duration", duration + "ms");
            // Start animation by changing CSS properties or class name
            if ($.isPlainObject(to)) {
                if (to.scaleX !== undefined1 && to.scaleY !== undefined1) {
                    delete to.width;
                    delete to.height;
                    if ($el.parent().hasClass("fancybox-slide--image")) $el.parent().addClass("fancybox-is-scaling");
                }
                $.fancybox.setTranslate($el, to);
            } else $el.addClass(to);
            // Make sure that `transitionend` callback gets fired
            $el.data("timer", setTimeout(function() {
                $el.trigger(transitionEnd);
            }, duration + 33));
        },
        stop: function($el, callCallback) {
            if ($el && $el.length) {
                clearTimeout($el.data("timer"));
                if (callCallback) $el.trigger(transitionEnd);
                $el.off(transitionEnd).css("transition-duration", "");
                $el.parent().removeClass("fancybox-is-scaling");
            }
        }
    };
    // Default click handler for "fancyboxed" links
    // ============================================
    function _run(e, opts) {
        var items = [], index = 0, $target, value, instance;
        // Avoid opening multiple times
        if (e && e.isDefaultPrevented()) return;
        e.preventDefault();
        opts = opts || {};
        if (e && e.data) opts = mergeOpts(e.data.options, opts);
        $target = opts.$target || $(e.currentTarget).trigger("blur");
        instance = $.fancybox.getInstance();
        if (instance && instance.$trigger && instance.$trigger.is($target)) return;
        if (opts.selector) items = $(opts.selector);
        else {
            // Get all related items and find index for clicked one
            value = $target.attr("data-fancybox") || "";
            if (value) {
                items = e.data ? e.data.items : [];
                items = items.length ? items.filter('[data-fancybox="' + value + '"]') : $('[data-fancybox="' + value + '"]');
            } else items = [
                $target
            ];
        }
        index = $(items).index($target);
        // Sometimes current item can not be found
        if (index < 0) index = 0;
        instance = $.fancybox.open(items, opts, index);
        // Save last active element
        instance.$trigger = $target;
    }
    // Create a jQuery plugin
    // ======================
    $.fn.fancybox = function(options) {
        var selector;
        options = options || {};
        selector = options.selector || false;
        if (selector) // Use body element instead of document so it executes first
        $("body").off("click.fb-start", selector).on("click.fb-start", selector, {
            options: options
        }, _run);
        else this.off("click.fb-start").on("click.fb-start", {
            items: this,
            options: options
        }, _run);
        return this;
    };
    // Self initializing plugin for all elements having `data-fancybox` attribute
    // ==========================================================================
    $D.on("click.fb-start", "[data-fancybox]", _run);
    // Enable "trigger elements"
    // =========================
    $D.on("click.fb-start", "[data-fancybox-trigger]", function(e) {
        $('[data-fancybox="' + $(this).attr("data-fancybox-trigger") + '"]').eq($(this).attr("data-fancybox-index") || 0).trigger("click.fb-start", {
            $trigger: $(this)
        });
    });
    // Track focus event for better accessibility styling
    // ==================================================
    (function() {
        var buttonStr = ".fancybox-button", focusStr = "fancybox-focus", $pressed = null;
        $D.on("mousedown mouseup focus blur", buttonStr, function(e) {
            switch(e.type){
                case "mousedown":
                    $pressed = $(this);
                    break;
                case "mouseup":
                    $pressed = null;
                    break;
                case "focusin":
                    $(buttonStr).removeClass(focusStr);
                    if (!$(this).is($pressed) && !$(this).is("[disabled]")) $(this).addClass(focusStr);
                    break;
                case "focusout":
                    $(buttonStr).removeClass(focusStr);
                    break;
            }
        });
    })();
})(window, document, jQuery);
// ==========================================================================
//
// Media
// Adds additional media type support
//
// ==========================================================================
(function($) {
    "use strict";
    // Object containing properties for each media type
    var defaults = {
        youtube: {
            matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
            params: {
                autoplay: 1,
                autohide: 1,
                fs: 1,
                rel: 0,
                hd: 1,
                wmode: "transparent",
                enablejsapi: 1,
                html5: 1
            },
            paramPlace: 8,
            type: "iframe",
            url: "https://www.youtube-nocookie.com/embed/$4",
            thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg"
        },
        vimeo: {
            matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
            params: {
                autoplay: 1,
                hd: 1,
                show_title: 1,
                show_byline: 1,
                show_portrait: 0,
                fullscreen: 1
            },
            paramPlace: 3,
            type: "iframe",
            url: "//player.vimeo.com/video/$2"
        },
        instagram: {
            matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
            type: "image",
            url: "//$1/p/$2/media/?size=l"
        },
        // Examples:
        // http://maps.google.com/?ll=48.857995,2.294297&spn=0.007666,0.021136&t=m&z=16
        // https://www.google.com/maps/@37.7852006,-122.4146355,14.65z
        // https://www.google.com/maps/@52.2111123,2.9237542,6.61z?hl=en
        // https://www.google.com/maps/place/Googleplex/@37.4220041,-122.0833494,17z/data=!4m5!3m4!1s0x0:0x6c296c66619367e0!8m2!3d37.4219998!4d-122.0840572
        gmap_place: {
            matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
            type: "iframe",
            url: function(rez) {
                return "//maps.google." + rez[2] + "/?ll=" + (rez[9] ? rez[9] + "&z=" + Math.floor(rez[10]) + (rez[12] ? rez[12].replace(/^\//, "&") : "") : rez[12] + "").replace(/\?/, "&") + "&output=" + (rez[12] && rez[12].indexOf("layer=c") > 0 ? "svembed" : "embed");
            }
        },
        // Examples:
        // https://www.google.com/maps/search/Empire+State+Building/
        // https://www.google.com/maps/search/?api=1&query=centurylink+field
        // https://www.google.com/maps/search/?api=1&query=47.5951518,-122.3316393
        gmap_search: {
            matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
            type: "iframe",
            url: function(rez) {
                return "//maps.google." + rez[2] + "/maps?q=" + rez[5].replace("query=", "q=").replace("api=1", "") + "&output=embed";
            }
        }
    };
    // Formats matching url to final form
    var format = function(url, rez, params) {
        if (!url) return;
        params = params || "";
        if ($.type(params) === "object") params = $.param(params, true);
        $.each(rez, function(key, value) {
            url = url.replace("$" + key, value || "");
        });
        if (params.length) url += (url.indexOf("?") > 0 ? "&" : "?") + params;
        return url;
    };
    $(document).on("objectNeedsType.fb", function(e, instance, item) {
        var url = item.src || "", type = false, media, thumb, rez, params, urlParams, paramObj, provider;
        media = $.extend(true, {}, defaults, item.opts.media);
        // Look for any matching media type
        $.each(media, function(providerName, providerOpts) {
            rez = url.match(providerOpts.matcher);
            if (!rez) return;
            type = providerOpts.type;
            provider = providerName;
            paramObj = {};
            if (providerOpts.paramPlace && rez[providerOpts.paramPlace]) {
                urlParams = rez[providerOpts.paramPlace];
                if (urlParams[0] == "?") urlParams = urlParams.substring(1);
                urlParams = urlParams.split("&");
                for(var m = 0; m < urlParams.length; ++m){
                    var p = urlParams[m].split("=", 2);
                    if (p.length == 2) paramObj[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
                }
            }
            params = $.extend(true, {}, providerOpts.params, item.opts[providerName], paramObj);
            url = $.type(providerOpts.url) === "function" ? providerOpts.url.call(this, rez, params, item) : format(providerOpts.url, rez, params);
            thumb = $.type(providerOpts.thumb) === "function" ? providerOpts.thumb.call(this, rez, params, item) : format(providerOpts.thumb, rez);
            if (providerName === "youtube") url = url.replace(/&t=((\d+)m)?(\d+)s/, function(match, p1, m, s) {
                return "&start=" + ((m ? parseInt(m, 10) * 60 : 0) + parseInt(s, 10));
            });
            else if (providerName === "vimeo") url = url.replace("&%23", "#");
            return false;
        });
        // If it is found, then change content type and update the url
        if (type) {
            if (!item.opts.thumb && !(item.opts.$thumb && item.opts.$thumb.length)) item.opts.thumb = thumb;
            if (type === "iframe") item.opts = $.extend(true, item.opts, {
                iframe: {
                    preload: false,
                    attr: {
                        scrolling: "no"
                    }
                }
            });
            $.extend(item, {
                type: type,
                src: url,
                origSrc: item.src,
                contentSource: provider,
                contentType: type === "image" ? "image" : provider == "gmap_place" || provider == "gmap_search" ? "map" : "video"
            });
        } else if (url) item.type = item.opts.defaultType;
    });
    // Load YouTube/Video API on request to detect when video finished playing
    var VideoAPILoader = {
        youtube: {
            src: "https://www.youtube.com/iframe_api",
            class: "YT",
            loading: false,
            loaded: false
        },
        vimeo: {
            src: "https://player.vimeo.com/api/player.js",
            class: "Vimeo",
            loading: false,
            loaded: false
        },
        load: function(vendor) {
            var _this = this, script;
            if (this[vendor].loaded) {
                setTimeout(function() {
                    _this.done(vendor);
                });
                return;
            }
            if (this[vendor].loading) return;
            this[vendor].loading = true;
            script = document.createElement("script");
            script.type = "text/javascript";
            script.src = this[vendor].src;
            if (vendor === "youtube") window.onYouTubeIframeAPIReady = function() {
                _this[vendor].loaded = true;
                _this.done(vendor);
            };
            else script.onload = function() {
                _this[vendor].loaded = true;
                _this.done(vendor);
            };
            document.body.appendChild(script);
        },
        done: function(vendor) {
            var instance, $el, player;
            if (vendor === "youtube") delete window.onYouTubeIframeAPIReady;
            instance = $.fancybox.getInstance();
            if (instance) {
                $el = instance.current.$content.find("iframe");
                if (vendor === "youtube" && YT !== undefined && YT) player = new YT.Player($el.attr("id"), {
                    events: {
                        onStateChange: function(e) {
                            if (e.data == 0) instance.next();
                        }
                    }
                });
                else if (vendor === "vimeo" && Vimeo !== undefined && Vimeo) {
                    player = new Vimeo.Player($el);
                    player.on("ended", function() {
                        instance.next();
                    });
                }
            }
        }
    };
    $(document).on({
        "afterShow.fb": function(e, instance, current) {
            if (instance.group.length > 1 && (current.contentSource === "youtube" || current.contentSource === "vimeo")) VideoAPILoader.load(current.contentSource);
        }
    });
})(jQuery);
// ==========================================================================
//
// Guestures
// Adds touch guestures, handles click and tap events
//
// ==========================================================================
(function(window1, document1, $) {
    "use strict";
    var requestAFrame = function() {
        return window1.requestAnimationFrame || window1.webkitRequestAnimationFrame || window1.mozRequestAnimationFrame || window1.oRequestAnimationFrame || // if all else fails, use setTimeout
        function(callback) {
            return window1.setTimeout(callback, 1000 / 60);
        };
    }();
    var cancelAFrame = function() {
        return window1.cancelAnimationFrame || window1.webkitCancelAnimationFrame || window1.mozCancelAnimationFrame || window1.oCancelAnimationFrame || function(id) {
            window1.clearTimeout(id);
        };
    }();
    var getPointerXY = function(e) {
        var result = [];
        e = e.originalEvent || e || window1.e;
        e = e.touches && e.touches.length ? e.touches : e.changedTouches && e.changedTouches.length ? e.changedTouches : [
            e
        ];
        for(var key in e){
            if (e[key].pageX) result.push({
                x: e[key].pageX,
                y: e[key].pageY
            });
            else if (e[key].clientX) result.push({
                x: e[key].clientX,
                y: e[key].clientY
            });
        }
        return result;
    };
    var distance = function(point2, point1, what) {
        if (!point1 || !point2) return 0;
        if (what === "x") return point2.x - point1.x;
        else if (what === "y") return point2.y - point1.y;
        return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
    };
    var isClickable = function($el) {
        if ($el.is('a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe') || $.isFunction($el.get(0).onclick) || $el.data("selectable")) return true;
        // Check for attributes like data-fancybox-next or data-fancybox-close
        for(var i = 0, atts = $el[0].attributes, n = atts.length; i < n; i++){
            if (atts[i].nodeName.substr(0, 14) === "data-fancybox-") return true;
        }
        return false;
    };
    var hasScrollbars = function(el) {
        var overflowY = window1.getComputedStyle(el)["overflow-y"], overflowX = window1.getComputedStyle(el)["overflow-x"], vertical = (overflowY === "scroll" || overflowY === "auto") && el.scrollHeight > el.clientHeight, horizontal = (overflowX === "scroll" || overflowX === "auto") && el.scrollWidth > el.clientWidth;
        return vertical || horizontal;
    };
    var isScrollable = function($el) {
        var rez = false;
        while(true){
            rez = hasScrollbars($el.get(0));
            if (rez) break;
            $el = $el.parent();
            if (!$el.length || $el.hasClass("fancybox-stage") || $el.is("body")) break;
        }
        return rez;
    };
    var Guestures = function(instance) {
        var self = this;
        self.instance = instance;
        self.$bg = instance.$refs.bg;
        self.$stage = instance.$refs.stage;
        self.$container = instance.$refs.container;
        self.destroy();
        self.$container.on("touchstart.fb.touch mousedown.fb.touch", $.proxy(self, "ontouchstart"));
    };
    Guestures.prototype.destroy = function() {
        var self = this;
        self.$container.off(".fb.touch");
        $(document1).off(".fb.touch");
        if (self.requestId) {
            cancelAFrame(self.requestId);
            self.requestId = null;
        }
        if (self.tapped) {
            clearTimeout(self.tapped);
            self.tapped = null;
        }
    };
    Guestures.prototype.ontouchstart = function(e) {
        var self = this, $target = $(e.target), instance = self.instance, current = instance.current, $slide = current.$slide, $content = current.$content, isTouchDevice = e.type == "touchstart";
        // Do not respond to both (touch and mouse) events
        if (isTouchDevice) self.$container.off("mousedown.fb.touch");
        // Ignore right click
        if (e.originalEvent && e.originalEvent.button == 2) return;
        // Ignore taping on links, buttons, input elements
        if (!$slide.length || !$target.length || isClickable($target) || isClickable($target.parent())) return;
        // Ignore clicks on the scrollbar
        if (!$target.is("img") && e.originalEvent.clientX > $target[0].clientWidth + $target.offset().left) return;
        // Ignore clicks while zooming or closing
        if (!current || instance.isAnimating || current.$slide.hasClass("fancybox-animated")) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        self.realPoints = self.startPoints = getPointerXY(e);
        if (!self.startPoints.length) return;
        // Allow other scripts to catch touch event if "touch" is set to false
        if (current.touch) e.stopPropagation();
        self.startEvent = e;
        self.canTap = true;
        self.$target = $target;
        self.$content = $content;
        self.opts = current.opts.touch;
        self.isPanning = false;
        self.isSwiping = false;
        self.isZooming = false;
        self.isScrolling = false;
        self.canPan = instance.canPan();
        self.startTime = new Date().getTime();
        self.distanceX = self.distanceY = self.distance = 0;
        self.canvasWidth = Math.round($slide[0].clientWidth);
        self.canvasHeight = Math.round($slide[0].clientHeight);
        self.contentLastPos = null;
        self.contentStartPos = $.fancybox.getTranslate(self.$content) || {
            top: 0,
            left: 0
        };
        self.sliderStartPos = $.fancybox.getTranslate($slide);
        // Since position will be absolute, but we need to make it relative to the stage
        self.stagePos = $.fancybox.getTranslate(instance.$refs.stage);
        self.sliderStartPos.top -= self.stagePos.top;
        self.sliderStartPos.left -= self.stagePos.left;
        self.contentStartPos.top -= self.stagePos.top;
        self.contentStartPos.left -= self.stagePos.left;
        $(document1).off(".fb.touch").on(isTouchDevice ? "touchend.fb.touch touchcancel.fb.touch" : "mouseup.fb.touch mouseleave.fb.touch", $.proxy(self, "ontouchend")).on(isTouchDevice ? "touchmove.fb.touch" : "mousemove.fb.touch", $.proxy(self, "ontouchmove"));
        if ($.fancybox.isMobile) document1.addEventListener("scroll", self.onscroll, true);
        // Skip if clicked outside the sliding area
        if (!(self.opts || self.canPan) || !($target.is(self.$stage) || self.$stage.find($target).length)) {
            if ($target.is(".fancybox-image")) e.preventDefault();
            if (!($.fancybox.isMobile && $target.parents(".fancybox-caption").length)) return;
        }
        self.isScrollable = isScrollable($target) || isScrollable($target.parent());
        // Check if element is scrollable and try to prevent default behavior (scrolling)
        if (!($.fancybox.isMobile && self.isScrollable)) e.preventDefault();
        // One finger or mouse click - swipe or pan an image
        if (self.startPoints.length === 1 || current.hasError) {
            if (self.canPan) {
                $.fancybox.stop(self.$content);
                self.isPanning = true;
            } else self.isSwiping = true;
            self.$container.addClass("fancybox-is-grabbing");
        }
        // Two fingers - zoom image
        if (self.startPoints.length === 2 && current.type === "image" && (current.isLoaded || current.$ghost)) {
            self.canTap = false;
            self.isSwiping = false;
            self.isPanning = false;
            self.isZooming = true;
            $.fancybox.stop(self.$content);
            self.centerPointStartX = (self.startPoints[0].x + self.startPoints[1].x) * 0.5 - $(window1).scrollLeft();
            self.centerPointStartY = (self.startPoints[0].y + self.startPoints[1].y) * 0.5 - $(window1).scrollTop();
            self.percentageOfImageAtPinchPointX = (self.centerPointStartX - self.contentStartPos.left) / self.contentStartPos.width;
            self.percentageOfImageAtPinchPointY = (self.centerPointStartY - self.contentStartPos.top) / self.contentStartPos.height;
            self.startDistanceBetweenFingers = distance(self.startPoints[0], self.startPoints[1]);
        }
    };
    Guestures.prototype.onscroll = function(e) {
        var self = this;
        self.isScrolling = true;
        document1.removeEventListener("scroll", self.onscroll, true);
    };
    Guestures.prototype.ontouchmove = function(e) {
        var self = this;
        // Make sure user has not released over iframe or disabled element
        if (e.originalEvent.buttons !== undefined && e.originalEvent.buttons === 0) {
            self.ontouchend(e);
            return;
        }
        if (self.isScrolling) {
            self.canTap = false;
            return;
        }
        self.newPoints = getPointerXY(e);
        if (!(self.opts || self.canPan) || !self.newPoints.length || !self.newPoints.length) return;
        if (!(self.isSwiping && self.isSwiping === true)) e.preventDefault();
        self.distanceX = distance(self.newPoints[0], self.startPoints[0], "x");
        self.distanceY = distance(self.newPoints[0], self.startPoints[0], "y");
        self.distance = distance(self.newPoints[0], self.startPoints[0]);
        // Skip false ontouchmove events (Chrome)
        if (self.distance > 0) {
            if (self.isSwiping) self.onSwipe(e);
            else if (self.isPanning) self.onPan();
            else if (self.isZooming) self.onZoom();
        }
    };
    Guestures.prototype.onSwipe = function(e) {
        var self = this, instance = self.instance, swiping = self.isSwiping, left = self.sliderStartPos.left || 0, angle;
        // If direction is not yet determined
        if (swiping === true) {
            // We need at least 10px distance to correctly calculate an angle
            if (Math.abs(self.distance) > 10) {
                self.canTap = false;
                if (instance.group.length < 2 && self.opts.vertical) self.isSwiping = "y";
                else if (instance.isDragging || self.opts.vertical === false || self.opts.vertical === "auto" && $(window1).width() > 800) self.isSwiping = "x";
                else {
                    angle = Math.abs(Math.atan2(self.distanceY, self.distanceX) * 180 / Math.PI);
                    self.isSwiping = angle > 45 && angle < 135 ? "y" : "x";
                }
                if (self.isSwiping === "y" && $.fancybox.isMobile && self.isScrollable) {
                    self.isScrolling = true;
                    return;
                }
                instance.isDragging = self.isSwiping;
                // Reset points to avoid jumping, because we dropped first swipes to calculate the angle
                self.startPoints = self.newPoints;
                $.each(instance.slides, function(index, slide) {
                    var slidePos, stagePos;
                    $.fancybox.stop(slide.$slide);
                    slidePos = $.fancybox.getTranslate(slide.$slide);
                    stagePos = $.fancybox.getTranslate(instance.$refs.stage);
                    slide.$slide.css({
                        transform: "",
                        opacity: "",
                        "transition-duration": ""
                    }).removeClass("fancybox-animated").removeClass(function(index, className) {
                        return (className.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                    });
                    if (slide.pos === instance.current.pos) {
                        self.sliderStartPos.top = slidePos.top - stagePos.top;
                        self.sliderStartPos.left = slidePos.left - stagePos.left;
                    }
                    $.fancybox.setTranslate(slide.$slide, {
                        top: slidePos.top - stagePos.top,
                        left: slidePos.left - stagePos.left
                    });
                });
                // Stop slideshow
                if (instance.SlideShow && instance.SlideShow.isActive) instance.SlideShow.stop();
            }
            return;
        }
        // Sticky edges
        if (swiping == "x") {
            if (self.distanceX > 0 && (self.instance.group.length < 2 || self.instance.current.index === 0 && !self.instance.current.opts.loop)) left = left + Math.pow(self.distanceX, 0.8);
            else if (self.distanceX < 0 && (self.instance.group.length < 2 || self.instance.current.index === self.instance.group.length - 1 && !self.instance.current.opts.loop)) left = left - Math.pow(-self.distanceX, 0.8);
            else left = left + self.distanceX;
        }
        self.sliderLastPos = {
            top: swiping == "x" ? 0 : self.sliderStartPos.top + self.distanceY,
            left: left
        };
        if (self.requestId) {
            cancelAFrame(self.requestId);
            self.requestId = null;
        }
        self.requestId = requestAFrame(function() {
            if (self.sliderLastPos) {
                $.each(self.instance.slides, function(index, slide) {
                    var pos = slide.pos - self.instance.currPos;
                    $.fancybox.setTranslate(slide.$slide, {
                        top: self.sliderLastPos.top,
                        left: self.sliderLastPos.left + pos * self.canvasWidth + pos * slide.opts.gutter
                    });
                });
                self.$container.addClass("fancybox-is-sliding");
            }
        });
    };
    Guestures.prototype.onPan = function() {
        var self = this;
        // Prevent accidental movement (sometimes, when tapping casually, finger can move a bit)
        if (distance(self.newPoints[0], self.realPoints[0]) < ($.fancybox.isMobile ? 10 : 5)) {
            self.startPoints = self.newPoints;
            return;
        }
        self.canTap = false;
        self.contentLastPos = self.limitMovement();
        if (self.requestId) cancelAFrame(self.requestId);
        self.requestId = requestAFrame(function() {
            $.fancybox.setTranslate(self.$content, self.contentLastPos);
        });
    };
    // Make panning sticky to the edges
    Guestures.prototype.limitMovement = function() {
        var self = this;
        var canvasWidth = self.canvasWidth;
        var canvasHeight = self.canvasHeight;
        var distanceX = self.distanceX;
        var distanceY = self.distanceY;
        var contentStartPos = self.contentStartPos;
        var currentOffsetX = contentStartPos.left;
        var currentOffsetY = contentStartPos.top;
        var currentWidth = contentStartPos.width;
        var currentHeight = contentStartPos.height;
        var minTranslateX, minTranslateY, maxTranslateX, maxTranslateY, newOffsetX, newOffsetY;
        if (currentWidth > canvasWidth) newOffsetX = currentOffsetX + distanceX;
        else newOffsetX = currentOffsetX;
        newOffsetY = currentOffsetY + distanceY;
        // Slow down proportionally to traveled distance
        minTranslateX = Math.max(0, canvasWidth * 0.5 - currentWidth * 0.5);
        minTranslateY = Math.max(0, canvasHeight * 0.5 - currentHeight * 0.5);
        maxTranslateX = Math.min(canvasWidth - currentWidth, canvasWidth * 0.5 - currentWidth * 0.5);
        maxTranslateY = Math.min(canvasHeight - currentHeight, canvasHeight * 0.5 - currentHeight * 0.5);
        //   ->
        if (distanceX > 0 && newOffsetX > minTranslateX) newOffsetX = minTranslateX - 1 + Math.pow(-minTranslateX + currentOffsetX + distanceX, 0.8) || 0;
        //    <-
        if (distanceX < 0 && newOffsetX < maxTranslateX) newOffsetX = maxTranslateX + 1 - Math.pow(maxTranslateX - currentOffsetX - distanceX, 0.8) || 0;
        //   \/
        if (distanceY > 0 && newOffsetY > minTranslateY) newOffsetY = minTranslateY - 1 + Math.pow(-minTranslateY + currentOffsetY + distanceY, 0.8) || 0;
        //   /\
        if (distanceY < 0 && newOffsetY < maxTranslateY) newOffsetY = maxTranslateY + 1 - Math.pow(maxTranslateY - currentOffsetY - distanceY, 0.8) || 0;
        return {
            top: newOffsetY,
            left: newOffsetX
        };
    };
    Guestures.prototype.limitPosition = function(newOffsetX, newOffsetY, newWidth, newHeight) {
        var self = this;
        var canvasWidth = self.canvasWidth;
        var canvasHeight = self.canvasHeight;
        if (newWidth > canvasWidth) {
            newOffsetX = newOffsetX > 0 ? 0 : newOffsetX;
            newOffsetX = newOffsetX < canvasWidth - newWidth ? canvasWidth - newWidth : newOffsetX;
        } else // Center horizontally
        newOffsetX = Math.max(0, canvasWidth / 2 - newWidth / 2);
        if (newHeight > canvasHeight) {
            newOffsetY = newOffsetY > 0 ? 0 : newOffsetY;
            newOffsetY = newOffsetY < canvasHeight - newHeight ? canvasHeight - newHeight : newOffsetY;
        } else // Center vertically
        newOffsetY = Math.max(0, canvasHeight / 2 - newHeight / 2);
        return {
            top: newOffsetY,
            left: newOffsetX
        };
    };
    Guestures.prototype.onZoom = function() {
        var self = this;
        // Calculate current distance between points to get pinch ratio and new width and height
        var contentStartPos = self.contentStartPos;
        var currentWidth = contentStartPos.width;
        var currentHeight = contentStartPos.height;
        var currentOffsetX = contentStartPos.left;
        var currentOffsetY = contentStartPos.top;
        var endDistanceBetweenFingers = distance(self.newPoints[0], self.newPoints[1]);
        var pinchRatio = endDistanceBetweenFingers / self.startDistanceBetweenFingers;
        var newWidth = Math.floor(currentWidth * pinchRatio);
        var newHeight = Math.floor(currentHeight * pinchRatio);
        // This is the translation due to pinch-zooming
        var translateFromZoomingX = (currentWidth - newWidth) * self.percentageOfImageAtPinchPointX;
        var translateFromZoomingY = (currentHeight - newHeight) * self.percentageOfImageAtPinchPointY;
        // Point between the two touches
        var centerPointEndX = (self.newPoints[0].x + self.newPoints[1].x) / 2 - $(window1).scrollLeft();
        var centerPointEndY = (self.newPoints[0].y + self.newPoints[1].y) / 2 - $(window1).scrollTop();
        // And this is the translation due to translation of the centerpoint
        // between the two fingers
        var translateFromTranslatingX = centerPointEndX - self.centerPointStartX;
        var translateFromTranslatingY = centerPointEndY - self.centerPointStartY;
        // The new offset is the old/current one plus the total translation
        var newOffsetX = currentOffsetX + (translateFromZoomingX + translateFromTranslatingX);
        var newOffsetY = currentOffsetY + (translateFromZoomingY + translateFromTranslatingY);
        var newPos = {
            top: newOffsetY,
            left: newOffsetX,
            scaleX: pinchRatio,
            scaleY: pinchRatio
        };
        self.canTap = false;
        self.newWidth = newWidth;
        self.newHeight = newHeight;
        self.contentLastPos = newPos;
        if (self.requestId) cancelAFrame(self.requestId);
        self.requestId = requestAFrame(function() {
            $.fancybox.setTranslate(self.$content, self.contentLastPos);
        });
    };
    Guestures.prototype.ontouchend = function(e) {
        var self = this;
        var swiping = self.isSwiping;
        var panning = self.isPanning;
        var zooming = self.isZooming;
        var scrolling = self.isScrolling;
        self.endPoints = getPointerXY(e);
        self.dMs = Math.max(new Date().getTime() - self.startTime, 1);
        self.$container.removeClass("fancybox-is-grabbing");
        $(document1).off(".fb.touch");
        document1.removeEventListener("scroll", self.onscroll, true);
        if (self.requestId) {
            cancelAFrame(self.requestId);
            self.requestId = null;
        }
        self.isSwiping = false;
        self.isPanning = false;
        self.isZooming = false;
        self.isScrolling = false;
        self.instance.isDragging = false;
        if (self.canTap) return self.onTap(e);
        self.speed = 100;
        // Speed in px/ms
        self.velocityX = self.distanceX / self.dMs * 0.5;
        self.velocityY = self.distanceY / self.dMs * 0.5;
        if (panning) self.endPanning();
        else if (zooming) self.endZooming();
        else self.endSwiping(swiping, scrolling);
        return;
    };
    Guestures.prototype.endSwiping = function(swiping, scrolling) {
        var self = this, ret = false, len = self.instance.group.length, distanceX = Math.abs(self.distanceX), canAdvance = swiping == "x" && len > 1 && (self.dMs > 130 && distanceX > 10 || distanceX > 50), speedX = 300;
        self.sliderLastPos = null;
        // Close if swiped vertically / navigate if horizontally
        if (swiping == "y" && !scrolling && Math.abs(self.distanceY) > 50) {
            // Continue vertical movement
            $.fancybox.animate(self.instance.current.$slide, {
                top: self.sliderStartPos.top + self.distanceY + self.velocityY * 150,
                opacity: 0
            }, 200);
            ret = self.instance.close(true, 250);
        } else if (canAdvance && self.distanceX > 0) ret = self.instance.previous(speedX);
        else if (canAdvance && self.distanceX < 0) ret = self.instance.next(speedX);
        if (ret === false && (swiping == "x" || swiping == "y")) self.instance.centerSlide(200);
        self.$container.removeClass("fancybox-is-sliding");
    };
    // Limit panning from edges
    // ========================
    Guestures.prototype.endPanning = function() {
        var self = this, newOffsetX, newOffsetY, newPos;
        if (!self.contentLastPos) return;
        if (self.opts.momentum === false || self.dMs > 350) {
            newOffsetX = self.contentLastPos.left;
            newOffsetY = self.contentLastPos.top;
        } else {
            // Continue movement
            newOffsetX = self.contentLastPos.left + self.velocityX * 500;
            newOffsetY = self.contentLastPos.top + self.velocityY * 500;
        }
        newPos = self.limitPosition(newOffsetX, newOffsetY, self.contentStartPos.width, self.contentStartPos.height);
        newPos.width = self.contentStartPos.width;
        newPos.height = self.contentStartPos.height;
        $.fancybox.animate(self.$content, newPos, 366);
    };
    Guestures.prototype.endZooming = function() {
        var self = this;
        var current = self.instance.current;
        var newOffsetX, newOffsetY, newPos, reset;
        var newWidth = self.newWidth;
        var newHeight = self.newHeight;
        if (!self.contentLastPos) return;
        newOffsetX = self.contentLastPos.left;
        newOffsetY = self.contentLastPos.top;
        reset = {
            top: newOffsetY,
            left: newOffsetX,
            width: newWidth,
            height: newHeight,
            scaleX: 1,
            scaleY: 1
        };
        // Reset scalex/scaleY values; this helps for perfomance and does not break animation
        $.fancybox.setTranslate(self.$content, reset);
        if (newWidth < self.canvasWidth && newHeight < self.canvasHeight) self.instance.scaleToFit(150);
        else if (newWidth > current.width || newHeight > current.height) self.instance.scaleToActual(self.centerPointStartX, self.centerPointStartY, 150);
        else {
            newPos = self.limitPosition(newOffsetX, newOffsetY, newWidth, newHeight);
            $.fancybox.animate(self.$content, newPos, 150);
        }
    };
    Guestures.prototype.onTap = function(e) {
        var self = this;
        var $target = $(e.target);
        var instance = self.instance;
        var current = instance.current;
        var endPoints = e && getPointerXY(e) || self.startPoints;
        var tapX = endPoints[0] ? endPoints[0].x - $(window1).scrollLeft() - self.stagePos.left : 0;
        var tapY = endPoints[0] ? endPoints[0].y - $(window1).scrollTop() - self.stagePos.top : 0;
        var where;
        var process = function(prefix) {
            var action = current.opts[prefix];
            if ($.isFunction(action)) action = action.apply(instance, [
                current,
                e
            ]);
            if (!action) return;
            switch(action){
                case "close":
                    instance.close(self.startEvent);
                    break;
                case "toggleControls":
                    instance.toggleControls();
                    break;
                case "next":
                    instance.next();
                    break;
                case "nextOrClose":
                    if (instance.group.length > 1) instance.next();
                    else instance.close(self.startEvent);
                    break;
                case "zoom":
                    if (current.type == "image" && (current.isLoaded || current.$ghost)) {
                        if (instance.canPan()) instance.scaleToFit();
                        else if (instance.isScaledDown()) instance.scaleToActual(tapX, tapY);
                        else if (instance.group.length < 2) instance.close(self.startEvent);
                    }
                    break;
            }
        };
        // Ignore right click
        if (e.originalEvent && e.originalEvent.button == 2) return;
        // Skip if clicked on the scrollbar
        if (!$target.is("img") && tapX > $target[0].clientWidth + $target.offset().left) return;
        // Check where is clicked
        if ($target.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container")) where = "Outside";
        else if ($target.is(".fancybox-slide")) where = "Slide";
        else if (instance.current.$content && instance.current.$content.find($target).addBack().filter($target).length) where = "Content";
        else return;
        // Check if this is a double tap
        if (self.tapped) {
            // Stop previously created single tap
            clearTimeout(self.tapped);
            self.tapped = null;
            // Skip if distance between taps is too big
            if (Math.abs(tapX - self.tapX) > 50 || Math.abs(tapY - self.tapY) > 50) return this;
            // OK, now we assume that this is a double-tap
            process("dblclick" + where);
        } else {
            // Single tap will be processed if user has not clicked second time within 300ms
            // or there is no need to wait for double-tap
            self.tapX = tapX;
            self.tapY = tapY;
            if (current.opts["dblclick" + where] && current.opts["dblclick" + where] !== current.opts["click" + where]) self.tapped = setTimeout(function() {
                self.tapped = null;
                if (!instance.isAnimating) process("click" + where);
            }, 500);
            else process("click" + where);
        }
        return this;
    };
    $(document1).on("onActivate.fb", function(e, instance) {
        if (instance && !instance.Guestures) instance.Guestures = new Guestures(instance);
    }).on("beforeClose.fb", function(e, instance) {
        if (instance && instance.Guestures) instance.Guestures.destroy();
    });
})(window, document, jQuery);
// ==========================================================================
//
// SlideShow
// Enables slideshow functionality
//
// Example of usage:
// $.fancybox.getInstance().SlideShow.start()
//
// ==========================================================================
(function(document1, $) {
    "use strict";
    $.extend(true, $.fancybox.defaults, {
        btnTpl: {
            slideShow: '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>'
        },
        slideShow: {
            autoStart: false,
            speed: 3000,
            progress: true
        }
    });
    var SlideShow = function(instance) {
        this.instance = instance;
        this.init();
    };
    $.extend(SlideShow.prototype, {
        timer: null,
        isActive: false,
        $button: null,
        init: function() {
            var self = this, instance = self.instance, opts = instance.group[instance.currIndex].opts.slideShow;
            self.$button = instance.$refs.toolbar.find("[data-fancybox-play]").on("click", function() {
                self.toggle();
            });
            if (instance.group.length < 2 || !opts) self.$button.hide();
            else if (opts.progress) self.$progress = $('<div class="fancybox-progress"></div>').appendTo(instance.$refs.inner);
        },
        set: function(force) {
            var self = this, instance = self.instance, current = instance.current;
            // Check if reached last element
            if (current && (force === true || current.opts.loop || instance.currIndex < instance.group.length - 1)) {
                if (self.isActive && current.contentType !== "video") {
                    if (self.$progress) $.fancybox.animate(self.$progress.show(), {
                        scaleX: 1
                    }, current.opts.slideShow.speed);
                    self.timer = setTimeout(function() {
                        if (!instance.current.opts.loop && instance.current.index == instance.group.length - 1) instance.jumpTo(0);
                        else instance.next();
                    }, current.opts.slideShow.speed);
                }
            } else {
                self.stop();
                instance.idleSecondsCounter = 0;
                instance.showControls();
            }
        },
        clear: function() {
            var self = this;
            clearTimeout(self.timer);
            self.timer = null;
            if (self.$progress) self.$progress.removeAttr("style").hide();
        },
        start: function() {
            var self = this, current = self.instance.current;
            if (current) {
                self.$button.attr("title", (current.opts.i18n[current.opts.lang] || current.opts.i18n.en).PLAY_STOP).removeClass("fancybox-button--play").addClass("fancybox-button--pause");
                self.isActive = true;
                if (current.isComplete) self.set(true);
                self.instance.trigger("onSlideShowChange", true);
            }
        },
        stop: function() {
            var self = this, current = self.instance.current;
            self.clear();
            self.$button.attr("title", (current.opts.i18n[current.opts.lang] || current.opts.i18n.en).PLAY_START).removeClass("fancybox-button--pause").addClass("fancybox-button--play");
            self.isActive = false;
            self.instance.trigger("onSlideShowChange", false);
            if (self.$progress) self.$progress.removeAttr("style").hide();
        },
        toggle: function() {
            var self = this;
            if (self.isActive) self.stop();
            else self.start();
        }
    });
    $(document1).on({
        "onInit.fb": function(e, instance) {
            if (instance && !instance.SlideShow) instance.SlideShow = new SlideShow(instance);
        },
        "beforeShow.fb": function(e, instance, current, firstRun) {
            var SlideShow = instance && instance.SlideShow;
            if (firstRun) {
                if (SlideShow && current.opts.slideShow.autoStart) SlideShow.start();
            } else if (SlideShow && SlideShow.isActive) SlideShow.clear();
        },
        "afterShow.fb": function(e, instance, current) {
            var SlideShow = instance && instance.SlideShow;
            if (SlideShow && SlideShow.isActive) SlideShow.set();
        },
        "afterKeydown.fb": function(e, instance, current, keypress, keycode) {
            var SlideShow = instance && instance.SlideShow;
            // "P" or Spacebar
            if (SlideShow && current.opts.slideShow && (keycode === 80 || keycode === 32) && !$(document1.activeElement).is("button,a,input")) {
                keypress.preventDefault();
                SlideShow.toggle();
            }
        },
        "beforeClose.fb onDeactivate.fb": function(e, instance) {
            var SlideShow = instance && instance.SlideShow;
            if (SlideShow) SlideShow.stop();
        }
    });
    // Page Visibility API to pause slideshow when window is not active
    $(document1).on("visibilitychange", function() {
        var instance = $.fancybox.getInstance(), SlideShow = instance && instance.SlideShow;
        if (SlideShow && SlideShow.isActive) {
            if (document1.hidden) SlideShow.clear();
            else SlideShow.set();
        }
    });
})(document, jQuery);
// ==========================================================================
//
// FullScreen
// Adds fullscreen functionality
//
// ==========================================================================
(function(document1, $) {
    "use strict";
    // Collection of methods supported by user browser
    var fn = function() {
        var fnMap = [
            [
                "requestFullscreen",
                "exitFullscreen",
                "fullscreenElement",
                "fullscreenEnabled",
                "fullscreenchange",
                "fullscreenerror"
            ],
            // new WebKit
            [
                "webkitRequestFullscreen",
                "webkitExitFullscreen",
                "webkitFullscreenElement",
                "webkitFullscreenEnabled",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            // old WebKit (Safari 5.1)
            [
                "webkitRequestFullScreen",
                "webkitCancelFullScreen",
                "webkitCurrentFullScreenElement",
                "webkitCancelFullScreen",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "mozRequestFullScreen",
                "mozCancelFullScreen",
                "mozFullScreenElement",
                "mozFullScreenEnabled",
                "mozfullscreenchange",
                "mozfullscreenerror"
            ],
            [
                "msRequestFullscreen",
                "msExitFullscreen",
                "msFullscreenElement",
                "msFullscreenEnabled",
                "MSFullscreenChange",
                "MSFullscreenError"
            ]
        ];
        var ret = {};
        for(var i = 0; i < fnMap.length; i++){
            var val = fnMap[i];
            if (val && val[1] in document1) {
                for(var j = 0; j < val.length; j++)ret[fnMap[0][j]] = val[j];
                return ret;
            }
        }
        return false;
    }();
    if (fn) {
        var FullScreen = {
            request: function(elem) {
                elem = elem || document1.documentElement;
                elem[fn.requestFullscreen](elem.ALLOW_KEYBOARD_INPUT);
            },
            exit: function() {
                document1[fn.exitFullscreen]();
            },
            toggle: function(elem) {
                elem = elem || document1.documentElement;
                if (this.isFullscreen()) this.exit();
                else this.request(elem);
            },
            isFullscreen: function() {
                return Boolean(document1[fn.fullscreenElement]);
            },
            enabled: function() {
                return Boolean(document1[fn.fullscreenEnabled]);
            }
        };
        $.extend(true, $.fancybox.defaults, {
            btnTpl: {
                fullScreen: '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>'
            },
            fullScreen: {
                autoStart: false
            }
        });
        $(document1).on(fn.fullscreenchange, function() {
            var isFullscreen = FullScreen.isFullscreen(), instance = $.fancybox.getInstance();
            if (instance) {
                // If image is zooming, then force to stop and reposition properly
                if (instance.current && instance.current.type === "image" && instance.isAnimating) {
                    instance.isAnimating = false;
                    instance.update(true, true, 0);
                    if (!instance.isComplete) instance.complete();
                }
                instance.trigger("onFullscreenChange", isFullscreen);
                instance.$refs.container.toggleClass("fancybox-is-fullscreen", isFullscreen);
                instance.$refs.toolbar.find("[data-fancybox-fullscreen]").toggleClass("fancybox-button--fsenter", !isFullscreen).toggleClass("fancybox-button--fsexit", isFullscreen);
            }
        });
    }
    $(document1).on({
        "onInit.fb": function(e, instance) {
            var $container;
            if (!fn) {
                instance.$refs.toolbar.find("[data-fancybox-fullscreen]").remove();
                return;
            }
            if (instance && instance.group[instance.currIndex].opts.fullScreen) {
                $container = instance.$refs.container;
                $container.on("click.fb-fullscreen", "[data-fancybox-fullscreen]", function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    FullScreen.toggle();
                });
                if (instance.opts.fullScreen && instance.opts.fullScreen.autoStart === true) FullScreen.request();
                // Expose API
                instance.FullScreen = FullScreen;
            } else if (instance) instance.$refs.toolbar.find("[data-fancybox-fullscreen]").hide();
        },
        "afterKeydown.fb": function(e, instance, current, keypress, keycode) {
            // "F"
            if (instance && instance.FullScreen && keycode === 70) {
                keypress.preventDefault();
                instance.FullScreen.toggle();
            }
        },
        "beforeClose.fb": function(e, instance) {
            if (instance && instance.FullScreen && instance.$refs.container.hasClass("fancybox-is-fullscreen")) FullScreen.exit();
        }
    });
})(document, jQuery);
// ==========================================================================
//
// Thumbs
// Displays thumbnails in a grid
//
// ==========================================================================
(function(document1, $) {
    "use strict";
    var CLASS = "fancybox-thumbs", CLASS_ACTIVE = CLASS + "-active";
    // Make sure there are default values
    $.fancybox.defaults = $.extend(true, {
        btnTpl: {
            thumbs: '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>'
        },
        thumbs: {
            autoStart: false,
            hideOnClose: true,
            parentEl: ".fancybox-container",
            axis: "y" // Vertical (y) or horizontal (x) scrolling
        }
    }, $.fancybox.defaults);
    var FancyThumbs = function(instance) {
        this.init(instance);
    };
    $.extend(FancyThumbs.prototype, {
        $button: null,
        $grid: null,
        $list: null,
        isVisible: false,
        isActive: false,
        init: function(instance) {
            var self = this, group = instance.group, enabled = 0;
            self.instance = instance;
            self.opts = group[instance.currIndex].opts.thumbs;
            instance.Thumbs = self;
            self.$button = instance.$refs.toolbar.find("[data-fancybox-thumbs]");
            // Enable thumbs if at least two group items have thumbnails
            for(var i = 0, len = group.length; i < len; i++){
                if (group[i].thumb) enabled++;
                if (enabled > 1) break;
            }
            if (enabled > 1 && !!self.opts) {
                self.$button.removeAttr("style").on("click", function() {
                    self.toggle();
                });
                self.isActive = true;
            } else self.$button.hide();
        },
        create: function() {
            var self = this, instance = self.instance, parentEl = self.opts.parentEl, list = [], src;
            if (!self.$grid) {
                // Create main element
                self.$grid = $('<div class="' + CLASS + " " + CLASS + "-" + self.opts.axis + '"></div>').appendTo(instance.$refs.container.find(parentEl).addBack().filter(parentEl));
                // Add "click" event that performs gallery navigation
                self.$grid.on("click", "a", function() {
                    instance.jumpTo($(this).attr("data-index"));
                });
            }
            // Build the list
            if (!self.$list) self.$list = $('<div class="' + CLASS + '__list">').appendTo(self.$grid);
            $.each(instance.group, function(i, item) {
                src = item.thumb;
                if (!src && item.type === "image") src = item.src;
                list.push('<a href="javascript:;" tabindex="0" data-index="' + i + '"' + (src && src.length ? ' style="background-image:url(' + src + ')"' : 'class="fancybox-thumbs-missing"') + "></a>");
            });
            self.$list[0].innerHTML = list.join("");
            if (self.opts.axis === "x") // Set fixed width for list element to enable horizontal scrolling
            self.$list.width(parseInt(self.$grid.css("padding-right"), 10) + instance.group.length * self.$list.children().eq(0).outerWidth(true));
        },
        focus: function(duration) {
            var self = this, $list = self.$list, $grid = self.$grid, thumb, thumbPos;
            if (!self.instance.current) return;
            thumb = $list.children().removeClass(CLASS_ACTIVE).filter('[data-index="' + self.instance.current.index + '"]').addClass(CLASS_ACTIVE);
            thumbPos = thumb.position();
            // Check if need to scroll to make current thumb visible
            if (self.opts.axis === "y" && (thumbPos.top < 0 || thumbPos.top > $list.height() - thumb.outerHeight())) $list.stop().animate({
                scrollTop: $list.scrollTop() + thumbPos.top
            }, duration);
            else if (self.opts.axis === "x" && (thumbPos.left < $grid.scrollLeft() || thumbPos.left > $grid.scrollLeft() + ($grid.width() - thumb.outerWidth()))) $list.parent().stop().animate({
                scrollLeft: thumbPos.left
            }, duration);
        },
        update: function() {
            var that = this;
            that.instance.$refs.container.toggleClass("fancybox-show-thumbs", this.isVisible);
            if (that.isVisible) {
                if (!that.$grid) that.create();
                that.instance.trigger("onThumbsShow");
                that.focus(0);
            } else if (that.$grid) that.instance.trigger("onThumbsHide");
            // Update content position
            that.instance.update();
        },
        hide: function() {
            this.isVisible = false;
            this.update();
        },
        show: function() {
            this.isVisible = true;
            this.update();
        },
        toggle: function() {
            this.isVisible = !this.isVisible;
            this.update();
        }
    });
    $(document1).on({
        "onInit.fb": function(e, instance) {
            var Thumbs;
            if (instance && !instance.Thumbs) {
                Thumbs = new FancyThumbs(instance);
                if (Thumbs.isActive && Thumbs.opts.autoStart === true) Thumbs.show();
            }
        },
        "beforeShow.fb": function(e, instance, item, firstRun) {
            var Thumbs = instance && instance.Thumbs;
            if (Thumbs && Thumbs.isVisible) Thumbs.focus(firstRun ? 0 : 250);
        },
        "afterKeydown.fb": function(e, instance, current, keypress, keycode) {
            var Thumbs = instance && instance.Thumbs;
            // "G"
            if (Thumbs && Thumbs.isActive && keycode === 71) {
                keypress.preventDefault();
                Thumbs.toggle();
            }
        },
        "beforeClose.fb": function(e, instance) {
            var Thumbs = instance && instance.Thumbs;
            if (Thumbs && Thumbs.isVisible && Thumbs.opts.hideOnClose !== false) Thumbs.$grid.hide();
        }
    });
})(document, jQuery);
//// ==========================================================================
//
// Share
// Displays simple form for sharing current url
//
// ==========================================================================
(function(document1, $) {
    "use strict";
    $.extend(true, $.fancybox.defaults, {
        btnTpl: {
            share: '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>'
        },
        share: {
            url: function(instance, item) {
                return (!instance.currentHash && !(item.type === "inline" || item.type === "html") ? item.origSrc || item.src : false) || window.location;
            },
            tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>'
        }
    });
    function escapeHtml(string) {
        var entityMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
            "/": "&#x2F;",
            "`": "&#x60;",
            "=": "&#x3D;"
        };
        return String(string).replace(/[&<>"'`=\/]/g, function(s) {
            return entityMap[s];
        });
    }
    $(document1).on("click", "[data-fancybox-share]", function() {
        var instance = $.fancybox.getInstance(), current = instance.current || null, url, tpl;
        if (!current) return;
        if ($.type(current.opts.share.url) === "function") url = current.opts.share.url.apply(current, [
            instance,
            current
        ]);
        tpl = current.opts.share.tpl.replace(/\{\{media\}\}/g, current.type === "image" ? encodeURIComponent(current.src) : "").replace(/\{\{url\}\}/g, encodeURIComponent(url)).replace(/\{\{url_raw\}\}/g, escapeHtml(url)).replace(/\{\{descr\}\}/g, instance.$caption ? encodeURIComponent(instance.$caption.text()) : "");
        $.fancybox.open({
            src: instance.translate(instance, tpl),
            type: "html",
            opts: {
                touch: false,
                animationEffect: false,
                afterLoad: function(shareInstance, shareCurrent) {
                    // Close self if parent instance is closing
                    instance.$refs.container.one("beforeClose.fb", function() {
                        shareInstance.close(null, 0);
                    });
                    // Opening links in a popup window
                    shareCurrent.$content.find(".fancybox-share__button").click(function() {
                        window.open(this.href, "Share", "width=550, height=450");
                        return false;
                    });
                },
                mobile: {
                    autoFocus: false
                }
            }
        });
    });
})(document, jQuery);
// ==========================================================================
//
// Hash
// Enables linking to each modal
//
// ==========================================================================
(function(window1, document1, $) {
    "use strict";
    // Simple $.escapeSelector polyfill (for jQuery prior v3)
    if (!$.escapeSelector) $.escapeSelector = function(sel) {
        var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
        var fcssescape = function(ch, asCodePoint) {
            if (asCodePoint) {
                // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                if (ch === "\x00") return "�";
                // Control characters and (dependent upon position) numbers get escaped as code points
                return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
            }
            // Other potentially-special ASCII characters get backslash-escaped
            return "\\" + ch;
        };
        return (sel + "").replace(rcssescape, fcssescape);
    };
    // Get info about gallery name and current index from url
    function parseUrl() {
        var hash = window1.location.hash.substr(1), rez = hash.split("-"), index = rez.length > 1 && /^\+?\d+$/.test(rez[rez.length - 1]) ? parseInt(rez.pop(-1), 10) || 1 : 1, gallery = rez.join("-");
        return {
            hash: hash,
            /* Index is starting from 1 */ index: index < 1 ? 1 : index,
            gallery: gallery
        };
    }
    // Trigger click evnt on links to open new fancyBox instance
    function triggerFromUrl(url) {
        if (url.gallery !== "") // If we can find element matching 'data-fancybox' atribute,
        // then triggering click event should start fancyBox
        $("[data-fancybox='" + $.escapeSelector(url.gallery) + "']").eq(url.index - 1).focus().trigger("click.fb-start");
    }
    // Get gallery name from current instance
    function getGalleryID(instance) {
        var opts, ret;
        if (!instance) return false;
        opts = instance.current ? instance.current.opts : instance.opts;
        ret = opts.hash || (opts.$orig ? opts.$orig.data("fancybox") || opts.$orig.data("fancybox-trigger") : "");
        return ret === "" ? false : ret;
    }
    // Start when DOM becomes ready
    $(function() {
        // Check if user has disabled this module
        if ($.fancybox.defaults.hash === false) return;
        // Update hash when opening/closing fancyBox
        $(document1).on({
            "onInit.fb": function(e, instance) {
                var url, gallery;
                if (instance.group[instance.currIndex].opts.hash === false) return;
                url = parseUrl();
                gallery = getGalleryID(instance);
                // Make sure gallery start index matches index from hash
                if (gallery && url.gallery && gallery == url.gallery) instance.currIndex = url.index - 1;
            },
            "beforeShow.fb": function(e, instance, current, firstRun) {
                var gallery;
                if (!current || current.opts.hash === false) return;
                // Check if need to update window hash
                gallery = getGalleryID(instance);
                if (!gallery) return;
                // Variable containing last hash value set by fancyBox
                // It will be used to determine if fancyBox needs to close after hash change is detected
                instance.currentHash = gallery + (instance.group.length > 1 ? "-" + (current.index + 1) : "");
                // If current hash is the same (this instance most likely is opened by hashchange), then do nothing
                if (window1.location.hash === "#" + instance.currentHash) return;
                if (firstRun && !instance.origHash) instance.origHash = window1.location.hash;
                if (instance.hashTimer) clearTimeout(instance.hashTimer);
                // Update hash
                instance.hashTimer = setTimeout(function() {
                    if ("replaceState" in window1.history) {
                        window1.history[firstRun ? "pushState" : "replaceState"]({}, document1.title, window1.location.pathname + window1.location.search + "#" + instance.currentHash);
                        if (firstRun) instance.hasCreatedHistory = true;
                    } else window1.location.hash = instance.currentHash;
                    instance.hashTimer = null;
                }, 300);
            },
            "beforeClose.fb": function(e, instance, current) {
                if (!current || current.opts.hash === false) return;
                clearTimeout(instance.hashTimer);
                // Goto previous history entry
                if (instance.currentHash && instance.hasCreatedHistory) window1.history.back();
                else if (instance.currentHash) {
                    if ("replaceState" in window1.history) window1.history.replaceState({}, document1.title, window1.location.pathname + window1.location.search + (instance.origHash || ""));
                    else window1.location.hash = instance.origHash;
                }
                instance.currentHash = null;
            }
        });
        // Check if need to start/close after url has changed
        $(window1).on("hashchange.fb", function() {
            var url = parseUrl(), fb = null;
            // Find last fancyBox instance that has "hash"
            $.each($(".fancybox-container").get().reverse(), function(index, value) {
                var tmp = $(value).data("FancyBox");
                if (tmp && tmp.currentHash) {
                    fb = tmp;
                    return false;
                }
            });
            if (fb) // Now, compare hash values
            {
                if (fb.currentHash !== url.gallery + "-" + url.index && !(url.index === 1 && fb.currentHash == url.gallery)) {
                    fb.currentHash = null;
                    fb.close();
                }
            } else if (url.gallery !== "") triggerFromUrl(url);
        });
        // Check current hash and trigger click event on matching element to start fancyBox, if needed
        setTimeout(function() {
            if (!$.fancybox.getInstance()) triggerFromUrl(parseUrl());
        }, 50);
    });
})(window, document, jQuery);
// ==========================================================================
//
// Wheel
// Basic mouse weheel support for gallery navigation
//
// ==========================================================================
(function(document1, $) {
    "use strict";
    var prevTime = new Date().getTime();
    $(document1).on({
        "onInit.fb": function(e, instance, current) {
            instance.$refs.stage.on("mousewheel DOMMouseScroll wheel MozMousePixelScroll", function(e) {
                var current = instance.current, currTime = new Date().getTime();
                if (instance.group.length < 2 || current.opts.wheel === false || current.opts.wheel === "auto" && current.type !== "image") return;
                e.preventDefault();
                e.stopPropagation();
                if (current.$slide.hasClass("fancybox-animated")) return;
                e = e.originalEvent || e;
                if (currTime - prevTime < 250) return;
                prevTime = currTime;
                instance[(-e.deltaY || -e.deltaX || e.wheelDelta || -e.detail) < 0 ? "next" : "previous"]();
            });
        }
    });
})(document, jQuery);


(0, $f564a415f4d19b8d$export$25ce5a424b770e84).use([
    (0, $3fb235b8df1172c3$export$2e2bcd8739ae039),
    (0, $eaaaf8b39da376c0$export$2e2bcd8739ae039),
    (0, $e9d5694a0a5e5ad4$export$2e2bcd8739ae039),
    (0, $eaf75da0b716a547$export$2e2bcd8739ae039)
]);
(0, (/*@__PURE__*/$parcel$interopDefault($adf38128cd050da0$exports))).init();
var $8e6ec98c28dc9e4e$var$productName;
//jquery validator defaults
(0, (/*@__PURE__*/$parcel$interopDefault($k7705))).validator.setDefaults({
    errorClass: "",
    validClass: "",
    highlight: function(element, errorClass, validClass) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(element).addClass("is-invalid").removeClass("is-valid");
        if (element.id) (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(element.form).find("[data-valmsg-for=" + element.id + "]").addClass("invalid-feedback");
    },
    unhighlight: function(element, errorClass, validClass) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(element).addClass("is-valid").removeClass("is-invalid");
        if (element.id) (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(element.form).find("[data-valmsg-for=" + element.id + "]").removeClass("invalid-feedback");
    }
});
(0, $e4381b4d92026ad0$export$a7c2c94bb9dfaf8f)();
(0, $adfea27fcc05dea0$export$9477d5792fdd966f)();
(0, $ecd5e57691808421$export$5bb2e8100a315ad2)();
document.addEventListener("DOMContentLoaded", function() {
    const newSwiper = new (0, $f564a415f4d19b8d$export$25ce5a424b770e84)(".homepage-swiper", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        autoplay: {
            delay: 50000
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
        scrollbar: {
            el: ".swiper-scrollbar"
        }
    });
    const productSwiperThumbs = new (0, $f564a415f4d19b8d$export$25ce5a424b770e84)(".product-swiper-thumb", {
        spaceBetween: 20,
        slidesPerView: 2,
        centerInsufficientSlides: true,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        }
    });
    const productSwiper = new (0, $f564a415f4d19b8d$export$25ce5a424b770e84)(".product-swiper", {
        modules: [
            (0, $3fb235b8df1172c3$export$2e2bcd8739ae039)
        ],
        spaceBetween: 10,
        autoplay: {
            delay: 5000000
        },
        thumbs: {
            swiper: productSwiperThumbs
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        on: {
            slideChange: updateButtonsUrl
        }
    });
    const homepageSwiperSlider = new (0, $f564a415f4d19b8d$export$25ce5a424b770e84)(".home-page-products-swiper", {
        spaceBetween: 20,
        slidesPerView: 4,
        centerInsufficientSlides: true,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 3
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 4
            }
        }
    });
    const $pinterestButton = (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(".pinterest-button");
    const $downloadButton = (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(".btn-download");
    function updateButtonsUrl() {
        $8e6ec98c28dc9e4e$var$productName = (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))("[data-product-name]").attr("data-product-name");
        const currentSlide = productSwiper.slides[productSwiper.activeIndex];
        const imageUrl = (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(currentSlide).find("img").attr("src");
        const encodedUrl = encodeURIComponent(imageUrl);
        $pinterestButton.attr("href", "http://pinterest.com/pin/create/button/?url=" + encodedUrl + "&description=Description");
        $downloadButton.attr("href", "/Download/DownloadImage?imageUrl=" + encodedUrl + "&fileName=" + encodeURIComponent($8e6ec98c28dc9e4e$var$productName) + ".jpeg");
    }
    // Update buttons URL at initial state
    updateButtonsUrl();
    var element = document.getElementById("customAlert");
    if (element) {
        element.style.display = "block";
        setTimeout(()=>element.style.display = "none", 5000);
    }
});
var $8e6ec98c28dc9e4e$var$toggleElement = document.getElementById("toggle");
if ($8e6ec98c28dc9e4e$var$toggleElement) $8e6ec98c28dc9e4e$var$toggleElement.addEventListener("click", function(e) {
    e.preventDefault();
    var textDiv = document.getElementById("text");
    if (textDiv && textDiv.style.maxHeight.replace("px", "") > 19.2) {
        // If block is expanded 
        textDiv.style.maxHeight = "1.2em"; // Collapse it
        this.innerHTML = "Show more +";
    } else if (textDiv) {
        textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
        this.innerHTML = "Show less";
    }
});
(0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(document).on("click", "#finishfilter .checkbox-menu a.dropdown-item", function(event) {
    event.preventDefault();
});
(0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(document).on("click", '.checkbox-menu input[type="checkbox"]', function() {
    var url = new URL(window.location.href);
    if (url.searchParams.has("page")) url.searchParams.delete("page");
    var selectedFinishes = $8e6ec98c28dc9e4e$var$getSelectedFinishes();
    if (selectedFinishes.length > 0) url.searchParams.set("finish", selectedFinishes.join(","));
    else url.searchParams.delete("finish");
    var baseUrl = url.href.split("?")[0];
    var params = url.searchParams.toString();
    // Only add '?' and parameters if there are any parameters
    var urlStr = params ? `${baseUrl}?${params}` : baseUrl;
    window.history.pushState({}, "", urlStr);
    // Show loading spinner
    (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))("#product-container").html('<div class="d-flex justify-content-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>');
    var params = new URLSearchParams(window.location.search);
    params.set("categoryId", (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))('input[name="CategoryId"]').val());
    var searchTerm = (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))('input[name="searchTerm"]').val() ? (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))('input[name="searchTerm"]').val() : "";
    params.set("searchTerm", searchTerm);
    var getResults = (0, (/*@__PURE__*/$parcel$interopDefault($k7705))).ajax({
        url: "/ProductSearchPage/GetResultsPartial",
        type: "GET",
        data: params.toString(),
        timeout: 50000
    }).fail(function(jqXHR, textStatus, errorThrown) {
        console.error("/ProductSearchPage/GetResultsPartial AJAX error: " + textStatus + " : " + errorThrown);
    });
    var getFilters = (0, (/*@__PURE__*/$parcel$interopDefault($k7705))).ajax({
        url: "/ProductSearchPage/GetFiltersPartial",
        type: "GET",
        data: params.toString(),
        timeout: 50000
    }).fail(function(jqXHR, textStatus, errorThrown) {
        console.error("/ProductSearchPage/GetFiltersPartial AJAX error: " + textStatus + " : " + errorThrown);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($k7705))).when(getResults, getFilters).done(function(result1, result2) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))("#product-container").html(result1[0]);
        (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))("#filter-container").html(result2[0]);
    }).fail(function() {
        console.error("An AJAX error occurred");
    });
//$.ajax({
//    url: '/ProductSearchPage/GetResults',
//    type: 'GET',
//    data: params.toString(),
//    success: function (data) {
//        $('#product-container').html(data);
//    },
//    error: function (jqXHR, textStatus, errorThrown) {
//        console.error("AJAX error: " + textStatus + ' : ' + errorThrown);
//    },
//    complete: function (data, textStatus) {
//        console.log("AJAX request complete with status: " + textStatus);
//    }
//});
//$.ajax({
//    url: '/ProductSearchPage/GetFilters',
//    type: 'GET',
//    data: params.toString(),
//    success: function (data) {
//        $('#filter-container').html(data);
//    },
//    error: function (jqXHR, textStatus, errorThrown) {
//        console.error("AJAX error: " + textStatus + ' : ' + errorThrown);
//    },
//    complete: function (data, textStatus) {
//        console.log("AJAX request complete with status: " + textStatus);
//    }
//});
});
function $8e6ec98c28dc9e4e$var$getSelectedFinishes() {
    var selectedFinishes = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))('.checkbox-menu input[type="checkbox"]:checked').each(function() {
        selectedFinishes.push((0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(this).val());
    });
    return selectedFinishes;
}
// product gallery
(0, (/*@__PURE__*/$parcel$interopDefault($k7705)))().fancybox({
    selector: '[data-fancybox="gallery"]',
    animationEffect: false,
    buttons: [
        "close"
    ],
    touch: {
        horizontal: true,
        momentum: true
    },
    clickContent: false,
    beforeShow: function(instance, slide) {
        // Remove the buttons before showing the next slide
        instance.$refs.stage.find(".lightbox-buttons").remove();
        let prevButton = (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(".fancybox-button--arrow_left div");
        let nextButton = (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(".fancybox-button--arrow_right div");
        if (prevButton && nextButton) {
            prevButton.html('<i class="bi bi-caret-left-fill"></i>');
            nextButton.html('<i class="bi bi-caret-right-fill"></i>');
        }
    },
    afterShow: function(instance, slide) {
        // Get the current image's URL
        var url = instance.current.src;
        // Get the title of the current image
        var description = instance.current.opts.caption;
        // Create a new Pinterest icon image element
        var $pinterestIcon = (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))("<img>").addClass("pinterest-icon").attr("src", "/Apps/ClearwaterInteriors/Content/images/icons/pinterest-icon.svg").attr("alt", "Pinterest");
        // Create a new Pinterest share button
        var $pinButton = (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))("<button>").addClass("btn btn-outline-dark rounded-0 my-pinterest-share-button standard-button fw-600 w-100 w-md-auto").text("Add to Pinterest").prepend($pinterestIcon) // Add the Pinterest icon in front of the text
        .data("url", "http://pinterest.com/pin/create/button/?url=" + encodeURIComponent(url) + "&description=" + encodeURIComponent(description));
        // Create a new Download button
        var $downloadButton = (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))("<a>").addClass("btn btn-outline-dark rounded-0 my-download-button standard-button fw-600 w-100 w-md-auto").text("Download Image").attr("href", "/Download/DownloadImage?imageUrl=" + encodeURIComponent(url) + "&fileName=" + encodeURIComponent($8e6ec98c28dc9e4e$var$productName) + ".jpeg").attr("download", "");
        // Add the buttons to the lightbox content area
        var $buttonsDiv = (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))("<div>").addClass("lightbox-buttons").append($downloadButton, $pinButton);
        instance.$refs.stage.append($buttonsDiv);
    },
    beforeClose: function(instance, slide) {
        // Remove the buttons when the lightbox closes
        instance.$refs.stage.find(".lightbox-buttons").remove();
    }
});
window.addEventListener("DOMContentLoaded", (event)=>{
    $8e6ec98c28dc9e4e$var$checkWidthAndCollapse();
});
window.addEventListener("resize", (event)=>{
    $8e6ec98c28dc9e4e$var$checkWidthAndCollapse();
});
function $8e6ec98c28dc9e4e$var$checkWidthAndCollapse() {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(window).width() <= 992) (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))("footer .collapse").removeClass("show");
    else (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))("footer .collapse").addClass("show");
    (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))("#collapseFooterNewsletter").addClass("show");
}
(0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(document).on("click", ".my-pinterest-share-button", function(event) {
    event.stopPropagation();
    window.open((0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(this).data("url"), "_blank"); // Open the URL in a new window/tab
});
(0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(".pinterest-button").hover(function() {
    // Mouse enters
    (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(this).find(".pinterest-icon").attr("src", "/Apps/ClearwaterInteriors/Content/images/icons/pinterest-icon.svg");
}, function() {
    // Mouse leaves
    (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(this).find(".pinterest-icon").attr("src", "/Apps/ClearwaterInteriors/Content/images/icons/pinterest-black-icon.svg");
});
//tooltips
const $8e6ec98c28dc9e4e$var$tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
const $8e6ec98c28dc9e4e$var$tooltipList = [
    ...$8e6ec98c28dc9e4e$var$tooltipTriggerList
].map((tooltipTriggerEl)=>new $8593c12df4688393$export$28c660c63b792dea(tooltipTriggerEl));
const $8e6ec98c28dc9e4e$var$productVariantDropdown = document.getElementById("productVariantDropdown");
if ($8e6ec98c28dc9e4e$var$productVariantDropdown) $8e6ec98c28dc9e4e$var$productVariantDropdown.addEventListener("change", function() {
    let selectedVariantId = this.value;
    window.location.href = window.location.pathname + "?variant=" + selectedVariantId;
});
//set focus on search input after click on search button (mobile)
let $8e6ec98c28dc9e4e$var$mobileSearchCollapse = document.getElementById("search-container");
if ($8e6ec98c28dc9e4e$var$mobileSearchCollapse) $8e6ec98c28dc9e4e$var$mobileSearchCollapse.addEventListener("shown.bs.offcanvas", function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(this).find('input[name="SearchTerm"]')[0].focus();
});
/// scroll top always
(0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(document).ready(function() {
    var offcanvasNav = (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))("#offcanvasNav");
    offcanvasNav.on("show.bs.offcanvas", function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k7705)))(".offcanvas-body").scrollTop(0);
    });
});

})();
//# sourceMappingURL=front-end.js.map
